/* tslint:disable */
/* eslint-disable */
/**
 * Backend API
 * This is the API to communicate from the device to the backend.
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AccidentTags
 */
export interface AccidentTags {
    /**
     * 
     * @type {number}
     * @memberof AccidentTags
     */
    accident_id: number;
    /**
     * 
     * @type {number}
     * @memberof AccidentTags
     */
    tags_id: number;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTags
     */
    driver_fault: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTags
     */
    front_accident: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTags
     */
    side_accident: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTags
     */
    rear_accident: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTags
     */
    preventable_with_dash_cam: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTags
     */
    preventable_with_side_sensor: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTags
     */
    preventable_with_rear_sensor: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTags
     */
    claim_prevented_by_camera: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTags
     */
    no_video: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTags
     */
    in_cabin_blocked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTags
     */
    front_facing_blocked: boolean;
    /**
     * 
     * @type {string}
     * @memberof AccidentTags
     */
    comment: string;
}
/**
 * 
 * @export
 * @interface AccidentTagsV1
 */
export interface AccidentTagsV1 {
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV1
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV1
     */
    main_reason: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV1
     */
    secondary_reason: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV1
     */
    damage_assessment: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV1
     */
    speed: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV1
     */
    vehicle_type: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV1
     */
    fault: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV1
     */
    frame_number: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV1
     */
    missing_video_reason: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV1
     */
    damage_mechanism: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV1
     */
    in_cabin_well: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV1
     */
    ff_well: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTagsV1
     */
    claim_prevented_by_camera: boolean;
}
/**
 * 
 * @export
 * @interface AccidentTagsV2
 */
export interface AccidentTagsV2 {
    /**
     * 
     * @type {number}
     * @memberof AccidentTagsV2
     */
    accident_id: number;
    /**
     * 
     * @type {AccidentTagsV2Details}
     * @memberof AccidentTagsV2
     */
    tag: AccidentTagsV2Details;
}
/**
 * 
 * @export
 * @interface AccidentTagsV2Details
 */
export interface AccidentTagsV2Details {
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV2Details
     */
    fault: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV2Details
     */
    speed: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccidentTagsV2Details
     */
    source: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV2Details
     */
    confidence: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV2Details
     */
    frame_number: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccidentTagsV2Details
     */
    damage_causes: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV2Details
     */
    primary_cause: string;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTagsV2Details
     */
    not_an_accident: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AccidentTagsV2Details
     */
    clearly_visible: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccidentTagsV2Details
     */
    points_of_impact: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccidentTagsV2Details
     */
    impacted_objects: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV2Details
     */
    in_cabin_wellness: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV2Details
     */
    front_facing_wellness: string;
    /**
     * 
     * @type {string}
     * @memberof AccidentTagsV2Details
     */
    missing_video_reason: string;
}
/**
 * 
 * @export
 * @interface AggregatedMalfunctions
 */
export interface AggregatedMalfunctions {
    /**
     * 
     * @type {string}
     * @memberof AggregatedMalfunctions
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof AggregatedMalfunctions
     */
    sub_fleet: string;
    /**
     * 
     * @type {number}
     * @memberof AggregatedMalfunctions
     */
    timestamp: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof AggregatedMalfunctions
     */
    malfunctions: { [key: string]: number; } | null;
}
/**
 * 
 * @export
 * @interface AggregatedMalfunctionsHistory
 */
export interface AggregatedMalfunctionsHistory {
    /**
     * 
     * @type {Array<AggregatedMalfunctions>}
     * @memberof AggregatedMalfunctionsHistory
     */
    current: Array<AggregatedMalfunctions>;
    /**
     * 
     * @type {Array<AggregatedMalfunctions>}
     * @memberof AggregatedMalfunctionsHistory
     */
    week: Array<AggregatedMalfunctions>;
    /**
     * 
     * @type {Array<AggregatedMalfunctions>}
     * @memberof AggregatedMalfunctionsHistory
     */
    month: Array<AggregatedMalfunctions>;
    /**
     * 
     * @type {Array<AggregatedMalfunctions>}
     * @memberof AggregatedMalfunctionsHistory
     */
    quarter: Array<AggregatedMalfunctions>;
}
/**
 * 
 * @export
 * @interface Alert
 */
export interface Alert {
    /**
     * 
     * @type {number}
     * @memberof Alert
     */
    pk: number;
    /**
     * 
     * @type {boolean}
     * @memberof Alert
     */
    is_report: boolean;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    report_type: string;
    /**
     * 
     * @type {object}
     * @memberof Alert
     */
    filters: object;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    method: string;
    /**
     * 
     * @type {number}
     * @memberof Alert
     */
    cooldown_minutes: number;
    /**
     * 
     * @type {boolean}
     * @memberof Alert
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    active_start_time?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Alert
     */
    active_end_time?: string | null;
}
/**
 * 
 * @export
 * @interface AlertOrReport
 */
export interface AlertOrReport {
    /**
     * 
     * @type {number}
     * @memberof AlertOrReport
     */
    pk: number;
    /**
     * 
     * @type {boolean}
     * @memberof AlertOrReport
     */
    is_report: boolean;
    /**
     * 
     * @type {string}
     * @memberof AlertOrReport
     */
    report_type: string;
    /**
     * 
     * @type {object}
     * @memberof AlertOrReport
     */
    filters: object;
    /**
     * 
     * @type {string}
     * @memberof AlertOrReport
     */
    method: string;
    /**
     * 
     * @type {number}
     * @memberof AlertOrReport
     */
    cooldown_minutes: number;
    /**
     * 
     * @type {boolean}
     * @memberof AlertOrReport
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof AlertOrReport
     */
    active_start_time?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertOrReport
     */
    active_end_time?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AlertOrReport
     */
    report_scope: string;
    /**
     * 
     * @type {number}
     * @memberof AlertOrReport
     */
    report_day: number;
    /**
     * 
     * @type {string}
     * @memberof AlertOrReport
     */
    report_time: string;
}
/**
 * 
 * @export
 * @interface AlertReportList
 */
export interface AlertReportList {
    /**
     * 
     * @type {Array<Alert>}
     * @memberof AlertReportList
     */
    alerts: Array<Alert>;
    /**
     * 
     * @type {Array<Report>}
     * @memberof AlertReportList
     */
    reports: Array<Report>;
}
/**
 * 
 * @export
 * @interface Appraiser
 */
export interface Appraiser {
    /**
     * 
     * @type {Contact}
     * @memberof Appraiser
     */
    contact: Contact;
    /**
     * 
     * @type {number}
     * @memberof Appraiser
     */
    cost: number;
}
/**
 * 
 * @export
 * @interface Artifact
 */
export interface Artifact {
    /**
     * 
     * @type {number}
     * @memberof Artifact
     */
    artifact_id: number;
    /**
     * 
     * @type {string}
     * @memberof Artifact
     */
    file_name: string;
    /**
     * 
     * @type {string}
     * @memberof Artifact
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof Artifact
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof Artifact
     */
    tag: string;
    /**
     * 
     * @type {boolean}
     * @memberof Artifact
     */
    shared_with_insurance?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Artifact
     */
    created_at: number;
}
/**
 * 
 * @export
 * @interface ArtifactAction
 */
export interface ArtifactAction {
    /**
     * 
     * @type {string}
     * @memberof ArtifactAction
     */
    action?: ArtifactActionActionEnum;
    /**
     * for action \"email\"
     * @type {string}
     * @memberof ArtifactAction
     */
    recipient?: string;
    /**
     * for action \"email\"
     * @type {string}
     * @memberof ArtifactAction
     */
    message?: string;
    /**
     * for action \"edit\"
     * @type {string}
     * @memberof ArtifactAction
     */
    name?: string;
    /**
     * for action \"edit\"
     * @type {string}
     * @memberof ArtifactAction
     */
    tag?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ArtifactActionActionEnum {
    Mail = 'mail',
    Edit = 'edit',
    Delete = 'delete'
}

/**
 * 
 * @export
 * @interface ArtifactRequest
 */
export interface ArtifactRequest {
    /**
     * 
     * @type {number}
     * @memberof ArtifactRequest
     */
    artifact_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ArtifactRequest
     */
    file_name: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactRequest
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactRequest
     */
    tag: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArtifactRequest
     */
    shared_with_insurance?: boolean;
}
/**
 * 
 * @export
 * @interface BackendResult
 */
export interface BackendResult {
    /**
     * 
     * @type {string}
     * @memberof BackendResult
     */
    status?: BackendResultStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof BackendResult
     */
    event_id?: number;
    /**
     * 
     * @type {string}
     * @memberof BackendResult
     */
    message?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum BackendResultStatusEnum {
    Success = 'success',
    Failure = 'failure'
}

/**
 * 
 * @export
 * @interface BaseAccident
 */
export interface BaseAccident {
    /**
     * 
     * @type {number}
     * @memberof BaseAccident
     */
    accident_id: number;
    /**
     * 
     * @type {number}
     * @memberof BaseAccident
     */
    event?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    sub_fleet_name: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    location: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    driver_name: string;
    /**
     * 
     * @type {number}
     * @memberof BaseAccident
     */
    driver_token?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    internal_status: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    handling_status: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    internal_id: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    assignee?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BaseAccident
     */
    is_closed: boolean;
    /**
     * 
     * @type {Array<Damage>}
     * @memberof BaseAccident
     */
    damage_list: Array<Damage>;
    /**
     * 
     * @type {Array<Comment>}
     * @memberof BaseAccident
     */
    comment_list: Array<Comment>;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    stage: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseAccident
     */
    is_anomaly?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    damage_category: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    claim_number: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    respondent?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseAccident
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    suing?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseAccident
     */
    has_lawsuit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseAccident
     */
    claim_prevented_by_camera?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseAccident
     */
    police_report_number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseAccident
     */
    archived?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BaseAccident
     */
    created_at: number;
    /**
     * 
     * @type {boolean}
     * @memberof BaseAccident
     */
    video_requested?: boolean;
}
/**
 * 
 * @export
 * @interface BaseAccidentV2
 */
export interface BaseAccidentV2 {
    /**
     * 
     * @type {number}
     * @memberof BaseAccidentV2
     */
    accident_id: number;
    /**
     * 
     * @type {number}
     * @memberof BaseAccidentV2
     */
    event: number | null;
    /**
     * 
     * @type {string}
     * @memberof BaseAccidentV2
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccidentV2
     */
    sub_fleet_name: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccidentV2
     */
    driver_name: string;
    /**
     * 
     * @type {number}
     * @memberof BaseAccidentV2
     */
    driver_token?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseAccidentV2
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccidentV2
     */
    internal_status: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccidentV2
     */
    internal_id: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccidentV2
     */
    assignee: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseAccidentV2
     */
    stage: string;
    /**
     * 
     * @type {number}
     * @memberof BaseAccidentV2
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof BaseAccidentV2
     */
    created_at: number;
    /**
     * 
     * @type {number}
     * @memberof BaseAccidentV2
     */
    updated_at: number;
    /**
     * 
     * @type {CommandData}
     * @memberof BaseAccidentV2
     */
    last_command: CommandData;
    /**
     * 
     * @type {AccidentTagsV2}
     * @memberof BaseAccidentV2
     */
    tags: AccidentTagsV2;
    /**
     * 
     * @type {number}
     * @memberof BaseAccidentV2
     */
    notification: number | null;
    /**
     * 
     * @type {string}
     * @memberof BaseAccidentV2
     */
    trip_id: string;
    /**
     * 
     * @type {string}
     * @memberof BaseAccidentV2
     */
    missing_trip_reason: string;
    /**
     * 
     * @type {number}
     * @memberof BaseAccidentV2
     */
    total_paid: number | null;
    /**
     * 
     * @type {number}
     * @memberof BaseAccidentV2
     */
    total_reserve: number | null;
}
/**
 * 
 * @export
 * @interface BaseEvent
 */
export interface BaseEvent {
    /**
     * 
     * @type {number}
     * @memberof BaseEvent
     */
    event_id: number;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    level: string;
    /**
     * 
     * @type {number}
     * @memberof BaseEvent
     */
    severity: number;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    trip_id: string;
    /**
     * 
     * @type {number}
     * @memberof BaseEvent
     */
    timestamp: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseEvent
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseEvent
     */
    artifacts?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    route: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    additional_info: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    location: string;
    /**
     * 
     * @type {number}
     * @memberof BaseEvent
     */
    speed: number | null;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    detector_version: string;
    /**
     * 
     * @type {string}
     * @memberof BaseEvent
     */
    event_description: string;
    /**
     * 
     * @type {number}
     * @memberof BaseEvent
     */
    start_frame_id: number;
    /**
     * 
     * @type {TripDetails}
     * @memberof BaseEvent
     */
    trip?: TripDetails;
}
/**
 * 
 * @export
 * @interface BaseExtendedAccident
 */
export interface BaseExtendedAccident {
    /**
     * 
     * @type {number}
     * @memberof BaseExtendedAccident
     */
    accident_id: number;
    /**
     * 
     * @type {number}
     * @memberof BaseExtendedAccident
     */
    event?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    sub_fleet_name: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    location: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    driver_name: string;
    /**
     * 
     * @type {number}
     * @memberof BaseExtendedAccident
     */
    driver_token?: number;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    internal_status: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    handling_status: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    internal_id: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    assignee?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BaseExtendedAccident
     */
    is_closed: boolean;
    /**
     * 
     * @type {Array<Damage>}
     * @memberof BaseExtendedAccident
     */
    damage_list: Array<Damage>;
    /**
     * 
     * @type {Array<Comment>}
     * @memberof BaseExtendedAccident
     */
    comment_list: Array<Comment>;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    stage: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseExtendedAccident
     */
    is_anomaly?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    damage_category: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    claim_number: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    respondent?: string;
    /**
     * 
     * @type {number}
     * @memberof BaseExtendedAccident
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    suing?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseExtendedAccident
     */
    has_lawsuit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BaseExtendedAccident
     */
    claim_prevented_by_camera?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    police_report_number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BaseExtendedAccident
     */
    archived?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BaseExtendedAccident
     */
    created_at: number;
    /**
     * 
     * @type {boolean}
     * @memberof BaseExtendedAccident
     */
    video_requested?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    norm_license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    customer?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    policy_number?: string;
    /**
     * 
     * @type {Array<Artifact>}
     * @memberof BaseExtendedAccident
     */
    artifact_list: Array<Artifact>;
    /**
     * 
     * @type {Array<Witness>}
     * @memberof BaseExtendedAccident
     */
    witness_list: Array<Witness>;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    appraiser: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    garage: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    at_fault: string;
    /**
     * 
     * @type {Driver}
     * @memberof BaseExtendedAccident
     */
    driver: Driver | null;
    /**
     * 
     * @type {number}
     * @memberof BaseExtendedAccident
     */
    updated_at: number;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    trip_id: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccident
     */
    missing_trip_reason: string;
    /**
     * 
     * @type {number}
     * @memberof BaseExtendedAccident
     */
    total_paid: number | null;
    /**
     * 
     * @type {number}
     * @memberof BaseExtendedAccident
     */
    total_reserve: number | null;
    /**
     * 
     * @type {Array<ClaimData>}
     * @memberof BaseExtendedAccident
     */
    claims: Array<ClaimData>;
}
/**
 * 
 * @export
 * @interface BaseExtendedAccidentAllOf
 */
export interface BaseExtendedAccidentAllOf {
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccidentAllOf
     */
    norm_license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccidentAllOf
     */
    customer?: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccidentAllOf
     */
    policy_number?: string;
    /**
     * 
     * @type {Array<Artifact>}
     * @memberof BaseExtendedAccidentAllOf
     */
    artifact_list: Array<Artifact>;
    /**
     * 
     * @type {Array<Witness>}
     * @memberof BaseExtendedAccidentAllOf
     */
    witness_list: Array<Witness>;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccidentAllOf
     */
    appraiser: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccidentAllOf
     */
    garage: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccidentAllOf
     */
    at_fault: string;
    /**
     * 
     * @type {Driver}
     * @memberof BaseExtendedAccidentAllOf
     */
    driver: Driver | null;
    /**
     * 
     * @type {number}
     * @memberof BaseExtendedAccidentAllOf
     */
    updated_at: number;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccidentAllOf
     */
    trip_id: string;
    /**
     * 
     * @type {string}
     * @memberof BaseExtendedAccidentAllOf
     */
    missing_trip_reason: string;
    /**
     * 
     * @type {number}
     * @memberof BaseExtendedAccidentAllOf
     */
    total_paid: number | null;
    /**
     * 
     * @type {number}
     * @memberof BaseExtendedAccidentAllOf
     */
    total_reserve: number | null;
    /**
     * 
     * @type {Array<ClaimData>}
     * @memberof BaseExtendedAccidentAllOf
     */
    claims: Array<ClaimData>;
}
/**
 * 
 * @export
 * @interface BaseLocationSample
 */
export interface BaseLocationSample {
    /**
     * 
     * @type {string}
     * @memberof BaseLocationSample
     */
    trip_id: string;
    /**
     * 
     * @type {number}
     * @memberof BaseLocationSample
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof BaseLocationSample
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof BaseLocationSample
     */
    longitude: number;
    /**
     * 
     * @type {number}
     * @memberof BaseLocationSample
     */
    speed: number;
    /**
     * 
     * @type {number}
     * @memberof BaseLocationSample
     */
    distance: number;
}
/**
 * 
 * @export
 * @interface Certification
 */
export interface Certification {
    /**
     * 
     * @type {boolean}
     * @memberof Certification
     */
    certify?: boolean;
}
/**
 * 
 * @export
 * @interface ChangeEmailRequest
 */
export interface ChangeEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailRequest
     */
    token: string;
}
/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    reset_token?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    password: string;
}
/**
 * 
 * @export
 * @interface ChangePermissionsRequest
 */
export interface ChangePermissionsRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangePermissionsRequest
     */
    message: string;
}
/**
 * 
 * @export
 * @interface CheckDeviceRequest
 */
export interface CheckDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckDeviceRequest
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDeviceRequest
     */
    customer_name: string;
    /**
     * 
     * @type {string}
     * @memberof CheckDeviceRequest
     */
    license_plate: string;
}
/**
 * 
 * @export
 * @interface Claim
 */
export interface Claim {
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    claim_number?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Claim
     */
    claim_occurred?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    insurance_company_status?: string;
}
/**
 * 
 * @export
 * @interface ClaimData
 */
export interface ClaimData {
    /**
     * 
     * @type {number}
     * @memberof ClaimData
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimData
     */
    insurer: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimData
     */
    claim_number: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimData
     */
    sub_claim_number: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimData
     */
    claim_type: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimData
     */
    loss_date: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimData
     */
    date_received: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimData
     */
    paid: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimData
     */
    reserve: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimData
     */
    expenses: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimData
     */
    salvage: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimData
     */
    recovery: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimData
     */
    total: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimData
     */
    claim_status: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimData
     */
    loss_run_date: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimData
     */
    period_id: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimData
     */
    accident_id: number;
}
/**
 * 
 * @export
 * @interface ClaimFileRequest
 */
export interface ClaimFileRequest {
    /**
     * 
     * @type {string}
     * @memberof ClaimFileRequest
     */
    file_name: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimFileRequest
     */
    loss_runs_date: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimFileRequest
     */
    period_id: number;
}
/**
 * 
 * @export
 * @interface CloneEventDetails
 */
export interface CloneEventDetails {
    /**
     * 
     * @type {string}
     * @memberof CloneEventDetails
     */
    level?: CloneEventDetailsLevelEnum;
    /**
     * 
     * @type {number}
     * @memberof CloneEventDetails
     */
    start_time?: number;
    /**
     * 
     * @type {number}
     * @memberof CloneEventDetails
     */
    end_time?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CloneEventDetails
     */
    blur_movie?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CloneEventDetails
     */
    comment?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CloneEventDetailsLevelEnum {
    Info = 'INFO',
    Warning = 'WARNING',
    Alert = 'ALERT'
}

/**
 * 
 * @export
 * @interface CoachAgendaItem
 */
export interface CoachAgendaItem {
    /**
     * 
     * @type {string}
     * @memberof CoachAgendaItem
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof CoachAgendaItem
     */
    id: number;
}
/**
 * 
 * @export
 * @interface CoachDriverResponse
 */
export interface CoachDriverResponse {
    /**
     * 
     * @type {number}
     * @memberof CoachDriverResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CoachDriverResponse
     */
    text: string;
    /**
     * 
     * @type {boolean}
     * @memberof CoachDriverResponse
     */
    is_required: boolean;
    /**
     * 
     * @type {number}
     * @memberof CoachDriverResponse
     */
    session_id: number;
}
/**
 * 
 * @export
 * @interface CoachEvent
 */
export interface CoachEvent {
    /**
     * 
     * @type {number}
     * @memberof CoachEvent
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CoachEvent
     */
    event: number;
    /**
     * 
     * @type {EventDetails}
     * @memberof CoachEvent
     */
    event_details: EventDetails;
    /**
     * 
     * @type {string}
     * @memberof CoachEvent
     */
    comment: string;
    /**
     * 
     * @type {boolean}
     * @memberof CoachEvent
     */
    completed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CoachEvent
     */
    is_accident?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CoachEvent
     */
    is_blurred: boolean;
}
/**
 * 
 * @export
 * @interface CoachEventDetails
 */
export interface CoachEventDetails {
    /**
     * 
     * @type {string}
     * @memberof CoachEventDetails
     */
    action?: CoachEventDetailsActionEnum;
    /**
     * 
     * @type {string}
     * @memberof CoachEventDetails
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CoachEventDetails
     */
    force_new?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CoachEventDetails
     */
    is_accident?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum CoachEventDetailsActionEnum {
    Add = 'ADD',
    Remove = 'REMOVE'
}

/**
 * 
 * @export
 * @interface CoachEventStatus
 */
export interface CoachEventStatus {
    /**
     * 
     * @type {Array<number>}
     * @memberof CoachEventStatus
     */
    event_id?: Array<number>;
}
/**
 * 
 * @export
 * @interface CoachManagerNotes
 */
export interface CoachManagerNotes {
    /**
     * 
     * @type {number}
     * @memberof CoachManagerNotes
     */
    id: number;
    /**
     * 
     * @type {Array<RichText | RichTextElement>}
     * @memberof CoachManagerNotes
     */
    text: Array<RichText | RichTextElement>;
    /**
     * 
     * @type {number}
     * @memberof CoachManagerNotes
     */
    session_id: number;
}
/**
 * 
 * @export
 * @interface CoachMediaFile
 */
export interface CoachMediaFile {
    /**
     * 
     * @type {number}
     * @memberof CoachMediaFile
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CoachMediaFile
     */
    title: string;
    /**
     * 
     * @type {MediaFile}
     * @memberof CoachMediaFile
     */
    file: MediaFile;
    /**
     * 
     * @type {string}
     * @memberof CoachMediaFile
     */
    file_url: string;
    /**
     * 
     * @type {number}
     * @memberof CoachMediaFile
     */
    session_id: number;
}
/**
 * 
 * @export
 * @interface CoachMediaFileRequest
 */
export interface CoachMediaFileRequest {
    /**
     * 
     * @type {string}
     * @memberof CoachMediaFileRequest
     */
    title: string;
    /**
     * 
     * @type {number}
     * @memberof CoachMediaFileRequest
     */
    media_file_id: number;
}
/**
 * 
 * @export
 * @interface CoachMetricByType
 */
export interface CoachMetricByType {
    /**
     * 
     * @type {CoachMetricData}
     * @memberof CoachMetricByType
     */
    safety: CoachMetricData;
}
/**
 * 
 * @export
 * @interface CoachMetricData
 */
export interface CoachMetricData {
    /**
     * 
     * @type {Array<CoachMetricDataPoint>}
     * @memberof CoachMetricData
     */
    current: Array<CoachMetricDataPoint>;
    /**
     * 
     * @type {Array<CoachMetricDataPoint>}
     * @memberof CoachMetricData
     */
    week: Array<CoachMetricDataPoint>;
    /**
     * 
     * @type {Array<CoachMetricDataPoint>}
     * @memberof CoachMetricData
     */
    month: Array<CoachMetricDataPoint>;
    /**
     * 
     * @type {Array<CoachMetricDataPoint>}
     * @memberof CoachMetricData
     */
    quarter: Array<CoachMetricDataPoint>;
}
/**
 * 
 * @export
 * @interface CoachMetricDataPoint
 */
export interface CoachMetricDataPoint {
    /**
     * 
     * @type {number}
     * @memberof CoachMetricDataPoint
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof CoachMetricDataPoint
     */
    score: number;
    /**
     * 
     * @type {string}
     * @memberof CoachMetricDataPoint
     */
    metadata: string;
    /**
     * 
     * @type {number}
     * @memberof CoachMetricDataPoint
     */
    sub_fleet_score: number;
    /**
     * 
     * @type {number}
     * @memberof CoachMetricDataPoint
     */
    fleet_score: number;
    /**
     * 
     * @type {string}
     * @memberof CoachMetricDataPoint
     */
    reason_for_no_score?: string;
}
/**
 * 
 * @export
 * @interface CoachMetrics
 */
export interface CoachMetrics {
    /**
     * 
     * @type {number}
     * @memberof CoachMetrics
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CoachMetrics
     */
    score_type: CoachMetricsScoreTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CoachMetrics
     */
    time_frame: CoachMetricsTimeFrameEnum;
    /**
     * 
     * @type {string}
     * @memberof CoachMetrics
     */
    additional_data: CoachMetricsAdditionalDataEnum;
    /**
     * 
     * @type {Array<CoachMetricDataPoint>}
     * @memberof CoachMetrics
     */
    metric_data: Array<CoachMetricDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof CoachMetrics
     */
    session_id: number;
}

/**
    * @export
    * @enum {string}
    */
export enum CoachMetricsScoreTypeEnum {
    Safety = 'safety',
    Wellness = 'wellness'
}
/**
    * @export
    * @enum {string}
    */
export enum CoachMetricsTimeFrameEnum {
    Current = 'current',
    Week = 'week',
    Month = 'month',
    Quarter = 'quarter'
}
/**
    * @export
    * @enum {string}
    */
export enum CoachMetricsAdditionalDataEnum {
    None = 'none',
    SubFleet = 'sub_fleet',
    Fleet = 'fleet'
}

/**
 * 
 * @export
 * @interface CoachMetricsRequest
 */
export interface CoachMetricsRequest {
    /**
     * 
     * @type {string}
     * @memberof CoachMetricsRequest
     */
    score_type?: string;
    /**
     * 
     * @type {string}
     * @memberof CoachMetricsRequest
     */
    time_frame?: string;
    /**
     * 
     * @type {string}
     * @memberof CoachMetricsRequest
     */
    additional_data?: string;
    /**
     * 
     * @type {Array<CoachMetricDataPoint>}
     * @memberof CoachMetricsRequest
     */
    metric_data?: Array<CoachMetricDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof CoachMetricsRequest
     */
    session_id?: number;
}
/**
 * 
 * @export
 * @interface CoachMetricsSaveRequest
 */
export interface CoachMetricsSaveRequest {
    /**
     * 
     * @type {string}
     * @memberof CoachMetricsSaveRequest
     */
    score_type?: string;
    /**
     * 
     * @type {string}
     * @memberof CoachMetricsSaveRequest
     */
    time_frame?: string;
    /**
     * 
     * @type {string}
     * @memberof CoachMetricsSaveRequest
     */
    additional_data?: string;
    /**
     * 
     * @type {Array<CoachMetricDataPoint>}
     * @memberof CoachMetricsSaveRequest
     */
    metric_data?: Array<CoachMetricDataPoint>;
    /**
     * 
     * @type {number}
     * @memberof CoachMetricsSaveRequest
     */
    driver_token?: number;
    /**
     * 
     * @type {string}
     * @memberof CoachMetricsSaveRequest
     */
    sub_fleet?: string;
}
/**
 * 
 * @export
 * @interface CoachSession
 */
export interface CoachSession {
    /**
     * 
     * @type {number}
     * @memberof CoachSession
     */
    session_id: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CoachSession
     */
    users: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CoachSession
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof CoachSession
     */
    driver_name: string;
    /**
     * 
     * @type {string}
     * @memberof CoachSession
     */
    sub_fleet_name: string;
    /**
     * 
     * @type {number}
     * @memberof CoachSession
     */
    created_at: number;
    /**
     * 
     * @type {number}
     * @memberof CoachSession
     */
    completed_at: number;
    /**
     * 
     * @type {number}
     * @memberof CoachSession
     */
    last_updated: number;
    /**
     * 
     * @type {number}
     * @memberof CoachSession
     */
    last_sent: number | null;
    /**
     * 
     * @type {string}
     * @memberof CoachSession
     */
    last_delivery_status: string | null;
    /**
     * 
     * @type {Array<CoachAgendaItem>}
     * @memberof CoachSession
     */
    agenda: Array<CoachAgendaItem>;
    /**
     * 
     * @type {boolean}
     * @memberof CoachSession
     */
    auto_generated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CoachSession
     */
    is_saved: boolean;
    /**
     * 
     * @type {number}
     * @memberof CoachSession
     */
    last_completed_session: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoachSession
     */
    driver_score: number | null;
    /**
     * 
     * @type {number}
     * @memberof CoachSession
     */
    assignee: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CoachSession
     */
    behaviors: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CoachSession
     */
    completion_method: string | null;
    /**
     * 
     * @type {string}
     * @memberof CoachSession
     */
    manager_conclusion: string;
    /**
     * 
     * @type {string}
     * @memberof CoachSession
     */
    driver_conclusion: string;
    /**
     * 
     * @type {Array<CoachEvent>}
     * @memberof CoachSession
     */
    events: Array<CoachEvent>;
    /**
     * 
     * @type {Array<CoachManagerNotes>}
     * @memberof CoachSession
     */
    notes: Array<CoachManagerNotes>;
    /**
     * 
     * @type {Array<CoachDriverResponse>}
     * @memberof CoachSession
     */
    response: Array<CoachDriverResponse>;
    /**
     * 
     * @type {Array<CoachMetrics>}
     * @memberof CoachSession
     */
    metrics: Array<CoachMetrics>;
    /**
     * 
     * @type {Array<CoachMediaFile>}
     * @memberof CoachSession
     */
    media_files: Array<CoachMediaFile>;
    /**
     * 
     * @type {Array<CoachWellnessStatus>}
     * @memberof CoachSession
     */
    wellness_statuses: Array<CoachWellnessStatus>;
    /**
     * 
     * @type {Array<CoachingMetadata>}
     * @memberof CoachSession
     */
    metadata: Array<CoachingMetadata>;
    /**
     * 
     * @type {FleetDriver}
     * @memberof CoachSession
     */
    driver: FleetDriver | null;
}
/**
 * 
 * @export
 * @interface CoachSessionAllOf
 */
export interface CoachSessionAllOf {
    /**
     * 
     * @type {string}
     * @memberof CoachSessionAllOf
     */
    manager_conclusion: string;
    /**
     * 
     * @type {string}
     * @memberof CoachSessionAllOf
     */
    driver_conclusion: string;
    /**
     * 
     * @type {Array<CoachEvent>}
     * @memberof CoachSessionAllOf
     */
    events: Array<CoachEvent>;
    /**
     * 
     * @type {Array<CoachManagerNotes>}
     * @memberof CoachSessionAllOf
     */
    notes: Array<CoachManagerNotes>;
    /**
     * 
     * @type {Array<CoachDriverResponse>}
     * @memberof CoachSessionAllOf
     */
    response: Array<CoachDriverResponse>;
    /**
     * 
     * @type {Array<CoachMetrics>}
     * @memberof CoachSessionAllOf
     */
    metrics: Array<CoachMetrics>;
    /**
     * 
     * @type {Array<CoachMediaFile>}
     * @memberof CoachSessionAllOf
     */
    media_files: Array<CoachMediaFile>;
    /**
     * 
     * @type {Array<CoachWellnessStatus>}
     * @memberof CoachSessionAllOf
     */
    wellness_statuses: Array<CoachWellnessStatus>;
    /**
     * 
     * @type {Array<CoachAgendaItem>}
     * @memberof CoachSessionAllOf
     */
    agenda: Array<CoachAgendaItem>;
    /**
     * 
     * @type {Array<CoachingMetadata>}
     * @memberof CoachSessionAllOf
     */
    metadata: Array<CoachingMetadata>;
    /**
     * 
     * @type {FleetDriver}
     * @memberof CoachSessionAllOf
     */
    driver: FleetDriver | null;
}
/**
 * 
 * @export
 * @interface CoachSessionMessage
 */
export interface CoachSessionMessage {
    /**
     * 
     * @type {number}
     * @memberof CoachSessionMessage
     */
    session_id: number;
    /**
     * 
     * @type {string}
     * @memberof CoachSessionMessage
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof CoachSessionMessage
     */
    message: string;
}
/**
 * 
 * @export
 * @interface CoachSessionMessageRequest
 */
export interface CoachSessionMessageRequest {
    /**
     * 
     * @type {Array<CoachSessionMessage>}
     * @memberof CoachSessionMessageRequest
     */
    drivers: Array<CoachSessionMessage>;
    /**
     * 
     * @type {boolean}
     * @memberof CoachSessionMessageRequest
     */
    is_blurred?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CoachSessionMessageRequest
     */
    assignee?: number | null;
}
/**
 * 
 * @export
 * @interface CoachSessionMessageResponse
 */
export interface CoachSessionMessageResponse {
    /**
     * 
     * @type {Array<CoachingMessageStatus>}
     * @memberof CoachSessionMessageResponse
     */
    results: Array<CoachingMessageStatus>;
}
/**
 * 
 * @export
 * @interface CoachSessionMetadata
 */
export interface CoachSessionMetadata {
    /**
     * 
     * @type {number}
     * @memberof CoachSessionMetadata
     */
    coach_event_id: number;
}
/**
 * 
 * @export
 * @interface CoachSessionToken
 */
export interface CoachSessionToken {
    /**
     * 
     * @type {string}
     * @memberof CoachSessionToken
     */
    token: string;
}
/**
 * 
 * @export
 * @interface CoachWellnessDetails
 */
export interface CoachWellnessDetails {
    /**
     * 
     * @type {string}
     * @memberof CoachWellnessDetails
     */
    action?: CoachWellnessDetailsActionEnum;
    /**
     * 
     * @type {string}
     * @memberof CoachWellnessDetails
     */
    comment?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CoachWellnessDetailsActionEnum {
    Add = 'ADD',
    Remove = 'REMOVE'
}

/**
 * 
 * @export
 * @interface CoachWellnessStatus
 */
export interface CoachWellnessStatus {
    /**
     * 
     * @type {number}
     * @memberof CoachWellnessStatus
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CoachWellnessStatus
     */
    session_id: number;
    /**
     * 
     * @type {InCabinWellnessV1}
     * @memberof CoachWellnessStatus
     */
    in_cabin_wellness_status?: InCabinWellnessV1 | null;
    /**
     * 
     * @type {FrontFacingWellness}
     * @memberof CoachWellnessStatus
     */
    front_facing_wellness_status?: FrontFacingWellness;
    /**
     * 
     * @type {string}
     * @memberof CoachWellnessStatus
     */
    comment: string;
    /**
     * 
     * @type {string}
     * @memberof CoachWellnessStatus
     */
    image_url: string | null;
}
/**
 * 
 * @export
 * @interface CoachingMessageStatus
 */
export interface CoachingMessageStatus {
    /**
     * 
     * @type {number}
     * @memberof CoachingMessageStatus
     */
    session_id: number;
    /**
     * 
     * @type {string}
     * @memberof CoachingMessageStatus
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof CoachingMessageStatus
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface CoachingMetadata
 */
export interface CoachingMetadata {
    /**
     * 
     * @type {number}
     * @memberof CoachingMetadata
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CoachingMetadata
     */
    session_id: number;
    /**
     * 
     * @type {number}
     * @memberof CoachingMetadata
     */
    timestamp: number;
    /**
     * 
     * @type {CoachingMetadataMetadata}
     * @memberof CoachingMetadata
     */
    metadata: CoachingMetadataMetadata;
}
/**
 * 
 * @export
 * @interface CoachingMetadataMetadata
 */
export interface CoachingMetadataMetadata {
    /**
     * 
     * @type {string}
     * @memberof CoachingMetadataMetadata
     */
    action: CoachingMetadataMetadataActionEnum;
    /**
     * 
     * @type {string}
     * @memberof CoachingMetadataMetadata
     */
    method?: CoachingMetadataMetadataMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof CoachingMetadataMetadata
     */
    manager_id?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CoachingMetadataMetadata
     */
    narratives?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CoachingMetadataMetadata
     */
    driver_score?: number;
    /**
     * 
     * @type {number}
     * @memberof CoachingMetadataMetadata
     */
    last_completed_session?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CoachingMetadataMetadata
     */
    coach_event_ids?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CoachingMetadataMetadata
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof CoachingMetadataMetadata
     */
    status?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CoachingMetadataMetadataActionEnum {
    Create = 'create',
    Send = 'send',
    Open = 'open',
    Complete = 'complete',
    Generate = 'generate',
    Watch = 'watch'
}
/**
    * @export
    * @enum {string}
    */
export enum CoachingMetadataMetadataMethodEnum {
    Onsite = 'onsite',
    Remote = 'remote'
}

/**
 * 
 * @export
 * @interface CoachingMetadataResponse
 */
export interface CoachingMetadataResponse {
    /**
     * 
     * @type {CoachingMetadata}
     * @memberof CoachingMetadataResponse
     */
    metadata: CoachingMetadata;
}
/**
 * 
 * @export
 * @interface CoachingOverview
 */
export interface CoachingOverview {
    /**
     * 
     * @type {number}
     * @memberof CoachingOverview
     */
    timestamp?: number;
    /**
     * 
     * @type {string}
     * @memberof CoachingOverview
     */
    customer?: string;
    /**
     * 
     * @type {string}
     * @memberof CoachingOverview
     */
    sub_fleet?: string;
    /**
     * 
     * @type {CoachingOverviewSessionsData}
     * @memberof CoachingOverview
     */
    sessions_data: CoachingOverviewSessionsData;
    /**
     * 
     * @type {Array<CoachingOverviewSafetyScoreSet>}
     * @memberof CoachingOverview
     */
    effectiveness_data: Array<CoachingOverviewSafetyScoreSet>;
}
/**
 * 
 * @export
 * @interface CoachingOverviewDataSet
 */
export interface CoachingOverviewDataSet {
    /**
     * 
     * @type {number}
     * @memberof CoachingOverviewDataSet
     */
    created_manual: number;
    /**
     * 
     * @type {number}
     * @memberof CoachingOverviewDataSet
     */
    created_auto: number;
    /**
     * 
     * @type {number}
     * @memberof CoachingOverviewDataSet
     */
    completed_office: number;
    /**
     * 
     * @type {number}
     * @memberof CoachingOverviewDataSet
     */
    completed_remote: number;
    /**
     * 
     * @type {Array<TopAssignee>}
     * @memberof CoachingOverviewDataSet
     */
    top_assignees: Array<TopAssignee>;
}
/**
 * 
 * @export
 * @interface CoachingOverviewSafetyScoreSet
 */
export interface CoachingOverviewSafetyScoreSet {
    /**
     * 
     * @type {string}
     * @memberof CoachingOverviewSafetyScoreSet
     */
    driver_name: string;
    /**
     * 
     * @type {number}
     * @memberof CoachingOverviewSafetyScoreSet
     */
    session_id: number;
    /**
     * 
     * @type {SafetyScore}
     * @memberof CoachingOverviewSafetyScoreSet
     */
    on_completion?: SafetyScore;
    /**
     * 
     * @type {SafetyScore}
     * @memberof CoachingOverviewSafetyScoreSet
     */
    two_weeks?: SafetyScore;
    /**
     * 
     * @type {SafetyScore}
     * @memberof CoachingOverviewSafetyScoreSet
     */
    one_month?: SafetyScore;
    /**
     * 
     * @type {SafetyScore}
     * @memberof CoachingOverviewSafetyScoreSet
     */
    three_months?: SafetyScore;
}
/**
 * 
 * @export
 * @interface CoachingOverviewSessionsData
 */
export interface CoachingOverviewSessionsData {
    /**
     * 
     * @type {CoachingOverviewDataSet}
     * @memberof CoachingOverviewSessionsData
     */
    one_month: CoachingOverviewDataSet;
    /**
     * 
     * @type {CoachingOverviewDataSet}
     * @memberof CoachingOverviewSessionsData
     */
    three_months: CoachingOverviewDataSet;
}
/**
 * 
 * @export
 * @interface Command
 */
export interface Command {
    /**
     * 
     * @type {string}
     * @memberof Command
     */
    device_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Command
     */
    start_time?: string;
    /**
     * 
     * @type {string}
     * @memberof Command
     */
    end_time?: string;
    /**
     * 
     * @type {number}
     * @memberof Command
     */
    accident_id?: number;
}
/**
 * 
 * @export
 * @interface CommandData
 */
export interface CommandData {
    /**
     * 
     * @type {number}
     * @memberof CommandData
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CommandData
     */
    user_id: number;
    /**
     * 
     * @type {Device}
     * @memberof CommandData
     */
    device: Device;
    /**
     * 
     * @type {string}
     * @memberof CommandData
     */
    command: string;
    /**
     * 
     * @type {string}
     * @memberof CommandData
     */
    data: string;
    /**
     * 
     * @type {string}
     * @memberof CommandData
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof CommandData
     */
    result: string;
    /**
     * 
     * @type {BackendResult}
     * @memberof CommandData
     */
    backend_result: BackendResult;
    /**
     * 
     * @type {number}
     * @memberof CommandData
     */
    created_at: number;
    /**
     * 
     * @type {number}
     * @memberof CommandData
     */
    done_at: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommandData
     */
    accident_id: number | null;
}
/**
 * 
 * @export
 * @interface Comment
 */
export interface Comment {
    /**
     * 
     * @type {number}
     * @memberof Comment
     */
    created_time: number;
    /**
     * 
     * @type {number}
     * @memberof Comment
     */
    comment_id: number;
    /**
     * 
     * @type {number}
     * @memberof Comment
     */
    accident_id: number;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    user: string;
    /**
     * 
     * @type {Array<RichText | RichTextElement>}
     * @memberof Comment
     */
    text: Array<RichText | RichTextElement>;
}
/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    phone_number: string;
    /**
     * 
     * @type {boolean}
     * @memberof Contact
     */
    contact_made: boolean;
}
/**
 * 
 * @export
 * @interface CustomerConfig
 */
export interface CustomerConfig {
    /**
     * 
     * @type {number}
     * @memberof CustomerConfig
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerConfig
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerConfig
     */
    sub_fleet: string;
    /**
     * 
     * @type {number}
     * @memberof CustomerConfig
     */
    timestamp?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CustomerConfig
     */
    overlays: Array<number>;
}
/**
 * 
 * @export
 * @interface CustomerData
 */
export interface CustomerData {
    /**
     * 
     * @type {string}
     * @memberof CustomerData
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerData
     */
    display_name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerData
     */
    contact_mail: string;
    /**
     * 
     * @type {CustomerDataSettings}
     * @memberof CustomerData
     */
    settings: CustomerDataSettings;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomerData
     */
    sub_fleets: Array<string>;
}
/**
 * 
 * @export
 * @interface CustomerData1
 */
export interface CustomerData1 {
    /**
     * 
     * @type {Array<CustomerHandlingStatus>}
     * @memberof CustomerData1
     */
    handling_status: Array<CustomerHandlingStatus>;
}
/**
 * 
 * @export
 * @interface CustomerDataSettings
 */
export interface CustomerDataSettings {
    /**
     * 
     * @type {string}
     * @memberof CustomerDataSettings
     */
    default_currency: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerDataSettings
     */
    default_locale: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerDataSettings
     */
    use_imperial_units: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerDataSettings
     */
    inactive_device_threshold: number;
    /**
     * 
     * @type {string}
     * @memberof CustomerDataSettings
     */
    country: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerDataSettings
     */
    use_auto_logout: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerDataSettings
     */
    auto_logout_after_minutes: number | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerDataSettings
     */
    driving_type: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerDataSettings
     */
    use_qr_identification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerDataSettings
     */
    use_speeding_policy: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerDataSettings
     */
    speeding_policy_threshold: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerDataSettings
     */
    otp_enforced: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerDataSettings
     */
    default_lng: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerDataSettings
     */
    default_lat: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerDataSettings
     */
    deactivate_users_after_days: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerDataSettings
     */
    lock_user_after_failed_attempts: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerDataSettings
     */
    default_malfunction_assignee: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerDataSettings
     */
    remind_driver_to_complete_session: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerDataSettings
     */
    remind_driver_after_days: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerDataSettings
     */
    driver_reminder_limit: number | null;
}
/**
 * 
 * @export
 * @interface CustomerHandlingStatus
 */
export interface CustomerHandlingStatus {
    /**
     * 
     * @type {string}
     * @memberof CustomerHandlingStatus
     */
    name: string;
}
/**
 * 
 * @export
 * @interface CustomerSettingsRequest
 */
export interface CustomerSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof CustomerSettingsRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerSettingsRequest
     */
    logo: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerSettingsRequest
     */
    use_speeding_policy: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerSettingsRequest
     */
    speeding_policy_threshold: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerSettingsRequest
     */
    otp_enforced: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerSettingsRequest
     */
    use_auto_logout: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerSettingsRequest
     */
    auto_logout_after_minutes: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerSettingsRequest
     */
    default_lng: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerSettingsRequest
     */
    default_lat: number;
    /**
     * 
     * @type {number}
     * @memberof CustomerSettingsRequest
     */
    deactivate_users_after_days: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerSettingsRequest
     */
    lock_user_after_failed_attempts: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerSettingsRequest
     */
    default_malfunction_assignee: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerSettingsRequest
     */
    remind_driver_to_complete_session: boolean;
    /**
     * 
     * @type {number}
     * @memberof CustomerSettingsRequest
     */
    remind_driver_after_days: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomerSettingsRequest
     */
    driver_reminder_limit: number | null;
}
/**
 * 
 * @export
 * @interface CustomerSubFleetData
 */
export interface CustomerSubFleetData {
    /**
     * 
     * @type {string}
     * @memberof CustomerSubFleetData
     */
    sub_fleet_name?: string;
}
/**
 * 
 * @export
 * @interface CustomerUserDetails
 */
export interface CustomerUserDetails {
    /**
     * 
     * @type {number}
     * @memberof CustomerUserDetails
     */
    user_id: number;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerUserDetails
     */
    admin: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserDetails
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserDetails
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserDetails
     */
    sub_fleet: string;
    /**
     * 
     * @type {UserRole}
     * @memberof CustomerUserDetails
     */
    role: UserRole;
    /**
     * 
     * @type {string}
     * @memberof CustomerUserDetails
     */
    image_url: string | null;
}
/**
 * 
 * @export
 * @interface Damage
 */
export interface Damage {
    /**
     * 
     * @type {number}
     * @memberof Damage
     */
    accident_id: number;
    /**
     * 
     * @type {number}
     * @memberof Damage
     */
    damage_id: number;
    /**
     * 
     * @type {string}
     * @memberof Damage
     */
    vehicle_owner: string;
    /**
     * 
     * @type {Vehicle}
     * @memberof Damage
     */
    vehicle: Vehicle;
    /**
     * 
     * @type {Array<Payment>}
     * @memberof Damage
     */
    payment_list: Array<Payment>;
    /**
     * 
     * @type {string}
     * @memberof Damage
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof Damage
     */
    garage: string | null;
    /**
     * 
     * @type {string}
     * @memberof Damage
     */
    category: string;
    /**
     * 
     * @type {Appraiser}
     * @memberof Damage
     */
    appraiser: Appraiser;
    /**
     * 
     * @type {Claim}
     * @memberof Damage
     */
    claim: Claim;
    /**
     * 
     * @type {Scheme}
     * @memberof Damage
     */
    scheme: Scheme | null;
    /**
     * 
     * @type {string}
     * @memberof Damage
     */
    insurance_company: string | null;
    /**
     * 
     * @type {string}
     * @memberof Damage
     */
    policy_number: string;
}
/**
 * 
 * @export
 * @interface Device
 */
export interface Device {
    /**
     * IMEI
     * @type {string}
     * @memberof Device
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    operator: string;
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    customer_sub_fleet: string;
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof Device
     */
    driver_name: string;
    /**
     * 
     * @type {number}
     * @memberof Device
     */
    default_driver?: number | null;
    /**
     * 
     * @type {EldDeviceDetails}
     * @memberof Device
     */
    eld_device_details?: EldDeviceDetails | null;
}
/**
 * 
 * @export
 * @interface DeviceConfigStatus
 */
export interface DeviceConfigStatus {
    /**
     * 
     * @type {string}
     * @memberof DeviceConfigStatus
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfigStatus
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfigStatus
     */
    operator: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceConfigStatus
     */
    package_id: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfigStatus
     */
    package_name: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceConfigStatus
     */
    overlay_id: number | null;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfigStatus
     */
    overlay_name: string | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceConfigStatus
     */
    experiment_id: number | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceConfigStatus
     */
    updated_at: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceConfigStatus
     */
    status: DeviceConfigStatusStatusEnum;
    /**
     * 
     * @type {object}
     * @memberof DeviceConfigStatus
     */
    vsc: object | null;
}

/**
    * @export
    * @enum {string}
    */
export enum DeviceConfigStatusStatusEnum {
    Created = 'CREATED',
    Pending = 'PENDING',
    Downloaded = 'DOWNLOADED',
    Aligned = 'ALIGNED',
    NoOverlay = 'NO_OVERLAY',
    AlignedObsolete = 'ALIGNED_OBSOLETE'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum DeviceHardware {
    ReachengR1 = 'Reacheng_R1',
    MitacK220 = 'Mitac_K220',
    MitacSprint = 'Mitac_Sprint'
}

/**
 * 
 * @export
 * @interface DeviceList
 */
export interface DeviceList {
    /**
     * 
     * @type {number}
     * @memberof DeviceList
     */
    timestamp: number;
    /**
     * 
     * @type {Array<DeviceV3>}
     * @memberof DeviceList
     */
    data: Array<DeviceV3>;
}
/**
 * 
 * @export
 * @interface DeviceLocation
 */
export interface DeviceLocation {
    /**
     * 
     * @type {string}
     * @memberof DeviceLocation
     */
    device_id?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceLocation
     */
    timestamp?: number;
    /**
     * 
     * @type {DeviceLocationLocationSample}
     * @memberof DeviceLocation
     */
    location_sample?: DeviceLocationLocationSample | null;
}
/**
 * 
 * @export
 * @interface DeviceLocationLocationSample
 */
export interface DeviceLocationLocationSample {
    /**
     * 
     * @type {Device}
     * @memberof DeviceLocationLocationSample
     */
    device?: Device;
    /**
     * 
     * @type {string}
     * @memberof DeviceLocationLocationSample
     */
    trip_id?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceLocationLocationSample
     */
    timestamp?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceLocationLocationSample
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceLocationLocationSample
     */
    longitude?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceLocationLocationSample
     */
    speed?: number;
    /**
     * 
     * @type {number}
     * @memberof DeviceLocationLocationSample
     */
    distance?: number;
}
/**
 * 
 * @export
 * @interface DeviceOperationData
 */
export interface DeviceOperationData {
    /**
     * 
     * @type {string}
     * @memberof DeviceOperationData
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceOperationData
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceOperationData
     */
    status: string;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceOperationData
     */
    active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DeviceOperationData
     */
    timestamp?: number;
}
/**
 * 
 * @export
 * @interface DeviceRequest
 */
export interface DeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof DeviceRequest
     */
    device_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceRequest
     */
    customer?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceRequest
     */
    customer_sub_fleet?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceRequest
     */
    license_plate?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceRequest
     */
    driver_name?: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceRequest
     */
    default_driver?: number | null;
}
/**
 * 
 * @export
 * @interface DeviceV2
 */
export interface DeviceV2 {
    /**
     * 
     * @type {Device}
     * @memberof DeviceV2
     */
    device: Device;
    /**
     * 
     * @type {string}
     * @memberof DeviceV2
     */
    sim_number?: string;
    /**
     * Device version
     * @type {string}
     * @memberof DeviceV2
     */
    version_name: string;
    /**
     * Last update
     * @type {string}
     * @memberof DeviceV2
     */
    last_config?: string | null;
    /**
     * 
     * @type {DeviceV2AggregatedWellness}
     * @memberof DeviceV2
     */
    aggregated_wellness?: DeviceV2AggregatedWellness;
    /**
     * 
     * @type {number}
     * @memberof DeviceV2
     */
    last_seen?: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceV2
     */
    location?: string;
    /**
     * 
     * @type {EldDeviceDetails}
     * @memberof DeviceV2
     */
    eld_device_details?: EldDeviceDetails | null;
}
/**
 * 
 * @export
 * @interface DeviceV2AggregatedWellness
 */
export interface DeviceV2AggregatedWellness {
    /**
     * 
     * @type {InCabinWellness | InCabinWellnessV1}
     * @memberof DeviceV2AggregatedWellness
     */
    in_cabin_wellness?: InCabinWellness | InCabinWellnessV1;
    /**
     * 
     * @type {DeviceV2AggregatedWellnessFrontFacingWellness}
     * @memberof DeviceV2AggregatedWellness
     */
    front_facing_wellness?: DeviceV2AggregatedWellnessFrontFacingWellness | null;
    /**
     * 
     * @type {DeviceV2AggregatedWellnessObdState}
     * @memberof DeviceV2AggregatedWellness
     */
    obd_state?: DeviceV2AggregatedWellnessObdState | null;
    /**
     * 
     * @type {DeviceV2AggregatedWellnessDeviceWellness}
     * @memberof DeviceV2AggregatedWellness
     */
    device_wellness?: DeviceV2AggregatedWellnessDeviceWellness | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeviceV2AggregatedWellness
     */
    statuses?: Array<string>;
}
/**
 * 
 * @export
 * @interface DeviceV2AggregatedWellnessDeviceWellness
 */
export interface DeviceV2AggregatedWellnessDeviceWellness {
    /**
     * 
     * @type {number}
     * @memberof DeviceV2AggregatedWellnessDeviceWellness
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceV2AggregatedWellnessDeviceWellness
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceV2AggregatedWellnessDeviceWellness
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceV2AggregatedWellnessDeviceWellness
     */
    timestamp: number;
}
/**
 * 
 * @export
 * @interface DeviceV2AggregatedWellnessFrontFacingWellness
 */
export interface DeviceV2AggregatedWellnessFrontFacingWellness {
    /**
     * 
     * @type {number}
     * @memberof DeviceV2AggregatedWellnessFrontFacingWellness
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceV2AggregatedWellnessFrontFacingWellness
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceV2AggregatedWellnessFrontFacingWellness
     */
    wellness_state: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceV2AggregatedWellnessFrontFacingWellness
     */
    timestamp: number;
}
/**
 * 
 * @export
 * @interface DeviceV2AggregatedWellnessObdState
 */
export interface DeviceV2AggregatedWellnessObdState {
    /**
     * 
     * @type {number}
     * @memberof DeviceV2AggregatedWellnessObdState
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceV2AggregatedWellnessObdState
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceV2AggregatedWellnessObdState
     */
    obd_state: string;
    /**
     * 
     * @type {number}
     * @memberof DeviceV2AggregatedWellnessObdState
     */
    timestamp: number;
}
/**
 * 
 * @export
 * @interface DeviceV3
 */
export interface DeviceV3 {
    /**
     * 
     * @type {Device}
     * @memberof DeviceV3
     */
    device: Device;
    /**
     * 
     * @type {string}
     * @memberof DeviceV3
     */
    sim_number?: string;
    /**
     * Device version
     * @type {string}
     * @memberof DeviceV3
     */
    version_name: string;
    /**
     * Last update
     * @type {string}
     * @memberof DeviceV3
     */
    last_config?: string | null;
    /**
     * 
     * @type {DeviceV2AggregatedWellness}
     * @memberof DeviceV3
     */
    aggregated_wellness?: DeviceV2AggregatedWellness;
    /**
     * 
     * @type {number}
     * @memberof DeviceV3
     */
    last_seen?: number;
    /**
     * 
     * @type {string}
     * @memberof DeviceV3
     */
    location?: string;
    /**
     * 
     * @type {EldDeviceDetails}
     * @memberof DeviceV3
     */
    eld_device_details?: EldDeviceDetails | null;
    /**
     * 
     * @type {number}
     * @memberof DeviceV3
     */
    pk?: number;
    /**
     * 
     * @type {TripDetails}
     * @memberof DeviceV3
     */
    current_trip?: TripDetails;
}
/**
 * 
 * @export
 * @interface DeviceV3AllOf
 */
export interface DeviceV3AllOf {
    /**
     * 
     * @type {number}
     * @memberof DeviceV3AllOf
     */
    pk?: number;
    /**
     * 
     * @type {TripDetails}
     * @memberof DeviceV3AllOf
     */
    current_trip?: TripDetails;
}
/**
 * 
 * @export
 * @interface DisposalLetterRequest
 */
export interface DisposalLetterRequest {
    /**
     * 
     * @type {string}
     * @memberof DisposalLetterRequest
     */
    payment?: string;
}
/**
 * 
 * @export
 * @interface DownloadVideoEventRequest
 */
export interface DownloadVideoEventRequest {
    /**
     * 
     * @type {boolean}
     * @memberof DownloadVideoEventRequest
     */
    picture_in_picture: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DownloadVideoEventRequest
     */
    is_in_cabin_primary: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DownloadVideoEventRequest
     */
    add_overlay: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DownloadVideoEventRequest
     */
    unblur: boolean;
}
/**
 * 
 * @export
 * @interface Driver
 */
export interface Driver {
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    driver_name: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    id_number: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    date_of_birth: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    license_type: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    license_number: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    license_issuing_state: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    license_issue_date: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    license_expiration: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    vehicle_owner: string;
    /**
     * 
     * @type {string}
     * @memberof Driver
     */
    signature: string;
}
/**
 * 
 * @export
 * @interface DriverBadgeRequest
 */
export interface DriverBadgeRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof DriverBadgeRequest
     */
    driver_tokens?: Array<number>;
}
/**
 * 
 * @export
 * @interface DriverForm
 */
export interface DriverForm {
    /**
     * 
     * @type {string}
     * @memberof DriverForm
     */
    customer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverForm
     */
    license_plate?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverForm
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverForm
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverForm
     */
    driver_name?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverForm
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverForm
     */
    at_fault?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverForm
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof DriverForm
     */
    signature?: string;
    /**
     * 
     * @type {Driver}
     * @memberof DriverForm
     */
    driver?: Driver | null;
    /**
     * 
     * @type {Array<Damage>}
     * @memberof DriverForm
     */
    damages?: Array<Damage>;
    /**
     * 
     * @type {Array<Witness>}
     * @memberof DriverForm
     */
    witnesses?: Array<Witness>;
}
/**
 * 
 * @export
 * @interface DriverFormReview
 */
export interface DriverFormReview {
    /**
     * 
     * @type {string}
     * @memberof DriverFormReview
     */
    driver_name?: string;
    /**
     * 
     * @type {number}
     * @memberof DriverFormReview
     */
    score?: number;
}
/**
 * 
 * @export
 * @interface DriverResponseRequest
 */
export interface DriverResponseRequest {
    /**
     * 
     * @type {boolean}
     * @memberof DriverResponseRequest
     */
    is_required: boolean;
    /**
     * 
     * @type {string}
     * @memberof DriverResponseRequest
     */
    text: string;
}
/**
 * 
 * @export
 * @interface DriverScore
 */
export interface DriverScore {
    /**
     * 
     * @type {number}
     * @memberof DriverScore
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof DriverScore
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof DriverScore
     */
    event_types: string;
    /**
     * 
     * @type {EventDetails}
     * @memberof DriverScore
     */
    most_recent_event: EventDetails | null;
    /**
     * 
     * @type {number}
     * @memberof DriverScore
     */
    score: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DriverScore
     */
    event_ids?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DriverScore
     */
    accident_event_ids?: Array<number>;
    /**
     * 
     * @type {Array<EventDetails>}
     * @memberof DriverScore
     */
    events?: Array<EventDetails>;
    /**
     * 
     * @type {Array<EventDetails>}
     * @memberof DriverScore
     */
    accident_events?: Array<EventDetails>;
    /**
     * 
     * @type {string}
     * @memberof DriverScore
     */
    metadata?: string;
    /**
     * 
     * @type {number}
     * @memberof DriverScore
     */
    auto_coaching_session_id?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverScore
     */
    inactive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverScore
     */
    unknown?: boolean;
    /**
     * 
     * @type {FleetDriver}
     * @memberof DriverScore
     */
    driver: FleetDriver;
}
/**
 * 
 * @export
 * @interface DriverScoreDetails
 */
export interface DriverScoreDetails {
    /**
     * 
     * @type {number}
     * @memberof DriverScoreDetails
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof DriverScoreDetails
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof DriverScoreDetails
     */
    event_types: string;
    /**
     * 
     * @type {EventDetails}
     * @memberof DriverScoreDetails
     */
    most_recent_event: EventDetails | null;
    /**
     * 
     * @type {number}
     * @memberof DriverScoreDetails
     */
    score: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof DriverScoreDetails
     */
    event_ids?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DriverScoreDetails
     */
    accident_event_ids?: Array<number>;
    /**
     * 
     * @type {Array<EventDetails>}
     * @memberof DriverScoreDetails
     */
    events?: Array<EventDetails>;
    /**
     * 
     * @type {Array<EventDetails>}
     * @memberof DriverScoreDetails
     */
    accident_events?: Array<EventDetails>;
    /**
     * 
     * @type {string}
     * @memberof DriverScoreDetails
     */
    metadata?: string;
    /**
     * 
     * @type {number}
     * @memberof DriverScoreDetails
     */
    auto_coaching_session_id?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DriverScoreDetails
     */
    inactive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DriverScoreDetails
     */
    unknown?: boolean;
    /**
     * 
     * @type {FleetDriver}
     * @memberof DriverScoreDetails
     */
    driver: FleetDriver;
}
/**
 * 
 * @export
 * @interface DriverScoreDetailsAllOf
 */
export interface DriverScoreDetailsAllOf {
    /**
     * 
     * @type {FleetDriver}
     * @memberof DriverScoreDetailsAllOf
     */
    driver: FleetDriver;
}
/**
 * 
 * @export
 * @interface EldDeviceDetails
 */
export interface EldDeviceDetails {
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDetails
     */
    cmv_power_unit_number: string;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDetails
     */
    trailer_number: string;
    /**
     * 
     * @type {string}
     * @memberof EldDeviceDetails
     */
    shipping_document_number: string;
}
/**
 * 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    event_id: number;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    level: string;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    severity: number;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    trip_id: string;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    timestamp: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Event
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Event
     */
    artifacts?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    route: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    additional_info: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    location: string;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    speed: number | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    detector_version: string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    event_description: string;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    start_frame_id: number;
    /**
     * 
     * @type {TripDetails}
     * @memberof Event
     */
    trip?: TripDetails;
    /**
     * 
     * @type {Device}
     * @memberof Event
     */
    device: Device;
}
/**
 * 
 * @export
 * @interface EventCount
 */
export interface EventCount {
    /**
     * 
     * @type {string}
     * @memberof EventCount
     */
    event_type: string;
    /**
     * 
     * @type {number}
     * @memberof EventCount
     */
    count: number;
}
/**
 * 
 * @export
 * @interface EventDetails
 */
export interface EventDetails {
    /**
     * 
     * @type {number}
     * @memberof EventDetails
     */
    event_id: number;
    /**
     * 
     * @type {Device}
     * @memberof EventDetails
     */
    device: Device;
    /**
     * 
     * @type {string}
     * @memberof EventDetails
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof EventDetails
     */
    level: string;
    /**
     * 
     * @type {number}
     * @memberof EventDetails
     */
    severity: number;
    /**
     * 
     * @type {string}
     * @memberof EventDetails
     */
    trip_id: string;
    /**
     * 
     * @type {number}
     * @memberof EventDetails
     */
    timestamp: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof EventDetails
     */
    tags: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof EventDetails
     */
    artifact_path: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof EventDetails
     */
    route?: string;
    /**
     * 
     * @type {string}
     * @memberof EventDetails
     */
    additional_info?: string;
    /**
     * 
     * @type {string}
     * @memberof EventDetails
     */
    location?: string;
    /**
     * 
     * @type {number}
     * @memberof EventDetails
     */
    speed: number | null;
    /**
     * 
     * @type {string}
     * @memberof EventDetails
     */
    detector_version?: string;
    /**
     * 
     * @type {string}
     * @memberof EventDetails
     */
    event_description?: string;
    /**
     * 
     * @type {number}
     * @memberof EventDetails
     */
    start_frame_id?: number;
    /**
     * 
     * @type {EventDetailsCoach}
     * @memberof EventDetails
     */
    coach: EventDetailsCoach;
    /**
     * 
     * @type {boolean}
     * @memberof EventDetails
     */
    is_video_frozen?: boolean;
    /**
     * 
     * @type {TripDetails}
     * @memberof EventDetails
     */
    trip?: TripDetails;
}
/**
 * 
 * @export
 * @interface EventDetailsCoach
 */
export interface EventDetailsCoach {
    /**
     * 
     * @type {number}
     * @memberof EventDetailsCoach
     */
    event?: number;
    /**
     * 
     * @type {string}
     * @memberof EventDetailsCoach
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EventDetailsCoach
     */
    completed?: boolean;
}
/**
 * 
 * @export
 * @interface EventEntry
 */
export interface EventEntry {
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    created_date: number;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    device: string;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    sequence_id_number: number;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    record_status: number;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    record_origin: number;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    record_type: number;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    record_code: number;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    time_zone_offset_from_utc: number;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    event_datetime: number;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    accumulated_vehicle_miles: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    total_vehicle_miles: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    elapsed_engine_hours: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    total_engine_hours: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    event_latitude: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    event_longitude: number | null;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    distance_since_last_valid_coordinates: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof EventEntry
     */
    malfunction_indicator_status: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    malfunction_or_diagnostic_code: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EventEntry
     */
    data_diagnostic_event_indicator_status: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    comment: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    drivers_location_description: string;
    /**
     * 
     * @type {string}
     * @memberof EventEntry
     */
    event_data_check_value: string;
    /**
     * 
     * @type {number}
     * @memberof EventEntry
     */
    driver: number;
}
/**
 * 
 * @export
 * @interface EventEntryApproval
 */
export interface EventEntryApproval {
    /**
     * 
     * @type {Array<number>}
     * @memberof EventEntryApproval
     */
    records?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof EventEntryApproval
     */
    approved?: boolean;
}
/**
 * 
 * @export
 * @interface EventOverlayRequest
 */
export interface EventOverlayRequest {
    /**
     * 
     * @type {number}
     * @memberof EventOverlayRequest
     */
    event_id: number;
    /**
     * 
     * @type {number}
     * @memberof EventOverlayRequest
     */
    first_frame_number: number;
    /**
     * 
     * @type {number}
     * @memberof EventOverlayRequest
     */
    delay_s: number;
    /**
     * 
     * @type {string}
     * @memberof EventOverlayRequest
     */
    language: EventOverlayRequestLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof EventOverlayRequest
     */
    audio: string;
    /**
     * 
     * @type {string}
     * @memberof EventOverlayRequest
     */
    recipients: string;
    /**
     * 
     * @type {string}
     * @memberof EventOverlayRequest
     */
    cache_bucket?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum EventOverlayRequestLanguageEnum {
    EnglishF = 'english_f',
    EnglishM = 'english_m',
    HebrewM = 'hebrew_m',
    SpanishM = 'spanish_m'
}

/**
 * 
 * @export
 * @interface EventTag
 */
export interface EventTag {
    /**
     * 
     * @type {string}
     * @memberof EventTag
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof EventTag
     */
    action?: EventTagActionEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum EventTagActionEnum {
    Add = 'ADD',
    Remove = 'REMOVE'
}

/**
 * 
 * @export
 * @interface EventWatchedRequest
 */
export interface EventWatchedRequest {
    /**
     * 
     * @type {number}
     * @memberof EventWatchedRequest
     */
    percent_watched: number;
}
/**
 * 
 * @export
 * @interface ExperimentConfig
 */
export interface ExperimentConfig {
    /**
     * 
     * @type {number}
     * @memberof ExperimentConfig
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ExperimentConfig
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ExperimentConfig
     */
    maximum_vehicles: number;
    /**
     * 
     * @type {object}
     * @memberof ExperimentConfig
     */
    overlay: object;
    /**
     * 
     * @type {number}
     * @memberof ExperimentConfig
     */
    created_at: number;
    /**
     * 
     * @type {number}
     * @memberof ExperimentConfig
     */
    expiration_date: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExperimentConfig
     */
    device_count: number;
}
/**
 * 
 * @export
 * @interface ExperimentDeviceRequest
 */
export interface ExperimentDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof ExperimentDeviceRequest
     */
    action: ExperimentDeviceRequestActionEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExperimentDeviceRequest
     */
    device_ids: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum ExperimentDeviceRequestActionEnum {
    Add = 'add',
    Remove = 'remove',
    Sample = 'sample'
}

/**
 * 
 * @export
 * @interface ExtendedAccident
 */
export interface ExtendedAccident {
    /**
     * 
     * @type {number}
     * @memberof ExtendedAccident
     */
    accident_id: number;
    /**
     * 
     * @type {number}
     * @memberof ExtendedAccident
     */
    event?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    sub_fleet_name: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    location: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    driver_name: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedAccident
     */
    driver_token?: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    internal_status: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    handling_status: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    internal_id: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    assignee?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedAccident
     */
    is_closed: boolean;
    /**
     * 
     * @type {Array<Damage>}
     * @memberof ExtendedAccident
     */
    damage_list: Array<Damage>;
    /**
     * 
     * @type {Array<Comment>}
     * @memberof ExtendedAccident
     */
    comment_list: Array<Comment>;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    stage: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedAccident
     */
    is_anomaly?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    damage_category: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    claim_number: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    respondent?: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedAccident
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    suing?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedAccident
     */
    has_lawsuit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedAccident
     */
    claim_prevented_by_camera?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    police_report_number: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedAccident
     */
    archived?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ExtendedAccident
     */
    created_at: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedAccident
     */
    video_requested?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    norm_license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    customer?: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    policy_number?: string;
    /**
     * 
     * @type {Array<Artifact>}
     * @memberof ExtendedAccident
     */
    artifact_list: Array<Artifact>;
    /**
     * 
     * @type {Array<Witness>}
     * @memberof ExtendedAccident
     */
    witness_list: Array<Witness>;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    appraiser: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    garage: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    at_fault: string;
    /**
     * 
     * @type {Driver}
     * @memberof ExtendedAccident
     */
    driver: Driver | null;
    /**
     * 
     * @type {number}
     * @memberof ExtendedAccident
     */
    updated_at: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    trip_id: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedAccident
     */
    missing_trip_reason: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedAccident
     */
    total_paid: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExtendedAccident
     */
    total_reserve: number | null;
    /**
     * 
     * @type {Array<ClaimData>}
     * @memberof ExtendedAccident
     */
    claims: Array<ClaimData>;
    /**
     * 
     * @type {AccidentTags}
     * @memberof ExtendedAccident
     */
    tags?: AccidentTags | null;
    /**
     * 
     * @type {Array<CommandData>}
     * @memberof ExtendedAccident
     */
    command_list: Array<CommandData>;
}
/**
 * 
 * @export
 * @interface ExtendedAccidentAllOf
 */
export interface ExtendedAccidentAllOf {
    /**
     * 
     * @type {AccidentTags}
     * @memberof ExtendedAccidentAllOf
     */
    tags?: AccidentTags | null;
    /**
     * 
     * @type {Array<CommandData>}
     * @memberof ExtendedAccidentAllOf
     */
    command_list: Array<CommandData>;
}
/**
 * 
 * @export
 * @interface ExtendedArtifact
 */
export interface ExtendedArtifact {
    /**
     * 
     * @type {number}
     * @memberof ExtendedArtifact
     */
    artifact_id: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedArtifact
     */
    file_name: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedArtifact
     */
    path?: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedArtifact
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedArtifact
     */
    tag: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedArtifact
     */
    shared_with_insurance?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ExtendedArtifact
     */
    created_at: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedArtifact
     */
    customer_name?: string;
}
/**
 * 
 * @export
 * @interface ExtendedCustomerData
 */
export interface ExtendedCustomerData {
    /**
     * 
     * @type {string}
     * @memberof ExtendedCustomerData
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedCustomerData
     */
    display_name: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedCustomerData
     */
    contact_mail: string;
    /**
     * 
     * @type {CustomerDataSettings}
     * @memberof ExtendedCustomerData
     */
    settings: CustomerDataSettings;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtendedCustomerData
     */
    sub_fleets: Array<string>;
    /**
     * 
     * @type {Array<CustomerUserDetails>}
     * @memberof ExtendedCustomerData
     */
    users: Array<CustomerUserDetails>;
    /**
     * 
     * @type {Array<ExtendedCustomerDataAllOfCompanies>}
     * @memberof ExtendedCustomerData
     */
    companies: Array<ExtendedCustomerDataAllOfCompanies>;
    /**
     * 
     * @type {any}
     * @memberof ExtendedCustomerData
     */
    logo_url: any | null;
}
/**
 * 
 * @export
 * @interface ExtendedCustomerDataAllOf
 */
export interface ExtendedCustomerDataAllOf {
    /**
     * 
     * @type {Array<CustomerUserDetails>}
     * @memberof ExtendedCustomerDataAllOf
     */
    users: Array<CustomerUserDetails>;
    /**
     * 
     * @type {Array<ExtendedCustomerDataAllOfCompanies>}
     * @memberof ExtendedCustomerDataAllOf
     */
    companies: Array<ExtendedCustomerDataAllOfCompanies>;
    /**
     * 
     * @type {any}
     * @memberof ExtendedCustomerDataAllOf
     */
    logo_url: any | null;
}
/**
 * 
 * @export
 * @interface ExtendedCustomerDataAllOfCompanies
 */
export interface ExtendedCustomerDataAllOfCompanies {
    /**
     * 
     * @type {string}
     * @memberof ExtendedCustomerDataAllOfCompanies
     */
    company_id: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedCustomerDataAllOfCompanies
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedCustomerDataAllOfCompanies
     */
    is_default: boolean;
}
/**
 * 
 * @export
 * @interface ExtendedDevice
 */
export interface ExtendedDevice {
    /**
     * IMEI
     * @type {string}
     * @memberof ExtendedDevice
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedDevice
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedDevice
     */
    operator: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedDevice
     */
    customer_sub_fleet: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedDevice
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedDevice
     */
    driver_name: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedDevice
     */
    default_driver?: number | null;
    /**
     * 
     * @type {EldDeviceDetails}
     * @memberof ExtendedDevice
     */
    eld_device_details?: EldDeviceDetails | null;
}
/**
 * 
 * @export
 * @interface ExtendedDeviceAllOf
 */
export interface ExtendedDeviceAllOf {
    /**
     * 
     * @type {string}
     * @memberof ExtendedDeviceAllOf
     */
    operator?: string;
}
/**
 * 
 * @export
 * @interface ExtendedEvent
 */
export interface ExtendedEvent {
    /**
     * 
     * @type {number}
     * @memberof ExtendedEvent
     */
    event_id: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedEvent
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedEvent
     */
    level: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedEvent
     */
    severity: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedEvent
     */
    trip_id: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedEvent
     */
    timestamp: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtendedEvent
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtendedEvent
     */
    artifacts?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExtendedEvent
     */
    route: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedEvent
     */
    additional_info: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedEvent
     */
    location: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedEvent
     */
    speed: number | null;
    /**
     * 
     * @type {string}
     * @memberof ExtendedEvent
     */
    detector_version: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedEvent
     */
    event_description: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedEvent
     */
    start_frame_id: number;
    /**
     * 
     * @type {TripDetails}
     * @memberof ExtendedEvent
     */
    trip?: TripDetails;
    /**
     * 
     * @type {ExtendedDevice}
     * @memberof ExtendedEvent
     */
    device: ExtendedDevice;
}
/**
 * 
 * @export
 * @interface ExtendedEventAllOf
 */
export interface ExtendedEventAllOf {
    /**
     * 
     * @type {ExtendedDevice}
     * @memberof ExtendedEventAllOf
     */
    device: ExtendedDevice;
}
/**
 * 
 * @export
 * @interface ExtendedFeedEvent
 */
export interface ExtendedFeedEvent {
    /**
     * 
     * @type {number}
     * @memberof ExtendedFeedEvent
     */
    event_id: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedFeedEvent
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedFeedEvent
     */
    timestamp: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtendedFeedEvent
     */
    tags: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExtendedFeedEvent
     */
    license_plate: string;
    /**
     * 
     * @type {number}
     * @memberof ExtendedFeedEvent
     */
    driver: number;
    /**
     * 
     * @type {string}
     * @memberof ExtendedFeedEvent
     */
    video_url: string;
    /**
     * 
     * @type {FeedEvent}
     * @memberof ExtendedFeedEvent
     */
    feed_event: FeedEvent | null;
    /**
     * 
     * @type {number}
     * @memberof ExtendedFeedEvent
     */
    coach_session: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ExtendedFeedEvent
     */
    is_accident: boolean;
}
/**
 * 
 * @export
 * @interface ExtendedFileData
 */
export interface ExtendedFileData {
    /**
     * 
     * @type {string}
     * @memberof ExtendedFileData
     */
    file_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedFileData
     */
    s3_path?: string;
    /**
     * 
     * @type {string}
     * @memberof ExtendedFileData
     */
    customer_name?: string;
}
/**
 * 
 * @export
 * @interface ExtendedFileDataAllOf
 */
export interface ExtendedFileDataAllOf {
    /**
     * 
     * @type {string}
     * @memberof ExtendedFileDataAllOf
     */
    customer_name?: string;
}
/**
 * 
 * @export
 * @interface ExtendedRouteData
 */
export interface ExtendedRouteData {
    /**
     * 
     * @type {Array<ShortLocationSample>}
     * @memberof ExtendedRouteData
     */
    route: Array<ShortLocationSample>;
    /**
     * 
     * @type {Array<EventDetails>}
     * @memberof ExtendedRouteData
     */
    events: Array<EventDetails>;
    /**
     * 
     * @type {TripDetails}
     * @memberof ExtendedRouteData
     */
    trip: TripDetails;
    /**
     * 
     * @type {Array<number>}
     * @memberof ExtendedRouteData
     */
    snapshots?: Array<number>;
}
/**
 * 
 * @export
 * @interface FeedComment
 */
export interface FeedComment {
    /**
     * 
     * @type {number}
     * @memberof FeedComment
     */
    user_id: number;
    /**
     * 
     * @type {Array<RichText | RichTextElement>}
     * @memberof FeedComment
     */
    content: Array<RichText | RichTextElement>;
    /**
     * 
     * @type {number}
     * @memberof FeedComment
     */
    timestamp: number;
}
/**
 * 
 * @export
 * @interface FeedCommentRequest
 */
export interface FeedCommentRequest {
    /**
     * 
     * @type {Array<RichText | RichTextElement>}
     * @memberof FeedCommentRequest
     */
    comment?: Array<RichText | RichTextElement>;
}
/**
 * 
 * @export
 * @interface FeedEvent
 */
export interface FeedEvent {
    /**
     * 
     * @type {number}
     * @memberof FeedEvent
     */
    event_id: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FeedEvent
     */
    likes: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof FeedEvent
     */
    dislikes: Array<number>;
    /**
     * 
     * @type {Array<FeedComment>}
     * @memberof FeedEvent
     */
    comments: Array<FeedComment>;
    /**
     * 
     * @type {number}
     * @memberof FeedEvent
     */
    coaching_session_id: number | null;
}
/**
 * 
 * @export
 * @interface FeedLinkRequest
 */
export interface FeedLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof FeedLinkRequest
     */
    phone_number?: string;
}
/**
 * 
 * @export
 * @interface FeedResponse
 */
export interface FeedResponse {
    /**
     * 
     * @type {number}
     * @memberof FeedResponse
     */
    user_id: number;
    /**
     * 
     * @type {Array<ExtendedFeedEvent>}
     * @memberof FeedResponse
     */
    events: Array<ExtendedFeedEvent>;
    /**
     * 
     * @type {number}
     * @memberof FeedResponse
     */
    generated_at: number;
}
/**
 * 
 * @export
 * @interface FileData
 */
export interface FileData {
    /**
     * 
     * @type {string}
     * @memberof FileData
     */
    file_name?: string;
    /**
     * 
     * @type {string}
     * @memberof FileData
     */
    s3_path?: string;
}
/**
 * 
 * @export
 * @interface FileUploadData
 */
export interface FileUploadData {
    /**
     * 
     * @type {string}
     * @memberof FileUploadData
     */
    s3_path: string;
    /**
     * 
     * @type {string}
     * @memberof FileUploadData
     */
    upload_url: string;
}
/**
 * 
 * @export
 * @interface FleetDriver
 */
export interface FleetDriver {
    /**
     * 
     * @type {number}
     * @memberof FleetDriver
     */
    token: number;
    /**
     * 
     * @type {string}
     * @memberof FleetDriver
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof FleetDriver
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof FleetDriver
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof FleetDriver
     */
    sub_fleet: string;
    /**
     * 
     * @type {string}
     * @memberof FleetDriver
     */
    image_url: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FleetDriver
     */
    active: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof FleetDriver
     */
    default_vehicles: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FleetDriver
     */
    is_auto_generated: boolean;
}
/**
 * 
 * @export
 * @interface FleetDriverList
 */
export interface FleetDriverList {
    /**
     * 
     * @type {Array<FleetDriverRequest>}
     * @memberof FleetDriverList
     */
    drivers: Array<FleetDriverRequest>;
}
/**
 * 
 * @export
 * @interface FleetDriverRequest
 */
export interface FleetDriverRequest {
    /**
     * 
     * @type {string}
     * @memberof FleetDriverRequest
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof FleetDriverRequest
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof FleetDriverRequest
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof FleetDriverRequest
     */
    sub_fleet: string;
    /**
     * 
     * @type {string}
     * @memberof FleetDriverRequest
     */
    image?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FleetDriverRequest
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface FleetSafetyScores
 */
export interface FleetSafetyScores {
    /**
     * 
     * @type {string}
     * @memberof FleetSafetyScores
     */
    date: string;
    /**
     * 
     * @type {number}
     * @memberof FleetSafetyScores
     */
    unsafe_driving_score: number;
    /**
     * 
     * @type {number}
     * @memberof FleetSafetyScores
     */
    crash_indicator_score: number;
    /**
     * 
     * @type {number}
     * @memberof FleetSafetyScores
     */
    hos_compliance_score: number;
    /**
     * 
     * @type {number}
     * @memberof FleetSafetyScores
     */
    vehicle_maintenance_score: number;
    /**
     * 
     * @type {number}
     * @memberof FleetSafetyScores
     */
    controlled_substances_alcohol_score: number;
    /**
     * 
     * @type {number}
     * @memberof FleetSafetyScores
     */
    hazardous_materials_score: number;
    /**
     * 
     * @type {number}
     * @memberof FleetSafetyScores
     */
    driver_fitness_score: number;
    /**
     * 
     * @type {number}
     * @memberof FleetSafetyScores
     */
    iss_score: number;
}
/**
 * 
 * @export
 * @interface FleetScoreDetails
 */
export interface FleetScoreDetails {
    /**
     * 
     * @type {string}
     * @memberof FleetScoreDetails
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof FleetScoreDetails
     */
    sub_fleet: string;
    /**
     * 
     * @type {number}
     * @memberof FleetScoreDetails
     */
    driver_score: number;
    /**
     * 
     * @type {number}
     * @memberof FleetScoreDetails
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof FleetScoreDetails
     */
    driven_distance: number;
    /**
     * 
     * @type {number}
     * @memberof FleetScoreDetails
     */
    driven_duration: number;
    /**
     * 
     * @type {number}
     * @memberof FleetScoreDetails
     */
    driver_score_count: number;
    /**
     * 
     * @type {Array<DriverScore>}
     * @memberof FleetScoreDetails
     */
    top_driver_scores: Array<DriverScore>;
    /**
     * 
     * @type {Array<DriverScore>}
     * @memberof FleetScoreDetails
     */
    bottom_driver_scores: Array<DriverScore>;
}
/**
 * 
 * @export
 * @interface FleetScoreShort
 */
export interface FleetScoreShort {
    /**
     * 
     * @type {string}
     * @memberof FleetScoreShort
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof FleetScoreShort
     */
    sub_fleet: string;
    /**
     * 
     * @type {number}
     * @memberof FleetScoreShort
     */
    driver_score: number;
    /**
     * 
     * @type {number}
     * @memberof FleetScoreShort
     */
    wellness_score: number;
    /**
     * 
     * @type {number}
     * @memberof FleetScoreShort
     */
    timestamp: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof FleetScoreShort
     */
    driver_score_histogram: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof FleetScoreShort
     */
    wellness_score_histogram: Array<number>;
}
/**
 * 
 * @export
 * @interface FrequencyDataPoint
 */
export interface FrequencyDataPoint {
    /**
     * 
     * @type {number}
     * @memberof FrequencyDataPoint
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof FrequencyDataPoint
     */
    exposure: number;
    /**
     * 
     * @type {number}
     * @memberof FrequencyDataPoint
     */
    number_of_accidents: number;
    /**
     * 
     * @type {number}
     * @memberof FrequencyDataPoint
     */
    accident_frequency: number;
}
/**
 * 
 * @export
 * @interface FrontFacingWellness
 */
export interface FrontFacingWellness {
    /**
     * 
     * @type {number}
     * @memberof FrontFacingWellness
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FrontFacingWellness
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof FrontFacingWellness
     */
    wellness_state: string;
    /**
     * 
     * @type {number}
     * @memberof FrontFacingWellness
     */
    timestamp: number;
}
/**
 * 
 * @export
 * @interface Geofence
 */
export interface Geofence {
    /**
     * 
     * @type {number}
     * @memberof Geofence
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Geofence
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof Geofence
     */
    event_on_enter: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Geofence
     */
    event_on_leave: boolean;
    /**
     * 
     * @type {string}
     * @memberof Geofence
     */
    color: string;
    /**
     * 
     * @type {Array<Array<number>>}
     * @memberof Geofence
     */
    coordinates: Array<Array<number>>;
}
/**
 * 
 * @export
 * @interface GuestTechnicianRequest
 */
export interface GuestTechnicianRequest {
    /**
     * 
     * @type {string}
     * @memberof GuestTechnicianRequest
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof GuestTechnicianRequest
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof GuestTechnicianRequest
     */
    phone_number: string;
}
/**
 * 
 * @export
 * @interface HomeTerminal
 */
export interface HomeTerminal {
    /**
     * 
     * @type {number}
     * @memberof HomeTerminal
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof HomeTerminal
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof HomeTerminal
     */
    address: string;
    /**
     * 
     * @type {number}
     * @memberof HomeTerminal
     */
    timezone_offset_from_utc: number;
    /**
     * 
     * @type {number}
     * @memberof HomeTerminal
     */
    consecutive_days: number;
    /**
     * 
     * @type {string}
     * @memberof HomeTerminal
     */
    day_start_time: string;
}
/**
 * 
 * @export
 * @interface HosCustomerData
 */
export interface HosCustomerData {
    /**
     * 
     * @type {Array<HosDriver>}
     * @memberof HosCustomerData
     */
    drivers: Array<HosDriver>;
    /**
     * 
     * @type {Array<HomeTerminal>}
     * @memberof HosCustomerData
     */
    home_terminals: Array<HomeTerminal>;
}
/**
 * 
 * @export
 * @interface HosDriver
 */
export interface HosDriver {
    /**
     * 
     * @type {number}
     * @memberof HosDriver
     */
    driver_id: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriver
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriver
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriver
     */
    driver_license_number: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriver
     */
    driver_license_state_province: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriver
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriver
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriver
     */
    license: string;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriver
     */
    personal_conveyance: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriver
     */
    yard_move: boolean;
    /**
     * 
     * @type {Device}
     * @memberof HosDriver
     */
    current_device: Device | null;
    /**
     * 
     * @type {number}
     * @memberof HosDriver
     */
    current_status?: number;
    /**
     * 
     * @type {HomeTerminal}
     * @memberof HosDriver
     */
    home_terminal: HomeTerminal;
    /**
     * 
     * @type {string}
     * @memberof HosDriver
     */
    driving_type: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriver
     */
    last_login?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriver
     */
    is_active?: boolean;
}
/**
 * 
 * @export
 * @interface HosDriverRequest
 */
export interface HosDriverRequest {
    /**
     * 
     * @type {number}
     * @memberof HosDriverRequest
     */
    driver_id: number;
    /**
     * 
     * @type {string}
     * @memberof HosDriverRequest
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriverRequest
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriverRequest
     */
    driver_license_number?: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriverRequest
     */
    driver_license_state_province?: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriverRequest
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriverRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof HosDriverRequest
     */
    license?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriverRequest
     */
    personal_conveyance?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriverRequest
     */
    yard_move?: boolean;
    /**
     * 
     * @type {Device}
     * @memberof HosDriverRequest
     */
    current_device?: Device;
    /**
     * 
     * @type {number}
     * @memberof HosDriverRequest
     */
    current_status?: number;
    /**
     * 
     * @type {HomeTerminal}
     * @memberof HosDriverRequest
     */
    home_terminal?: HomeTerminal;
    /**
     * 
     * @type {string}
     * @memberof HosDriverRequest
     */
    driving_type?: string;
    /**
     * 
     * @type {number}
     * @memberof HosDriverRequest
     */
    last_login?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriverRequest
     */
    is_active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HosDriverRequest
     */
    send_invitation?: boolean;
}
/**
 * 
 * @export
 * @interface HosTransferRequest
 */
export interface HosTransferRequest {
    /**
     * 
     * @type {string}
     * @memberof HosTransferRequest
     */
    method?: HosTransferRequestMethodEnum;
    /**
     * 
     * @type {string}
     * @memberof HosTransferRequest
     */
    comment?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum HosTransferRequestMethodEnum {
    Mail = 'mail',
    WebService = 'web_service'
}

/**
 * 
 * @export
 * @interface HosUnassignedAssignmentRequest
 */
export interface HosUnassignedAssignmentRequest {
    /**
     * 
     * @type {number}
     * @memberof HosUnassignedAssignmentRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof HosUnassignedAssignmentRequest
     */
    device_id: string;
    /**
     * 
     * @type {number}
     * @memberof HosUnassignedAssignmentRequest
     */
    driver_id?: number;
    /**
     * 
     * @type {number}
     * @memberof HosUnassignedAssignmentRequest
     */
    start_time: number;
    /**
     * 
     * @type {number}
     * @memberof HosUnassignedAssignmentRequest
     */
    end_time: number;
    /**
     * 
     * @type {OverrideDriving}
     * @memberof HosUnassignedAssignmentRequest
     */
    override_driving?: OverrideDriving;
    /**
     * 
     * @type {OverrideStop}
     * @memberof HosUnassignedAssignmentRequest
     */
    override_stop?: OverrideStop;
    /**
     * 
     * @type {RequestStatus}
     * @memberof HosUnassignedAssignmentRequest
     */
    status?: RequestStatus;
    /**
     * 
     * @type {string}
     * @memberof HosUnassignedAssignmentRequest
     */
    comment?: string;
}
/**
 * 
 * @export
 * @interface HosUnassignedRecord
 */
export interface HosUnassignedRecord {
    /**
     * 
     * @type {Array<HosUnassignedRecordSet>}
     * @memberof HosUnassignedRecord
     */
    unassigned_records?: Array<HosUnassignedRecordSet>;
    /**
     * 
     * @type {Array<HosUnassignedAssignmentRequest>}
     * @memberof HosUnassignedRecord
     */
    assignment_requests?: Array<HosUnassignedAssignmentRequest>;
}
/**
 * 
 * @export
 * @interface HosUnassignedRecordSet
 */
export interface HosUnassignedRecordSet {
    /**
     * 
     * @type {number}
     * @memberof HosUnassignedRecordSet
     */
    start_time: number;
    /**
     * 
     * @type {number}
     * @memberof HosUnassignedRecordSet
     */
    end_time: number;
    /**
     * 
     * @type {Device}
     * @memberof HosUnassignedRecordSet
     */
    device: Device;
    /**
     * 
     * @type {Array<EventEntry>}
     * @memberof HosUnassignedRecordSet
     */
    records: Array<EventEntry>;
    /**
     * 
     * @type {boolean}
     * @memberof HosUnassignedRecordSet
     */
    annotated: boolean;
    /**
     * 
     * @type {string}
     * @memberof HosUnassignedRecordSet
     */
    comment: string;
}
/**
 * 
 * @export
 * @interface InCabinWellness
 */
export interface InCabinWellness {
    /**
     * 
     * @type {number}
     * @memberof InCabinWellness
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InCabinWellness
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof InCabinWellness
     */
    blocked: string;
    /**
     * 
     * @type {string}
     * @memberof InCabinWellness
     */
    no_face: string;
    /**
     * 
     * @type {string}
     * @memberof InCabinWellness
     */
    peripheral_face: string;
    /**
     * 
     * @type {number}
     * @memberof InCabinWellness
     */
    timestamp: number;
}
/**
 * 
 * @export
 * @interface InCabinWellnessV1
 */
export interface InCabinWellnessV1 {
    /**
     * 
     * @type {number}
     * @memberof InCabinWellnessV1
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InCabinWellnessV1
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof InCabinWellnessV1
     */
    wellness_state: string;
    /**
     * 
     * @type {number}
     * @memberof InCabinWellnessV1
     */
    timestamp: number;
}
/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    event_description?: string;
    /**
     * 
     * @type {number}
     * @memberof InlineObject
     */
    start_frame_id?: number;
}
/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * 
     * @type {Array<Event>}
     * @memberof InlineResponse200
     */
    events: Array<Event>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse200
     */
    last_trip_id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse200
     */
    last_event_id?: number | null;
}
/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
    /**
     * 
     * @type {Array<ExtendedEvent>}
     * @memberof InlineResponse2001
     */
    events: Array<ExtendedEvent>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2001
     */
    search_after: number;
}
/**
 * 
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2002
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2003
     */
    status?: string;
}
/**
 * 
 * @export
 * @interface InstallDeviceRequest
 */
export interface InstallDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof InstallDeviceRequest
     */
    installer: string;
    /**
     * 
     * @type {string}
     * @memberof InstallDeviceRequest
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof InstallDeviceRequest
     */
    customer_name: string;
    /**
     * 
     * @type {string}
     * @memberof InstallDeviceRequest
     */
    license_plate: string;
    /**
     * 
     * @type {number}
     * @memberof InstallDeviceRequest
     */
    instHeight: number;
    /**
     * 
     * @type {number}
     * @memberof InstallDeviceRequest
     */
    instDepth: number;
    /**
     * 
     * @type {number}
     * @memberof InstallDeviceRequest
     */
    instHoodHeight: number;
    /**
     * 
     * @type {number}
     * @memberof InstallDeviceRequest
     */
    instHorizontalOffset: number;
    /**
     * 
     * @type {number}
     * @memberof InstallDeviceRequest
     */
    vehicle_weight: number;
    /**
     * 
     * @type {number}
     * @memberof InstallDeviceRequest
     */
    vehicle_width: number;
    /**
     * 
     * @type {string}
     * @memberof InstallDeviceRequest
     */
    old_imei: string;
    /**
     * 
     * @type {number}
     * @memberof InstallDeviceRequest
     */
    policy_id?: number;
    /**
     * 
     * @type {number}
     * @memberof InstallDeviceRequest
     */
    malfunction_id?: number;
}
/**
 * 
 * @export
 * @interface InstallationCommandResult
 */
export interface InstallationCommandResult {
    /**
     * 
     * @type {string}
     * @memberof InstallationCommandResult
     */
    status: InstallationCommandResultStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof InstallationCommandResult
     */
    ICImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof InstallationCommandResult
     */
    FFImageUrl?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum InstallationCommandResultStatusEnum {
    Pending = 'pending',
    Started = 'started',
    Streaming = 'streaming',
    Success = 'success',
    Failure = 'failure',
    NoSupport = 'no_support'
}

/**
 * 
 * @export
 * @interface InstallationFileRequest
 */
export interface InstallationFileRequest {
    /**
     * 
     * @type {string}
     * @memberof InstallationFileRequest
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof InstallationFileRequest
     */
    file_name: string;
}
/**
 * 
 * @export
 * @interface InstallationFileRequestV2
 */
export interface InstallationFileRequestV2 {
    /**
     * 
     * @type {string}
     * @memberof InstallationFileRequestV2
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof InstallationFileRequestV2
     */
    file_name: string;
}
/**
 * 
 * @export
 * @interface InstallationFileResponse
 */
export interface InstallationFileResponse {
    /**
     * 
     * @type {string}
     * @memberof InstallationFileResponse
     */
    upload_url: string;
}
/**
 * 
 * @export
 * @interface InstallationFileResponse1
 */
export interface InstallationFileResponse1 {
    /**
     * 
     * @type {string}
     * @memberof InstallationFileResponse1
     */
    message?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof InstallationFileResponse1
     */
    installation_params?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface InstallationFileResponseV2
 */
export interface InstallationFileResponseV2 {
    /**
     * 
     * @type {string}
     * @memberof InstallationFileResponseV2
     */
    upload_url: string;
}
/**
 * 
 * @export
 * @interface InstallationParams
 */
export interface InstallationParams {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof InstallationParams
     */
    installation_params?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface InstallationReportRequest
 */
export interface InstallationReportRequest {
    /**
     * 
     * @type {string}
     * @memberof InstallationReportRequest
     */
    recipient: string;
}
/**
 * 
 * @export
 * @interface InsurancePeriod
 */
export interface InsurancePeriod {
    /**
     * 
     * @type {number}
     * @memberof InsurancePeriod
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof InsurancePeriod
     */
    start_date: string;
    /**
     * 
     * @type {string}
     * @memberof InsurancePeriod
     */
    end_date: string;
    /**
     * 
     * @type {string}
     * @memberof InsurancePeriod
     */
    coverage_type: string;
    /**
     * 
     * @type {string}
     * @memberof InsurancePeriod
     */
    carrier: string;
    /**
     * 
     * @type {string}
     * @memberof InsurancePeriod
     */
    policy_number: string;
}
/**
 * 
 * @export
 * @interface JWTToken
 */
export interface JWTToken {
    /**
     * 
     * @type {string}
     * @memberof JWTToken
     */
    refresh?: string;
    /**
     * 
     * @type {string}
     * @memberof JWTToken
     */
    access?: string;
    /**
     * 
     * @type {number}
     * @memberof JWTToken
     */
    expires_in?: number;
}
/**
 * 
 * @export
 * @interface LoadClaimsRequest
 */
export interface LoadClaimsRequest {
    /**
     * 
     * @type {Array<ClaimData>}
     * @memberof LoadClaimsRequest
     */
    claims_data: Array<ClaimData>;
    /**
     * 
     * @type {boolean}
     * @memberof LoadClaimsRequest
     */
    commit_changes: boolean;
}
/**
 * 
 * @export
 * @interface LoadClaimsResponse
 */
export interface LoadClaimsResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof LoadClaimsResponse
     */
    claims_updated: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LoadClaimsResponse
     */
    claims_to_delete: Array<string>;
}
/**
 * 
 * @export
 * @interface LocationSample
 */
export interface LocationSample {
    /**
     * 
     * @type {string}
     * @memberof LocationSample
     */
    trip_id: string;
    /**
     * 
     * @type {number}
     * @memberof LocationSample
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof LocationSample
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof LocationSample
     */
    longitude: number;
    /**
     * 
     * @type {number}
     * @memberof LocationSample
     */
    speed: number;
    /**
     * 
     * @type {number}
     * @memberof LocationSample
     */
    distance: number;
    /**
     * 
     * @type {Device}
     * @memberof LocationSample
     */
    device: Device;
}
/**
 * 
 * @export
 * @interface LocationSampleAllOf
 */
export interface LocationSampleAllOf {
    /**
     * 
     * @type {Device}
     * @memberof LocationSampleAllOf
     */
    device: Device;
}
/**
 * 
 * @export
 * @interface Malfunction
 */
export interface Malfunction {
    /**
     * 
     * @type {number}
     * @memberof Malfunction
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Malfunction
     */
    device_id: string | null;
    /**
     * 
     * @type {DeviceHardware}
     * @memberof Malfunction
     */
    hardware: DeviceHardware;
    /**
     * 
     * @type {string}
     * @memberof Malfunction
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof Malfunction
     */
    sub_fleet: string | null;
    /**
     * 
     * @type {string}
     * @memberof Malfunction
     */
    type: MalfunctionTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Malfunction
     */
    is_unwell: boolean;
    /**
     * 
     * @type {number}
     * @memberof Malfunction
     */
    since: number;
    /**
     * 
     * @type {number}
     * @memberof Malfunction
     */
    updated_at: number;
    /**
     * 
     * @type {number}
     * @memberof Malfunction
     */
    comment_count: number;
    /**
     * 
     * @type {number}
     * @memberof Malfunction
     */
    assignee: number | null;
    /**
     * 
     * @type {number}
     * @memberof Malfunction
     */
    policy_id: number | null;
    /**
     * 
     * @type {string}
     * @memberof Malfunction
     */
    policy_customer_type?: MalfunctionPolicyCustomerTypeEnum;
    /**
     * 
     * @type {MalfunctionMetadata}
     * @memberof Malfunction
     */
    metadata: MalfunctionMetadata;
}

/**
    * @export
    * @enum {string}
    */
export enum MalfunctionTypeEnum {
    InCabinV1 = 'IN_CABIN_V1',
    FrontFacing = 'FRONT_FACING',
    DeviceWellness = 'DEVICE_WELLNESS',
    MultipleButtonPresses = 'MULTIPLE_BUTTON_PRESSES',
    SystemConstantlyOn = 'SYSTEM_CONSTANTLY_ON',
    WrongInstallation = 'WRONG_INSTALLATION',
    PendingInstallation = 'PENDING_INSTALLATION',
    PendingRemoval = 'PENDING_REMOVAL',
    WrongLicensePlate = 'WRONG_LICENSE_PLATE',
    InactiveDevice = 'INACTIVE_DEVICE'
}
/**
    * @export
    * @enum {string}
    */
export enum MalfunctionPolicyCustomerTypeEnum {
    Insured = 'insured',
    Saas = 'saas',
    ClaimsHandling = 'claims_handling',
    Pilot = 'pilot',
    Pending = 'pending'
}

/**
 * 
 * @export
 * @interface MalfunctionAssigneeRequest
 */
export interface MalfunctionAssigneeRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof MalfunctionAssigneeRequest
     */
    malfunctions: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof MalfunctionAssigneeRequest
     */
    assignee: number | null;
}
/**
 * 
 * @export
 * @interface MalfunctionComment
 */
export interface MalfunctionComment {
    /**
     * 
     * @type {number}
     * @memberof MalfunctionComment
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof MalfunctionComment
     */
    author: number;
    /**
     * 
     * @type {Array<RichText | RichTextElement>}
     * @memberof MalfunctionComment
     */
    text: Array<RichText | RichTextElement>;
    /**
     * 
     * @type {number}
     * @memberof MalfunctionComment
     */
    timestamp: number;
}
/**
 * 
 * @export
 * @interface MalfunctionCommentRequest
 */
export interface MalfunctionCommentRequest {
    /**
     * 
     * @type {Array<RichText | RichTextElement>}
     * @memberof MalfunctionCommentRequest
     */
    text?: Array<RichText | RichTextElement>;
}
/**
 * 
 * @export
 * @interface MalfunctionMetadata
 */
export interface MalfunctionMetadata {
    /**
     * 
     * @type {number}
     * @memberof MalfunctionMetadata
     */
    wellness_id: number | null;
    /**
     * 
     * @type {string}
     * @memberof MalfunctionMetadata
     */
    wellness_state: string | null;
    /**
     * 
     * @type {number}
     * @memberof MalfunctionMetadata
     */
    wellness_timestamp: number | null;
    /**
     * 
     * @type {string}
     * @memberof MalfunctionMetadata
     */
    image_path?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof MalfunctionMetadata
     */
    additional_metadata?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface ManagerNotesRequest
 */
export interface ManagerNotesRequest {
    /**
     * 
     * @type {Array<RichText | RichTextElement>}
     * @memberof ManagerNotesRequest
     */
    text?: Array<RichText | RichTextElement>;
}
/**
 * 
 * @export
 * @interface MediaFile
 */
export interface MediaFile {
    /**
     * 
     * @type {number}
     * @memberof MediaFile
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof MediaFile
     */
    file_name: string;
    /**
     * 
     * @type {string}
     * @memberof MediaFile
     */
    file_type: string;
    /**
     * 
     * @type {string}
     * @memberof MediaFile
     */
    path: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFile
     */
    is_public: boolean;
    /**
     * 
     * @type {number}
     * @memberof MediaFile
     */
    user_id: number;
    /**
     * 
     * @type {number}
     * @memberof MediaFile
     */
    customer_id: number;
}
/**
 * 
 * @export
 * @interface MediaFileRequest
 */
export interface MediaFileRequest {
    /**
     * 
     * @type {string}
     * @memberof MediaFileRequest
     */
    file_name: string;
    /**
     * 
     * @type {string}
     * @memberof MediaFileRequest
     */
    file_type: string;
    /**
     * 
     * @type {string}
     * @memberof MediaFileRequest
     */
    path: string;
    /**
     * 
     * @type {boolean}
     * @memberof MediaFileRequest
     */
    is_public: boolean;
}
/**
 * 
 * @export
 * @interface MostCommonList
 */
export interface MostCommonList {
    /**
     * 
     * @type {string}
     * @memberof MostCommonList
     */
    key: string;
    /**
     * 
     * @type {number}
     * @memberof MostCommonList
     */
    count: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MostCommonList
     */
    values?: Array<string>;
}
/**
 * 
 * @export
 * @interface NewDevice
 */
export interface NewDevice {
    /**
     * 
     * @type {string}
     * @memberof NewDevice
     */
    imei: string;
    /**
     * 
     * @type {DeviceHardware}
     * @memberof NewDevice
     */
    hardware: DeviceHardware;
}
/**
 * 
 * @export
 * @interface NoticeRequest
 */
export interface NoticeRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof NoticeRequest
     */
    artifacts?: Array<number>;
}
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    pk: number;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    created_by: number;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    user: number;
    /**
     * 
     * @type {boolean}
     * @memberof Notification
     */
    is_report: boolean;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    report_type: string;
    /**
     * 
     * @type {object}
     * @memberof Notification
     */
    filters: object;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    datetime: number;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    sent_at: number | null;
}
/**
 * 
 * @export
 * @interface NotificationRequest
 */
export interface NotificationRequest {
    /**
     * 
     * @type {number}
     * @memberof NotificationRequest
     */
    pk?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationRequest
     */
    user?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationRequest
     */
    datetime?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationRequest
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface NotificationRequestV2
 */
export interface NotificationRequestV2 {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationRequestV2
     */
    read?: boolean;
}
/**
 * 
 * @export
 * @interface NotificationResponseV2
 */
export interface NotificationResponseV2 {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationResponseV2
     */
    read: boolean;
    /**
     * 
     * @type {number}
     * @memberof NotificationResponseV2
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationResponseV2
     */
    user: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationResponseV2
     */
    accident: number;
}
/**
 * 
 * @export
 * @interface NotificationSettings
 */
export interface NotificationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    email: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationSettings
     */
    dashboard: boolean;
}
/**
 * 
 * @export
 * @interface Nps
 */
export interface Nps {
    /**
     * 
     * @type {number}
     * @memberof Nps
     */
    response: number;
    /**
     * 
     * @type {string}
     * @memberof Nps
     */
    feedback: string;
}
/**
 * 
 * @export
 * @interface OTPUserCredentials
 */
export interface OTPUserCredentials {
    /**
     * Phone number
     * @type {string}
     * @memberof OTPUserCredentials
     */
    phone_number?: string;
    /**
     * Code - for 2FA
     * @type {string}
     * @memberof OTPUserCredentials
     */
    code?: string;
}
/**
 * 
 * @export
 * @interface Overlay
 */
export interface Overlay {
    /**
     * 
     * @type {number}
     * @memberof Overlay
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Overlay
     */
    feature: string;
    /**
     * 
     * @type {string}
     * @memberof Overlay
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof Overlay
     */
    overlay: object;
}
/**
 * 
 * @export
 * @interface OverlayRequest
 */
export interface OverlayRequest {
    /**
     * 
     * @type {string}
     * @memberof OverlayRequest
     */
    feature?: string;
    /**
     * 
     * @type {string}
     * @memberof OverlayRequest
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof OverlayRequest
     */
    overlay: object;
}
/**
 * 
 * @export
 * @interface OverlaysResponse
 */
export interface OverlaysResponse {
    /**
     * 
     * @type {Array<Overlay>}
     * @memberof OverlaysResponse
     */
    overlays: Array<Overlay>;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum OverrideDriving {
    D = 'D',
    Ym = 'YM',
    Pc = 'PC'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum OverrideStop {
    On = 'ON',
    Off = 'OFF'
}

/**
 * 
 * @export
 * @interface OverviewData
 */
export interface OverviewData {
    /**
     * 
     * @type {number}
     * @memberof OverviewData
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof OverviewData
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof OverviewData
     */
    sub_fleet: string;
    /**
     * 
     * @type {Array<FrequencyDataPoint>}
     * @memberof OverviewData
     */
    accident_data: Array<FrequencyDataPoint>;
    /**
     * 
     * @type {Array<MostCommonList>}
     * @memberof OverviewData
     */
    most_common_license_plates: Array<MostCommonList>;
    /**
     * 
     * @type {Array<MostCommonList>}
     * @memberof OverviewData
     */
    most_common_driver_names: Array<MostCommonList>;
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof OverviewData
     */
    accident_locations: Array<Array<string>>;
    /**
     * 
     * @type {TaggingData}
     * @memberof OverviewData
     */
    tagging_data: TaggingData;
}
/**
 * 
 * @export
 * @interface PackageData
 */
export interface PackageData {
    /**
     * 
     * @type {number}
     * @memberof PackageData
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PackageData
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface PackageName
 */
export interface PackageName {
    /**
     * 
     * @type {string}
     * @memberof PackageName
     */
    name?: string;
}
/**
 * 
 * @export
 * @interface PackageTrackerData
 */
export interface PackageTrackerData {
    /**
     * 
     * @type {Array<string>}
     * @memberof PackageTrackerData
     */
    device_ids?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PackageTrackerData
     */
    package_id?: number;
}
/**
 * 
 * @export
 * @interface Payment
 */
export interface Payment {
    /**
     * 
     * @type {number}
     * @memberof Payment
     */
    payment_id: number;
    /**
     * 
     * @type {number}
     * @memberof Payment
     */
    created_time: number;
    /**
     * 
     * @type {number}
     * @memberof Payment
     */
    damage_id: number;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    paid_by: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    transaction_direction: string;
    /**
     * 
     * @type {number}
     * @memberof Payment
     */
    cost: number;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    tag: string;
    /**
     * 
     * @type {string}
     * @memberof Payment
     */
    currency: string;
}
/**
 * 
 * @export
 * @interface Policy
 */
export interface Policy {
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    license_plate?: string;
    /**
     * 
     * @type {number}
     * @memberof Policy
     */
    start_date?: number;
    /**
     * 
     * @type {number}
     * @memberof Policy
     */
    end_date?: number;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    compulsory_automobile_insurance_number?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Policy
     */
    casco_insurance_number?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Policy
     */
    is_protected?: boolean;
}
/**
 * 
 * @export
 * @interface PolicyDeleteRequest
 */
export interface PolicyDeleteRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof PolicyDeleteRequest
     */
    policy_ids?: Array<number>;
}
/**
 * 
 * @export
 * @interface PolicyV1Request
 */
export interface PolicyV1Request {
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Request
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    customer?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    license_plate?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    model_code?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    vehicle_manufacture_model?: string;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Request
     */
    vehicle_manufacture_year?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Request
     */
    vehicle_weight?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    vehicle_type?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    use_type?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    insurance_company?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    policy_type?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    policy_number?: string;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Request
     */
    manual_premium?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Request
     */
    auto_premium?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    payment_method?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV1Request
     */
    payment_status?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Request
     */
    seat_count?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Request
     */
    min_premium?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Request
     */
    vehicle_value?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Request
     */
    refrigerator_unit_value?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Request
     */
    trunk_value?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Request
     */
    lift_value?: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Request
     */
    devalue_percent?: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    casco_type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV1Request
     */
    windshields_cover?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV1Request
     */
    car_towing_cover?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV1Request
     */
    car_replacement_cover?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    driver_age?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    manual_start_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    manual_end_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    auto_start_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    auto_end_date?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    cancellation_date?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV1Request
     */
    total_lost?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV1Request
     */
    _protected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    bond_bank?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    comments?: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Request
     */
    norm_license_plate?: string;
}
/**
 * 
 * @export
 * @interface PolicyV1Response
 */
export interface PolicyV1Response {
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Response
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    company: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    model_code: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    vehicle_manufacture_model: string;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Response
     */
    vehicle_manufacture_year: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Response
     */
    vehicle_weight: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    vehicle_type: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    use_type: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    insurance_company: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    policy_type: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    policy_number: string;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Response
     */
    manual_premium: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Response
     */
    auto_premium: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    payment_method: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV1Response
     */
    payment_status: boolean;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Response
     */
    seat_count: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Response
     */
    min_premium: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Response
     */
    vehicle_value: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Response
     */
    refrigerator_unit_value: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Response
     */
    trunk_value: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Response
     */
    lift_value: number;
    /**
     * 
     * @type {number}
     * @memberof PolicyV1Response
     */
    devalue_percent: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    casco_type: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV1Response
     */
    windshields_cover: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV1Response
     */
    car_towing_cover: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV1Response
     */
    car_replacement_cover: boolean;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    driver_age: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    manual_start_date: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    manual_end_date: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    auto_start_date: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    auto_end_date: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    cancellation_date: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV1Response
     */
    total_lost: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV1Response
     */
    is_protected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    bond_bank: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    comments: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV1Response
     */
    norm_license_plate: string;
}
/**
 * 
 * @export
 * @interface PolicyV2
 */
export interface PolicyV2 {
    /**
     * 
     * @type {number}
     * @memberof PolicyV2
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PolicyV2
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV2
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof PolicyV2
     */
    vehicle_type: PolicyV2VehicleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PolicyV2
     */
    customer_type: PolicyV2CustomerTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PolicyV2
     */
    start_date: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyV2
     */
    end_date: string | null;
    /**
     * 
     * @type {string}
     * @memberof PolicyV2
     */
    cancellation_date: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV2
     */
    driver_refuse: boolean;
    /**
     * 
     * @type {string}
     * @memberof PolicyV2
     */
    insurance_company: string;
    /**
     * 
     * @type {boolean}
     * @memberof PolicyV2
     */
    total_loss: boolean;
    /**
     * 
     * @type {string}
     * @memberof PolicyV2
     */
    comment: string;
}

/**
    * @export
    * @enum {string}
    */
export enum PolicyV2VehicleTypeEnum {
    Truck = 'truck',
    Ptb = 'ptb',
    Bus = 'bus',
    Midibus = 'midibus',
    Minibus = 'minibus',
    Other = 'other'
}
/**
    * @export
    * @enum {string}
    */
export enum PolicyV2CustomerTypeEnum {
    Insured = 'insured',
    Saas = 'saas',
    ClaimsHandling = 'claims_handling',
    Pilot = 'pilot',
    Pending = 'pending'
}

/**
 * 
 * @export
 * @interface PremiumOptimization
 */
export interface PremiumOptimization {
    /**
     * 
     * @type {number}
     * @memberof PremiumOptimization
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PremiumOptimization
     */
    customer: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumOptimization
     */
    optimization_type: string;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumOptimization
     */
    is_header: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof PremiumOptimization
     */
    insight: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof PremiumOptimization
     */
    dismissed: boolean;
    /**
     * 
     * @type {string}
     * @memberof PremiumOptimization
     */
    dismissed_at: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumOptimization
     */
    dismissed_by: string | null;
}
/**
 * 
 * @export
 * @interface PremiumOptimizationReminderRequest
 */
export interface PremiumOptimizationReminderRequest {
    /**
     * 
     * @type {number}
     * @memberof PremiumOptimizationReminderRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PremiumOptimizationReminderRequest
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumOptimizationReminderRequest
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface PremiumOptimizationRequest
 */
export interface PremiumOptimizationRequest {
    /**
     * 
     * @type {number}
     * @memberof PremiumOptimizationRequest
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumOptimizationRequest
     */
    dismissed?: boolean;
}
/**
 * 
 * @export
 * @interface RefreshTokenRequest
 */
export interface RefreshTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenRequest
     */
    refresh?: string;
}
/**
 * 
 * @export
 * @interface RelatedEvents
 */
export interface RelatedEvents {
    /**
     * 
     * @type {Array<ExtendedEvent>}
     * @memberof RelatedEvents
     */
    day: Array<ExtendedEvent>;
    /**
     * 
     * @type {Array<ExtendedEvent>}
     * @memberof RelatedEvents
     */
    type: Array<ExtendedEvent>;
}
/**
 * 
 * @export
 * @interface ReleaseNotes
 */
export interface ReleaseNotes {
    /**
     * 
     * @type {number}
     * @memberof ReleaseNotes
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNotes
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNotes
     */
    language: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReleaseNotes
     */
    tags: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReleaseNotes
     */
    release_notes: string;
}
/**
 * 
 * @export
 * @interface RemoteCommand
 */
export interface RemoteCommand {
    /**
     * 
     * @type {string}
     * @memberof RemoteCommand
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof RemoteCommand
     */
    command: string;
    /**
     * 
     * @type {string}
     * @memberof RemoteCommand
     */
    payload?: string;
}
/**
 * 
 * @export
 * @interface RemoveDeviceRequest
 */
export interface RemoveDeviceRequest {
    /**
     * 
     * @type {string}
     * @memberof RemoveDeviceRequest
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveDeviceRequest
     */
    customer_name: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveDeviceRequest
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveDeviceRequest
     */
    installer: string;
    /**
     * 
     * @type {number}
     * @memberof RemoveDeviceRequest
     */
    malfunction_id?: number;
}
/**
 * 
 * @export
 * @interface Report
 */
export interface Report {
    /**
     * 
     * @type {number}
     * @memberof Report
     */
    pk: number;
    /**
     * 
     * @type {boolean}
     * @memberof Report
     */
    is_report: boolean;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    report_type: string;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    report_scope: string;
    /**
     * 
     * @type {number}
     * @memberof Report
     */
    report_day: number;
    /**
     * 
     * @type {string}
     * @memberof Report
     */
    report_time: string;
    /**
     * 
     * @type {object}
     * @memberof Report
     */
    filters: object;
    /**
     * 
     * @type {boolean}
     * @memberof Report
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface ReportInstance
 */
export interface ReportInstance {
    /**
     * 
     * @type {number}
     * @memberof ReportInstance
     */
    pk: number;
    /**
     * 
     * @type {number}
     * @memberof ReportInstance
     */
    user: number;
    /**
     * 
     * @type {string}
     * @memberof ReportInstance
     */
    report_type: string;
    /**
     * 
     * @type {number}
     * @memberof ReportInstance
     */
    created_at: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportInstance
     */
    is_generated: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportInstance
     */
    report_scope: string;
    /**
     * 
     * @type {object}
     * @memberof ReportInstance
     */
    filters: object;
    /**
     * 
     * @type {string}
     * @memberof ReportInstance
     */
    download_url: string | null;
}
/**
 * 
 * @export
 * @interface ReportInstanceRequest
 */
export interface ReportInstanceRequest {
    /**
     * 
     * @type {string}
     * @memberof ReportInstanceRequest
     */
    report_type: string;
    /**
     * 
     * @type {string}
     * @memberof ReportInstanceRequest
     */
    report_scope: string;
    /**
     * 
     * @type {object}
     * @memberof ReportInstanceRequest
     */
    filters: object;
}
/**
 * 
 * @export
 * @interface ReportInstanceUpdate
 */
export interface ReportInstanceUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof ReportInstanceUpdate
     */
    send_by_email: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum RequestStatus {
    Pending = 'pending',
    Approved = 'approved',
    Rejected = 'rejected'
}

/**
 * 
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    username?: string;
}
/**
 * 
 * @export
 * @interface RichText
 */
export interface RichText {
    /**
     * 
     * @type {string}
     * @memberof RichText
     */
    text: string;
    /**
     * 
     * @type {boolean}
     * @memberof RichText
     */
    bold?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RichText
     */
    italic?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RichText
     */
    underline?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RichText
     */
    color?: string;
}
/**
 * 
 * @export
 * @interface RichTextElement
 */
export interface RichTextElement {
    /**
     * 
     * @type {string}
     * @memberof RichTextElement
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof RichTextElement
     */
    align?: string;
    /**
     * 
     * @type {User}
     * @memberof RichTextElement
     */
    user?: User;
    /**
     * 
     * @type {Array<RichTextElement | RichText>}
     * @memberof RichTextElement
     */
    children: Array<RichTextElement | RichText>;
}
/**
 * 
 * @export
 * @interface RouteData
 */
export interface RouteData {
    /**
     * 
     * @type {Array<ShortLocationSample>}
     * @memberof RouteData
     */
    route: Array<ShortLocationSample>;
    /**
     * 
     * @type {Array<EventDetails>}
     * @memberof RouteData
     */
    events: Array<EventDetails>;
    /**
     * 
     * @type {TripDetails}
     * @memberof RouteData
     */
    trip?: TripDetails;
    /**
     * 
     * @type {Array<number>}
     * @memberof RouteData
     */
    snapshots?: Array<number>;
}
/**
 * 
 * @export
 * @interface RouteWellnessData
 */
export interface RouteWellnessData {
    /**
     * 
     * @type {Array<InCabinWellness>}
     * @memberof RouteWellnessData
     */
    in_cabin_wellness: Array<InCabinWellness>;
    /**
     * 
     * @type {Array<FrontFacingWellness>}
     * @memberof RouteWellnessData
     */
    front_facing_wellness: Array<FrontFacingWellness>;
}
/**
 * 
 * @export
 * @interface RunWellnessRequest
 */
export interface RunWellnessRequest {
    /**
     * 
     * @type {string}
     * @memberof RunWellnessRequest
     */
    task: string;
}
/**
 * 
 * @export
 * @interface SafetyScore
 */
export interface SafetyScore {
    /**
     * 
     * @type {number}
     * @memberof SafetyScore
     */
    score: number;
    /**
     * 
     * @type {string}
     * @memberof SafetyScore
     */
    reason?: string;
}
/**
 * 
 * @export
 * @interface SaveToSessionResult
 */
export interface SaveToSessionResult {
    /**
     * 
     * @type {number}
     * @memberof SaveToSessionResult
     */
    session_id?: number | null;
}
/**
 * 
 * @export
 * @interface Scheme
 */
export interface Scheme {
    /**
     * 
     * @type {number}
     * @memberof Scheme
     */
    angle_start?: number;
    /**
     * 
     * @type {number}
     * @memberof Scheme
     */
    angle_end?: number;
    /**
     * 
     * @type {string}
     * @memberof Scheme
     */
    move_direction?: string;
}
/**
 * 
 * @export
 * @interface SendAccidentRequest
 */
export interface SendAccidentRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof SendAccidentRequest
     */
    recipients: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SendAccidentRequest
     */
    message: string;
}
/**
 * 
 * @export
 * @interface SendEventRequest
 */
export interface SendEventRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof SendEventRequest
     */
    recipients: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SendEventRequest
     */
    message: string;
}
/**
 * 
 * @export
 * @interface SendReportRequest
 */
export interface SendReportRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof SendReportRequest
     */
    recipients: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SendReportRequest
     */
    message: string;
}
/**
 * 
 * @export
 * @interface ShortCoachSession
 */
export interface ShortCoachSession {
    /**
     * 
     * @type {number}
     * @memberof ShortCoachSession
     */
    session_id: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShortCoachSession
     */
    users: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ShortCoachSession
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof ShortCoachSession
     */
    driver_name: string;
    /**
     * 
     * @type {string}
     * @memberof ShortCoachSession
     */
    sub_fleet_name: string;
    /**
     * 
     * @type {number}
     * @memberof ShortCoachSession
     */
    created_at: number;
    /**
     * 
     * @type {number}
     * @memberof ShortCoachSession
     */
    completed_at: number;
    /**
     * 
     * @type {number}
     * @memberof ShortCoachSession
     */
    last_updated: number;
    /**
     * 
     * @type {number}
     * @memberof ShortCoachSession
     */
    last_sent: number | null;
    /**
     * 
     * @type {string}
     * @memberof ShortCoachSession
     */
    last_delivery_status: string | null;
    /**
     * 
     * @type {Array<CoachAgendaItem>}
     * @memberof ShortCoachSession
     */
    agenda?: Array<CoachAgendaItem>;
    /**
     * 
     * @type {boolean}
     * @memberof ShortCoachSession
     */
    auto_generated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ShortCoachSession
     */
    is_saved: boolean;
    /**
     * 
     * @type {number}
     * @memberof ShortCoachSession
     */
    last_completed_session: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShortCoachSession
     */
    driver_score: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShortCoachSession
     */
    assignee: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShortCoachSession
     */
    behaviors: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ShortCoachSession
     */
    completion_method: string | null;
}
/**
 * 
 * @export
 * @interface ShortLocationSample
 */
export interface ShortLocationSample {
    /**
     * 
     * @type {string}
     * @memberof ShortLocationSample
     */
    trip_id: string;
    /**
     * 
     * @type {number}
     * @memberof ShortLocationSample
     */
    timestamp: number;
    /**
     * 
     * @type {number}
     * @memberof ShortLocationSample
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof ShortLocationSample
     */
    longitude: number;
    /**
     * 
     * @type {number}
     * @memberof ShortLocationSample
     */
    speed: number;
    /**
     * 
     * @type {number}
     * @memberof ShortLocationSample
     */
    distance: number;
    /**
     * 
     * @type {string}
     * @memberof ShortLocationSample
     */
    device_id: string;
}
/**
 * 
 * @export
 * @interface ShortLocationSampleAllOf
 */
export interface ShortLocationSampleAllOf {
    /**
     * 
     * @type {string}
     * @memberof ShortLocationSampleAllOf
     */
    device_id: string;
}
/**
 * 
 * @export
 * @interface TaggingData
 */
export interface TaggingData {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TaggingData
     */
    primary_cause: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TaggingData
     */
    fault: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TaggingData
     */
    speed: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TaggingData
     */
    points_of_impact: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TaggingData
     */
    day_of_week: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TaggingData
     */
    hour_of_day: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface TopAssignee
 */
export interface TopAssignee {
    /**
     * 
     * @type {number}
     * @memberof TopAssignee
     */
    user_id: number;
    /**
     * 
     * @type {number}
     * @memberof TopAssignee
     */
    count: number;
}
/**
 * 
 * @export
 * @interface TripDetails
 */
export interface TripDetails {
    /**
     * 
     * @type {number}
     * @memberof TripDetails
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TripDetails
     */
    license_plate?: string;
    /**
     * 
     * @type {string}
     * @memberof TripDetails
     */
    trip_id: string;
    /**
     * 
     * @type {number}
     * @memberof TripDetails
     */
    start_time: number;
    /**
     * 
     * @type {number}
     * @memberof TripDetails
     */
    end_time: number;
    /**
     * 
     * @type {number}
     * @memberof TripDetails
     */
    duration: number;
    /**
     * 
     * @type {number}
     * @memberof TripDetails
     */
    distance: number;
    /**
     * 
     * @type {number}
     * @memberof TripDetails
     */
    driver: number | null;
    /**
     * 
     * @type {string}
     * @memberof TripDetails
     */
    driver_assignment_method: TripDetailsDriverAssignmentMethodEnum;
    /**
     * 
     * @type {Array<EventCount>}
     * @memberof TripDetails
     */
    number_of_events_per_type: Array<EventCount> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TripDetails
     */
    is_deleted: boolean;
    /**
     * 
     * @type {number}
     * @memberof TripDetails
     */
    orig_trip_id?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum TripDetailsDriverAssignmentMethodEnum {
    Null = 'NULL',
    Default = 'DEFAULT',
    Manual = 'MANUAL',
    DriverQr = 'DRIVER_QR'
}

/**
 * 
 * @export
 * @interface TripUpdateRequest
 */
export interface TripUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof TripUpdateRequest
     */
    trip_obj_id: number;
    /**
     * 
     * @type {number}
     * @memberof TripUpdateRequest
     */
    driver_trip_id?: number;
    /**
     * 
     * @type {number}
     * @memberof TripUpdateRequest
     */
    driver_token: number;
    /**
     * 
     * @type {boolean}
     * @memberof TripUpdateRequest
     */
    confirm?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateClaimRequest
 */
export interface UpdateClaimRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof UpdateClaimRequest
     */
    claim_ids?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof UpdateClaimRequest
     */
    accident_id?: number;
}
/**
 * 
 * @export
 * @interface UpdateCoachEvent
 */
export interface UpdateCoachEvent {
    /**
     * 
     * @type {string}
     * @memberof UpdateCoachEvent
     */
    comment: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCoachEvent
     */
    is_blurred: boolean;
}
/**
 * 
 * @export
 * @interface UpdateCoachSession
 */
export interface UpdateCoachSession {
    /**
     * 
     * @type {number}
     * @memberof UpdateCoachSession
     */
    session_id: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCoachSession
     */
    users: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateCoachSession
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCoachSession
     */
    driver_name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCoachSession
     */
    sub_fleet_name: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCoachSession
     */
    created_at: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCoachSession
     */
    completed_at: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCoachSession
     */
    last_updated: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCoachSession
     */
    last_sent: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCoachSession
     */
    last_delivery_status: string | null;
    /**
     * 
     * @type {Array<CoachAgendaItem>}
     * @memberof UpdateCoachSession
     */
    agenda: Array<CoachAgendaItem>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCoachSession
     */
    auto_generated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCoachSession
     */
    is_saved: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateCoachSession
     */
    last_completed_session: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCoachSession
     */
    driver_score: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateCoachSession
     */
    assignee: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateCoachSession
     */
    behaviors: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCoachSession
     */
    completion_method: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateCoachSession
     */
    manager_conclusion: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCoachSession
     */
    driver_conclusion: string;
    /**
     * 
     * @type {Array<CoachEvent>}
     * @memberof UpdateCoachSession
     */
    events: Array<CoachEvent>;
    /**
     * 
     * @type {Array<CoachManagerNotes>}
     * @memberof UpdateCoachSession
     */
    notes: Array<CoachManagerNotes>;
    /**
     * 
     * @type {Array<CoachDriverResponse>}
     * @memberof UpdateCoachSession
     */
    response: Array<CoachDriverResponse>;
    /**
     * 
     * @type {Array<CoachMetrics>}
     * @memberof UpdateCoachSession
     */
    metrics: Array<CoachMetrics>;
    /**
     * 
     * @type {Array<CoachMediaFile>}
     * @memberof UpdateCoachSession
     */
    media_files: Array<CoachMediaFile>;
    /**
     * 
     * @type {Array<CoachWellnessStatus>}
     * @memberof UpdateCoachSession
     */
    wellness_statuses: Array<CoachWellnessStatus>;
    /**
     * 
     * @type {Array<CoachingMetadata>}
     * @memberof UpdateCoachSession
     */
    metadata: Array<CoachingMetadata>;
    /**
     * 
     * @type {FleetDriver}
     * @memberof UpdateCoachSession
     */
    driver: FleetDriver | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCoachSession
     */
    complete?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateCoachSessionAllOf
 */
export interface UpdateCoachSessionAllOf {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCoachSessionAllOf
     */
    complete?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateCoachWellnessStatus
 */
export interface UpdateCoachWellnessStatus {
    /**
     * 
     * @type {string}
     * @memberof UpdateCoachWellnessStatus
     */
    comment: string;
}
/**
 * 
 * @export
 * @interface UploadMediaFileRequest
 */
export interface UploadMediaFileRequest {
    /**
     * 
     * @type {string}
     * @memberof UploadMediaFileRequest
     */
    file_name: string;
    /**
     * 
     * @type {boolean}
     * @memberof UploadMediaFileRequest
     */
    is_public: boolean;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    name: string;
}
/**
 * 
 * @export
 * @interface UserCreationData
 */
export interface UserCreationData {
    /**
     * user full name
     * @type {string}
     * @memberof UserCreationData
     */
    name?: string;
    /**
     * user email
     * @type {string}
     * @memberof UserCreationData
     */
    email?: string;
    /**
     * user phone number
     * @type {string}
     * @memberof UserCreationData
     */
    phone_number?: string;
    /**
     * sub fleet
     * @type {string}
     * @memberof UserCreationData
     */
    sub_fleet?: string;
    /**
     * role of user
     * @type {string}
     * @memberof UserCreationData
     */
    role?: string;
    /**
     * create user in active mode
     * @type {boolean}
     * @memberof UserCreationData
     */
    is_active?: boolean;
    /**
     * send invitation to user
     * @type {boolean}
     * @memberof UserCreationData
     */
    send_invitation?: boolean;
}
/**
 * 
 * @export
 * @interface UserCredentials
 */
export interface UserCredentials {
    /**
     * Username
     * @type {string}
     * @memberof UserCredentials
     */
    username?: string;
    /**
     * Password
     * @type {string}
     * @memberof UserCredentials
     */
    password?: string;
    /**
     * Code - for 2FA
     * @type {string}
     * @memberof UserCredentials
     */
    code?: string;
}
/**
 * 
 * @export
 * @interface UserDetails
 */
export interface UserDetails {
    /**
     * user id
     * @type {number}
     * @memberof UserDetails
     */
    id?: number;
    /**
     * user full name
     * @type {string}
     * @memberof UserDetails
     */
    name?: string;
    /**
     * user email
     * @type {string}
     * @memberof UserDetails
     */
    email?: string;
    /**
     * user phone number
     * @type {string}
     * @memberof UserDetails
     */
    phone_number?: string;
    /**
     * sub fleet
     * @type {string}
     * @memberof UserDetails
     */
    sub_fleet?: string;
    /**
     * role of the user
     * @type {string}
     * @memberof UserDetails
     */
    role?: string;
    /**
     * last login date
     * @type {number}
     * @memberof UserDetails
     */
    last_login?: number | null;
    /**
     * user status
     * @type {boolean}
     * @memberof UserDetails
     */
    is_active?: boolean;
}
/**
 * 
 * @export
 * @interface UserDetailsResponse
 */
export interface UserDetailsResponse {
    /**
     * user id
     * @type {number}
     * @memberof UserDetailsResponse
     */
    id: number;
    /**
     * user full name
     * @type {string}
     * @memberof UserDetailsResponse
     */
    name: string;
    /**
     * user email
     * @type {string}
     * @memberof UserDetailsResponse
     */
    email: string;
    /**
     * user phone number
     * @type {string}
     * @memberof UserDetailsResponse
     */
    phone_number: string;
    /**
     * sub fleet
     * @type {string}
     * @memberof UserDetailsResponse
     */
    sub_fleet: string;
    /**
     * role of the user
     * @type {string}
     * @memberof UserDetailsResponse
     */
    role: string;
    /**
     * last login date
     * @type {number}
     * @memberof UserDetailsResponse
     */
    last_login: number | null;
    /**
     * user status
     * @type {boolean}
     * @memberof UserDetailsResponse
     */
    is_active: boolean;
}
/**
 * 
 * @export
 * @interface UserNotification
 */
export interface UserNotification {
    /**
     * 
     * @type {number}
     * @memberof UserNotification
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof UserNotification
     */
    created_at: number;
    /**
     * 
     * @type {UserNotificationText}
     * @memberof UserNotification
     */
    text: UserNotificationText;
    /**
     * 
     * @type {number}
     * @memberof UserNotification
     */
    related_user: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserNotification
     */
    link: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserNotification
     */
    is_read: boolean;
}
/**
 * 
 * @export
 * @interface UserNotificationList
 */
export interface UserNotificationList {
    /**
     * 
     * @type {number}
     * @memberof UserNotificationList
     */
    user_id: number;
    /**
     * 
     * @type {number}
     * @memberof UserNotificationList
     */
    last_seen: number | null;
    /**
     * 
     * @type {number}
     * @memberof UserNotificationList
     */
    new_count: number;
    /**
     * 
     * @type {Array<UserNotification>}
     * @memberof UserNotificationList
     */
    notifications: Array<UserNotification>;
    /**
     * 
     * @type {number}
     * @memberof UserNotificationList
     */
    next_notification_id: number | null;
}
/**
 * 
 * @export
 * @interface UserNotificationRequest
 */
export interface UserNotificationRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UserNotificationRequest
     */
    is_read: boolean;
}
/**
 * 
 * @export
 * @interface UserNotificationSettings
 */
export interface UserNotificationSettings {
    /**
     * 
     * @type {NotificationSettings}
     * @memberof UserNotificationSettings
     */
    upcoming_features: NotificationSettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof UserNotificationSettings
     */
    mentions: NotificationSettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof UserNotificationSettings
     */
    accident_update: NotificationSettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof UserNotificationSettings
     */
    coach_assignment: NotificationSettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof UserNotificationSettings
     */
    coach_completed: NotificationSettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof UserNotificationSettings
     */
    pending_session: NotificationSettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof UserNotificationSettings
     */
    malfunction_assignment: NotificationSettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof UserNotificationSettings
     */
    malfunction_comment: NotificationSettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof UserNotificationSettings
     */
    malfunction_resolved: NotificationSettings;
    /**
     * 
     * @type {NotificationSettings}
     * @memberof UserNotificationSettings
     */
    event_feed_comment: NotificationSettings;
}
/**
 * 
 * @export
 * @interface UserNotificationText
 */
export interface UserNotificationText {
    /**
     * 
     * @type {string}
     * @memberof UserNotificationText
     */
    en?: string;
    /**
     * 
     * @type {string}
     * @memberof UserNotificationText
     */
    he?: string;
}
/**
 * 
 * @export
 * @interface UserProfile
 */
export interface UserProfile {
    /**
     * 
     * @type {number}
     * @memberof UserProfile
     */
    user_id: number;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfile
     */
    admin: boolean;
    /**
     * 
     * @type {UserRole}
     * @memberof UserProfile
     */
    role: UserRole;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    sub_fleet: string;
    /**
     * 
     * @type {CustomerData}
     * @memberof UserProfile
     */
    customer: CustomerData;
    /**
     * user selected language code
     * @type {string}
     * @memberof UserProfile
     */
    language: string;
    /**
     * user selected timezone
     * @type {string}
     * @memberof UserProfile
     */
    timezone: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    locale: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    home_page: string;
    /**
     * 
     * @type {number}
     * @memberof UserProfile
     */
    accident_notification_cooldown_minutes: number;
    /**
     * 
     * @type {number}
     * @memberof UserProfile
     */
    notify_pending_session_after_days: number;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfile
     */
    image_url?: string | null;
    /**
     * 
     * @type {UserNotificationSettings}
     * @memberof UserProfile
     */
    notifications: UserNotificationSettings;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof UserProfile
     */
    other_fleets: { [key: string]: string; };
}
/**
 * role name - new permission scheme
 * @export
 * @enum {string}
 */
export enum UserRole {
    OeAdmin = 'oe_admin',
    OeInsuranceOperator = 'oe_insurance_operator',
    OeDev = 'oe_dev',
    FleetAdmin = 'fleet_admin',
    FleetInsuranceOperator = 'fleet_insurance_operator',
    FleetSafetyManager = 'fleet_safety_manager',
    FleetExecutive = 'fleet_executive',
    Driver = 'driver',
    CarShop = 'car_shop',
    Technician = 'technician',
    GuestTechnician = 'guest_technician'
}

/**
 * 
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * 
     * @type {Contact}
     * @memberof Vehicle
     */
    contact: Contact;
    /**
     * 
     * @type {boolean}
     * @memberof Vehicle
     */
    third_party: boolean;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    year_of_manufacture: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    model: string;
}
/**
 * 
 * @export
 * @interface VerifyCamerasRequest
 */
export interface VerifyCamerasRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyCamerasRequest
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyCamerasRequest
     */
    installer: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyCamerasRequest
     */
    snapshot: string;
    /**
     * 
     * @type {number}
     * @memberof VerifyCamerasRequest
     */
    malfunction_id?: number;
}
/**
 * 
 * @export
 * @interface VideoPreviewRequest
 */
export interface VideoPreviewRequest {
    /**
     * 
     * @type {number}
     * @memberof VideoPreviewRequest
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof VideoPreviewRequest
     */
    trip_id: number;
    /**
     * 
     * @type {number}
     * @memberof VideoPreviewRequest
     */
    driver_trip_id?: number;
    /**
     * 
     * @type {string}
     * @memberof VideoPreviewRequest
     */
    status: VideoPreviewRequestStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof VideoPreviewRequest
     */
    created_at: number;
    /**
     * 
     * @type {string}
     * @memberof VideoPreviewRequest
     */
    video_url: string;
    /**
     * 
     * @type {number}
     * @memberof VideoPreviewRequest
     */
    event_id: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof VideoPreviewRequest
     */
    partial: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum VideoPreviewRequestStatusEnum {
    Pending = 'pending',
    Success = 'success',
    Failure = 'failure'
}

/**
 * 
 * @export
 * @interface VideoPreviewRequestBody
 */
export interface VideoPreviewRequestBody {
    /**
     * 
     * @type {number}
     * @memberof VideoPreviewRequestBody
     */
    trip_id: number;
    /**
     * 
     * @type {number}
     * @memberof VideoPreviewRequestBody
     */
    driver_trip_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VideoPreviewRequestBody
     */
    partial?: boolean;
}
/**
 * 
 * @export
 * @interface Wellness
 */
export interface Wellness {
    /**
     * 
     * @type {string}
     * @memberof Wellness
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof Wellness
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof Wellness
     */
    status: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Wellness
     */
    timestamp: number;
    /**
     * 
     * @type {object}
     * @memberof Wellness
     */
    metadata?: object | null;
}
/**
 * 
 * @export
 * @interface WellnessList
 */
export interface WellnessList {
    /**
     * 
     * @type {Array<Wellness>}
     * @memberof WellnessList
     */
    data: Array<Wellness>;
    /**
     * 
     * @type {number}
     * @memberof WellnessList
     */
    next_page: number | null;
}
/**
 * 
 * @export
 * @interface WellnessScore
 */
export interface WellnessScore {
    /**
     * 
     * @type {number}
     * @memberof WellnessScore
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof WellnessScore
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof WellnessScore
     */
    driver_name: string;
    /**
     * 
     * @type {string}
     * @memberof WellnessScore
     */
    sub_fleet: string;
    /**
     * 
     * @type {number}
     * @memberof WellnessScore
     */
    score: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof WellnessScore
     */
    in_cabin_wellness_ids: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof WellnessScore
     */
    front_facing_wellness_ids: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof WellnessScore
     */
    event_ids: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof WellnessScore
     */
    event_types: string;
    /**
     * 
     * @type {number}
     * @memberof WellnessScore
     */
    most_recent_event_datetime: number | null;
    /**
     * 
     * @type {number}
     * @memberof WellnessScore
     */
    most_recent_event_id: number | null;
}
/**
 * 
 * @export
 * @interface WellnessScoreDetails
 */
export interface WellnessScoreDetails {
    /**
     * 
     * @type {number}
     * @memberof WellnessScoreDetails
     */
    timestamp: number;
    /**
     * 
     * @type {string}
     * @memberof WellnessScoreDetails
     */
    license_plate: string;
    /**
     * 
     * @type {string}
     * @memberof WellnessScoreDetails
     */
    driver_name: string;
    /**
     * 
     * @type {string}
     * @memberof WellnessScoreDetails
     */
    sub_fleet: string;
    /**
     * 
     * @type {number}
     * @memberof WellnessScoreDetails
     */
    score: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof WellnessScoreDetails
     */
    in_cabin_wellness_ids: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof WellnessScoreDetails
     */
    front_facing_wellness_ids: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof WellnessScoreDetails
     */
    event_ids: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof WellnessScoreDetails
     */
    event_types: string;
    /**
     * 
     * @type {number}
     * @memberof WellnessScoreDetails
     */
    most_recent_event_datetime: number | null;
    /**
     * 
     * @type {number}
     * @memberof WellnessScoreDetails
     */
    most_recent_event_id: number | null;
    /**
     * 
     * @type {Array<InCabinWellnessV1>}
     * @memberof WellnessScoreDetails
     */
    in_cabin_wellness_statuses: Array<InCabinWellnessV1>;
    /**
     * 
     * @type {Array<FrontFacingWellness>}
     * @memberof WellnessScoreDetails
     */
    front_facing_wellness_statuses: Array<FrontFacingWellness>;
    /**
     * 
     * @type {Array<EventDetails>}
     * @memberof WellnessScoreDetails
     */
    events: Array<EventDetails>;
    /**
     * 
     * @type {FleetDriver}
     * @memberof WellnessScoreDetails
     */
    driver: FleetDriver;
}
/**
 * 
 * @export
 * @interface WellnessScoreDetailsAllOf
 */
export interface WellnessScoreDetailsAllOf {
    /**
     * 
     * @type {Array<InCabinWellnessV1>}
     * @memberof WellnessScoreDetailsAllOf
     */
    in_cabin_wellness_statuses: Array<InCabinWellnessV1>;
    /**
     * 
     * @type {Array<FrontFacingWellness>}
     * @memberof WellnessScoreDetailsAllOf
     */
    front_facing_wellness_statuses: Array<FrontFacingWellness>;
    /**
     * 
     * @type {Array<EventDetails>}
     * @memberof WellnessScoreDetailsAllOf
     */
    events: Array<EventDetails>;
    /**
     * 
     * @type {FleetDriver}
     * @memberof WellnessScoreDetailsAllOf
     */
    driver: FleetDriver;
}
/**
 * 
 * @export
 * @interface WellnessUpdate
 */
export interface WellnessUpdate {
    /**
     * 
     * @type {string}
     * @memberof WellnessUpdate
     */
    device_id: string;
    /**
     * 
     * @type {string}
     * @memberof WellnessUpdate
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof WellnessUpdate
     */
    status: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof WellnessUpdate
     */
    data?: string;
}
/**
 * 
 * @export
 * @interface Witness
 */
export interface Witness {
    /**
     * 
     * @type {number}
     * @memberof Witness
     */
    witness_id: number;
    /**
     * 
     * @type {number}
     * @memberof Witness
     */
    accident_id: number;
    /**
     * 
     * @type {Contact}
     * @memberof Witness
     */
    contact: Contact;
    /**
     * 
     * @type {string}
     * @memberof Witness
     */
    statement: string;
}

/**
 * AgencyApi - axios parameter creator
 * @export
 */
export const AgencyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get list of claims
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimGet: async (date?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v0/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update claim assigned to accident
         * @param {Array<UpdateClaimRequest>} [updateClaimRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimPatch: async (updateClaimRequest?: Array<UpdateClaimRequest>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v0/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClaimRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Load claim data
         * @param {LoadClaimsRequest} [loadClaimsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimPost: async (loadClaimsRequest?: LoadClaimsRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v0/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loadClaimsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get upload url for claim file
         * @param {ClaimFileRequest} [claimFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimUploadPost: async (claimFileRequest?: ClaimFileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v0/claim/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(claimFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0EventEventIdGet: async (eventId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('agencyV0EventEventIdGet', 'eventId', eventId)
            const localVarPath = `/agency/v0/event/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get event image
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0EventEventIdImageGet: async (eventId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('agencyV0EventEventIdImageGet', 'eventId', eventId)
            const localVarPath = `/agency/v0/event/{eventId}/image`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of insurance periods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v0/period`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update insurance period
         * @param {number} periodId 
         * @param {InsurancePeriod} [insurancePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodPeriodIdPatch: async (periodId: number, insurancePeriod?: InsurancePeriod, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'periodId' is not null or undefined
            assertParamExists('agencyV0PeriodPeriodIdPatch', 'periodId', periodId)
            const localVarPath = `/agency/v0/period/{periodId}`
                .replace(`{${"periodId"}}`, encodeURIComponent(String(periodId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(insurancePeriod, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new insurance period
         * @param {InsurancePeriod} [insurancePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodPost: async (insurancePeriod?: InsurancePeriod, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v0/period`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(insurancePeriod, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Do action on artifact
         * @summary Do action on artifact
         * @param {number} accidentId 
         * @param {number} artifactId 
         * @param {ArtifactAction} [artifactAction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactArtifactIdActionPost: async (accidentId: number, artifactId: number, artifactAction?: ArtifactAction, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdArtifactArtifactIdActionPost', 'accidentId', accidentId)
            // verify required parameter 'artifactId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdArtifactArtifactIdActionPost', 'artifactId', artifactId)
            const localVarPath = `/agency/v1/accident/{accidentId}/artifact/{artifactId}/action`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)))
                .replace(`{${"artifactId"}}`, encodeURIComponent(String(artifactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(artifactAction, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get signed url for artifact
         * @summary Get signed url for artifact
         * @param {number} accidentId 
         * @param {number} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactArtifactIdGet: async (accidentId: number, artifactId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdArtifactArtifactIdGet', 'accidentId', accidentId)
            // verify required parameter 'artifactId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdArtifactArtifactIdGet', 'artifactId', artifactId)
            const localVarPath = `/agency/v1/accident/{accidentId}/artifact/{artifactId}`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)))
                .replace(`{${"artifactId"}}`, encodeURIComponent(String(artifactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get upload url for artifact
         * @summary Get upload url for artifact
         * @param {number} accidentId 
         * @param {FileData} [fileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactPost: async (accidentId: number, fileData?: FileData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdArtifactPost', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/artifact`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new artifact
         * @summary Create new artifact
         * @param {number} accidentId 
         * @param {ArtifactRequest} [artifactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactPut: async (accidentId: number, artifactRequest?: ArtifactRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdArtifactPut', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/artifact`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(artifactRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update comment
         * @summary Update comment
         * @param {number} accidentId 
         * @param {number} commentId 
         * @param {Comment} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdCommentCommentIdPatch: async (accidentId: number, commentId: number, comment?: Comment, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdCommentCommentIdPatch', 'accidentId', accidentId)
            // verify required parameter 'commentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdCommentCommentIdPatch', 'commentId', commentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/comment/{commentId}`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)))
                .replace(`{${"commentId"}}`, encodeURIComponent(String(commentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(comment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new comment
         * @summary Create new comment
         * @param {number} accidentId 
         * @param {Comment} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdCommentPost: async (accidentId: number, comment?: Comment, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdCommentPost', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/comment`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(comment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get damage details
         * @summary Get damage details
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdGet: async (accidentId: number, damageId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamageDamageIdGet', 'accidentId', accidentId)
            // verify required parameter 'damageId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamageDamageIdGet', 'damageId', damageId)
            const localVarPath = `/agency/v1/accident/{accidentId}/damage/{damageId}`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)))
                .replace(`{${"damageId"}}`, encodeURIComponent(String(damageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update damage details
         * @summary Update damage details
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {Damage} [damage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPatch: async (accidentId: number, damageId: number, damage?: Damage, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamageDamageIdPatch', 'accidentId', accidentId)
            // verify required parameter 'damageId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamageDamageIdPatch', 'damageId', damageId)
            const localVarPath = `/agency/v1/accident/{accidentId}/damage/{damageId}`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)))
                .replace(`{${"damageId"}}`, encodeURIComponent(String(damageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete payment
         * @summary Delete payment
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {number} paymentId 
         * @param {Payment} [payment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete: async (accidentId: number, damageId: number, paymentId: number, payment?: Payment, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete', 'accidentId', accidentId)
            // verify required parameter 'damageId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete', 'damageId', damageId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete', 'paymentId', paymentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/damage/{damageId}/payment/{paymentId}`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)))
                .replace(`{${"damageId"}}`, encodeURIComponent(String(damageId)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change payment status
         * @summary Change payment status
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {number} paymentId 
         * @param {Payment} [payment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch: async (accidentId: number, damageId: number, paymentId: number, payment?: Payment, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch', 'accidentId', accidentId)
            // verify required parameter 'damageId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch', 'damageId', damageId)
            // verify required parameter 'paymentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch', 'paymentId', paymentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/damage/{damageId}/payment/{paymentId}`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)))
                .replace(`{${"damageId"}}`, encodeURIComponent(String(damageId)))
                .replace(`{${"paymentId"}}`, encodeURIComponent(String(paymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new payment
         * @summary Create new payment
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {Payment} [payment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPost: async (accidentId: number, damageId: number, payment?: Payment, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamageDamageIdPaymentPost', 'accidentId', accidentId)
            // verify required parameter 'damageId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamageDamageIdPaymentPost', 'damageId', damageId)
            const localVarPath = `/agency/v1/accident/{accidentId}/damage/{damageId}/payment`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)))
                .replace(`{${"damageId"}}`, encodeURIComponent(String(damageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create damage
         * @summary Create damage
         * @param {number} accidentId 
         * @param {Damage} [damage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamagePost: async (accidentId: number, damage?: Damage, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDamagePost', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/damage`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create or update driver details
         * @summary Create or update driver details
         * @param {number} accidentId 
         * @param {Driver} [driver] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDriverPost: async (accidentId: number, driver?: Driver, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdDriverPost', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/driver`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(driver, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get accident details
         * @summary Get accident details
         * @param {number} accidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdGet: async (accidentId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdGet', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create accident notice form
         * @param {number} accidentId 
         * @param {NoticeRequest} [noticeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNoticePost: async (accidentId: number, noticeRequest?: NoticeRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdNoticePost', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/notice`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noticeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete notification for accident
         * @param {number} accidentId 
         * @param {NotificationRequest} [notificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationDelete: async (accidentId: number, notificationRequest?: NotificationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdNotificationDelete', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/notification`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get notifications list for accident
         * @param {number} accidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationGet: async (accidentId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdNotificationGet', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/notification`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update notification for accident
         * @param {number} accidentId 
         * @param {NotificationRequest} [notificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationPatch: async (accidentId: number, notificationRequest?: NotificationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdNotificationPatch', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/notification`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new notification for accident
         * @param {number} accidentId 
         * @param {NotificationRequest} [notificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationPost: async (accidentId: number, notificationRequest?: NotificationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdNotificationPost', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/notification`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {number} accidentId 
         * @param {ExtendedAccident} extendedAccident Update data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdPatch: async (accidentId: number, extendedAccident: ExtendedAccident, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdPatch', 'accidentId', accidentId)
            // verify required parameter 'extendedAccident' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdPatch', 'extendedAccident', extendedAccident)
            const localVarPath = `/agency/v1/accident/{accidentId}`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extendedAccident, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send accident to users
         * @param {number} accidentId 
         * @param {SendAccidentRequest} [sendAccidentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdSendPost: async (accidentId: number, sendAccidentRequest?: SendAccidentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdSendPost', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/send`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendAccidentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId 
         * @param {AccidentTags} [accidentTags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsPatch: async (accidentId: number, accidentTags?: AccidentTags, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdTagsPatch', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/tags`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accidentTags, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId 
         * @param {AccidentTags} [accidentTags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsPost: async (accidentId: number, accidentTags?: AccidentTags, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdTagsPost', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/tags`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accidentTags, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get accident tags
         * @summary get accident tags
         * @param {number} accidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Get: async (accidentId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdTagsV1Get', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/tags/v1`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId 
         * @param {AccidentTagsV1} [accidentTagsV1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Patch: async (accidentId: number, accidentTagsV1?: AccidentTagsV1, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdTagsV1Patch', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/tags/v1`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accidentTagsV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId 
         * @param {AccidentTagsV1} [accidentTagsV1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Post: async (accidentId: number, accidentTagsV1?: AccidentTagsV1, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdTagsV1Post', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/tags/v1`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accidentTagsV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get accident tags
         * @summary get accident tags
         * @param {number} accidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Get: async (accidentId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdTagsV2Get', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/tags/v2`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId 
         * @param {AccidentTagsV2} [accidentTagsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Patch: async (accidentId: number, accidentTagsV2?: AccidentTagsV2, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdTagsV2Patch', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/tags/v2`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accidentTagsV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId 
         * @param {AccidentTagsV2} [accidentTagsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Post: async (accidentId: number, accidentTagsV2?: AccidentTagsV2, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdTagsV2Post', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/tags/v2`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(accidentTagsV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new witness statement
         * @summary Create new witness statement
         * @param {number} accidentId 
         * @param {Witness} [witness] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdWitnessPost: async (accidentId: number, witness?: Witness, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdWitnessPost', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/accident/{accidentId}/witness`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(witness, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update witness statement
         * @summary Update witness statement
         * @param {number} accidentId 
         * @param {number} witnessId 
         * @param {Witness} [witness] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdWitnessWitnessIdPatch: async (accidentId: number, witnessId: number, witness?: Witness, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdWitnessWitnessIdPatch', 'accidentId', accidentId)
            // verify required parameter 'witnessId' is not null or undefined
            assertParamExists('agencyV1AccidentAccidentIdWitnessWitnessIdPatch', 'witnessId', witnessId)
            const localVarPath = `/agency/v1/accident/{accidentId}/witness/{witnessId}`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)))
                .replace(`{${"witnessId"}}`, encodeURIComponent(String(witnessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(witness, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of customer\'s articat tags
         * @summary Get list of customer\'s articat tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentArtifactTagsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v1/accident/artifact/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {string} [licensePlate] 
         * @param {string} [normLicensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [subFleet] 
         * @param {boolean} [isClosed] 
         * @param {number} [timeFrom] 
         * @param {number} [timeTo] 
         * @param {number} [createdFrom] 
         * @param {number} [createdTo] 
         * @param {number} [lastId] 
         * @param {number} [csv] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentGet: async (licensePlate?: string, normLicensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, subFleet?: string, isClosed?: boolean, timeFrom?: number, timeTo?: number, createdFrom?: number, createdTo?: number, lastId?: number, csv?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v1/accident`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (licensePlate !== undefined) {
                localVarQueryParameter['license_plate'] = licensePlate;
            }

            if (normLicensePlate !== undefined) {
                localVarQueryParameter['norm_license_plate'] = normLicensePlate;
            }

            if (driverName !== undefined) {
                localVarQueryParameter['driver_name'] = driverName;
            }

            if (licensePlateContains !== undefined) {
                localVarQueryParameter['license_plate_contains'] = licensePlateContains;
            }

            if (driverNameContains !== undefined) {
                localVarQueryParameter['driver_name_contains'] = driverNameContains;
            }

            if (subFleet !== undefined) {
                localVarQueryParameter['sub_fleet'] = subFleet;
            }

            if (isClosed !== undefined) {
                localVarQueryParameter['is_closed'] = isClosed;
            }

            if (timeFrom !== undefined) {
                localVarQueryParameter['time_from'] = timeFrom;
            }

            if (timeTo !== undefined) {
                localVarQueryParameter['time_to'] = timeTo;
            }

            if (createdFrom !== undefined) {
                localVarQueryParameter['created_from'] = createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['created_to'] = createdTo;
            }

            if (lastId !== undefined) {
                localVarQueryParameter['last_id'] = lastId;
            }

            if (csv !== undefined) {
                localVarQueryParameter['csv'] = csv;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create accident
         * @summary Create accident
         * @param {ExtendedAccident} extendedAccident Accident to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentPost: async (extendedAccident: ExtendedAccident, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'extendedAccident' is not null or undefined
            assertParamExists('agencyV1AccidentPost', 'extendedAccident', extendedAccident)
            const localVarPath = `/agency/v1/accident`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extendedAccident, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1CustomerDataGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v1/customer/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new customer data
         * @param {CustomerHandlingStatus} [customerHandlingStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1CustomerDataPost: async (customerHandlingStatus?: CustomerHandlingStatus, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v1/customer/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerHandlingStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create disposal letter for damage
         * @param {string} damageId 
         * @param {DisposalLetterRequest} [disposalLetterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DamageDamageIdDisposalPost: async (damageId: string, disposalLetterRequest?: DisposalLetterRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageId' is not null or undefined
            assertParamExists('agencyV1DamageDamageIdDisposalPost', 'damageId', damageId)
            const localVarPath = `/agency/v1/damage/{damageId}/disposal`
                .replace(`{${"damageId"}}`, encodeURIComponent(String(damageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(disposalLetterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload file for accident from driver form
         * @param {number} accidentId 
         * @param {ExtendedFileData} [extendedFileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdFilePost: async (accidentId: number, extendedFileData?: ExtendedFileData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1DriverFormAccidentIdFilePost', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/driver/form/{accidentId}/file`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extendedFileData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new artifact
         * @summary Create new artifact
         * @param {number} accidentId 
         * @param {ExtendedArtifact} [extendedArtifact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdFilePut: async (accidentId: number, extendedArtifact?: ExtendedArtifact, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1DriverFormAccidentIdFilePut', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/driver/form/{accidentId}/file`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extendedArtifact, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get app review from driver form
         * @param {number} accidentId 
         * @param {DriverFormReview} [driverFormReview] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdReviewPost: async (accidentId: number, driverFormReview?: DriverFormReview, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV1DriverFormAccidentIdReviewPost', 'accidentId', accidentId)
            const localVarPath = `/agency/v1/driver/form/{accidentId}/review`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(driverFormReview, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create accident from driver form
         * @param {DriverForm} [driverForm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormPost: async (driverForm?: DriverForm, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v1/driver/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(driverForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get policy list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v1/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update policy
         * @param {number} policyId 
         * @param {PolicyV1Request} [policyV1Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyPolicyIdPatch: async (policyId: number, policyV1Request?: PolicyV1Request, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('agencyV1PolicyPolicyIdPatch', 'policyId', policyId)
            const localVarPath = `/agency/v1/policy/{policyId}`
                .replace(`{${"policyId"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyV1Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new policy
         * @param {PolicyV1Request} [policyV1Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyPost: async (policyV1Request?: PolicyV1Request, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v1/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyV1Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new notification for accident (UI only)
         * @param {number} accidentId 
         * @param {NotificationRequestV2} [notificationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2AccidentAccidentIdNotificationPost: async (accidentId: number, notificationRequestV2?: NotificationRequestV2, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'accidentId' is not null or undefined
            assertParamExists('agencyV2AccidentAccidentIdNotificationPost', 'accidentId', accidentId)
            const localVarPath = `/agency/v2/accident/{accidentId}/notification`
                .replace(`{${"accidentId"}}`, encodeURIComponent(String(accidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notificationRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {string} [licensePlate] 
         * @param {string} [normLicensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [subFleet] 
         * @param {boolean} [isClosed] 
         * @param {number} [timeFrom] 
         * @param {number} [timeTo] 
         * @param {number} [createdFrom] 
         * @param {number} [createdTo] 
         * @param {number} [lastId] 
         * @param {number} [limit] 
         * @param {number} [csv] 
         * @param {string} [damageCause] 
         * @param {string} [speed] 
         * @param {string} [fault] 
         * @param {string} [pointOfImpact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2AccidentGet: async (licensePlate?: string, normLicensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, subFleet?: string, isClosed?: boolean, timeFrom?: number, timeTo?: number, createdFrom?: number, createdTo?: number, lastId?: number, limit?: number, csv?: number, damageCause?: string, speed?: string, fault?: string, pointOfImpact?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v2/accident`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (licensePlate !== undefined) {
                localVarQueryParameter['license_plate'] = licensePlate;
            }

            if (normLicensePlate !== undefined) {
                localVarQueryParameter['norm_license_plate'] = normLicensePlate;
            }

            if (driverName !== undefined) {
                localVarQueryParameter['driver_name'] = driverName;
            }

            if (licensePlateContains !== undefined) {
                localVarQueryParameter['license_plate_contains'] = licensePlateContains;
            }

            if (driverNameContains !== undefined) {
                localVarQueryParameter['driver_name_contains'] = driverNameContains;
            }

            if (subFleet !== undefined) {
                localVarQueryParameter['sub_fleet'] = subFleet;
            }

            if (isClosed !== undefined) {
                localVarQueryParameter['is_closed'] = isClosed;
            }

            if (timeFrom !== undefined) {
                localVarQueryParameter['time_from'] = timeFrom;
            }

            if (timeTo !== undefined) {
                localVarQueryParameter['time_to'] = timeTo;
            }

            if (createdFrom !== undefined) {
                localVarQueryParameter['created_from'] = createdFrom;
            }

            if (createdTo !== undefined) {
                localVarQueryParameter['created_to'] = createdTo;
            }

            if (lastId !== undefined) {
                localVarQueryParameter['last_id'] = lastId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (csv !== undefined) {
                localVarQueryParameter['csv'] = csv;
            }

            if (damageCause !== undefined) {
                localVarQueryParameter['damage_cause'] = damageCause;
            }

            if (speed !== undefined) {
                localVarQueryParameter['speed'] = speed;
            }

            if (fault !== undefined) {
                localVarQueryParameter['fault'] = fault;
            }

            if (pointOfImpact !== undefined) {
                localVarQueryParameter['point_of_impact'] = pointOfImpact;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get report with vehicles to charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyChargeGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v2/policy/charge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a policy by IDs
         * @param {PolicyDeleteRequest} policyDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyDelete: async (policyDeleteRequest: PolicyDeleteRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyDeleteRequest' is not null or undefined
            assertParamExists('agencyV2PolicyDelete', 'policyDeleteRequest', policyDeleteRequest)
            const localVarPath = `/agency/v2/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyDeleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve all customer\'s policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agency/v2/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a policy by ID
         * @param {number} policyId ID of the policy to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdDelete: async (policyId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('agencyV2PolicyPolicyIdDelete', 'policyId', policyId)
            const localVarPath = `/agency/v2/policy/{policyId}`
                .replace(`{${"policyId"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a policy by ID
         * @param {number} policyId ID of the policy to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdGet: async (policyId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('agencyV2PolicyPolicyIdGet', 'policyId', policyId)
            const localVarPath = `/agency/v2/policy/{policyId}`
                .replace(`{${"policyId"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or update a policy
         * @param {number} policyId ID of the policy to update (optional)
         * @param {Array<PolicyV2>} policyV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdPost: async (policyId: number, policyV2: Array<PolicyV2>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyId' is not null or undefined
            assertParamExists('agencyV2PolicyPolicyIdPost', 'policyId', policyId)
            // verify required parameter 'policyV2' is not null or undefined
            assertParamExists('agencyV2PolicyPolicyIdPost', 'policyV2', policyV2)
            const localVarPath = `/agency/v2/policy/{policyId}`
                .replace(`{${"policyId"}}`, encodeURIComponent(String(policyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or update list of policies
         * @param {Array<PolicyV2>} policyV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPost: async (policyV2: Array<PolicyV2>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'policyV2' is not null or undefined
            assertParamExists('agencyV2PolicyPost', 'policyV2', policyV2)
            const localVarPath = `/agency/v2/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(policyV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost: async (oTPUserCredentials?: OTPUserCredentials, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(oTPUserCredentials, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user token
         * @param {UserCredentials} [userCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost: async (userCredentials?: UserCredentials, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCredentials, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost: async (refreshTokenRequest?: RefreshTokenRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgencyApi - functional programming interface
 * @export
 */
export const AgencyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgencyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get list of claims
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV0ClaimGet(date?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClaimData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV0ClaimGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update claim assigned to accident
         * @param {Array<UpdateClaimRequest>} [updateClaimRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV0ClaimPatch(updateClaimRequest?: Array<UpdateClaimRequest>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV0ClaimPatch(updateClaimRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Load claim data
         * @param {LoadClaimsRequest} [loadClaimsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV0ClaimPost(loadClaimsRequest?: LoadClaimsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadClaimsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV0ClaimPost(loadClaimsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get upload url for claim file
         * @param {ClaimFileRequest} [claimFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV0ClaimUploadPost(claimFileRequest?: ClaimFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV0ClaimUploadPost(claimFileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV0EventEventIdGet(eventId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV0EventEventIdGet(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get event image
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV0EventEventIdImageGet(eventId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV0EventEventIdImageGet(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of insurance periods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV0PeriodGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InsurancePeriod>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV0PeriodGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update insurance period
         * @param {number} periodId 
         * @param {InsurancePeriod} [insurancePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV0PeriodPeriodIdPatch(periodId: number, insurancePeriod?: InsurancePeriod, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsurancePeriod>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV0PeriodPeriodIdPatch(periodId, insurancePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new insurance period
         * @param {InsurancePeriod} [insurancePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV0PeriodPost(insurancePeriod?: InsurancePeriod, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsurancePeriod>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV0PeriodPost(insurancePeriod, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Do action on artifact
         * @summary Do action on artifact
         * @param {number} accidentId 
         * @param {number} artifactId 
         * @param {ArtifactAction} [artifactAction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdArtifactArtifactIdActionPost(accidentId: number, artifactId: number, artifactAction?: ArtifactAction, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdArtifactArtifactIdActionPost(accidentId, artifactId, artifactAction, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get signed url for artifact
         * @summary Get signed url for artifact
         * @param {number} accidentId 
         * @param {number} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdArtifactArtifactIdGet(accidentId: number, artifactId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdArtifactArtifactIdGet(accidentId, artifactId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get upload url for artifact
         * @summary Get upload url for artifact
         * @param {number} accidentId 
         * @param {FileData} [fileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdArtifactPost(accidentId: number, fileData?: FileData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdArtifactPost(accidentId, fileData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create new artifact
         * @summary Create new artifact
         * @param {number} accidentId 
         * @param {ArtifactRequest} [artifactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdArtifactPut(accidentId: number, artifactRequest?: ArtifactRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Artifact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdArtifactPut(accidentId, artifactRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update comment
         * @summary Update comment
         * @param {number} accidentId 
         * @param {number} commentId 
         * @param {Comment} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdCommentCommentIdPatch(accidentId: number, commentId: number, comment?: Comment, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdCommentCommentIdPatch(accidentId, commentId, comment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create new comment
         * @summary Create new comment
         * @param {number} accidentId 
         * @param {Comment} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdCommentPost(accidentId: number, comment?: Comment, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdCommentPost(accidentId, comment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get damage details
         * @summary Get damage details
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdDamageDamageIdGet(accidentId: number, damageId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Damage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdDamageDamageIdGet(accidentId, damageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update damage details
         * @summary Update damage details
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {Damage} [damage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdDamageDamageIdPatch(accidentId: number, damageId: number, damage?: Damage, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Damage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdDamageDamageIdPatch(accidentId, damageId, damage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete payment
         * @summary Delete payment
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {number} paymentId 
         * @param {Payment} [payment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete(accidentId: number, damageId: number, paymentId: number, payment?: Payment, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete(accidentId, damageId, paymentId, payment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Change payment status
         * @summary Change payment status
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {number} paymentId 
         * @param {Payment} [payment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch(accidentId: number, damageId: number, paymentId: number, payment?: Payment, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch(accidentId, damageId, paymentId, payment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create new payment
         * @summary Create new payment
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {Payment} [payment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdDamageDamageIdPaymentPost(accidentId: number, damageId: number, payment?: Payment, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdDamageDamageIdPaymentPost(accidentId, damageId, payment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create damage
         * @summary Create damage
         * @param {number} accidentId 
         * @param {Damage} [damage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdDamagePost(accidentId: number, damage?: Damage, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Damage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdDamagePost(accidentId, damage, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create or update driver details
         * @summary Create or update driver details
         * @param {number} accidentId 
         * @param {Driver} [driver] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdDriverPost(accidentId: number, driver?: Driver, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Driver>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdDriverPost(accidentId, driver, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get accident details
         * @summary Get accident details
         * @param {number} accidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdGet(accidentId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendedAccident>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdGet(accidentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create accident notice form
         * @param {number} accidentId 
         * @param {NoticeRequest} [noticeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdNoticePost(accidentId: number, noticeRequest?: NoticeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Artifact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdNoticePost(accidentId, noticeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete notification for accident
         * @param {number} accidentId 
         * @param {NotificationRequest} [notificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdNotificationDelete(accidentId: number, notificationRequest?: NotificationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdNotificationDelete(accidentId, notificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get notifications list for accident
         * @param {number} accidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdNotificationGet(accidentId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Notification>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdNotificationGet(accidentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update notification for accident
         * @param {number} accidentId 
         * @param {NotificationRequest} [notificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdNotificationPatch(accidentId: number, notificationRequest?: NotificationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdNotificationPatch(accidentId, notificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new notification for accident
         * @param {number} accidentId 
         * @param {NotificationRequest} [notificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdNotificationPost(accidentId: number, notificationRequest?: NotificationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Notification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdNotificationPost(accidentId, notificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {number} accidentId 
         * @param {ExtendedAccident} extendedAccident Update data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdPatch(accidentId: number, extendedAccident: ExtendedAccident, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendedAccident>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdPatch(accidentId, extendedAccident, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send accident to users
         * @param {number} accidentId 
         * @param {SendAccidentRequest} [sendAccidentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdSendPost(accidentId: number, sendAccidentRequest?: SendAccidentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdSendPost(accidentId, sendAccidentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId 
         * @param {AccidentTags} [accidentTags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdTagsPatch(accidentId: number, accidentTags?: AccidentTags, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsPatch(accidentId, accidentTags, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId 
         * @param {AccidentTags} [accidentTags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdTagsPost(accidentId: number, accidentTags?: AccidentTags, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsPost(accidentId, accidentTags, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get accident tags
         * @summary get accident tags
         * @param {number} accidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdTagsV1Get(accidentId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccidentTagsV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsV1Get(accidentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId 
         * @param {AccidentTagsV1} [accidentTagsV1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdTagsV1Patch(accidentId: number, accidentTagsV1?: AccidentTagsV1, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsV1Patch(accidentId, accidentTagsV1, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId 
         * @param {AccidentTagsV1} [accidentTagsV1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdTagsV1Post(accidentId: number, accidentTagsV1?: AccidentTagsV1, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsV1Post(accidentId, accidentTagsV1, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get accident tags
         * @summary get accident tags
         * @param {number} accidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdTagsV2Get(accidentId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccidentTagsV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsV2Get(accidentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId 
         * @param {AccidentTagsV2} [accidentTagsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdTagsV2Patch(accidentId: number, accidentTagsV2?: AccidentTagsV2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsV2Patch(accidentId, accidentTagsV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId 
         * @param {AccidentTagsV2} [accidentTagsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdTagsV2Post(accidentId: number, accidentTagsV2?: AccidentTagsV2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdTagsV2Post(accidentId, accidentTagsV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create new witness statement
         * @summary Create new witness statement
         * @param {number} accidentId 
         * @param {Witness} [witness] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdWitnessPost(accidentId: number, witness?: Witness, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Witness>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdWitnessPost(accidentId, witness, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update witness statement
         * @summary Update witness statement
         * @param {number} accidentId 
         * @param {number} witnessId 
         * @param {Witness} [witness] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentAccidentIdWitnessWitnessIdPatch(accidentId: number, witnessId: number, witness?: Witness, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentAccidentIdWitnessWitnessIdPatch(accidentId, witnessId, witness, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of customer\'s articat tags
         * @summary Get list of customer\'s articat tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentArtifactTagsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentArtifactTagsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {string} [licensePlate] 
         * @param {string} [normLicensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [subFleet] 
         * @param {boolean} [isClosed] 
         * @param {number} [timeFrom] 
         * @param {number} [timeTo] 
         * @param {number} [createdFrom] 
         * @param {number} [createdTo] 
         * @param {number} [lastId] 
         * @param {number} [csv] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentGet(licensePlate?: string, normLicensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, subFleet?: string, isClosed?: boolean, timeFrom?: number, timeTo?: number, createdFrom?: number, createdTo?: number, lastId?: number, csv?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseAccident>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentGet(licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, csv, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create accident
         * @summary Create accident
         * @param {ExtendedAccident} extendedAccident Accident to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1AccidentPost(extendedAccident: ExtendedAccident, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendedAccident>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1AccidentPost(extendedAccident, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get customer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1CustomerDataGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerData1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1CustomerDataGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new customer data
         * @param {CustomerHandlingStatus} [customerHandlingStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1CustomerDataPost(customerHandlingStatus?: CustomerHandlingStatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerHandlingStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1CustomerDataPost(customerHandlingStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create disposal letter for damage
         * @param {string} damageId 
         * @param {DisposalLetterRequest} [disposalLetterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1DamageDamageIdDisposalPost(damageId: string, disposalLetterRequest?: DisposalLetterRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Artifact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1DamageDamageIdDisposalPost(damageId, disposalLetterRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload file for accident from driver form
         * @param {number} accidentId 
         * @param {ExtendedFileData} [extendedFileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1DriverFormAccidentIdFilePost(accidentId: number, extendedFileData?: ExtendedFileData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1DriverFormAccidentIdFilePost(accidentId, extendedFileData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create new artifact
         * @summary Create new artifact
         * @param {number} accidentId 
         * @param {ExtendedArtifact} [extendedArtifact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1DriverFormAccidentIdFilePut(accidentId: number, extendedArtifact?: ExtendedArtifact, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Artifact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1DriverFormAccidentIdFilePut(accidentId, extendedArtifact, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get app review from driver form
         * @param {number} accidentId 
         * @param {DriverFormReview} [driverFormReview] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1DriverFormAccidentIdReviewPost(accidentId: number, driverFormReview?: DriverFormReview, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1DriverFormAccidentIdReviewPost(accidentId, driverFormReview, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create accident from driver form
         * @param {DriverForm} [driverForm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1DriverFormPost(driverForm?: DriverForm, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1DriverFormPost(driverForm, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get policy list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1PolicyGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PolicyV1Response>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1PolicyGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update policy
         * @param {number} policyId 
         * @param {PolicyV1Request} [policyV1Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1PolicyPolicyIdPatch(policyId: number, policyV1Request?: PolicyV1Request, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyV1Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1PolicyPolicyIdPatch(policyId, policyV1Request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new policy
         * @param {PolicyV1Request} [policyV1Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV1PolicyPost(policyV1Request?: PolicyV1Request, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PolicyV1Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV1PolicyPost(policyV1Request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new notification for accident (UI only)
         * @param {number} accidentId 
         * @param {NotificationRequestV2} [notificationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV2AccidentAccidentIdNotificationPost(accidentId: number, notificationRequestV2?: NotificationRequestV2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV2AccidentAccidentIdNotificationPost(accidentId, notificationRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {string} [licensePlate] 
         * @param {string} [normLicensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [subFleet] 
         * @param {boolean} [isClosed] 
         * @param {number} [timeFrom] 
         * @param {number} [timeTo] 
         * @param {number} [createdFrom] 
         * @param {number} [createdTo] 
         * @param {number} [lastId] 
         * @param {number} [limit] 
         * @param {number} [csv] 
         * @param {string} [damageCause] 
         * @param {string} [speed] 
         * @param {string} [fault] 
         * @param {string} [pointOfImpact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV2AccidentGet(licensePlate?: string, normLicensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, subFleet?: string, isClosed?: boolean, timeFrom?: number, timeTo?: number, createdFrom?: number, createdTo?: number, lastId?: number, limit?: number, csv?: number, damageCause?: string, speed?: string, fault?: string, pointOfImpact?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseAccidentV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV2AccidentGet(licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, limit, csv, damageCause, speed, fault, pointOfImpact, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get report with vehicles to charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV2PolicyChargeGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV2PolicyChargeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a policy by IDs
         * @param {PolicyDeleteRequest} policyDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV2PolicyDelete(policyDeleteRequest: PolicyDeleteRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV2PolicyDelete(policyDeleteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve all customer\'s policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV2PolicyGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PolicyV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV2PolicyGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a policy by ID
         * @param {number} policyId ID of the policy to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV2PolicyPolicyIdDelete(policyId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV2PolicyPolicyIdDelete(policyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a policy by ID
         * @param {number} policyId ID of the policy to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV2PolicyPolicyIdGet(policyId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PolicyV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV2PolicyPolicyIdGet(policyId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create or update a policy
         * @param {number} policyId ID of the policy to update (optional)
         * @param {Array<PolicyV2>} policyV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV2PolicyPolicyIdPost(policyId: number, policyV2: Array<PolicyV2>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PolicyV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV2PolicyPolicyIdPost(policyId, policyV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create or update list of policies
         * @param {Array<PolicyV2>} policyV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agencyV2PolicyPost(policyV2: Array<PolicyV2>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PolicyV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agencyV2PolicyPost(policyV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthOtpPost(oTPUserCredentials?: OTPUserCredentials, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWTToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthOtpPost(oTPUserCredentials, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user token
         * @param {UserCredentials} [userCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthPost(userCredentials?: UserCredentials, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWTToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthPost(userCredentials, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthRefreshPost(refreshTokenRequest?: RefreshTokenRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWTToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthRefreshPost(refreshTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgencyApi - factory interface
 * @export
 */
export const AgencyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgencyApiFp(configuration)
    return {
        /**
         * 
         * @summary Get list of claims
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimGet(date?: string, options?: any): AxiosPromise<Array<ClaimData>> {
            return localVarFp.agencyV0ClaimGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update claim assigned to accident
         * @param {Array<UpdateClaimRequest>} [updateClaimRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimPatch(updateClaimRequest?: Array<UpdateClaimRequest>, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV0ClaimPatch(updateClaimRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Load claim data
         * @param {LoadClaimsRequest} [loadClaimsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimPost(loadClaimsRequest?: LoadClaimsRequest, options?: any): AxiosPromise<LoadClaimsResponse> {
            return localVarFp.agencyV0ClaimPost(loadClaimsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get upload url for claim file
         * @param {ClaimFileRequest} [claimFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0ClaimUploadPost(claimFileRequest?: ClaimFileRequest, options?: any): AxiosPromise<FileUploadData> {
            return localVarFp.agencyV0ClaimUploadPost(claimFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0EventEventIdGet(eventId: number, options?: any): AxiosPromise<EventDetails> {
            return localVarFp.agencyV0EventEventIdGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get event image
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0EventEventIdImageGet(eventId: number, options?: any): AxiosPromise<any> {
            return localVarFp.agencyV0EventEventIdImageGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of insurance periods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodGet(options?: any): AxiosPromise<Array<InsurancePeriod>> {
            return localVarFp.agencyV0PeriodGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update insurance period
         * @param {number} periodId 
         * @param {InsurancePeriod} [insurancePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodPeriodIdPatch(periodId: number, insurancePeriod?: InsurancePeriod, options?: any): AxiosPromise<InsurancePeriod> {
            return localVarFp.agencyV0PeriodPeriodIdPatch(periodId, insurancePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new insurance period
         * @param {InsurancePeriod} [insurancePeriod] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV0PeriodPost(insurancePeriod?: InsurancePeriod, options?: any): AxiosPromise<InsurancePeriod> {
            return localVarFp.agencyV0PeriodPost(insurancePeriod, options).then((request) => request(axios, basePath));
        },
        /**
         * Do action on artifact
         * @summary Do action on artifact
         * @param {number} accidentId 
         * @param {number} artifactId 
         * @param {ArtifactAction} [artifactAction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactArtifactIdActionPost(accidentId: number, artifactId: number, artifactAction?: ArtifactAction, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdArtifactArtifactIdActionPost(accidentId, artifactId, artifactAction, options).then((request) => request(axios, basePath));
        },
        /**
         * Get signed url for artifact
         * @summary Get signed url for artifact
         * @param {number} accidentId 
         * @param {number} artifactId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactArtifactIdGet(accidentId: number, artifactId: number, options?: any): AxiosPromise<string> {
            return localVarFp.agencyV1AccidentAccidentIdArtifactArtifactIdGet(accidentId, artifactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get upload url for artifact
         * @summary Get upload url for artifact
         * @param {number} accidentId 
         * @param {FileData} [fileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactPost(accidentId: number, fileData?: FileData, options?: any): AxiosPromise<FileUploadData> {
            return localVarFp.agencyV1AccidentAccidentIdArtifactPost(accidentId, fileData, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new artifact
         * @summary Create new artifact
         * @param {number} accidentId 
         * @param {ArtifactRequest} [artifactRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdArtifactPut(accidentId: number, artifactRequest?: ArtifactRequest, options?: any): AxiosPromise<Artifact> {
            return localVarFp.agencyV1AccidentAccidentIdArtifactPut(accidentId, artifactRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update comment
         * @summary Update comment
         * @param {number} accidentId 
         * @param {number} commentId 
         * @param {Comment} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdCommentCommentIdPatch(accidentId: number, commentId: number, comment?: Comment, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdCommentCommentIdPatch(accidentId, commentId, comment, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new comment
         * @summary Create new comment
         * @param {number} accidentId 
         * @param {Comment} [comment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdCommentPost(accidentId: number, comment?: Comment, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdCommentPost(accidentId, comment, options).then((request) => request(axios, basePath));
        },
        /**
         * Get damage details
         * @summary Get damage details
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdGet(accidentId: number, damageId: number, options?: any): AxiosPromise<Damage> {
            return localVarFp.agencyV1AccidentAccidentIdDamageDamageIdGet(accidentId, damageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update damage details
         * @summary Update damage details
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {Damage} [damage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPatch(accidentId: number, damageId: number, damage?: Damage, options?: any): AxiosPromise<Damage> {
            return localVarFp.agencyV1AccidentAccidentIdDamageDamageIdPatch(accidentId, damageId, damage, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete payment
         * @summary Delete payment
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {number} paymentId 
         * @param {Payment} [payment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete(accidentId: number, damageId: number, paymentId: number, payment?: Payment, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete(accidentId, damageId, paymentId, payment, options).then((request) => request(axios, basePath));
        },
        /**
         * Change payment status
         * @summary Change payment status
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {number} paymentId 
         * @param {Payment} [payment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch(accidentId: number, damageId: number, paymentId: number, payment?: Payment, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch(accidentId, damageId, paymentId, payment, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new payment
         * @summary Create new payment
         * @param {number} accidentId 
         * @param {number} damageId 
         * @param {Payment} [payment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamageDamageIdPaymentPost(accidentId: number, damageId: number, payment?: Payment, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdDamageDamageIdPaymentPost(accidentId, damageId, payment, options).then((request) => request(axios, basePath));
        },
        /**
         * Create damage
         * @summary Create damage
         * @param {number} accidentId 
         * @param {Damage} [damage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDamagePost(accidentId: number, damage?: Damage, options?: any): AxiosPromise<Damage> {
            return localVarFp.agencyV1AccidentAccidentIdDamagePost(accidentId, damage, options).then((request) => request(axios, basePath));
        },
        /**
         * Create or update driver details
         * @summary Create or update driver details
         * @param {number} accidentId 
         * @param {Driver} [driver] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdDriverPost(accidentId: number, driver?: Driver, options?: any): AxiosPromise<Driver> {
            return localVarFp.agencyV1AccidentAccidentIdDriverPost(accidentId, driver, options).then((request) => request(axios, basePath));
        },
        /**
         * Get accident details
         * @summary Get accident details
         * @param {number} accidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdGet(accidentId: number, options?: any): AxiosPromise<ExtendedAccident> {
            return localVarFp.agencyV1AccidentAccidentIdGet(accidentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create accident notice form
         * @param {number} accidentId 
         * @param {NoticeRequest} [noticeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNoticePost(accidentId: number, noticeRequest?: NoticeRequest, options?: any): AxiosPromise<Artifact> {
            return localVarFp.agencyV1AccidentAccidentIdNoticePost(accidentId, noticeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete notification for accident
         * @param {number} accidentId 
         * @param {NotificationRequest} [notificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationDelete(accidentId: number, notificationRequest?: NotificationRequest, options?: any): AxiosPromise<Notification> {
            return localVarFp.agencyV1AccidentAccidentIdNotificationDelete(accidentId, notificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get notifications list for accident
         * @param {number} accidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationGet(accidentId: number, options?: any): AxiosPromise<Array<Notification>> {
            return localVarFp.agencyV1AccidentAccidentIdNotificationGet(accidentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update notification for accident
         * @param {number} accidentId 
         * @param {NotificationRequest} [notificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationPatch(accidentId: number, notificationRequest?: NotificationRequest, options?: any): AxiosPromise<Notification> {
            return localVarFp.agencyV1AccidentAccidentIdNotificationPatch(accidentId, notificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new notification for accident
         * @param {number} accidentId 
         * @param {NotificationRequest} [notificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdNotificationPost(accidentId: number, notificationRequest?: NotificationRequest, options?: any): AxiosPromise<Notification> {
            return localVarFp.agencyV1AccidentAccidentIdNotificationPost(accidentId, notificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {number} accidentId 
         * @param {ExtendedAccident} extendedAccident Update data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdPatch(accidentId: number, extendedAccident: ExtendedAccident, options?: any): AxiosPromise<ExtendedAccident> {
            return localVarFp.agencyV1AccidentAccidentIdPatch(accidentId, extendedAccident, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send accident to users
         * @param {number} accidentId 
         * @param {SendAccidentRequest} [sendAccidentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdSendPost(accidentId: number, sendAccidentRequest?: SendAccidentRequest, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdSendPost(accidentId, sendAccidentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId 
         * @param {AccidentTags} [accidentTags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsPatch(accidentId: number, accidentTags?: AccidentTags, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdTagsPatch(accidentId, accidentTags, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId 
         * @param {AccidentTags} [accidentTags] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsPost(accidentId: number, accidentTags?: AccidentTags, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdTagsPost(accidentId, accidentTags, options).then((request) => request(axios, basePath));
        },
        /**
         * get accident tags
         * @summary get accident tags
         * @param {number} accidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Get(accidentId: number, options?: any): AxiosPromise<AccidentTagsV1> {
            return localVarFp.agencyV1AccidentAccidentIdTagsV1Get(accidentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId 
         * @param {AccidentTagsV1} [accidentTagsV1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Patch(accidentId: number, accidentTagsV1?: AccidentTagsV1, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdTagsV1Patch(accidentId, accidentTagsV1, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId 
         * @param {AccidentTagsV1} [accidentTagsV1] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV1Post(accidentId: number, accidentTagsV1?: AccidentTagsV1, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdTagsV1Post(accidentId, accidentTagsV1, options).then((request) => request(axios, basePath));
        },
        /**
         * get accident tags
         * @summary get accident tags
         * @param {number} accidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Get(accidentId: number, options?: any): AxiosPromise<AccidentTagsV2> {
            return localVarFp.agencyV1AccidentAccidentIdTagsV2Get(accidentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update accident tags
         * @summary Update accident tags
         * @param {number} accidentId 
         * @param {AccidentTagsV2} [accidentTagsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Patch(accidentId: number, accidentTagsV2?: AccidentTagsV2, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdTagsV2Patch(accidentId, accidentTagsV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new accident tags
         * @summary Create new accident tags
         * @param {number} accidentId 
         * @param {AccidentTagsV2} [accidentTagsV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdTagsV2Post(accidentId: number, accidentTagsV2?: AccidentTagsV2, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdTagsV2Post(accidentId, accidentTagsV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new witness statement
         * @summary Create new witness statement
         * @param {number} accidentId 
         * @param {Witness} [witness] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdWitnessPost(accidentId: number, witness?: Witness, options?: any): AxiosPromise<Witness> {
            return localVarFp.agencyV1AccidentAccidentIdWitnessPost(accidentId, witness, options).then((request) => request(axios, basePath));
        },
        /**
         * Update witness statement
         * @summary Update witness statement
         * @param {number} accidentId 
         * @param {number} witnessId 
         * @param {Witness} [witness] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentAccidentIdWitnessWitnessIdPatch(accidentId: number, witnessId: number, witness?: Witness, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV1AccidentAccidentIdWitnessWitnessIdPatch(accidentId, witnessId, witness, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of customer\'s articat tags
         * @summary Get list of customer\'s articat tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentArtifactTagsGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.agencyV1AccidentArtifactTagsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {string} [licensePlate] 
         * @param {string} [normLicensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [subFleet] 
         * @param {boolean} [isClosed] 
         * @param {number} [timeFrom] 
         * @param {number} [timeTo] 
         * @param {number} [createdFrom] 
         * @param {number} [createdTo] 
         * @param {number} [lastId] 
         * @param {number} [csv] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentGet(licensePlate?: string, normLicensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, subFleet?: string, isClosed?: boolean, timeFrom?: number, timeTo?: number, createdFrom?: number, createdTo?: number, lastId?: number, csv?: number, options?: any): AxiosPromise<Array<BaseAccident>> {
            return localVarFp.agencyV1AccidentGet(licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, csv, options).then((request) => request(axios, basePath));
        },
        /**
         * Create accident
         * @summary Create accident
         * @param {ExtendedAccident} extendedAccident Accident to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1AccidentPost(extendedAccident: ExtendedAccident, options?: any): AxiosPromise<ExtendedAccident> {
            return localVarFp.agencyV1AccidentPost(extendedAccident, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get customer data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1CustomerDataGet(options?: any): AxiosPromise<CustomerData1> {
            return localVarFp.agencyV1CustomerDataGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new customer data
         * @param {CustomerHandlingStatus} [customerHandlingStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1CustomerDataPost(customerHandlingStatus?: CustomerHandlingStatus, options?: any): AxiosPromise<CustomerHandlingStatus> {
            return localVarFp.agencyV1CustomerDataPost(customerHandlingStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create disposal letter for damage
         * @param {string} damageId 
         * @param {DisposalLetterRequest} [disposalLetterRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DamageDamageIdDisposalPost(damageId: string, disposalLetterRequest?: DisposalLetterRequest, options?: any): AxiosPromise<Artifact> {
            return localVarFp.agencyV1DamageDamageIdDisposalPost(damageId, disposalLetterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload file for accident from driver form
         * @param {number} accidentId 
         * @param {ExtendedFileData} [extendedFileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdFilePost(accidentId: number, extendedFileData?: ExtendedFileData, options?: any): AxiosPromise<FileUploadData> {
            return localVarFp.agencyV1DriverFormAccidentIdFilePost(accidentId, extendedFileData, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new artifact
         * @summary Create new artifact
         * @param {number} accidentId 
         * @param {ExtendedArtifact} [extendedArtifact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdFilePut(accidentId: number, extendedArtifact?: ExtendedArtifact, options?: any): AxiosPromise<Artifact> {
            return localVarFp.agencyV1DriverFormAccidentIdFilePut(accidentId, extendedArtifact, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get app review from driver form
         * @param {number} accidentId 
         * @param {DriverFormReview} [driverFormReview] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormAccidentIdReviewPost(accidentId: number, driverFormReview?: DriverFormReview, options?: any): AxiosPromise<InlineResponse2003> {
            return localVarFp.agencyV1DriverFormAccidentIdReviewPost(accidentId, driverFormReview, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create accident from driver form
         * @param {DriverForm} [driverForm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1DriverFormPost(driverForm?: DriverForm, options?: any): AxiosPromise<InlineResponse2002> {
            return localVarFp.agencyV1DriverFormPost(driverForm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get policy list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyGet(options?: any): AxiosPromise<Array<PolicyV1Response>> {
            return localVarFp.agencyV1PolicyGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update policy
         * @param {number} policyId 
         * @param {PolicyV1Request} [policyV1Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyPolicyIdPatch(policyId: number, policyV1Request?: PolicyV1Request, options?: any): AxiosPromise<PolicyV1Response> {
            return localVarFp.agencyV1PolicyPolicyIdPatch(policyId, policyV1Request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new policy
         * @param {PolicyV1Request} [policyV1Request] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV1PolicyPost(policyV1Request?: PolicyV1Request, options?: any): AxiosPromise<PolicyV1Response> {
            return localVarFp.agencyV1PolicyPost(policyV1Request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new notification for accident (UI only)
         * @param {number} accidentId 
         * @param {NotificationRequestV2} [notificationRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2AccidentAccidentIdNotificationPost(accidentId: number, notificationRequestV2?: NotificationRequestV2, options?: any): AxiosPromise<NotificationResponseV2> {
            return localVarFp.agencyV2AccidentAccidentIdNotificationPost(accidentId, notificationRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of accidents
         * @summary Get list of accidents
         * @param {string} [licensePlate] 
         * @param {string} [normLicensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [subFleet] 
         * @param {boolean} [isClosed] 
         * @param {number} [timeFrom] 
         * @param {number} [timeTo] 
         * @param {number} [createdFrom] 
         * @param {number} [createdTo] 
         * @param {number} [lastId] 
         * @param {number} [limit] 
         * @param {number} [csv] 
         * @param {string} [damageCause] 
         * @param {string} [speed] 
         * @param {string} [fault] 
         * @param {string} [pointOfImpact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2AccidentGet(licensePlate?: string, normLicensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, subFleet?: string, isClosed?: boolean, timeFrom?: number, timeTo?: number, createdFrom?: number, createdTo?: number, lastId?: number, limit?: number, csv?: number, damageCause?: string, speed?: string, fault?: string, pointOfImpact?: string, options?: any): AxiosPromise<Array<BaseAccidentV2>> {
            return localVarFp.agencyV2AccidentGet(licensePlate, normLicensePlate, driverName, licensePlateContains, driverNameContains, subFleet, isClosed, timeFrom, timeTo, createdFrom, createdTo, lastId, limit, csv, damageCause, speed, fault, pointOfImpact, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get report with vehicles to charge
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyChargeGet(options?: any): AxiosPromise<void> {
            return localVarFp.agencyV2PolicyChargeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a policy by IDs
         * @param {PolicyDeleteRequest} policyDeleteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyDelete(policyDeleteRequest: PolicyDeleteRequest, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV2PolicyDelete(policyDeleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve all customer\'s policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyGet(options?: any): AxiosPromise<Array<PolicyV2>> {
            return localVarFp.agencyV2PolicyGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a policy by ID
         * @param {number} policyId ID of the policy to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdDelete(policyId: number, options?: any): AxiosPromise<void> {
            return localVarFp.agencyV2PolicyPolicyIdDelete(policyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a policy by ID
         * @param {number} policyId ID of the policy to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdGet(policyId: number, options?: any): AxiosPromise<Array<PolicyV2>> {
            return localVarFp.agencyV2PolicyPolicyIdGet(policyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or update a policy
         * @param {number} policyId ID of the policy to update (optional)
         * @param {Array<PolicyV2>} policyV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPolicyIdPost(policyId: number, policyV2: Array<PolicyV2>, options?: any): AxiosPromise<Array<PolicyV2>> {
            return localVarFp.agencyV2PolicyPolicyIdPost(policyId, policyV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or update list of policies
         * @param {Array<PolicyV2>} policyV2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agencyV2PolicyPost(policyV2: Array<PolicyV2>, options?: any): AxiosPromise<Array<PolicyV2>> {
            return localVarFp.agencyV2PolicyPost(policyV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost(oTPUserCredentials?: OTPUserCredentials, options?: any): AxiosPromise<JWTToken> {
            return localVarFp.apiAuthOtpPost(oTPUserCredentials, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user token
         * @param {UserCredentials} [userCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost(userCredentials?: UserCredentials, options?: any): AxiosPromise<JWTToken> {
            return localVarFp.apiAuthPost(userCredentials, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost(refreshTokenRequest?: RefreshTokenRequest, options?: any): AxiosPromise<JWTToken> {
            return localVarFp.apiAuthRefreshPost(refreshTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for agencyV0ClaimGet operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV0ClaimGetRequest
 */
export interface AgencyApiAgencyV0ClaimGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV0ClaimGet
     */
    readonly date?: string
}

/**
 * Request parameters for agencyV0ClaimPatch operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV0ClaimPatchRequest
 */
export interface AgencyApiAgencyV0ClaimPatchRequest {
    /**
     * 
     * @type {Array<UpdateClaimRequest>}
     * @memberof AgencyApiAgencyV0ClaimPatch
     */
    readonly updateClaimRequest?: Array<UpdateClaimRequest>
}

/**
 * Request parameters for agencyV0ClaimPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV0ClaimPostRequest
 */
export interface AgencyApiAgencyV0ClaimPostRequest {
    /**
     * 
     * @type {LoadClaimsRequest}
     * @memberof AgencyApiAgencyV0ClaimPost
     */
    readonly loadClaimsRequest?: LoadClaimsRequest
}

/**
 * Request parameters for agencyV0ClaimUploadPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV0ClaimUploadPostRequest
 */
export interface AgencyApiAgencyV0ClaimUploadPostRequest {
    /**
     * 
     * @type {ClaimFileRequest}
     * @memberof AgencyApiAgencyV0ClaimUploadPost
     */
    readonly claimFileRequest?: ClaimFileRequest
}

/**
 * Request parameters for agencyV0EventEventIdGet operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV0EventEventIdGetRequest
 */
export interface AgencyApiAgencyV0EventEventIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV0EventEventIdGet
     */
    readonly eventId: number
}

/**
 * Request parameters for agencyV0EventEventIdImageGet operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV0EventEventIdImageGetRequest
 */
export interface AgencyApiAgencyV0EventEventIdImageGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV0EventEventIdImageGet
     */
    readonly eventId: number
}

/**
 * Request parameters for agencyV0PeriodPeriodIdPatch operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV0PeriodPeriodIdPatchRequest
 */
export interface AgencyApiAgencyV0PeriodPeriodIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV0PeriodPeriodIdPatch
     */
    readonly periodId: number

    /**
     * 
     * @type {InsurancePeriod}
     * @memberof AgencyApiAgencyV0PeriodPeriodIdPatch
     */
    readonly insurancePeriod?: InsurancePeriod
}

/**
 * Request parameters for agencyV0PeriodPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV0PeriodPostRequest
 */
export interface AgencyApiAgencyV0PeriodPostRequest {
    /**
     * 
     * @type {InsurancePeriod}
     * @memberof AgencyApiAgencyV0PeriodPost
     */
    readonly insurancePeriod?: InsurancePeriod
}

/**
 * Request parameters for agencyV1AccidentAccidentIdArtifactArtifactIdActionPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdActionPostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdActionPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdActionPost
     */
    readonly accidentId: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdActionPost
     */
    readonly artifactId: number

    /**
     * 
     * @type {ArtifactAction}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdActionPost
     */
    readonly artifactAction?: ArtifactAction
}

/**
 * Request parameters for agencyV1AccidentAccidentIdArtifactArtifactIdGet operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdGetRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdGet
     */
    readonly accidentId: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdGet
     */
    readonly artifactId: number
}

/**
 * Request parameters for agencyV1AccidentAccidentIdArtifactPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdArtifactPostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdArtifactPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdArtifactPost
     */
    readonly accidentId: number

    /**
     * 
     * @type {FileData}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdArtifactPost
     */
    readonly fileData?: FileData
}

/**
 * Request parameters for agencyV1AccidentAccidentIdArtifactPut operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdArtifactPutRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdArtifactPutRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdArtifactPut
     */
    readonly accidentId: number

    /**
     * 
     * @type {ArtifactRequest}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdArtifactPut
     */
    readonly artifactRequest?: ArtifactRequest
}

/**
 * Request parameters for agencyV1AccidentAccidentIdCommentCommentIdPatch operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdCommentCommentIdPatchRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdCommentCommentIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdCommentCommentIdPatch
     */
    readonly accidentId: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdCommentCommentIdPatch
     */
    readonly commentId: number

    /**
     * 
     * @type {Comment}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdCommentCommentIdPatch
     */
    readonly comment?: Comment
}

/**
 * Request parameters for agencyV1AccidentAccidentIdCommentPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdCommentPostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdCommentPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdCommentPost
     */
    readonly accidentId: number

    /**
     * 
     * @type {Comment}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdCommentPost
     */
    readonly comment?: Comment
}

/**
 * Request parameters for agencyV1AccidentAccidentIdDamageDamageIdGet operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdGetRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdGet
     */
    readonly accidentId: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdGet
     */
    readonly damageId: number
}

/**
 * Request parameters for agencyV1AccidentAccidentIdDamageDamageIdPatch operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPatchRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPatch
     */
    readonly accidentId: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPatch
     */
    readonly damageId: number

    /**
     * 
     * @type {Damage}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPatch
     */
    readonly damage?: Damage
}

/**
 * Request parameters for agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDeleteRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete
     */
    readonly accidentId: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete
     */
    readonly damageId: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete
     */
    readonly paymentId: number

    /**
     * 
     * @type {Payment}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete
     */
    readonly payment?: Payment
}

/**
 * Request parameters for agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatchRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch
     */
    readonly accidentId: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch
     */
    readonly damageId: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch
     */
    readonly paymentId: number

    /**
     * 
     * @type {Payment}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch
     */
    readonly payment?: Payment
}

/**
 * Request parameters for agencyV1AccidentAccidentIdDamageDamageIdPaymentPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPost
     */
    readonly accidentId: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPost
     */
    readonly damageId: number

    /**
     * 
     * @type {Payment}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPost
     */
    readonly payment?: Payment
}

/**
 * Request parameters for agencyV1AccidentAccidentIdDamagePost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdDamagePostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdDamagePostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamagePost
     */
    readonly accidentId: number

    /**
     * 
     * @type {Damage}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDamagePost
     */
    readonly damage?: Damage
}

/**
 * Request parameters for agencyV1AccidentAccidentIdDriverPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdDriverPostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdDriverPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDriverPost
     */
    readonly accidentId: number

    /**
     * 
     * @type {Driver}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdDriverPost
     */
    readonly driver?: Driver
}

/**
 * Request parameters for agencyV1AccidentAccidentIdGet operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdGetRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdGet
     */
    readonly accidentId: number
}

/**
 * Request parameters for agencyV1AccidentAccidentIdNoticePost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdNoticePostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdNoticePostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdNoticePost
     */
    readonly accidentId: number

    /**
     * 
     * @type {NoticeRequest}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdNoticePost
     */
    readonly noticeRequest?: NoticeRequest
}

/**
 * Request parameters for agencyV1AccidentAccidentIdNotificationDelete operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdNotificationDeleteRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdNotificationDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdNotificationDelete
     */
    readonly accidentId: number

    /**
     * 
     * @type {NotificationRequest}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdNotificationDelete
     */
    readonly notificationRequest?: NotificationRequest
}

/**
 * Request parameters for agencyV1AccidentAccidentIdNotificationGet operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdNotificationGetRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdNotificationGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdNotificationGet
     */
    readonly accidentId: number
}

/**
 * Request parameters for agencyV1AccidentAccidentIdNotificationPatch operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdNotificationPatchRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdNotificationPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdNotificationPatch
     */
    readonly accidentId: number

    /**
     * 
     * @type {NotificationRequest}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdNotificationPatch
     */
    readonly notificationRequest?: NotificationRequest
}

/**
 * Request parameters for agencyV1AccidentAccidentIdNotificationPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdNotificationPostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdNotificationPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdNotificationPost
     */
    readonly accidentId: number

    /**
     * 
     * @type {NotificationRequest}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdNotificationPost
     */
    readonly notificationRequest?: NotificationRequest
}

/**
 * Request parameters for agencyV1AccidentAccidentIdPatch operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdPatchRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdPatch
     */
    readonly accidentId: number

    /**
     * Update data
     * @type {ExtendedAccident}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdPatch
     */
    readonly extendedAccident: ExtendedAccident
}

/**
 * Request parameters for agencyV1AccidentAccidentIdSendPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdSendPostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdSendPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdSendPost
     */
    readonly accidentId: number

    /**
     * 
     * @type {SendAccidentRequest}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdSendPost
     */
    readonly sendAccidentRequest?: SendAccidentRequest
}

/**
 * Request parameters for agencyV1AccidentAccidentIdTagsPatch operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdTagsPatchRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdTagsPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsPatch
     */
    readonly accidentId: number

    /**
     * 
     * @type {AccidentTags}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsPatch
     */
    readonly accidentTags?: AccidentTags
}

/**
 * Request parameters for agencyV1AccidentAccidentIdTagsPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdTagsPostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdTagsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsPost
     */
    readonly accidentId: number

    /**
     * 
     * @type {AccidentTags}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsPost
     */
    readonly accidentTags?: AccidentTags
}

/**
 * Request parameters for agencyV1AccidentAccidentIdTagsV1Get operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdTagsV1GetRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdTagsV1GetRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsV1Get
     */
    readonly accidentId: number
}

/**
 * Request parameters for agencyV1AccidentAccidentIdTagsV1Patch operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdTagsV1PatchRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdTagsV1PatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsV1Patch
     */
    readonly accidentId: number

    /**
     * 
     * @type {AccidentTagsV1}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsV1Patch
     */
    readonly accidentTagsV1?: AccidentTagsV1
}

/**
 * Request parameters for agencyV1AccidentAccidentIdTagsV1Post operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdTagsV1PostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdTagsV1PostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsV1Post
     */
    readonly accidentId: number

    /**
     * 
     * @type {AccidentTagsV1}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsV1Post
     */
    readonly accidentTagsV1?: AccidentTagsV1
}

/**
 * Request parameters for agencyV1AccidentAccidentIdTagsV2Get operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdTagsV2GetRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdTagsV2GetRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsV2Get
     */
    readonly accidentId: number
}

/**
 * Request parameters for agencyV1AccidentAccidentIdTagsV2Patch operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdTagsV2PatchRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdTagsV2PatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsV2Patch
     */
    readonly accidentId: number

    /**
     * 
     * @type {AccidentTagsV2}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsV2Patch
     */
    readonly accidentTagsV2?: AccidentTagsV2
}

/**
 * Request parameters for agencyV1AccidentAccidentIdTagsV2Post operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdTagsV2PostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdTagsV2PostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsV2Post
     */
    readonly accidentId: number

    /**
     * 
     * @type {AccidentTagsV2}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdTagsV2Post
     */
    readonly accidentTagsV2?: AccidentTagsV2
}

/**
 * Request parameters for agencyV1AccidentAccidentIdWitnessPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdWitnessPostRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdWitnessPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdWitnessPost
     */
    readonly accidentId: number

    /**
     * 
     * @type {Witness}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdWitnessPost
     */
    readonly witness?: Witness
}

/**
 * Request parameters for agencyV1AccidentAccidentIdWitnessWitnessIdPatch operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentAccidentIdWitnessWitnessIdPatchRequest
 */
export interface AgencyApiAgencyV1AccidentAccidentIdWitnessWitnessIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdWitnessWitnessIdPatch
     */
    readonly accidentId: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdWitnessWitnessIdPatch
     */
    readonly witnessId: number

    /**
     * 
     * @type {Witness}
     * @memberof AgencyApiAgencyV1AccidentAccidentIdWitnessWitnessIdPatch
     */
    readonly witness?: Witness
}

/**
 * Request parameters for agencyV1AccidentGet operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentGetRequest
 */
export interface AgencyApiAgencyV1AccidentGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly licensePlate?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly normLicensePlate?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly driverName?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly licensePlateContains?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly driverNameContains?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly subFleet?: string

    /**
     * 
     * @type {boolean}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly isClosed?: boolean

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly timeFrom?: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly timeTo?: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly createdFrom?: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly createdTo?: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly lastId?: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1AccidentGet
     */
    readonly csv?: number
}

/**
 * Request parameters for agencyV1AccidentPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1AccidentPostRequest
 */
export interface AgencyApiAgencyV1AccidentPostRequest {
    /**
     * Accident to create
     * @type {ExtendedAccident}
     * @memberof AgencyApiAgencyV1AccidentPost
     */
    readonly extendedAccident: ExtendedAccident
}

/**
 * Request parameters for agencyV1CustomerDataPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1CustomerDataPostRequest
 */
export interface AgencyApiAgencyV1CustomerDataPostRequest {
    /**
     * 
     * @type {CustomerHandlingStatus}
     * @memberof AgencyApiAgencyV1CustomerDataPost
     */
    readonly customerHandlingStatus?: CustomerHandlingStatus
}

/**
 * Request parameters for agencyV1DamageDamageIdDisposalPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1DamageDamageIdDisposalPostRequest
 */
export interface AgencyApiAgencyV1DamageDamageIdDisposalPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV1DamageDamageIdDisposalPost
     */
    readonly damageId: string

    /**
     * 
     * @type {DisposalLetterRequest}
     * @memberof AgencyApiAgencyV1DamageDamageIdDisposalPost
     */
    readonly disposalLetterRequest?: DisposalLetterRequest
}

/**
 * Request parameters for agencyV1DriverFormAccidentIdFilePost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1DriverFormAccidentIdFilePostRequest
 */
export interface AgencyApiAgencyV1DriverFormAccidentIdFilePostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1DriverFormAccidentIdFilePost
     */
    readonly accidentId: number

    /**
     * 
     * @type {ExtendedFileData}
     * @memberof AgencyApiAgencyV1DriverFormAccidentIdFilePost
     */
    readonly extendedFileData?: ExtendedFileData
}

/**
 * Request parameters for agencyV1DriverFormAccidentIdFilePut operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1DriverFormAccidentIdFilePutRequest
 */
export interface AgencyApiAgencyV1DriverFormAccidentIdFilePutRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1DriverFormAccidentIdFilePut
     */
    readonly accidentId: number

    /**
     * 
     * @type {ExtendedArtifact}
     * @memberof AgencyApiAgencyV1DriverFormAccidentIdFilePut
     */
    readonly extendedArtifact?: ExtendedArtifact
}

/**
 * Request parameters for agencyV1DriverFormAccidentIdReviewPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1DriverFormAccidentIdReviewPostRequest
 */
export interface AgencyApiAgencyV1DriverFormAccidentIdReviewPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1DriverFormAccidentIdReviewPost
     */
    readonly accidentId: number

    /**
     * 
     * @type {DriverFormReview}
     * @memberof AgencyApiAgencyV1DriverFormAccidentIdReviewPost
     */
    readonly driverFormReview?: DriverFormReview
}

/**
 * Request parameters for agencyV1DriverFormPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1DriverFormPostRequest
 */
export interface AgencyApiAgencyV1DriverFormPostRequest {
    /**
     * 
     * @type {DriverForm}
     * @memberof AgencyApiAgencyV1DriverFormPost
     */
    readonly driverForm?: DriverForm
}

/**
 * Request parameters for agencyV1PolicyPolicyIdPatch operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1PolicyPolicyIdPatchRequest
 */
export interface AgencyApiAgencyV1PolicyPolicyIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV1PolicyPolicyIdPatch
     */
    readonly policyId: number

    /**
     * 
     * @type {PolicyV1Request}
     * @memberof AgencyApiAgencyV1PolicyPolicyIdPatch
     */
    readonly policyV1Request?: PolicyV1Request
}

/**
 * Request parameters for agencyV1PolicyPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV1PolicyPostRequest
 */
export interface AgencyApiAgencyV1PolicyPostRequest {
    /**
     * 
     * @type {PolicyV1Request}
     * @memberof AgencyApiAgencyV1PolicyPost
     */
    readonly policyV1Request?: PolicyV1Request
}

/**
 * Request parameters for agencyV2AccidentAccidentIdNotificationPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV2AccidentAccidentIdNotificationPostRequest
 */
export interface AgencyApiAgencyV2AccidentAccidentIdNotificationPostRequest {
    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV2AccidentAccidentIdNotificationPost
     */
    readonly accidentId: number

    /**
     * 
     * @type {NotificationRequestV2}
     * @memberof AgencyApiAgencyV2AccidentAccidentIdNotificationPost
     */
    readonly notificationRequestV2?: NotificationRequestV2
}

/**
 * Request parameters for agencyV2AccidentGet operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV2AccidentGetRequest
 */
export interface AgencyApiAgencyV2AccidentGetRequest {
    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly licensePlate?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly normLicensePlate?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly driverName?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly licensePlateContains?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly driverNameContains?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly subFleet?: string

    /**
     * 
     * @type {boolean}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly isClosed?: boolean

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly timeFrom?: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly timeTo?: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly createdFrom?: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly createdTo?: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly lastId?: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly csv?: number

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly damageCause?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly speed?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly fault?: string

    /**
     * 
     * @type {string}
     * @memberof AgencyApiAgencyV2AccidentGet
     */
    readonly pointOfImpact?: string
}

/**
 * Request parameters for agencyV2PolicyDelete operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV2PolicyDeleteRequest
 */
export interface AgencyApiAgencyV2PolicyDeleteRequest {
    /**
     * 
     * @type {PolicyDeleteRequest}
     * @memberof AgencyApiAgencyV2PolicyDelete
     */
    readonly policyDeleteRequest: PolicyDeleteRequest
}

/**
 * Request parameters for agencyV2PolicyPolicyIdDelete operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV2PolicyPolicyIdDeleteRequest
 */
export interface AgencyApiAgencyV2PolicyPolicyIdDeleteRequest {
    /**
     * ID of the policy to delete
     * @type {number}
     * @memberof AgencyApiAgencyV2PolicyPolicyIdDelete
     */
    readonly policyId: number
}

/**
 * Request parameters for agencyV2PolicyPolicyIdGet operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV2PolicyPolicyIdGetRequest
 */
export interface AgencyApiAgencyV2PolicyPolicyIdGetRequest {
    /**
     * ID of the policy to retrieve
     * @type {number}
     * @memberof AgencyApiAgencyV2PolicyPolicyIdGet
     */
    readonly policyId: number
}

/**
 * Request parameters for agencyV2PolicyPolicyIdPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV2PolicyPolicyIdPostRequest
 */
export interface AgencyApiAgencyV2PolicyPolicyIdPostRequest {
    /**
     * ID of the policy to update (optional)
     * @type {number}
     * @memberof AgencyApiAgencyV2PolicyPolicyIdPost
     */
    readonly policyId: number

    /**
     * 
     * @type {Array<PolicyV2>}
     * @memberof AgencyApiAgencyV2PolicyPolicyIdPost
     */
    readonly policyV2: Array<PolicyV2>
}

/**
 * Request parameters for agencyV2PolicyPost operation in AgencyApi.
 * @export
 * @interface AgencyApiAgencyV2PolicyPostRequest
 */
export interface AgencyApiAgencyV2PolicyPostRequest {
    /**
     * 
     * @type {Array<PolicyV2>}
     * @memberof AgencyApiAgencyV2PolicyPost
     */
    readonly policyV2: Array<PolicyV2>
}

/**
 * Request parameters for apiAuthOtpPost operation in AgencyApi.
 * @export
 * @interface AgencyApiApiAuthOtpPostRequest
 */
export interface AgencyApiApiAuthOtpPostRequest {
    /**
     * 
     * @type {OTPUserCredentials}
     * @memberof AgencyApiApiAuthOtpPost
     */
    readonly oTPUserCredentials?: OTPUserCredentials
}

/**
 * Request parameters for apiAuthPost operation in AgencyApi.
 * @export
 * @interface AgencyApiApiAuthPostRequest
 */
export interface AgencyApiApiAuthPostRequest {
    /**
     * 
     * @type {UserCredentials}
     * @memberof AgencyApiApiAuthPost
     */
    readonly userCredentials?: UserCredentials
}

/**
 * Request parameters for apiAuthRefreshPost operation in AgencyApi.
 * @export
 * @interface AgencyApiApiAuthRefreshPostRequest
 */
export interface AgencyApiApiAuthRefreshPostRequest {
    /**
     * 
     * @type {RefreshTokenRequest}
     * @memberof AgencyApiApiAuthRefreshPost
     */
    readonly refreshTokenRequest?: RefreshTokenRequest
}

/**
 * AgencyApi - object-oriented interface
 * @export
 * @class AgencyApi
 * @extends {BaseAPI}
 */
export class AgencyApi extends BaseAPI {
    /**
     * 
     * @summary Get list of claims
     * @param {AgencyApiAgencyV0ClaimGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV0ClaimGet(requestParameters: AgencyApiAgencyV0ClaimGetRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).agencyV0ClaimGet(requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update claim assigned to accident
     * @param {AgencyApiAgencyV0ClaimPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV0ClaimPatch(requestParameters: AgencyApiAgencyV0ClaimPatchRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).agencyV0ClaimPatch(requestParameters.updateClaimRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Load claim data
     * @param {AgencyApiAgencyV0ClaimPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV0ClaimPost(requestParameters: AgencyApiAgencyV0ClaimPostRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).agencyV0ClaimPost(requestParameters.loadClaimsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get upload url for claim file
     * @param {AgencyApiAgencyV0ClaimUploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV0ClaimUploadPost(requestParameters: AgencyApiAgencyV0ClaimUploadPostRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).agencyV0ClaimUploadPost(requestParameters.claimFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get event details
     * @summary Get event details
     * @param {AgencyApiAgencyV0EventEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV0EventEventIdGet(requestParameters: AgencyApiAgencyV0EventEventIdGetRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV0EventEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get event image
     * @param {AgencyApiAgencyV0EventEventIdImageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV0EventEventIdImageGet(requestParameters: AgencyApiAgencyV0EventEventIdImageGetRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV0EventEventIdImageGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of insurance periods
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV0PeriodGet(options?: any) {
        return AgencyApiFp(this.configuration).agencyV0PeriodGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update insurance period
     * @param {AgencyApiAgencyV0PeriodPeriodIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV0PeriodPeriodIdPatch(requestParameters: AgencyApiAgencyV0PeriodPeriodIdPatchRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV0PeriodPeriodIdPatch(requestParameters.periodId, requestParameters.insurancePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new insurance period
     * @param {AgencyApiAgencyV0PeriodPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV0PeriodPost(requestParameters: AgencyApiAgencyV0PeriodPostRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).agencyV0PeriodPost(requestParameters.insurancePeriod, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Do action on artifact
     * @summary Do action on artifact
     * @param {AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdActionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdArtifactArtifactIdActionPost(requestParameters: AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdActionPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdArtifactArtifactIdActionPost(requestParameters.accidentId, requestParameters.artifactId, requestParameters.artifactAction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get signed url for artifact
     * @summary Get signed url for artifact
     * @param {AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdArtifactArtifactIdGet(requestParameters: AgencyApiAgencyV1AccidentAccidentIdArtifactArtifactIdGetRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdArtifactArtifactIdGet(requestParameters.accidentId, requestParameters.artifactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get upload url for artifact
     * @summary Get upload url for artifact
     * @param {AgencyApiAgencyV1AccidentAccidentIdArtifactPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdArtifactPost(requestParameters: AgencyApiAgencyV1AccidentAccidentIdArtifactPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdArtifactPost(requestParameters.accidentId, requestParameters.fileData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new artifact
     * @summary Create new artifact
     * @param {AgencyApiAgencyV1AccidentAccidentIdArtifactPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdArtifactPut(requestParameters: AgencyApiAgencyV1AccidentAccidentIdArtifactPutRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdArtifactPut(requestParameters.accidentId, requestParameters.artifactRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update comment
     * @summary Update comment
     * @param {AgencyApiAgencyV1AccidentAccidentIdCommentCommentIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdCommentCommentIdPatch(requestParameters: AgencyApiAgencyV1AccidentAccidentIdCommentCommentIdPatchRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdCommentCommentIdPatch(requestParameters.accidentId, requestParameters.commentId, requestParameters.comment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new comment
     * @summary Create new comment
     * @param {AgencyApiAgencyV1AccidentAccidentIdCommentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdCommentPost(requestParameters: AgencyApiAgencyV1AccidentAccidentIdCommentPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdCommentPost(requestParameters.accidentId, requestParameters.comment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get damage details
     * @summary Get damage details
     * @param {AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdDamageDamageIdGet(requestParameters: AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdGetRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdDamageDamageIdGet(requestParameters.accidentId, requestParameters.damageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update damage details
     * @summary Update damage details
     * @param {AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdDamageDamageIdPatch(requestParameters: AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPatchRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdDamageDamageIdPatch(requestParameters.accidentId, requestParameters.damageId, requestParameters.damage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete payment
     * @summary Delete payment
     * @param {AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete(requestParameters: AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDeleteRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdDelete(requestParameters.accidentId, requestParameters.damageId, requestParameters.paymentId, requestParameters.payment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change payment status
     * @summary Change payment status
     * @param {AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch(requestParameters: AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatchRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdDamageDamageIdPaymentPaymentIdPatch(requestParameters.accidentId, requestParameters.damageId, requestParameters.paymentId, requestParameters.payment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new payment
     * @summary Create new payment
     * @param {AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdDamageDamageIdPaymentPost(requestParameters: AgencyApiAgencyV1AccidentAccidentIdDamageDamageIdPaymentPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdDamageDamageIdPaymentPost(requestParameters.accidentId, requestParameters.damageId, requestParameters.payment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create damage
     * @summary Create damage
     * @param {AgencyApiAgencyV1AccidentAccidentIdDamagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdDamagePost(requestParameters: AgencyApiAgencyV1AccidentAccidentIdDamagePostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdDamagePost(requestParameters.accidentId, requestParameters.damage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create or update driver details
     * @summary Create or update driver details
     * @param {AgencyApiAgencyV1AccidentAccidentIdDriverPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdDriverPost(requestParameters: AgencyApiAgencyV1AccidentAccidentIdDriverPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdDriverPost(requestParameters.accidentId, requestParameters.driver, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get accident details
     * @summary Get accident details
     * @param {AgencyApiAgencyV1AccidentAccidentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdGet(requestParameters: AgencyApiAgencyV1AccidentAccidentIdGetRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdGet(requestParameters.accidentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create accident notice form
     * @param {AgencyApiAgencyV1AccidentAccidentIdNoticePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdNoticePost(requestParameters: AgencyApiAgencyV1AccidentAccidentIdNoticePostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdNoticePost(requestParameters.accidentId, requestParameters.noticeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete notification for accident
     * @param {AgencyApiAgencyV1AccidentAccidentIdNotificationDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdNotificationDelete(requestParameters: AgencyApiAgencyV1AccidentAccidentIdNotificationDeleteRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdNotificationDelete(requestParameters.accidentId, requestParameters.notificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get notifications list for accident
     * @param {AgencyApiAgencyV1AccidentAccidentIdNotificationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdNotificationGet(requestParameters: AgencyApiAgencyV1AccidentAccidentIdNotificationGetRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdNotificationGet(requestParameters.accidentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update notification for accident
     * @param {AgencyApiAgencyV1AccidentAccidentIdNotificationPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdNotificationPatch(requestParameters: AgencyApiAgencyV1AccidentAccidentIdNotificationPatchRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdNotificationPatch(requestParameters.accidentId, requestParameters.notificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new notification for accident
     * @param {AgencyApiAgencyV1AccidentAccidentIdNotificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdNotificationPost(requestParameters: AgencyApiAgencyV1AccidentAccidentIdNotificationPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdNotificationPost(requestParameters.accidentId, requestParameters.notificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of accidents
     * @summary Get list of accidents
     * @param {AgencyApiAgencyV1AccidentAccidentIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdPatch(requestParameters: AgencyApiAgencyV1AccidentAccidentIdPatchRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdPatch(requestParameters.accidentId, requestParameters.extendedAccident, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send accident to users
     * @param {AgencyApiAgencyV1AccidentAccidentIdSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdSendPost(requestParameters: AgencyApiAgencyV1AccidentAccidentIdSendPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdSendPost(requestParameters.accidentId, requestParameters.sendAccidentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update accident tags
     * @summary Update accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdTagsPatch(requestParameters: AgencyApiAgencyV1AccidentAccidentIdTagsPatchRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdTagsPatch(requestParameters.accidentId, requestParameters.accidentTags, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new accident tags
     * @summary Create new accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdTagsPost(requestParameters: AgencyApiAgencyV1AccidentAccidentIdTagsPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdTagsPost(requestParameters.accidentId, requestParameters.accidentTags, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get accident tags
     * @summary get accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsV1GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdTagsV1Get(requestParameters: AgencyApiAgencyV1AccidentAccidentIdTagsV1GetRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdTagsV1Get(requestParameters.accidentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update accident tags
     * @summary Update accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsV1PatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdTagsV1Patch(requestParameters: AgencyApiAgencyV1AccidentAccidentIdTagsV1PatchRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdTagsV1Patch(requestParameters.accidentId, requestParameters.accidentTagsV1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new accident tags
     * @summary Create new accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsV1PostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdTagsV1Post(requestParameters: AgencyApiAgencyV1AccidentAccidentIdTagsV1PostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdTagsV1Post(requestParameters.accidentId, requestParameters.accidentTagsV1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get accident tags
     * @summary get accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsV2GetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdTagsV2Get(requestParameters: AgencyApiAgencyV1AccidentAccidentIdTagsV2GetRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdTagsV2Get(requestParameters.accidentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update accident tags
     * @summary Update accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsV2PatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdTagsV2Patch(requestParameters: AgencyApiAgencyV1AccidentAccidentIdTagsV2PatchRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdTagsV2Patch(requestParameters.accidentId, requestParameters.accidentTagsV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new accident tags
     * @summary Create new accident tags
     * @param {AgencyApiAgencyV1AccidentAccidentIdTagsV2PostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdTagsV2Post(requestParameters: AgencyApiAgencyV1AccidentAccidentIdTagsV2PostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdTagsV2Post(requestParameters.accidentId, requestParameters.accidentTagsV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new witness statement
     * @summary Create new witness statement
     * @param {AgencyApiAgencyV1AccidentAccidentIdWitnessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdWitnessPost(requestParameters: AgencyApiAgencyV1AccidentAccidentIdWitnessPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdWitnessPost(requestParameters.accidentId, requestParameters.witness, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update witness statement
     * @summary Update witness statement
     * @param {AgencyApiAgencyV1AccidentAccidentIdWitnessWitnessIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentAccidentIdWitnessWitnessIdPatch(requestParameters: AgencyApiAgencyV1AccidentAccidentIdWitnessWitnessIdPatchRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentAccidentIdWitnessWitnessIdPatch(requestParameters.accidentId, requestParameters.witnessId, requestParameters.witness, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of customer\'s articat tags
     * @summary Get list of customer\'s articat tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentArtifactTagsGet(options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentArtifactTagsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of accidents
     * @summary Get list of accidents
     * @param {AgencyApiAgencyV1AccidentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentGet(requestParameters: AgencyApiAgencyV1AccidentGetRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentGet(requestParameters.licensePlate, requestParameters.normLicensePlate, requestParameters.driverName, requestParameters.licensePlateContains, requestParameters.driverNameContains, requestParameters.subFleet, requestParameters.isClosed, requestParameters.timeFrom, requestParameters.timeTo, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.lastId, requestParameters.csv, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create accident
     * @summary Create accident
     * @param {AgencyApiAgencyV1AccidentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1AccidentPost(requestParameters: AgencyApiAgencyV1AccidentPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1AccidentPost(requestParameters.extendedAccident, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get customer data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1CustomerDataGet(options?: any) {
        return AgencyApiFp(this.configuration).agencyV1CustomerDataGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new customer data
     * @param {AgencyApiAgencyV1CustomerDataPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1CustomerDataPost(requestParameters: AgencyApiAgencyV1CustomerDataPostRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1CustomerDataPost(requestParameters.customerHandlingStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create disposal letter for damage
     * @param {AgencyApiAgencyV1DamageDamageIdDisposalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1DamageDamageIdDisposalPost(requestParameters: AgencyApiAgencyV1DamageDamageIdDisposalPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1DamageDamageIdDisposalPost(requestParameters.damageId, requestParameters.disposalLetterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload file for accident from driver form
     * @param {AgencyApiAgencyV1DriverFormAccidentIdFilePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1DriverFormAccidentIdFilePost(requestParameters: AgencyApiAgencyV1DriverFormAccidentIdFilePostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1DriverFormAccidentIdFilePost(requestParameters.accidentId, requestParameters.extendedFileData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new artifact
     * @summary Create new artifact
     * @param {AgencyApiAgencyV1DriverFormAccidentIdFilePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1DriverFormAccidentIdFilePut(requestParameters: AgencyApiAgencyV1DriverFormAccidentIdFilePutRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1DriverFormAccidentIdFilePut(requestParameters.accidentId, requestParameters.extendedArtifact, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get app review from driver form
     * @param {AgencyApiAgencyV1DriverFormAccidentIdReviewPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1DriverFormAccidentIdReviewPost(requestParameters: AgencyApiAgencyV1DriverFormAccidentIdReviewPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1DriverFormAccidentIdReviewPost(requestParameters.accidentId, requestParameters.driverFormReview, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create accident from driver form
     * @param {AgencyApiAgencyV1DriverFormPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1DriverFormPost(requestParameters: AgencyApiAgencyV1DriverFormPostRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1DriverFormPost(requestParameters.driverForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get policy list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1PolicyGet(options?: any) {
        return AgencyApiFp(this.configuration).agencyV1PolicyGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update policy
     * @param {AgencyApiAgencyV1PolicyPolicyIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1PolicyPolicyIdPatch(requestParameters: AgencyApiAgencyV1PolicyPolicyIdPatchRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1PolicyPolicyIdPatch(requestParameters.policyId, requestParameters.policyV1Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new policy
     * @param {AgencyApiAgencyV1PolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV1PolicyPost(requestParameters: AgencyApiAgencyV1PolicyPostRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).agencyV1PolicyPost(requestParameters.policyV1Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new notification for accident (UI only)
     * @param {AgencyApiAgencyV2AccidentAccidentIdNotificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV2AccidentAccidentIdNotificationPost(requestParameters: AgencyApiAgencyV2AccidentAccidentIdNotificationPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV2AccidentAccidentIdNotificationPost(requestParameters.accidentId, requestParameters.notificationRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of accidents
     * @summary Get list of accidents
     * @param {AgencyApiAgencyV2AccidentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV2AccidentGet(requestParameters: AgencyApiAgencyV2AccidentGetRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).agencyV2AccidentGet(requestParameters.licensePlate, requestParameters.normLicensePlate, requestParameters.driverName, requestParameters.licensePlateContains, requestParameters.driverNameContains, requestParameters.subFleet, requestParameters.isClosed, requestParameters.timeFrom, requestParameters.timeTo, requestParameters.createdFrom, requestParameters.createdTo, requestParameters.lastId, requestParameters.limit, requestParameters.csv, requestParameters.damageCause, requestParameters.speed, requestParameters.fault, requestParameters.pointOfImpact, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get report with vehicles to charge
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV2PolicyChargeGet(options?: any) {
        return AgencyApiFp(this.configuration).agencyV2PolicyChargeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a policy by IDs
     * @param {AgencyApiAgencyV2PolicyDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV2PolicyDelete(requestParameters: AgencyApiAgencyV2PolicyDeleteRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV2PolicyDelete(requestParameters.policyDeleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve all customer\'s policies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV2PolicyGet(options?: any) {
        return AgencyApiFp(this.configuration).agencyV2PolicyGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a policy by ID
     * @param {AgencyApiAgencyV2PolicyPolicyIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV2PolicyPolicyIdDelete(requestParameters: AgencyApiAgencyV2PolicyPolicyIdDeleteRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV2PolicyPolicyIdDelete(requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a policy by ID
     * @param {AgencyApiAgencyV2PolicyPolicyIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV2PolicyPolicyIdGet(requestParameters: AgencyApiAgencyV2PolicyPolicyIdGetRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV2PolicyPolicyIdGet(requestParameters.policyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or update a policy
     * @param {AgencyApiAgencyV2PolicyPolicyIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV2PolicyPolicyIdPost(requestParameters: AgencyApiAgencyV2PolicyPolicyIdPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV2PolicyPolicyIdPost(requestParameters.policyId, requestParameters.policyV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or update list of policies
     * @param {AgencyApiAgencyV2PolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public agencyV2PolicyPost(requestParameters: AgencyApiAgencyV2PolicyPostRequest, options?: any) {
        return AgencyApiFp(this.configuration).agencyV2PolicyPost(requestParameters.policyV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user token
     * @param {AgencyApiApiAuthOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public apiAuthOtpPost(requestParameters: AgencyApiApiAuthOtpPostRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).apiAuthOtpPost(requestParameters.oTPUserCredentials, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user token
     * @param {AgencyApiApiAuthPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public apiAuthPost(requestParameters: AgencyApiApiAuthPostRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).apiAuthPost(requestParameters.userCredentials, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user token
     * @param {AgencyApiApiAuthRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgencyApi
     */
    public apiAuthRefreshPost(requestParameters: AgencyApiApiAuthRefreshPostRequest = {}, options?: any) {
        return AgencyApiFp(this.configuration).apiAuthRefreshPost(requestParameters.refreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ApiApi - axios parameter creator
 * @export
 */
export const ApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get device details
         * @param {string} [licensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [deviceId] 
         * @param {string} [deviceIdContains] 
         * @param {string} [subFleet] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [version] 
         * @param {string} [status] 
         * @param {string} [versionName] 
         * @param {number} [cache] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceGet: async (licensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, deviceId?: string, deviceIdContains?: string, subFleet?: string, date?: string, dateFrom?: string, dateTo?: string, version?: string, status?: string, versionName?: string, cache?: number, page?: number, pageSize?: number, country?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (licensePlate !== undefined) {
                localVarQueryParameter['license_plate'] = licensePlate;
            }

            if (driverName !== undefined) {
                localVarQueryParameter['driver_name'] = driverName;
            }

            if (licensePlateContains !== undefined) {
                localVarQueryParameter['license_plate_contains'] = licensePlateContains;
            }

            if (driverNameContains !== undefined) {
                localVarQueryParameter['driver_name_contains'] = driverNameContains;
            }

            if (deviceId !== undefined) {
                localVarQueryParameter['device_id'] = deviceId;
            }

            if (deviceIdContains !== undefined) {
                localVarQueryParameter['device_id_contains'] = deviceIdContains;
            }

            if (subFleet !== undefined) {
                localVarQueryParameter['sub_fleet'] = subFleet;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = dateTo;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (versionName !== undefined) {
                localVarQueryParameter['version_name'] = versionName;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get device operation details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceOperationGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/device_operation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new device operation details
         * @param {DeviceOperationData} [deviceOperationData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceOperationPost: async (deviceOperationData?: DeviceOperationData, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/device_operation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceOperationData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create overlay on event video
         * @param {EventOverlayRequest} [eventOverlayRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOverlayPost: async (eventOverlayRequest?: EventOverlayRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/overlay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventOverlayRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get list of all wellness details
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminWellnessGet: async (page?: number, pageSize?: number, country?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/wellness`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new wellness details
         * @param {WellnessUpdate} [wellnessUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminWellnessPost: async (wellnessUpdate?: WellnessUpdate, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/wellness`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(wellnessUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost: async (oTPUserCredentials?: OTPUserCredentials, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(oTPUserCredentials, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user token
         * @param {UserCredentials} [userCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost: async (userCredentials?: UserCredentials, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCredentials, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost: async (refreshTokenRequest?: RefreshTokenRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get accident overview data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AccidentOverviewGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/accident_overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventEventIdGet: async (eventId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0CoachEventEventIdGet', 'eventId', eventId)
            const localVarPath = `/api/v0/coach/event/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get coaching event image
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventEventIdImageGet: async (eventId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0CoachEventEventIdImageGet', 'eventId', eventId)
            const localVarPath = `/api/v0/coach/event/{eventId}/image`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get event coaching status
         * @param {CoachEventStatus} [coachEventStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventPost: async (coachEventStatus?: CoachEventStatus, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/coach/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachEventStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get metrics data
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachMetricsGet: async (driverToken: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverToken' is not null or undefined
            assertParamExists('apiV0CoachMetricsGet', 'driverToken', driverToken)
            const localVarPath = `/api/v0/coach/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverToken !== undefined) {
                localVarQueryParameter['driver_token'] = driverToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new coaching metrics by driver token
         * @param {CoachMetricsSaveRequest} [coachMetricsSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachMetricsPost: async (coachMetricsSaveRequest?: CoachMetricsSaveRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/coach/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachMetricsSaveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete event from coaching session
         * @param {number} sessionId 
         * @param {number} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdEventItemIdDelete: async (sessionId: number, itemId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdEventItemIdDelete', 'sessionId', sessionId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdEventItemIdDelete', 'itemId', itemId)
            const localVarPath = `/api/v0/coach/{sessionId}/event/{itemId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update event in coaching session
         * @param {number} sessionId 
         * @param {number} itemId 
         * @param {UpdateCoachEvent} [updateCoachEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdEventItemIdPatch: async (sessionId: number, itemId: number, updateCoachEvent?: UpdateCoachEvent, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdEventItemIdPatch', 'sessionId', sessionId)
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdEventItemIdPatch', 'itemId', itemId)
            const localVarPath = `/api/v0/coach/{sessionId}/event/{itemId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCoachEvent, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get coaching session details
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdGet: async (sessionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdGet', 'sessionId', sessionId)
            const localVarPath = `/api/v0/coach/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get coaching session image
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdImageGet: async (sessionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdImageGet', 'sessionId', sessionId)
            const localVarPath = `/api/v0/coach/{sessionId}/image`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete coach media file
         * @param {number} sessionId 
         * @param {number} coachMediaFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete: async (sessionId: number, coachMediaFileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete', 'sessionId', sessionId)
            // verify required parameter 'coachMediaFileId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete', 'coachMediaFileId', coachMediaFileId)
            const localVarPath = `/api/v0/coach/{sessionId}/media_file/{coachMediaFileId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"coachMediaFileId"}}`, encodeURIComponent(String(coachMediaFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update coach media file
         * @param {number} sessionId 
         * @param {number} coachMediaFileId 
         * @param {CoachMediaFileRequest} [coachMediaFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch: async (sessionId: number, coachMediaFileId: number, coachMediaFileRequest?: CoachMediaFileRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch', 'sessionId', sessionId)
            // verify required parameter 'coachMediaFileId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch', 'coachMediaFileId', coachMediaFileId)
            const localVarPath = `/api/v0/coach/{sessionId}/media_file/{coachMediaFileId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"coachMediaFileId"}}`, encodeURIComponent(String(coachMediaFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachMediaFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new coach media file
         * @param {number} sessionId 
         * @param {CoachMediaFileRequest} [coachMediaFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFilePost: async (sessionId: number, coachMediaFileRequest?: CoachMediaFileRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdMediaFilePost', 'sessionId', sessionId)
            const localVarPath = `/api/v0/coach/{sessionId}/media_file`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachMediaFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete coach metrics
         * @param {number} sessionId 
         * @param {number} metricsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsMetricsIdDelete: async (sessionId: number, metricsId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdMetricsMetricsIdDelete', 'sessionId', sessionId)
            // verify required parameter 'metricsId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdMetricsMetricsIdDelete', 'metricsId', metricsId)
            const localVarPath = `/api/v0/coach/{sessionId}/metrics/{metricsId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"metricsId"}}`, encodeURIComponent(String(metricsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update coach metrics
         * @param {number} sessionId 
         * @param {number} metricsId 
         * @param {CoachMetrics} [coachMetrics] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsMetricsIdPatch: async (sessionId: number, metricsId: number, coachMetrics?: CoachMetrics, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdMetricsMetricsIdPatch', 'sessionId', sessionId)
            // verify required parameter 'metricsId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdMetricsMetricsIdPatch', 'metricsId', metricsId)
            const localVarPath = `/api/v0/coach/{sessionId}/metrics/{metricsId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"metricsId"}}`, encodeURIComponent(String(metricsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachMetrics, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new coaching metrics
         * @param {number} sessionId 
         * @param {CoachMetricsRequest} [coachMetricsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsPost: async (sessionId: number, coachMetricsRequest?: CoachMetricsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdMetricsPost', 'sessionId', sessionId)
            const localVarPath = `/api/v0/coach/{sessionId}/metrics`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachMetricsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete manager notes
         * @param {number} sessionId 
         * @param {number} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesNoteIdDelete: async (sessionId: number, noteId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdNotesNoteIdDelete', 'sessionId', sessionId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdNotesNoteIdDelete', 'noteId', noteId)
            const localVarPath = `/api/v0/coach/{sessionId}/notes/{noteId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update manager notes
         * @param {number} sessionId 
         * @param {number} noteId 
         * @param {CoachManagerNotes} [coachManagerNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesNoteIdPatch: async (sessionId: number, noteId: number, coachManagerNotes?: CoachManagerNotes, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdNotesNoteIdPatch', 'sessionId', sessionId)
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdNotesNoteIdPatch', 'noteId', noteId)
            const localVarPath = `/api/v0/coach/{sessionId}/notes/{noteId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachManagerNotes, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new manager notes
         * @param {number} sessionId 
         * @param {ManagerNotesRequest} [managerNotesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesPost: async (sessionId: number, managerNotesRequest?: ManagerNotesRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdNotesPost', 'sessionId', sessionId)
            const localVarPath = `/api/v0/coach/{sessionId}/notes`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(managerNotesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of coaching sessions
         * @param {number} sessionId 
         * @param {UpdateCoachSession} [updateCoachSession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdPost: async (sessionId: number, updateCoachSession?: UpdateCoachSession, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdPost', 'sessionId', sessionId)
            const localVarPath = `/api/v0/coach/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCoachSession, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new driver response
         * @param {number} sessionId 
         * @param {DriverResponseRequest} [driverResponseRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponsePost: async (sessionId: number, driverResponseRequest?: DriverResponseRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdResponsePost', 'sessionId', sessionId)
            const localVarPath = `/api/v0/coach/{sessionId}/response`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(driverResponseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete driver response
         * @param {number} sessionId 
         * @param {number} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponseResponseIdDelete: async (sessionId: number, responseId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdResponseResponseIdDelete', 'sessionId', sessionId)
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdResponseResponseIdDelete', 'responseId', responseId)
            const localVarPath = `/api/v0/coach/{sessionId}/response/{responseId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"responseId"}}`, encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update driver response
         * @param {number} sessionId 
         * @param {number} responseId 
         * @param {CoachDriverResponse} [coachDriverResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponseResponseIdPatch: async (sessionId: number, responseId: number, coachDriverResponse?: CoachDriverResponse, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdResponseResponseIdPatch', 'sessionId', sessionId)
            // verify required parameter 'responseId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdResponseResponseIdPatch', 'responseId', responseId)
            const localVarPath = `/api/v0/coach/{sessionId}/response/{responseId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"responseId"}}`, encodeURIComponent(String(responseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachDriverResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove wellness status from driver coaching session
         * @param {number} sessionId 
         * @param {number} wellnessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdWellnessStatusWellnessIdDelete: async (sessionId: number, wellnessId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdWellnessStatusWellnessIdDelete', 'sessionId', sessionId)
            // verify required parameter 'wellnessId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdWellnessStatusWellnessIdDelete', 'wellnessId', wellnessId)
            const localVarPath = `/api/v0/coach/{sessionId}/wellness_status/{wellnessId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"wellnessId"}}`, encodeURIComponent(String(wellnessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update wellness status from driver coaching session
         * @param {number} sessionId 
         * @param {number} wellnessId 
         * @param {UpdateCoachWellnessStatus} [updateCoachWellnessStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdWellnessStatusWellnessIdPatch: async (sessionId: number, wellnessId: number, updateCoachWellnessStatus?: UpdateCoachWellnessStatus, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdWellnessStatusWellnessIdPatch', 'sessionId', sessionId)
            // verify required parameter 'wellnessId' is not null or undefined
            assertParamExists('apiV0CoachSessionIdWellnessStatusWellnessIdPatch', 'wellnessId', wellnessId)
            const localVarPath = `/api/v0/coach/{sessionId}/wellness_status/{wellnessId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)))
                .replace(`{${"wellnessId"}}`, encodeURIComponent(String(wellnessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCoachWellnessStatus, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get coaching overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachingOverviewGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/coaching_overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get clip from device
         * @summary Get clip from device
         * @param {number} commandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdGet: async (commandId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'commandId' is not null or undefined
            assertParamExists('apiV0CommandCommandIdGet', 'commandId', commandId)
            const localVarPath = `/api/v0/command/{commandId}`
                .replace(`{${"commandId"}}`, encodeURIComponent(String(commandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create remote command
         * @summary Create remote command
         * @param {number} commandId 
         * @param {RemoteCommand} [remoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdPost: async (commandId: number, remoteCommand?: RemoteCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'commandId' is not null or undefined
            assertParamExists('apiV0CommandCommandIdPost', 'commandId', commandId)
            const localVarPath = `/api/v0/command/{commandId}`
                .replace(`{${"commandId"}}`, encodeURIComponent(String(commandId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(remoteCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of get clip commands
         * @summary Get list of get clip commands
         * @param {number} [timeFrom] 
         * @param {number} [timeTo] 
         * @param {number} [accident] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandGet: async (timeFrom?: number, timeTo?: number, accident?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/command`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeFrom !== undefined) {
                localVarQueryParameter['time_from'] = timeFrom;
            }

            if (timeTo !== undefined) {
                localVarQueryParameter['time_to'] = timeTo;
            }

            if (accident !== undefined) {
                localVarQueryParameter['accident'] = accident;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get clip from device
         * @summary Get clip from device
         * @param {Command} [command] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandPost: async (command?: Command, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/command`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(command, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove customer sub fleet
         * @param {CustomerSubFleetData} [customerSubFleetData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerDelete: async (customerSubFleetData?: CustomerSubFleetData, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerSubFleetData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customer details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new customer sub fleet
         * @param {CustomerSubFleetData} [customerSubFleetData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerPost: async (customerSubFleetData?: CustomerSubFleetData, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerSubFleetData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get device snapshot
         * @param {string} deviceId 
         * @param {number} [timestamp] 
         * @param {number} [since] 
         * @param {number} [exact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceDeviceIdSnapshotGet: async (deviceId: string, timestamp?: number, since?: number, exact?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('apiV0DeviceDeviceIdSnapshotGet', 'deviceId', deviceId)
            const localVarPath = `/api/v0/device/{deviceId}/snapshot`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }

            if (since !== undefined) {
                localVarQueryParameter['since'] = since;
            }

            if (exact !== undefined) {
                localVarQueryParameter['exact'] = exact;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get device location
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {number} [radius] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceLocateGet: async (timeFrom?: string, timeTo?: string, latitude?: number, longitude?: number, radius?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/device/locate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeFrom !== undefined) {
                localVarQueryParameter['time_from'] = timeFrom;
            }

            if (timeTo !== undefined) {
                localVarQueryParameter['time_to'] = timeTo;
            }

            if (latitude !== undefined) {
                localVarQueryParameter['latitude'] = latitude;
            }

            if (longitude !== undefined) {
                localVarQueryParameter['longitude'] = longitude;
            }

            if (radius !== undefined) {
                localVarQueryParameter['radius'] = radius;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update device details
         * @param {Array<DeviceRequest>} [deviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceUpdatePatch: async (deviceRequest?: Array<DeviceRequest>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/device/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get driver badge
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverBadgeDriverTokenGet: async (driverToken: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverToken' is not null or undefined
            assertParamExists('apiV0DriverBadgeDriverTokenGet', 'driverToken', driverToken)
            const localVarPath = `/api/v0/driver/badge/{driverToken}`
                .replace(`{${"driverToken"}}`, encodeURIComponent(String(driverToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get driver badges
         * @param {DriverBadgeRequest} [driverBadgeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverBadgePost: async (driverBadgeRequest?: DriverBadgeRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/driver/badge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(driverBadgeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get driver details
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverDriverTokenGet: async (driverToken: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverToken' is not null or undefined
            assertParamExists('apiV0DriverDriverTokenGet', 'driverToken', driverToken)
            const localVarPath = `/api/v0/driver/{driverToken}`
                .replace(`{${"driverToken"}}`, encodeURIComponent(String(driverToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update driver details
         * @param {number} driverToken 
         * @param {FleetDriverRequest} [fleetDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverDriverTokenPatch: async (driverToken: number, fleetDriverRequest?: FleetDriverRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverToken' is not null or undefined
            assertParamExists('apiV0DriverDriverTokenPatch', 'driverToken', driverToken)
            const localVarPath = `/api/v0/driver/{driverToken}`
                .replace(`{${"driverToken"}}`, encodeURIComponent(String(driverToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fleetDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/driver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update multiple drivers
         * @param {FleetDriverList} [fleetDriverList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverPatch: async (fleetDriverList?: FleetDriverList, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/driver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fleetDriverList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new driver
         * @param {FleetDriverRequest} [fleetDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverPost: async (fleetDriverRequest?: FleetDriverRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/driver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fleetDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * recalculate driver score
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresDriverTokenCalculatePatch: async (driverToken: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverToken' is not null or undefined
            assertParamExists('apiV0DriverScoresDriverTokenCalculatePatch', 'driverToken', driverToken)
            const localVarPath = `/api/v0/driver_scores/{driverToken}/calculate`
                .replace(`{${"driverToken"}}`, encodeURIComponent(String(driverToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get driver score with relevant events
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresDriverTokenGet: async (driverToken: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverToken' is not null or undefined
            assertParamExists('apiV0DriverScoresDriverTokenGet', 'driverToken', driverToken)
            const localVarPath = `/api/v0/driver_scores/{driverToken}`
                .replace(`{${"driverToken"}}`, encodeURIComponent(String(driverToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get driver scores
         * @param {number} [allDrivers] 
         * @param {number} [page] 
         * @param {number} [cache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresGet: async (allDrivers?: number, page?: number, cache?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/driver_scores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (allDrivers !== undefined) {
                localVarQueryParameter['all_drivers'] = allDrivers;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create new event from existing one
         * @param {number} eventId 
         * @param {CloneEventDetails} [cloneEventDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdClonePost: async (eventId: number, cloneEventDetails?: CloneEventDetails, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0EventEventIdClonePost', 'eventId', eventId)
            const localVarPath = `/api/v0/event/{eventId}/clone`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloneEventDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get event coaching data
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdCoachGet: async (eventId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0EventEventIdCoachGet', 'eventId', eventId)
            const localVarPath = `/api/v0/event/{eventId}/coach`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add or dismiss event from driver coaching session
         * @param {number} eventId 
         * @param {CoachEventDetails} [coachEventDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdCoachPost: async (eventId: number, coachEventDetails?: CoachEventDetails, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0EventEventIdCoachPost', 'eventId', eventId)
            const localVarPath = `/api/v0/event/{eventId}/coach`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachEventDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download event video request
         * @param {number} eventId 
         * @param {DownloadVideoEventRequest} [downloadVideoEventRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdDownloadPost: async (eventId: number, downloadVideoEventRequest?: DownloadVideoEventRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0EventEventIdDownloadPost', 'eventId', eventId)
            const localVarPath = `/api/v0/event/{eventId}/download`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadVideoEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId 
         * @param {string} [bucket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdGet: async (eventId: number, bucket?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0EventEventIdGet', 'eventId', eventId)
            const localVarPath = `/api/v0/event/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (bucket !== undefined) {
                localVarQueryParameter['bucket'] = bucket;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get event image
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdImageGet: async (eventId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0EventEventIdImageGet', 'eventId', eventId)
            const localVarPath = `/api/v0/event/{eventId}/image`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update event details
         * @param {number} eventId 
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdPatch: async (eventId: number, inlineObject?: InlineObject, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0EventEventIdPatch', 'eventId', eventId)
            const localVarPath = `/api/v0/event/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inlineObject, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get related events
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdRelatedGet: async (eventId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0EventEventIdRelatedGet', 'eventId', eventId)
            const localVarPath = `/api/v0/event/{eventId}/related`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send event
         * @param {number} eventId 
         * @param {SendEventRequest} [sendEventRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdSendPost: async (eventId: number, sendEventRequest?: SendEventRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0EventEventIdSendPost', 'eventId', eventId)
            const localVarPath = `/api/v0/event/{eventId}/send`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Change event tags
         * @summary Change event tags
         * @param {number} eventId 
         * @param {EventTag} [eventTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdTagPost: async (eventId: number, eventTag?: EventTag, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0EventEventIdTagPost', 'eventId', eventId)
            const localVarPath = `/api/v0/event/{eventId}/tag`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventTag, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add comment to feed event
         * @summary Add comment
         * @param {number} eventId 
         * @param {FeedCommentRequest} [feedCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdCommentPost: async (eventId: number, feedCommentRequest?: FeedCommentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0FeedEventIdCommentPost', 'eventId', eventId)
            const localVarPath = `/api/v0/feed/{eventId}/comment`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feedCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add or remove dislike from event
         * @summary Dislike event
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdDislikePost: async (eventId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0FeedEventIdDislikePost', 'eventId', eventId)
            const localVarPath = `/api/v0/feed/{eventId}/dislike`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get feed event
         * @summary Get feed event
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdGet: async (eventId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0FeedEventIdGet', 'eventId', eventId)
            const localVarPath = `/api/v0/feed/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add or remove like from event
         * @summary Like event
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdLikePost: async (eventId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0FeedEventIdLikePost', 'eventId', eventId)
            const localVarPath = `/api/v0/feed/{eventId}/like`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update percent watched
         * @summary Update percent watched
         * @param {number} eventId 
         * @param {EventWatchedRequest} [eventWatchedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdWatchedPost: async (eventId: number, eventWatchedRequest?: EventWatchedRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('apiV0FeedEventIdWatchedPost', 'eventId', eventId)
            const localVarPath = `/api/v0/feed/{eventId}/watched`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventWatchedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get events
         * @summary Get user feed
         * @param {number} [generatedAt] 
         * @param {number} [size] 
         * @param {number} [fromEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedGet: async (generatedAt?: number, size?: number, fromEvent?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (generatedAt !== undefined) {
                localVarQueryParameter['generated_at'] = generatedAt;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (fromEvent !== undefined) {
                localVarQueryParameter['from_event'] = fromEvent;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get sms with link to feed page
         * @summary Get sms with link to feed page
         * @param {FeedLinkRequest} [feedLinkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedLinkPost: async (feedLinkRequest?: FeedLinkRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/feed/link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(feedLinkRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get fleet safety scores
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetSafetyScoresGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/fleet_safety_scores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get fleet score and fleet metric data
         * @param {number} [cache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetScoreGet: async (cache?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/fleet_score`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get fleet scores and score distribution over time
         * @param {number} [cache] 
         * @param {number} [endDate] 
         * @param {number} [daysCount] 
         * @param {number} [daysInterval] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetScoreTrendGet: async (cache?: number, endDate?: number, daysCount?: number, daysInterval?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/fleet_score_trend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (daysCount !== undefined) {
                localVarQueryParameter['days_count'] = daysCount;
            }

            if (daysInterval !== undefined) {
                localVarQueryParameter['days_interval'] = daysInterval;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a geofence
         * @param {number} geofenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGeofenceIdDelete: async (geofenceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'geofenceId' is not null or undefined
            assertParamExists('apiV0GeofenceGeofenceIdDelete', 'geofenceId', geofenceId)
            const localVarPath = `/api/v0/geofence/{geofenceId}`
                .replace(`{${"geofenceId"}}`, encodeURIComponent(String(geofenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a geofence
         * @param {number} geofenceId 
         * @param {Geofence} [geofence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGeofenceIdPatch: async (geofenceId: number, geofence?: Geofence, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'geofenceId' is not null or undefined
            assertParamExists('apiV0GeofenceGeofenceIdPatch', 'geofenceId', geofenceId)
            const localVarPath = `/api/v0/geofence/{geofenceId}`
                .replace(`{${"geofenceId"}}`, encodeURIComponent(String(geofenceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(geofence, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get geofence details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/geofence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new geofence
         * @param {Geofence} [geofence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofencePost: async (geofence?: Geofence, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/geofence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(geofence, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get help videos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HelpGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/help`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get aggregated data of malfunctions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionAggregatedGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/malfunction/aggregated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get malfunction list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/malfunction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create guest technician
         * @param {GuestTechnicianRequest} [guestTechnicianRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionGuestPost: async (guestTechnicianRequest?: GuestTechnicianRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/malfunction/guest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(guestTechnicianRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get malfunction comments
         * @param {number} malfunctionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdCommentGet: async (malfunctionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'malfunctionId' is not null or undefined
            assertParamExists('apiV0MalfunctionMalfunctionIdCommentGet', 'malfunctionId', malfunctionId)
            const localVarPath = `/api/v0/malfunction/{malfunctionId}/comment`
                .replace(`{${"malfunctionId"}}`, encodeURIComponent(String(malfunctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add new comment to malfunction
         * @param {number} malfunctionId 
         * @param {MalfunctionCommentRequest} [malfunctionCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdCommentPost: async (malfunctionId: number, malfunctionCommentRequest?: MalfunctionCommentRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'malfunctionId' is not null or undefined
            assertParamExists('apiV0MalfunctionMalfunctionIdCommentPost', 'malfunctionId', malfunctionId)
            const localVarPath = `/api/v0/malfunction/{malfunctionId}/comment`
                .replace(`{${"malfunctionId"}}`, encodeURIComponent(String(malfunctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(malfunctionCommentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get malfunction image
         * @param {number} malfunctionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdImageGet: async (malfunctionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'malfunctionId' is not null or undefined
            assertParamExists('apiV0MalfunctionMalfunctionIdImageGet', 'malfunctionId', malfunctionId)
            const localVarPath = `/api/v0/malfunction/{malfunctionId}/image`
                .replace(`{${"malfunctionId"}}`, encodeURIComponent(String(malfunctionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update malfunction assignee
         * @param {MalfunctionAssigneeRequest} [malfunctionAssigneeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionPatch: async (malfunctionAssigneeRequest?: MalfunctionAssigneeRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/malfunction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(malfunctionAssigneeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync malfunctions with policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionUpdateGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/malfunction/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get media file library
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/media_files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete media file
         * @param {number} mediaFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdDelete: async (mediaFileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaFileId' is not null or undefined
            assertParamExists('apiV0MediaFilesMediaFileIdDelete', 'mediaFileId', mediaFileId)
            const localVarPath = `/api/v0/media_files/{mediaFileId}`
                .replace(`{${"mediaFileId"}}`, encodeURIComponent(String(mediaFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get signed url for media file
         * @summary Get signed url for media file
         * @param {number} mediaFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdGet: async (mediaFileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaFileId' is not null or undefined
            assertParamExists('apiV0MediaFilesMediaFileIdGet', 'mediaFileId', mediaFileId)
            const localVarPath = `/api/v0/media_files/{mediaFileId}`
                .replace(`{${"mediaFileId"}}`, encodeURIComponent(String(mediaFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update media file
         * @param {number} mediaFileId 
         * @param {MediaFile} [mediaFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdPatch: async (mediaFileId: number, mediaFile?: MediaFile, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mediaFileId' is not null or undefined
            assertParamExists('apiV0MediaFilesMediaFileIdPatch', 'mediaFileId', mediaFileId)
            const localVarPath = `/api/v0/media_files/{mediaFileId}`
                .replace(`{${"mediaFileId"}}`, encodeURIComponent(String(mediaFileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mediaFile, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get file upload url
         * @param {UploadMediaFileRequest} [uploadMediaFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesPost: async (uploadMediaFileRequest?: UploadMediaFileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/media_files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadMediaFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add media file to database
         * @param {MediaFileRequest} [mediaFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesPut: async (mediaFileRequest?: MediaFileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/media_files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mediaFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new NPS
         * @param {Nps} [nps] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0NpsPost: async (nps?: Nps, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/nps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(nps, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove package to device list
         * @param {PackageTrackerData} [packageTrackerData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackageDelete: async (packageTrackerData?: PackageTrackerData, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/package`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(packageTrackerData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove file from package
         * @param {number} packageId 
         * @param {FileData} [fileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdDelete: async (packageId: number, fileData?: FileData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'packageId' is not null or undefined
            assertParamExists('apiV0PackagePackageIdDelete', 'packageId', packageId)
            const localVarPath = `/api/v0/package/{packageId}`
                .replace(`{${"packageId"}}`, encodeURIComponent(String(packageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get file upload data
         * @param {number} packageId 
         * @param {FileData} [fileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdPost: async (packageId: number, fileData?: FileData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'packageId' is not null or undefined
            assertParamExists('apiV0PackagePackageIdPost', 'packageId', packageId)
            const localVarPath = `/api/v0/package/{packageId}`
                .replace(`{${"packageId"}}`, encodeURIComponent(String(packageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add file to existing package
         * @param {number} packageId 
         * @param {FileData} [fileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdPut: async (packageId: number, fileData?: FileData, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'packageId' is not null or undefined
            assertParamExists('apiV0PackagePackageIdPut', 'packageId', packageId)
            const localVarPath = `/api/v0/package/{packageId}`
                .replace(`{${"packageId"}}`, encodeURIComponent(String(packageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new package
         * @param {PackageName} [packageName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePost: async (packageName?: PackageName, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/package`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(packageName, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Attach package to device list
         * @param {PackageTrackerData} [packageTrackerData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePut: async (packageTrackerData?: PackageTrackerData, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/package`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(packageTrackerData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get premium optimization details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/premium_optimization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new premium optimization details
         * @param {PremiumOptimizationRequest} [premiumOptimizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationPost: async (premiumOptimizationRequest?: PremiumOptimizationRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/premium_optimization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(premiumOptimizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send reminder
         * @param {PremiumOptimizationReminderRequest} [premiumOptimizationReminderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationReminderPost: async (premiumOptimizationReminderRequest?: PremiumOptimizationReminderRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/premium_optimization/reminder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(premiumOptimizationReminderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get release notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReleaseNotesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/release_notes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of reports and alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create new report or alert
         * @param {AlertOrReport} [alertOrReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportPost: async (alertOrReport?: AlertOrReport, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alertOrReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create new report or alert
         * @param {number} reportId 
         * @param {AlertOrReport} [alertOrReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportReportIdDelete: async (reportId: number, alertOrReport?: AlertOrReport, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('apiV0ReportReportIdDelete', 'reportId', reportId)
            const localVarPath = `/api/v0/report/{reportId}`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alertOrReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update report or alert
         * @param {number} reportId 
         * @param {AlertOrReport} [alertOrReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportReportIdPatch: async (reportId: number, alertOrReport?: AlertOrReport, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('apiV0ReportReportIdPatch', 'reportId', reportId)
            const localVarPath = `/api/v0/report/{reportId}`
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(alertOrReport, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of report instances
         * @param {string} [reportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunGet: async (reportType?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/report/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reportType !== undefined) {
                localVarQueryParameter['report_type'] = reportType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get report instance
         * @param {number} instanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdGet: async (instanceId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('apiV0ReportRunInstanceIdGet', 'instanceId', instanceId)
            const localVarPath = `/api/v0/report/run/{instanceId}`
                .replace(`{${"instanceId"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update report instance
         * @param {number} instanceId 
         * @param {ReportInstanceUpdate} [reportInstanceUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdPatch: async (instanceId: number, reportInstanceUpdate?: ReportInstanceUpdate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('apiV0ReportRunInstanceIdPatch', 'instanceId', instanceId)
            const localVarPath = `/api/v0/report/run/{instanceId}`
                .replace(`{${"instanceId"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportInstanceUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send report
         * @param {number} instanceId 
         * @param {SendReportRequest} [sendReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdSendPost: async (instanceId: number, sendReportRequest?: SendReportRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'instanceId' is not null or undefined
            assertParamExists('apiV0ReportRunInstanceIdSendPost', 'instanceId', instanceId)
            const localVarPath = `/api/v0/report/run/{instanceId}/send`
                .replace(`{${"instanceId"}}`, encodeURIComponent(String(instanceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate report
         * @param {ReportInstanceRequest} [reportInstanceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunPost: async (reportInstanceRequest?: ReportInstanceRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/report/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportInstanceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update customer settings
         * @param {CustomerSettingsRequest} [customerSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsCustomerPatch: async (customerSettingsRequest?: CustomerSettingsRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/settings/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customer accident sticker
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsCustomerStickerPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/settings/customer/sticker`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change user\'s email
         * @param {ChangeEmailRequest} [changeEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserEmailPatch: async (changeEmailRequest?: ChangeEmailRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/settings/user/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove users
         * @param {Array<UserDetails>} [userDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementDelete: async (userDetails?: Array<UserDetails>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/settings/user/management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users\' permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/settings/user/management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update users\' permissions
         * @param {Array<UserDetails>} [userDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementPatch: async (userDetails?: Array<UserDetails>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/settings/user/management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new user
         * @param {Array<UserCreationData>} [userCreationData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementPost: async (userCreationData?: Array<UserCreationData>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/settings/user/management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCreationData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change user\'s password
         * @param {ChangePasswordRequest} [changePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserPasswordPatch: async (changePasswordRequest?: ChangePasswordRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/settings/user/password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request permission change
         * @param {ChangePermissionsRequest} [changePermissionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserPermissionPost: async (changePermissionsRequest?: ChangePermissionsRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/settings/user/permission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePermissionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request password reset
         * @param {ResetPasswordRequest} [resetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserResetPasswordPost: async (resetPasswordRequest?: ResetPasswordRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/settings/user/reset_password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of existing tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TagGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/tag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user notifications
         * @param {number} [from] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationGet: async (from?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/user_notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user notification
         * @param {number} notificationId 
         * @param {UserNotificationRequest} [userNotificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationNotificationIdPatch: async (notificationId: number, userNotificationRequest?: UserNotificationRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('apiV0UserNotificationNotificationIdPatch', 'notificationId', notificationId)
            const localVarPath = `/api/v0/user_notification/{notificationId}`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userNotificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update last seen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationPatch: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/user_notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save video preview as an event
         * @param {number} previewRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestEventPreviewRequestIdPost: async (previewRequestId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'previewRequestId' is not null or undefined
            assertParamExists('apiV0VideoPreviewRequestEventPreviewRequestIdPost', 'previewRequestId', previewRequestId)
            const localVarPath = `/api/v0/video_preview_request/event/{previewRequestId}`
                .replace(`{${"previewRequestId"}}`, encodeURIComponent(String(previewRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get video preview request details
         * @param {number} tripId 
         * @param {number} [driverTripId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestGet: async (tripId: number, driverTripId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tripId' is not null or undefined
            assertParamExists('apiV0VideoPreviewRequestGet', 'tripId', tripId)
            const localVarPath = `/api/v0/video_preview_request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tripId !== undefined) {
                localVarQueryParameter['trip_id'] = tripId;
            }

            if (driverTripId !== undefined) {
                localVarQueryParameter['driver_trip_id'] = driverTripId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new video preview request
         * @param {VideoPreviewRequestBody} [videoPreviewRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestPost: async (videoPreviewRequestBody?: VideoPreviewRequestBody, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/video_preview_request`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(videoPreviewRequestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get wellness score list
         * @param {number} [cache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessScoresGet: async (cache?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v0/wellness_scores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get wellness score details
         * @param {string} licensePlate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessScoresLicensePlateGet: async (licensePlate: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'licensePlate' is not null or undefined
            assertParamExists('apiV0WellnessScoresLicensePlateGet', 'licensePlate', licensePlate)
            const localVarPath = `/api/v0/wellness_scores/{licensePlate}`
                .replace(`{${"licensePlate"}}`, encodeURIComponent(String(licensePlate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add or dismiss wellness status from driver coaching session
         * @param {number} wellnessId 
         * @param {CoachWellnessDetails} [coachWellnessDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessStatusWellnessIdCoachPost: async (wellnessId: number, coachWellnessDetails?: CoachWellnessDetails, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'wellnessId' is not null or undefined
            assertParamExists('apiV0WellnessStatusWellnessIdCoachPost', 'wellnessId', wellnessId)
            const localVarPath = `/api/v0/wellness_status/{wellnessId}/coach`
                .replace(`{${"wellnessId"}}`, encodeURIComponent(String(wellnessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachWellnessDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get driver coaching session
         * @param {string} token 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverGet: async (token: string, code?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiV1CoachDriverGet', 'token', token)
            const localVarPath = `/api/v1/coach/driver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update session metadata
         * @param {string} token 
         * @param {string} [code] 
         * @param {CoachSessionMetadata} [coachSessionMetadata] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverPatch: async (token: string, code?: string, coachSessionMetadata?: CoachSessionMetadata, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiV1CoachDriverPatch', 'token', token)
            const localVarPath = `/api/v1/coach/driver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachSessionMetadata, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Complete driver coaching session
         * @param {string} token 
         * @param {string} [code] 
         * @param {UpdateCoachSession} [updateCoachSession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverPost: async (token: string, code?: string, updateCoachSession?: UpdateCoachSession, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('apiV1CoachDriverPost', 'token', token)
            const localVarPath = `/api/v1/coach/driver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCoachSession, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of coaching sessions
         * @param {number} [driverToken] 
         * @param {number} [completedFrom] 
         * @param {number} [completedTo] 
         * @param {number} [additionalInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachGet: async (driverToken?: number, completedFrom?: number, completedTo?: number, additionalInfo?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/coach`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (driverToken !== undefined) {
                localVarQueryParameter['driver_token'] = driverToken;
            }

            if (completedFrom !== undefined) {
                localVarQueryParameter['completed_from'] = completedFrom;
            }

            if (completedTo !== undefined) {
                localVarQueryParameter['completed_to'] = completedTo;
            }

            if (additionalInfo !== undefined) {
                localVarQueryParameter['additional_info'] = additionalInfo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send coaching session link by sms
         * @param {CoachSessionMessageRequest} coachSessionMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSendPost: async (coachSessionMessageRequest: CoachSessionMessageRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'coachSessionMessageRequest' is not null or undefined
            assertParamExists('apiV1CoachSendPost', 'coachSessionMessageRequest', coachSessionMessageRequest)
            const localVarPath = `/api/v1/coach/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachSessionMessageRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete coaching session
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdDelete: async (sessionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV1CoachSessionIdDelete', 'sessionId', sessionId)
            const localVarPath = `/api/v1/coach/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get coaching session details
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdGet: async (sessionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV1CoachSessionIdGet', 'sessionId', sessionId)
            const localVarPath = `/api/v1/coach/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change coaching session assignee or agenda
         * @param {number} sessionId 
         * @param {CoachSession} [coachSession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdPatch: async (sessionId: number, coachSession?: CoachSession, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV1CoachSessionIdPatch', 'sessionId', sessionId)
            const localVarPath = `/api/v1/coach/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(coachSession, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of coaching sessions
         * @param {number} sessionId 
         * @param {UpdateCoachSession} [updateCoachSession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdPost: async (sessionId: number, updateCoachSession?: UpdateCoachSession, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV1CoachSessionIdPost', 'sessionId', sessionId)
            const localVarPath = `/api/v1/coach/{sessionId}`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCoachSession, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send the driver a reminder to complete session
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdRemindPost: async (sessionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV1CoachSessionIdRemindPost', 'sessionId', sessionId)
            const localVarPath = `/api/v1/coach/{sessionId}/remind`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save auto-generated coaching session
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdSavePost: async (sessionId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('apiV1CoachSessionIdSavePost', 'sessionId', sessionId)
            const localVarPath = `/api/v1/coach/{sessionId}/save`
                .replace(`{${"sessionId"}}`, encodeURIComponent(String(sessionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get events
         * @summary Get events
         * @param {string} [licensePlate] 
         * @param {string} [licensePlateList] 
         * @param {string} [licensePlateContains] 
         * @param {string} [subFleet] 
         * @param {string} [subFleetList] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {string} [tripId] 
         * @param {number} [lastTrip] 
         * @param {string} [tripObjIn] 
         * @param {string} [severity] 
         * @param {string} [eventType] 
         * @param {string} [eventTypeList] 
         * @param {number} [lastEvent] 
         * @param {string} [tag] 
         * @param {string} [level] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EventGet: async (licensePlate?: string, licensePlateList?: string, licensePlateContains?: string, subFleet?: string, subFleetList?: string, date?: string, dateFrom?: string, dateTo?: string, timeFrom?: string, timeTo?: string, tripId?: string, lastTrip?: number, tripObjIn?: string, severity?: string, eventType?: string, eventTypeList?: string, lastEvent?: number, tag?: string, level?: string, limit?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (licensePlate !== undefined) {
                localVarQueryParameter['license_plate'] = licensePlate;
            }

            if (licensePlateList !== undefined) {
                localVarQueryParameter['license_plate_list'] = licensePlateList;
            }

            if (licensePlateContains !== undefined) {
                localVarQueryParameter['license_plate_contains'] = licensePlateContains;
            }

            if (subFleet !== undefined) {
                localVarQueryParameter['sub_fleet'] = subFleet;
            }

            if (subFleetList !== undefined) {
                localVarQueryParameter['sub_fleet_list'] = subFleetList;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = dateTo;
            }

            if (timeFrom !== undefined) {
                localVarQueryParameter['time_from'] = timeFrom;
            }

            if (timeTo !== undefined) {
                localVarQueryParameter['time_to'] = timeTo;
            }

            if (tripId !== undefined) {
                localVarQueryParameter['trip_id'] = tripId;
            }

            if (lastTrip !== undefined) {
                localVarQueryParameter['last_trip'] = lastTrip;
            }

            if (tripObjIn !== undefined) {
                localVarQueryParameter['trip_obj__in'] = tripObjIn;
            }

            if (severity !== undefined) {
                localVarQueryParameter['severity'] = severity;
            }

            if (eventType !== undefined) {
                localVarQueryParameter['event_type'] = eventType;
            }

            if (eventTypeList !== undefined) {
                localVarQueryParameter['event_type_list'] = eventTypeList;
            }

            if (lastEvent !== undefined) {
                localVarQueryParameter['last_event'] = lastEvent;
            }

            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of policies
         * @param {string} [dateFrom] 
         * @param {string} [date] 
         * @param {string} [csv] 
         * @param {string} [_long] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PolicyGet: async (dateFrom?: string, date?: string, csv?: string, _long?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = dateFrom;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (csv !== undefined) {
                localVarQueryParameter['csv'] = csv;
            }

            if (_long !== undefined) {
                localVarQueryParameter['long'] = _long;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send list of policies
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PolicyPost: async (body?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/policy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/octet-stream';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get array of trips for a vehicle
         * @param {string} licensePlate 
         * @param {number} from 
         * @param {number} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripGet: async (licensePlate: string, from: number, to: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'licensePlate' is not null or undefined
            assertParamExists('apiV1TripGet', 'licensePlate', licensePlate)
            // verify required parameter 'from' is not null or undefined
            assertParamExists('apiV1TripGet', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('apiV1TripGet', 'to', to)
            const localVarPath = `/api/v1/trip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (licensePlate !== undefined) {
                localVarQueryParameter['license_plate'] = licensePlate;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get trip location data
         * @param {string} licensePlate 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {boolean} [csv] 
         * @param {string} [tripId] 
         * @param {number} [snapshots] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripLicensePlateGet: async (licensePlate: string, timeFrom?: string, timeTo?: string, csv?: boolean, tripId?: string, snapshots?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'licensePlate' is not null or undefined
            assertParamExists('apiV1TripLicensePlateGet', 'licensePlate', licensePlate)
            const localVarPath = `/api/v1/trip/{licensePlate}`
                .replace(`{${"licensePlate"}}`, encodeURIComponent(String(licensePlate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeFrom !== undefined) {
                localVarQueryParameter['time_from'] = timeFrom;
            }

            if (timeTo !== undefined) {
                localVarQueryParameter['time_to'] = timeTo;
            }

            if (csv !== undefined) {
                localVarQueryParameter['csv'] = csv;
            }

            if (tripId !== undefined) {
                localVarQueryParameter['trip_id'] = tripId;
            }

            if (snapshots !== undefined) {
                localVarQueryParameter['snapshots'] = snapshots;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get trip wellness data
         * @param {string} licensePlate 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripLicensePlateWellnessGet: async (licensePlate: string, timeFrom?: string, timeTo?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'licensePlate' is not null or undefined
            assertParamExists('apiV1TripLicensePlateWellnessGet', 'licensePlate', licensePlate)
            const localVarPath = `/api/v1/trip/{licensePlate}/wellness`
                .replace(`{${"licensePlate"}}`, encodeURIComponent(String(licensePlate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeFrom !== undefined) {
                localVarQueryParameter['time_from'] = timeFrom;
            }

            if (timeTo !== undefined) {
                localVarQueryParameter['time_to'] = timeTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users\' settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user\'s settings
         * @param {UserProfile} [userProfile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserPatch: async (userProfile?: UserProfile, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userProfile, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get device details
         * @param {string} [licensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [deviceId] 
         * @param {string} [deviceIdContains] 
         * @param {string} [subFleet] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [version] 
         * @param {string} [status] 
         * @param {string} [versionName] 
         * @param {number} [cache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DeviceGet: async (licensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, deviceId?: string, deviceIdContains?: string, subFleet?: string, date?: string, dateFrom?: string, dateTo?: string, version?: string, status?: string, versionName?: string, cache?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (licensePlate !== undefined) {
                localVarQueryParameter['license_plate'] = licensePlate;
            }

            if (driverName !== undefined) {
                localVarQueryParameter['driver_name'] = driverName;
            }

            if (licensePlateContains !== undefined) {
                localVarQueryParameter['license_plate_contains'] = licensePlateContains;
            }

            if (driverNameContains !== undefined) {
                localVarQueryParameter['driver_name_contains'] = driverNameContains;
            }

            if (deviceId !== undefined) {
                localVarQueryParameter['device_id'] = deviceId;
            }

            if (deviceIdContains !== undefined) {
                localVarQueryParameter['device_id_contains'] = deviceIdContains;
            }

            if (subFleet !== undefined) {
                localVarQueryParameter['sub_fleet'] = subFleet;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = dateTo;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (versionName !== undefined) {
                localVarQueryParameter['version_name'] = versionName;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get device location
         * @param {string} [licensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [deviceId] 
         * @param {string} [deviceIdContains] 
         * @param {string} [subFleet] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [version] 
         * @param {string} [versionName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DeviceLocationGet: async (licensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, deviceId?: string, deviceIdContains?: string, subFleet?: string, date?: string, dateFrom?: string, dateTo?: string, version?: string, versionName?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/device/location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (licensePlate !== undefined) {
                localVarQueryParameter['license_plate'] = licensePlate;
            }

            if (driverName !== undefined) {
                localVarQueryParameter['driver_name'] = driverName;
            }

            if (licensePlateContains !== undefined) {
                localVarQueryParameter['license_plate_contains'] = licensePlateContains;
            }

            if (driverNameContains !== undefined) {
                localVarQueryParameter['driver_name_contains'] = driverNameContains;
            }

            if (deviceId !== undefined) {
                localVarQueryParameter['device_id'] = deviceId;
            }

            if (deviceIdContains !== undefined) {
                localVarQueryParameter['device_id_contains'] = deviceIdContains;
            }

            if (subFleet !== undefined) {
                localVarQueryParameter['sub_fleet'] = subFleet;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = dateTo;
            }

            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }

            if (versionName !== undefined) {
                localVarQueryParameter['version_name'] = versionName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get events
         * @summary Get events
         * @param {string} [licensePlate] 
         * @param {string} [licensePlateList] 
         * @param {string} [driverName] 
         * @param {string} [driverNameList] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [subFleet] 
         * @param {string} [subFleetList] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {string} [tripId] 
         * @param {string} [tripObjIn] 
         * @param {string} [eventType] 
         * @param {string} [eventTypeList] 
         * @param {number} [severityFrom] 
         * @param {number} [severityTo] 
         * @param {string} [tag] 
         * @param {string} [level] 
         * @param {number} [limit] 
         * @param {number} [searchAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EventGet: async (licensePlate?: string, licensePlateList?: string, driverName?: string, driverNameList?: string, licensePlateContains?: string, driverNameContains?: string, subFleet?: string, subFleetList?: string, date?: string, dateFrom?: string, dateTo?: string, timeFrom?: string, timeTo?: string, tripId?: string, tripObjIn?: string, eventType?: string, eventTypeList?: string, severityFrom?: number, severityTo?: number, tag?: string, level?: string, limit?: number, searchAfter?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (licensePlate !== undefined) {
                localVarQueryParameter['license_plate'] = licensePlate;
            }

            if (licensePlateList !== undefined) {
                localVarQueryParameter['license_plate_list'] = licensePlateList;
            }

            if (driverName !== undefined) {
                localVarQueryParameter['driver_name'] = driverName;
            }

            if (driverNameList !== undefined) {
                localVarQueryParameter['driver_name_list'] = driverNameList;
            }

            if (licensePlateContains !== undefined) {
                localVarQueryParameter['license_plate_contains'] = licensePlateContains;
            }

            if (driverNameContains !== undefined) {
                localVarQueryParameter['driver_name_contains'] = driverNameContains;
            }

            if (subFleet !== undefined) {
                localVarQueryParameter['sub_fleet'] = subFleet;
            }

            if (subFleetList !== undefined) {
                localVarQueryParameter['sub_fleet_list'] = subFleetList;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = dateTo;
            }

            if (timeFrom !== undefined) {
                localVarQueryParameter['time_from'] = timeFrom;
            }

            if (timeTo !== undefined) {
                localVarQueryParameter['time_to'] = timeTo;
            }

            if (tripId !== undefined) {
                localVarQueryParameter['trip_id'] = tripId;
            }

            if (tripObjIn !== undefined) {
                localVarQueryParameter['trip_obj__in'] = tripObjIn;
            }

            if (eventType !== undefined) {
                localVarQueryParameter['event_type'] = eventType;
            }

            if (eventTypeList !== undefined) {
                localVarQueryParameter['event_type_list'] = eventTypeList;
            }

            if (severityFrom !== undefined) {
                localVarQueryParameter['severity_from'] = severityFrom;
            }

            if (severityTo !== undefined) {
                localVarQueryParameter['severity_to'] = severityTo;
            }

            if (tag !== undefined) {
                localVarQueryParameter['tag'] = tag;
            }

            if (level !== undefined) {
                localVarQueryParameter['level'] = level;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (searchAfter !== undefined) {
                localVarQueryParameter['search_after'] = searchAfter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get trip location data
         * @param {string} licensePlate 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {boolean} [csv] 
         * @param {string} [tripId] 
         * @param {number} [driverTripId] 
         * @param {number} [snapshots] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TripLicensePlateGet: async (licensePlate: string, timeFrom?: string, timeTo?: string, csv?: boolean, tripId?: string, driverTripId?: number, snapshots?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'licensePlate' is not null or undefined
            assertParamExists('apiV2TripLicensePlateGet', 'licensePlate', licensePlate)
            const localVarPath = `/api/v2/trip/{licensePlate}`
                .replace(`{${"licensePlate"}}`, encodeURIComponent(String(licensePlate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (timeFrom !== undefined) {
                localVarQueryParameter['time_from'] = timeFrom;
            }

            if (timeTo !== undefined) {
                localVarQueryParameter['time_to'] = timeTo;
            }

            if (csv !== undefined) {
                localVarQueryParameter['csv'] = csv;
            }

            if (tripId !== undefined) {
                localVarQueryParameter['trip_id'] = tripId;
            }

            if (driverTripId !== undefined) {
                localVarQueryParameter['driver_trip_id'] = driverTripId;
            }

            if (snapshots !== undefined) {
                localVarQueryParameter['snapshots'] = snapshots;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update trip details
         * @param {string} licensePlate 
         * @param {TripUpdateRequest} [tripUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TripLicensePlatePost: async (licensePlate: string, tripUpdateRequest?: TripUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'licensePlate' is not null or undefined
            assertParamExists('apiV2TripLicensePlatePost', 'licensePlate', licensePlate)
            const localVarPath = `/api/v2/trip/{licensePlate}`
                .replace(`{${"licensePlate"}}`, encodeURIComponent(String(licensePlate)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tripUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get wellness image
         * @param {string} wellnessType 
         * @param {string} [wellnessId] 
         * @param {number} [timestamp] 
         * @param {string} [licensePlate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2WellnessImageWellnessTypeGet: async (wellnessType: string, wellnessId?: string, timestamp?: number, licensePlate?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'wellnessType' is not null or undefined
            assertParamExists('apiV2WellnessImageWellnessTypeGet', 'wellnessType', wellnessType)
            const localVarPath = `/api/v2/wellness_image/{wellnessType}`
                .replace(`{${"wellnessType"}}`, encodeURIComponent(String(wellnessType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (wellnessId !== undefined) {
                localVarQueryParameter['wellness_id'] = wellnessId;
            }

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }

            if (licensePlate !== undefined) {
                localVarQueryParameter['license_plate'] = licensePlate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Run wellness check
         * @param {RunWellnessRequest} [runWellnessRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2WellnessRunTaskPost: async (runWellnessRequest?: RunWellnessRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/wellness/run_task`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runWellnessRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get device details
         * @param {number} [cache] 
         * @param {number} [timestamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3DeviceGet: async (cache?: number, timestamp?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v3/device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }

            if (timestamp !== undefined) {
                localVarQueryParameter['timestamp'] = timestamp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customer drivers and home terminals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsCustomerGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/settings/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove hos drivers
         * @param {Array<HosDriverRequest>} [hosDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementDelete: async (hosDriverRequest?: Array<HosDriverRequest>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/settings/driver/management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hosDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get hos drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/settings/driver/management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update hos drivers
         * @param {Array<HosDriverRequest>} [hosDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementPatch: async (hosDriverRequest?: Array<HosDriverRequest>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/settings/driver/management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hosDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new hos driver
         * @param {Array<HosDriverRequest>} [hosDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementPost: async (hosDriverRequest?: Array<HosDriverRequest>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/settings/driver/management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hosDriverRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove home terminals
         * @param {Array<HomeTerminal>} [homeTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementDelete: async (homeTerminal?: Array<HomeTerminal>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/settings/terminal/management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homeTerminal, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get home terminals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/settings/terminal/management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update home terminals
         * @param {Array<HomeTerminal>} [homeTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementPatch: async (homeTerminal?: Array<HomeTerminal>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/settings/terminal/management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homeTerminal, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create new home terminal
         * @param {Array<HomeTerminal>} [homeTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementPost: async (homeTerminal?: Array<HomeTerminal>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/settings/terminal/management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(homeTerminal, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiApi - functional programming interface
 * @export
 */
export const ApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get device details
         * @param {string} [licensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [deviceId] 
         * @param {string} [deviceIdContains] 
         * @param {string} [subFleet] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [version] 
         * @param {string} [status] 
         * @param {string} [versionName] 
         * @param {number} [cache] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminDeviceGet(licensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, deviceId?: string, deviceIdContains?: string, subFleet?: string, date?: string, dateFrom?: string, dateTo?: string, version?: string, status?: string, versionName?: string, cache?: number, page?: number, pageSize?: number, country?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminDeviceGet(licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, page, pageSize, country, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get device operation details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminDeviceOperationGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceOperationData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminDeviceOperationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new device operation details
         * @param {DeviceOperationData} [deviceOperationData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminDeviceOperationPost(deviceOperationData?: DeviceOperationData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminDeviceOperationPost(deviceOperationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create overlay on event video
         * @param {EventOverlayRequest} [eventOverlayRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminOverlayPost(eventOverlayRequest?: EventOverlayRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminOverlayPost(eventOverlayRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get list of all wellness details
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminWellnessGet(page?: number, pageSize?: number, country?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WellnessList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminWellnessGet(page, pageSize, country, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new wellness details
         * @param {WellnessUpdate} [wellnessUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAdminWellnessPost(wellnessUpdate?: WellnessUpdate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAdminWellnessPost(wellnessUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthOtpPost(oTPUserCredentials?: OTPUserCredentials, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWTToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthOtpPost(oTPUserCredentials, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user token
         * @param {UserCredentials} [userCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthPost(userCredentials?: UserCredentials, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWTToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthPost(userCredentials, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthRefreshPost(refreshTokenRequest?: RefreshTokenRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWTToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthRefreshPost(refreshTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get accident overview data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0AccidentOverviewGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OverviewData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0AccidentOverviewGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachEventEventIdGet(eventId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachEventEventIdGet(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get coaching event image
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachEventEventIdImageGet(eventId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachEventEventIdImageGet(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get event coaching status
         * @param {CoachEventStatus} [coachEventStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachEventPost(coachEventStatus?: CoachEventStatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: object; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachEventPost(coachEventStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get metrics data
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachMetricsGet(driverToken: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachMetricByType>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachMetricsGet(driverToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new coaching metrics by driver token
         * @param {CoachMetricsSaveRequest} [coachMetricsSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachMetricsPost(coachMetricsSaveRequest?: CoachMetricsSaveRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachMetrics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachMetricsPost(coachMetricsSaveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete event from coaching session
         * @param {number} sessionId 
         * @param {number} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdEventItemIdDelete(sessionId: number, itemId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdEventItemIdDelete(sessionId, itemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update event in coaching session
         * @param {number} sessionId 
         * @param {number} itemId 
         * @param {UpdateCoachEvent} [updateCoachEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdEventItemIdPatch(sessionId: number, itemId: number, updateCoachEvent?: UpdateCoachEvent, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdEventItemIdPatch(sessionId, itemId, updateCoachEvent, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get coaching session details
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdGet(sessionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdGet(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get coaching session image
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdImageGet(sessionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdImageGet(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete coach media file
         * @param {number} sessionId 
         * @param {number} coachMediaFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete(sessionId: number, coachMediaFileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete(sessionId, coachMediaFileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update coach media file
         * @param {number} sessionId 
         * @param {number} coachMediaFileId 
         * @param {CoachMediaFileRequest} [coachMediaFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch(sessionId: number, coachMediaFileId: number, coachMediaFileRequest?: CoachMediaFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachMediaFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch(sessionId, coachMediaFileId, coachMediaFileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new coach media file
         * @param {number} sessionId 
         * @param {CoachMediaFileRequest} [coachMediaFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdMediaFilePost(sessionId: number, coachMediaFileRequest?: CoachMediaFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachMediaFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdMediaFilePost(sessionId, coachMediaFileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete coach metrics
         * @param {number} sessionId 
         * @param {number} metricsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdMetricsMetricsIdDelete(sessionId: number, metricsId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdMetricsMetricsIdDelete(sessionId, metricsId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update coach metrics
         * @param {number} sessionId 
         * @param {number} metricsId 
         * @param {CoachMetrics} [coachMetrics] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdMetricsMetricsIdPatch(sessionId: number, metricsId: number, coachMetrics?: CoachMetrics, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachMetrics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdMetricsMetricsIdPatch(sessionId, metricsId, coachMetrics, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new coaching metrics
         * @param {number} sessionId 
         * @param {CoachMetricsRequest} [coachMetricsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdMetricsPost(sessionId: number, coachMetricsRequest?: CoachMetricsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachMetrics>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdMetricsPost(sessionId, coachMetricsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete manager notes
         * @param {number} sessionId 
         * @param {number} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdNotesNoteIdDelete(sessionId: number, noteId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdNotesNoteIdDelete(sessionId, noteId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update manager notes
         * @param {number} sessionId 
         * @param {number} noteId 
         * @param {CoachManagerNotes} [coachManagerNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdNotesNoteIdPatch(sessionId: number, noteId: number, coachManagerNotes?: CoachManagerNotes, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachManagerNotes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdNotesNoteIdPatch(sessionId, noteId, coachManagerNotes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new manager notes
         * @param {number} sessionId 
         * @param {ManagerNotesRequest} [managerNotesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdNotesPost(sessionId: number, managerNotesRequest?: ManagerNotesRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachManagerNotes>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdNotesPost(sessionId, managerNotesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of coaching sessions
         * @param {number} sessionId 
         * @param {UpdateCoachSession} [updateCoachSession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdPost(sessionId: number, updateCoachSession?: UpdateCoachSession, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdPost(sessionId, updateCoachSession, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new driver response
         * @param {number} sessionId 
         * @param {DriverResponseRequest} [driverResponseRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdResponsePost(sessionId: number, driverResponseRequest?: DriverResponseRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachDriverResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdResponsePost(sessionId, driverResponseRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete driver response
         * @param {number} sessionId 
         * @param {number} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdResponseResponseIdDelete(sessionId: number, responseId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdResponseResponseIdDelete(sessionId, responseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update driver response
         * @param {number} sessionId 
         * @param {number} responseId 
         * @param {CoachDriverResponse} [coachDriverResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdResponseResponseIdPatch(sessionId: number, responseId: number, coachDriverResponse?: CoachDriverResponse, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachDriverResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdResponseResponseIdPatch(sessionId, responseId, coachDriverResponse, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Remove wellness status from driver coaching session
         * @param {number} sessionId 
         * @param {number} wellnessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdWellnessStatusWellnessIdDelete(sessionId: number, wellnessId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachWellnessStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdWellnessStatusWellnessIdDelete(sessionId, wellnessId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update wellness status from driver coaching session
         * @param {number} sessionId 
         * @param {number} wellnessId 
         * @param {UpdateCoachWellnessStatus} [updateCoachWellnessStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachSessionIdWellnessStatusWellnessIdPatch(sessionId: number, wellnessId: number, updateCoachWellnessStatus?: UpdateCoachWellnessStatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachWellnessStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachSessionIdWellnessStatusWellnessIdPatch(sessionId, wellnessId, updateCoachWellnessStatus, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get coaching overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CoachingOverviewGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachingOverview>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CoachingOverviewGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get clip from device
         * @summary Get clip from device
         * @param {number} commandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CommandCommandIdGet(commandId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CommandCommandIdGet(commandId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create remote command
         * @summary Create remote command
         * @param {number} commandId 
         * @param {RemoteCommand} [remoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CommandCommandIdPost(commandId: number, remoteCommand?: RemoteCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CommandCommandIdPost(commandId, remoteCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of get clip commands
         * @summary Get list of get clip commands
         * @param {number} [timeFrom] 
         * @param {number} [timeTo] 
         * @param {number} [accident] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CommandGet(timeFrom?: number, timeTo?: number, accident?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommandData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CommandGet(timeFrom, timeTo, accident, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get clip from device
         * @summary Get clip from device
         * @param {Command} [command] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CommandPost(command?: Command, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CommandPost(command, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove customer sub fleet
         * @param {CustomerSubFleetData} [customerSubFleetData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CustomerDelete(customerSubFleetData?: CustomerSubFleetData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CustomerDelete(customerSubFleetData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get customer details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CustomerGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendedCustomerData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CustomerGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new customer sub fleet
         * @param {CustomerSubFleetData} [customerSubFleetData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0CustomerPost(customerSubFleetData?: CustomerSubFleetData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0CustomerPost(customerSubFleetData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get device snapshot
         * @param {string} deviceId 
         * @param {number} [timestamp] 
         * @param {number} [since] 
         * @param {number} [exact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DeviceDeviceIdSnapshotGet(deviceId: string, timestamp?: number, since?: number, exact?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DeviceDeviceIdSnapshotGet(deviceId, timestamp, since, exact, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get device location
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {number} [radius] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DeviceLocateGet(timeFrom?: string, timeTo?: string, latitude?: number, longitude?: number, radius?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LocationSample>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DeviceLocateGet(timeFrom, timeTo, latitude, longitude, radius, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update device details
         * @param {Array<DeviceRequest>} [deviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DeviceUpdatePatch(deviceRequest?: Array<DeviceRequest>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DeviceUpdatePatch(deviceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get driver badge
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DriverBadgeDriverTokenGet(driverToken: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DriverBadgeDriverTokenGet(driverToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get driver badges
         * @param {DriverBadgeRequest} [driverBadgeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DriverBadgePost(driverBadgeRequest?: DriverBadgeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DriverBadgePost(driverBadgeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get driver details
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DriverDriverTokenGet(driverToken: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetDriver>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DriverDriverTokenGet(driverToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update driver details
         * @param {number} driverToken 
         * @param {FleetDriverRequest} [fleetDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DriverDriverTokenPatch(driverToken: number, fleetDriverRequest?: FleetDriverRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetDriver>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DriverDriverTokenPatch(driverToken, fleetDriverRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DriverGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FleetDriver>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DriverGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update multiple drivers
         * @param {FleetDriverList} [fleetDriverList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DriverPatch(fleetDriverList?: FleetDriverList, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FleetDriver>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DriverPatch(fleetDriverList, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new driver
         * @param {FleetDriverRequest} [fleetDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DriverPost(fleetDriverRequest?: FleetDriverRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FleetDriver>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DriverPost(fleetDriverRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * recalculate driver score
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DriverScoresDriverTokenCalculatePatch(driverToken: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DriverScoresDriverTokenCalculatePatch(driverToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get driver score with relevant events
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DriverScoresDriverTokenGet(driverToken: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DriverScoreDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DriverScoresDriverTokenGet(driverToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get driver scores
         * @param {number} [allDrivers] 
         * @param {number} [page] 
         * @param {number} [cache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0DriverScoresGet(allDrivers?: number, page?: number, cache?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DriverScore>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0DriverScoresGet(allDrivers, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create new event from existing one
         * @param {number} eventId 
         * @param {CloneEventDetails} [cloneEventDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0EventEventIdClonePost(eventId: number, cloneEventDetails?: CloneEventDetails, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Event>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0EventEventIdClonePost(eventId, cloneEventDetails, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get event coaching data
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0EventEventIdCoachGet(eventId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0EventEventIdCoachGet(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add or dismiss event from driver coaching session
         * @param {number} eventId 
         * @param {CoachEventDetails} [coachEventDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0EventEventIdCoachPost(eventId: number, coachEventDetails?: CoachEventDetails, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveToSessionResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0EventEventIdCoachPost(eventId, coachEventDetails, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download event video request
         * @param {number} eventId 
         * @param {DownloadVideoEventRequest} [downloadVideoEventRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0EventEventIdDownloadPost(eventId: number, downloadVideoEventRequest?: DownloadVideoEventRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0EventEventIdDownloadPost(eventId, downloadVideoEventRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId 
         * @param {string} [bucket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0EventEventIdGet(eventId: number, bucket?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0EventEventIdGet(eventId, bucket, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get event image
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0EventEventIdImageGet(eventId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0EventEventIdImageGet(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update event details
         * @param {number} eventId 
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0EventEventIdPatch(eventId: number, inlineObject?: InlineObject, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0EventEventIdPatch(eventId, inlineObject, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get related events
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0EventEventIdRelatedGet(eventId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RelatedEvents>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0EventEventIdRelatedGet(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send event
         * @param {number} eventId 
         * @param {SendEventRequest} [sendEventRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0EventEventIdSendPost(eventId: number, sendEventRequest?: SendEventRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0EventEventIdSendPost(eventId, sendEventRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Change event tags
         * @summary Change event tags
         * @param {number} eventId 
         * @param {EventTag} [eventTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0EventEventIdTagPost(eventId: number, eventTag?: EventTag, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0EventEventIdTagPost(eventId, eventTag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add comment to feed event
         * @summary Add comment
         * @param {number} eventId 
         * @param {FeedCommentRequest} [feedCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FeedEventIdCommentPost(eventId: number, feedCommentRequest?: FeedCommentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FeedEventIdCommentPost(eventId, feedCommentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add or remove dislike from event
         * @summary Dislike event
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FeedEventIdDislikePost(eventId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FeedEventIdDislikePost(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get feed event
         * @summary Get feed event
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FeedEventIdGet(eventId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendedFeedEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FeedEventIdGet(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add or remove like from event
         * @summary Like event
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FeedEventIdLikePost(eventId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FeedEventIdLikePost(eventId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update percent watched
         * @summary Update percent watched
         * @param {number} eventId 
         * @param {EventWatchedRequest} [eventWatchedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FeedEventIdWatchedPost(eventId: number, eventWatchedRequest?: EventWatchedRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FeedEventIdWatchedPost(eventId, eventWatchedRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get events
         * @summary Get user feed
         * @param {number} [generatedAt] 
         * @param {number} [size] 
         * @param {number} [fromEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FeedGet(generatedAt?: number, size?: number, fromEvent?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FeedGet(generatedAt, size, fromEvent, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get sms with link to feed page
         * @summary Get sms with link to feed page
         * @param {FeedLinkRequest} [feedLinkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FeedLinkPost(feedLinkRequest?: FeedLinkRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FeedResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FeedLinkPost(feedLinkRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get fleet safety scores
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FleetSafetyScoresGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FleetSafetyScores>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FleetSafetyScoresGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get fleet score and fleet metric data
         * @param {number} [cache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FleetScoreGet(cache?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FleetScoreDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FleetScoreGet(cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get fleet scores and score distribution over time
         * @param {number} [cache] 
         * @param {number} [endDate] 
         * @param {number} [daysCount] 
         * @param {number} [daysInterval] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0FleetScoreTrendGet(cache?: number, endDate?: number, daysCount?: number, daysInterval?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FleetScoreShort>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0FleetScoreTrendGet(cache, endDate, daysCount, daysInterval, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete a geofence
         * @param {number} geofenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0GeofenceGeofenceIdDelete(geofenceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0GeofenceGeofenceIdDelete(geofenceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a geofence
         * @param {number} geofenceId 
         * @param {Geofence} [geofence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0GeofenceGeofenceIdPatch(geofenceId: number, geofence?: Geofence, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Geofence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0GeofenceGeofenceIdPatch(geofenceId, geofence, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get geofence details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0GeofenceGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Geofence>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0GeofenceGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new geofence
         * @param {Geofence} [geofence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0GeofencePost(geofence?: Geofence, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Geofence>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0GeofencePost(geofence, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get help videos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0HelpGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0HelpGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get aggregated data of malfunctions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MalfunctionAggregatedGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregatedMalfunctionsHistory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MalfunctionAggregatedGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get malfunction list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MalfunctionGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Malfunction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MalfunctionGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create guest technician
         * @param {GuestTechnicianRequest} [guestTechnicianRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MalfunctionGuestPost(guestTechnicianRequest?: GuestTechnicianRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerUserDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MalfunctionGuestPost(guestTechnicianRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get malfunction comments
         * @param {number} malfunctionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MalfunctionMalfunctionIdCommentGet(malfunctionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MalfunctionComment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MalfunctionMalfunctionIdCommentGet(malfunctionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add new comment to malfunction
         * @param {number} malfunctionId 
         * @param {MalfunctionCommentRequest} [malfunctionCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MalfunctionMalfunctionIdCommentPost(malfunctionId: number, malfunctionCommentRequest?: MalfunctionCommentRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MalfunctionComment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MalfunctionMalfunctionIdCommentPost(malfunctionId, malfunctionCommentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get malfunction image
         * @param {number} malfunctionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MalfunctionMalfunctionIdImageGet(malfunctionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MalfunctionMalfunctionIdImageGet(malfunctionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update malfunction assignee
         * @param {MalfunctionAssigneeRequest} [malfunctionAssigneeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MalfunctionPatch(malfunctionAssigneeRequest?: MalfunctionAssigneeRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MalfunctionPatch(malfunctionAssigneeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Sync malfunctions with policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MalfunctionUpdateGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MalfunctionUpdateGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get media file library
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MediaFilesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MediaFile>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MediaFilesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete media file
         * @param {number} mediaFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MediaFilesMediaFileIdDelete(mediaFileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MediaFilesMediaFileIdDelete(mediaFileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get signed url for media file
         * @summary Get signed url for media file
         * @param {number} mediaFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MediaFilesMediaFileIdGet(mediaFileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MediaFilesMediaFileIdGet(mediaFileId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update media file
         * @param {number} mediaFileId 
         * @param {MediaFile} [mediaFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MediaFilesMediaFileIdPatch(mediaFileId: number, mediaFile?: MediaFile, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MediaFilesMediaFileIdPatch(mediaFileId, mediaFile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get file upload url
         * @param {UploadMediaFileRequest} [uploadMediaFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MediaFilesPost(uploadMediaFileRequest?: UploadMediaFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MediaFilesPost(uploadMediaFileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add media file to database
         * @param {MediaFileRequest} [mediaFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0MediaFilesPut(mediaFileRequest?: MediaFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MediaFile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0MediaFilesPut(mediaFileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new NPS
         * @param {Nps} [nps] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0NpsPost(nps?: Nps, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0NpsPost(nps, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove package to device list
         * @param {PackageTrackerData} [packageTrackerData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PackageDelete(packageTrackerData?: PackageTrackerData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PackageDelete(packageTrackerData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove file from package
         * @param {number} packageId 
         * @param {FileData} [fileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PackagePackageIdDelete(packageId: number, fileData?: FileData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PackagePackageIdDelete(packageId, fileData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get file upload data
         * @param {number} packageId 
         * @param {FileData} [fileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PackagePackageIdPost(packageId: number, fileData?: FileData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PackagePackageIdPost(packageId, fileData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add file to existing package
         * @param {number} packageId 
         * @param {FileData} [fileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PackagePackageIdPut(packageId: number, fileData?: FileData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PackagePackageIdPut(packageId, fileData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new package
         * @param {PackageName} [packageName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PackagePost(packageName?: PackageName, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PackageData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PackagePost(packageName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Attach package to device list
         * @param {PackageTrackerData} [packageTrackerData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PackagePut(packageTrackerData?: PackageTrackerData, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PackagePut(packageTrackerData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get premium optimization details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PremiumOptimizationGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PremiumOptimization>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PremiumOptimizationGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new premium optimization details
         * @param {PremiumOptimizationRequest} [premiumOptimizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PremiumOptimizationPost(premiumOptimizationRequest?: PremiumOptimizationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PremiumOptimizationPost(premiumOptimizationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send reminder
         * @param {PremiumOptimizationReminderRequest} [premiumOptimizationReminderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0PremiumOptimizationReminderPost(premiumOptimizationReminderRequest?: PremiumOptimizationReminderRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0PremiumOptimizationReminderPost(premiumOptimizationReminderRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get release notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ReleaseNotesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReleaseNotes>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ReleaseNotesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of reports and alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ReportGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AlertReportList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ReportGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary create new report or alert
         * @param {AlertOrReport} [alertOrReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ReportPost(alertOrReport?: AlertOrReport, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Alert | Report>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ReportPost(alertOrReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary create new report or alert
         * @param {number} reportId 
         * @param {AlertOrReport} [alertOrReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ReportReportIdDelete(reportId: number, alertOrReport?: AlertOrReport, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ReportReportIdDelete(reportId, alertOrReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update report or alert
         * @param {number} reportId 
         * @param {AlertOrReport} [alertOrReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ReportReportIdPatch(reportId: number, alertOrReport?: AlertOrReport, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Alert | Report>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ReportReportIdPatch(reportId, alertOrReport, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of report instances
         * @param {string} [reportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ReportRunGet(reportType?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportInstance>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ReportRunGet(reportType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get report instance
         * @param {number} instanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ReportRunInstanceIdGet(instanceId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportInstance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ReportRunInstanceIdGet(instanceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update report instance
         * @param {number} instanceId 
         * @param {ReportInstanceUpdate} [reportInstanceUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ReportRunInstanceIdPatch(instanceId: number, reportInstanceUpdate?: ReportInstanceUpdate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ReportRunInstanceIdPatch(instanceId, reportInstanceUpdate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send report
         * @param {number} instanceId 
         * @param {SendReportRequest} [sendReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ReportRunInstanceIdSendPost(instanceId: number, sendReportRequest?: SendReportRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ReportRunInstanceIdSendPost(instanceId, sendReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate report
         * @param {ReportInstanceRequest} [reportInstanceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ReportRunPost(reportInstanceRequest?: ReportInstanceRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportInstance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ReportRunPost(reportInstanceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update customer settings
         * @param {CustomerSettingsRequest} [customerSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SettingsCustomerPatch(customerSettingsRequest?: CustomerSettingsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendedCustomerData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SettingsCustomerPatch(customerSettingsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get customer accident sticker
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SettingsCustomerStickerPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SettingsCustomerStickerPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change user\'s email
         * @param {ChangeEmailRequest} [changeEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SettingsUserEmailPatch(changeEmailRequest?: ChangeEmailRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SettingsUserEmailPatch(changeEmailRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove users
         * @param {Array<UserDetails>} [userDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SettingsUserManagementDelete(userDetails?: Array<UserDetails>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SettingsUserManagementDelete(userDetails, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get users\' permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SettingsUserManagementGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDetailsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SettingsUserManagementGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update users\' permissions
         * @param {Array<UserDetails>} [userDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SettingsUserManagementPatch(userDetails?: Array<UserDetails>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDetailsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SettingsUserManagementPatch(userDetails, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new user
         * @param {Array<UserCreationData>} [userCreationData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SettingsUserManagementPost(userCreationData?: Array<UserCreationData>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDetailsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SettingsUserManagementPost(userCreationData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change user\'s password
         * @param {ChangePasswordRequest} [changePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SettingsUserPasswordPatch(changePasswordRequest?: ChangePasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SettingsUserPasswordPatch(changePasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request permission change
         * @param {ChangePermissionsRequest} [changePermissionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SettingsUserPermissionPost(changePermissionsRequest?: ChangePermissionsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SettingsUserPermissionPost(changePermissionsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request password reset
         * @param {ResetPasswordRequest} [resetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SettingsUserResetPasswordPost(resetPasswordRequest?: ResetPasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SettingsUserResetPasswordPost(resetPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of existing tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0TagGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0TagGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user notifications
         * @param {number} [from] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0UserNotificationGet(from?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserNotificationList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0UserNotificationGet(from, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update user notification
         * @param {number} notificationId 
         * @param {UserNotificationRequest} [userNotificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0UserNotificationNotificationIdPatch(notificationId: number, userNotificationRequest?: UserNotificationRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0UserNotificationNotificationIdPatch(notificationId, userNotificationRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update last seen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0UserNotificationPatch(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0UserNotificationPatch(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save video preview as an event
         * @param {number} previewRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0VideoPreviewRequestEventPreviewRequestIdPost(previewRequestId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoPreviewRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0VideoPreviewRequestEventPreviewRequestIdPost(previewRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get video preview request details
         * @param {number} tripId 
         * @param {number} [driverTripId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0VideoPreviewRequestGet(tripId: number, driverTripId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoPreviewRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0VideoPreviewRequestGet(tripId, driverTripId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new video preview request
         * @param {VideoPreviewRequestBody} [videoPreviewRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0VideoPreviewRequestPost(videoPreviewRequestBody?: VideoPreviewRequestBody, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VideoPreviewRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0VideoPreviewRequestPost(videoPreviewRequestBody, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get wellness score list
         * @param {number} [cache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0WellnessScoresGet(cache?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WellnessScore>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0WellnessScoresGet(cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get wellness score details
         * @param {string} licensePlate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0WellnessScoresLicensePlateGet(licensePlate: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WellnessScoreDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0WellnessScoresLicensePlateGet(licensePlate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Add or dismiss wellness status from driver coaching session
         * @param {number} wellnessId 
         * @param {CoachWellnessDetails} [coachWellnessDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0WellnessStatusWellnessIdCoachPost(wellnessId: number, coachWellnessDetails?: CoachWellnessDetails, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaveToSessionResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0WellnessStatusWellnessIdCoachPost(wellnessId, coachWellnessDetails, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get driver coaching session
         * @param {string} token 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoachDriverGet(token: string, code?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachSession | CoachSessionToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoachDriverGet(token, code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update session metadata
         * @param {string} token 
         * @param {string} [code] 
         * @param {CoachSessionMetadata} [coachSessionMetadata] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoachDriverPatch(token: string, code?: string, coachSessionMetadata?: CoachSessionMetadata, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoachDriverPatch(token, code, coachSessionMetadata, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Complete driver coaching session
         * @param {string} token 
         * @param {string} [code] 
         * @param {UpdateCoachSession} [updateCoachSession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoachDriverPost(token: string, code?: string, updateCoachSession?: UpdateCoachSession, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoachDriverPost(token, code, updateCoachSession, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of coaching sessions
         * @param {number} [driverToken] 
         * @param {number} [completedFrom] 
         * @param {number} [completedTo] 
         * @param {number} [additionalInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoachGet(driverToken?: number, completedFrom?: number, completedTo?: number, additionalInfo?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShortCoachSession>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoachGet(driverToken, completedFrom, completedTo, additionalInfo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send coaching session link by sms
         * @param {CoachSessionMessageRequest} coachSessionMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoachSendPost(coachSessionMessageRequest: CoachSessionMessageRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachSessionMessageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoachSendPost(coachSessionMessageRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete coaching session
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoachSessionIdDelete(sessionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoachSessionIdDelete(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get coaching session details
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoachSessionIdGet(sessionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoachSessionIdGet(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change coaching session assignee or agenda
         * @param {number} sessionId 
         * @param {CoachSession} [coachSession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoachSessionIdPatch(sessionId: number, coachSession?: CoachSession, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoachSessionIdPatch(sessionId, coachSession, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of coaching sessions
         * @param {number} sessionId 
         * @param {UpdateCoachSession} [updateCoachSession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoachSessionIdPost(sessionId: number, updateCoachSession?: UpdateCoachSession, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoachSessionIdPost(sessionId, updateCoachSession, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send the driver a reminder to complete session
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoachSessionIdRemindPost(sessionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoachSessionIdRemindPost(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save auto-generated coaching session
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1CoachSessionIdSavePost(sessionId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CoachingMetadataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1CoachSessionIdSavePost(sessionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get events
         * @summary Get events
         * @param {string} [licensePlate] 
         * @param {string} [licensePlateList] 
         * @param {string} [licensePlateContains] 
         * @param {string} [subFleet] 
         * @param {string} [subFleetList] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {string} [tripId] 
         * @param {number} [lastTrip] 
         * @param {string} [tripObjIn] 
         * @param {string} [severity] 
         * @param {string} [eventType] 
         * @param {string} [eventTypeList] 
         * @param {number} [lastEvent] 
         * @param {string} [tag] 
         * @param {string} [level] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1EventGet(licensePlate?: string, licensePlateList?: string, licensePlateContains?: string, subFleet?: string, subFleetList?: string, date?: string, dateFrom?: string, dateTo?: string, timeFrom?: string, timeTo?: string, tripId?: string, lastTrip?: number, tripObjIn?: string, severity?: string, eventType?: string, eventTypeList?: string, lastEvent?: number, tag?: string, level?: string, limit?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1EventGet(licensePlate, licensePlateList, licensePlateContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, lastTrip, tripObjIn, severity, eventType, eventTypeList, lastEvent, tag, level, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of policies
         * @param {string} [dateFrom] 
         * @param {string} [date] 
         * @param {string} [csv] 
         * @param {string} [_long] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PolicyGet(dateFrom?: string, date?: string, csv?: string, _long?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Policy>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PolicyGet(dateFrom, date, csv, _long, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send list of policies
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1PolicyPost(body?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1PolicyPost(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get array of trips for a vehicle
         * @param {string} licensePlate 
         * @param {number} from 
         * @param {number} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TripGet(licensePlate: string, from: number, to: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TripDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TripGet(licensePlate, from, to, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get trip location data
         * @param {string} licensePlate 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {boolean} [csv] 
         * @param {string} [tripId] 
         * @param {number} [snapshots] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TripLicensePlateGet(licensePlate: string, timeFrom?: string, timeTo?: string, csv?: boolean, tripId?: string, snapshots?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TripLicensePlateGet(licensePlate, timeFrom, timeTo, csv, tripId, snapshots, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get trip wellness data
         * @param {string} licensePlate 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1TripLicensePlateWellnessGet(licensePlate: string, timeFrom?: string, timeTo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RouteWellnessData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1TripLicensePlateWellnessGet(licensePlate, timeFrom, timeTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get users\' settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update user\'s settings
         * @param {UserProfile} [userProfile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UserPatch(userProfile?: UserProfile, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UserPatch(userProfile, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get device details
         * @param {string} [licensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [deviceId] 
         * @param {string} [deviceIdContains] 
         * @param {string} [subFleet] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [version] 
         * @param {string} [status] 
         * @param {string} [versionName] 
         * @param {number} [cache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2DeviceGet(licensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, deviceId?: string, deviceIdContains?: string, subFleet?: string, date?: string, dateFrom?: string, dateTo?: string, version?: string, status?: string, versionName?: string, cache?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2DeviceGet(licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get device location
         * @param {string} [licensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [deviceId] 
         * @param {string} [deviceIdContains] 
         * @param {string} [subFleet] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [version] 
         * @param {string} [versionName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2DeviceLocationGet(licensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, deviceId?: string, deviceIdContains?: string, subFleet?: string, date?: string, dateFrom?: string, dateTo?: string, version?: string, versionName?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceLocation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2DeviceLocationGet(licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, versionName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get events
         * @summary Get events
         * @param {string} [licensePlate] 
         * @param {string} [licensePlateList] 
         * @param {string} [driverName] 
         * @param {string} [driverNameList] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [subFleet] 
         * @param {string} [subFleetList] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {string} [tripId] 
         * @param {string} [tripObjIn] 
         * @param {string} [eventType] 
         * @param {string} [eventTypeList] 
         * @param {number} [severityFrom] 
         * @param {number} [severityTo] 
         * @param {string} [tag] 
         * @param {string} [level] 
         * @param {number} [limit] 
         * @param {number} [searchAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2EventGet(licensePlate?: string, licensePlateList?: string, driverName?: string, driverNameList?: string, licensePlateContains?: string, driverNameContains?: string, subFleet?: string, subFleetList?: string, date?: string, dateFrom?: string, dateTo?: string, timeFrom?: string, timeTo?: string, tripId?: string, tripObjIn?: string, eventType?: string, eventTypeList?: string, severityFrom?: number, severityTo?: number, tag?: string, level?: string, limit?: number, searchAfter?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2EventGet(licensePlate, licensePlateList, driverName, driverNameList, licensePlateContains, driverNameContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, tripObjIn, eventType, eventTypeList, severityFrom, severityTo, tag, level, limit, searchAfter, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get trip location data
         * @param {string} licensePlate 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {boolean} [csv] 
         * @param {string} [tripId] 
         * @param {number} [driverTripId] 
         * @param {number} [snapshots] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TripLicensePlateGet(licensePlate: string, timeFrom?: string, timeTo?: string, csv?: boolean, tripId?: string, driverTripId?: number, snapshots?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExtendedRouteData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TripLicensePlateGet(licensePlate, timeFrom, timeTo, csv, tripId, driverTripId, snapshots, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update trip details
         * @param {string} licensePlate 
         * @param {TripUpdateRequest} [tripUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2TripLicensePlatePost(licensePlate: string, tripUpdateRequest?: TripUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TripDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2TripLicensePlatePost(licensePlate, tripUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get wellness image
         * @param {string} wellnessType 
         * @param {string} [wellnessId] 
         * @param {number} [timestamp] 
         * @param {string} [licensePlate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2WellnessImageWellnessTypeGet(wellnessType: string, wellnessId?: string, timestamp?: number, licensePlate?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2WellnessImageWellnessTypeGet(wellnessType, wellnessId, timestamp, licensePlate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Run wellness check
         * @param {RunWellnessRequest} [runWellnessRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV2WellnessRunTaskPost(runWellnessRequest?: RunWellnessRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV2WellnessRunTaskPost(runWellnessRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get device details
         * @param {number} [cache] 
         * @param {number} [timestamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV3DeviceGet(cache?: number, timestamp?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV3DeviceGet(cache, timestamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get customer drivers and home terminals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0SettingsCustomerGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HosCustomerData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0SettingsCustomerGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove hos drivers
         * @param {Array<HosDriverRequest>} [hosDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0SettingsDriverManagementDelete(hosDriverRequest?: Array<HosDriverRequest>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0SettingsDriverManagementDelete(hosDriverRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get hos drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0SettingsDriverManagementGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HosDriver>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0SettingsDriverManagementGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update hos drivers
         * @param {Array<HosDriverRequest>} [hosDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0SettingsDriverManagementPatch(hosDriverRequest?: Array<HosDriverRequest>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HosDriver>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0SettingsDriverManagementPatch(hosDriverRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new hos driver
         * @param {Array<HosDriverRequest>} [hosDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0SettingsDriverManagementPost(hosDriverRequest?: Array<HosDriverRequest>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HosDriver>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0SettingsDriverManagementPost(hosDriverRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove home terminals
         * @param {Array<HomeTerminal>} [homeTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0SettingsTerminalManagementDelete(homeTerminal?: Array<HomeTerminal>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0SettingsTerminalManagementDelete(homeTerminal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get home terminals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0SettingsTerminalManagementGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HomeTerminal>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0SettingsTerminalManagementGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update home terminals
         * @param {Array<HomeTerminal>} [homeTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0SettingsTerminalManagementPatch(homeTerminal?: Array<HomeTerminal>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HomeTerminal>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0SettingsTerminalManagementPatch(homeTerminal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create new home terminal
         * @param {Array<HomeTerminal>} [homeTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0SettingsTerminalManagementPost(homeTerminal?: Array<HomeTerminal>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HomeTerminal>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0SettingsTerminalManagementPost(homeTerminal, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ApiApi - factory interface
 * @export
 */
export const ApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiApiFp(configuration)
    return {
        /**
         * 
         * @summary Get device details
         * @param {string} [licensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [deviceId] 
         * @param {string} [deviceIdContains] 
         * @param {string} [subFleet] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [version] 
         * @param {string} [status] 
         * @param {string} [versionName] 
         * @param {number} [cache] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceGet(licensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, deviceId?: string, deviceIdContains?: string, subFleet?: string, date?: string, dateFrom?: string, dateTo?: string, version?: string, status?: string, versionName?: string, cache?: number, page?: number, pageSize?: number, country?: string, options?: any): AxiosPromise<Array<DeviceV2>> {
            return localVarFp.apiAdminDeviceGet(licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, page, pageSize, country, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get device operation details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceOperationGet(options?: any): AxiosPromise<Array<DeviceOperationData>> {
            return localVarFp.apiAdminDeviceOperationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new device operation details
         * @param {DeviceOperationData} [deviceOperationData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminDeviceOperationPost(deviceOperationData?: DeviceOperationData, options?: any): AxiosPromise<void> {
            return localVarFp.apiAdminDeviceOperationPost(deviceOperationData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create overlay on event video
         * @param {EventOverlayRequest} [eventOverlayRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminOverlayPost(eventOverlayRequest?: EventOverlayRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiAdminOverlayPost(eventOverlayRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get list of all wellness details
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [country] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminWellnessGet(page?: number, pageSize?: number, country?: string, options?: any): AxiosPromise<WellnessList> {
            return localVarFp.apiAdminWellnessGet(page, pageSize, country, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new wellness details
         * @param {WellnessUpdate} [wellnessUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAdminWellnessPost(wellnessUpdate?: WellnessUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.apiAdminWellnessPost(wellnessUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost(oTPUserCredentials?: OTPUserCredentials, options?: any): AxiosPromise<JWTToken> {
            return localVarFp.apiAuthOtpPost(oTPUserCredentials, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user token
         * @param {UserCredentials} [userCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost(userCredentials?: UserCredentials, options?: any): AxiosPromise<JWTToken> {
            return localVarFp.apiAuthPost(userCredentials, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost(refreshTokenRequest?: RefreshTokenRequest, options?: any): AxiosPromise<JWTToken> {
            return localVarFp.apiAuthRefreshPost(refreshTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * get accident overview data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0AccidentOverviewGet(options?: any): AxiosPromise<Array<OverviewData>> {
            return localVarFp.apiV0AccidentOverviewGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventEventIdGet(eventId: number, options?: any): AxiosPromise<EventDetails> {
            return localVarFp.apiV0CoachEventEventIdGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get coaching event image
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventEventIdImageGet(eventId: number, options?: any): AxiosPromise<any> {
            return localVarFp.apiV0CoachEventEventIdImageGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get event coaching status
         * @param {CoachEventStatus} [coachEventStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachEventPost(coachEventStatus?: CoachEventStatus, options?: any): AxiosPromise<{ [key: string]: object; }> {
            return localVarFp.apiV0CoachEventPost(coachEventStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get metrics data
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachMetricsGet(driverToken: number, options?: any): AxiosPromise<CoachMetricByType> {
            return localVarFp.apiV0CoachMetricsGet(driverToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new coaching metrics by driver token
         * @param {CoachMetricsSaveRequest} [coachMetricsSaveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachMetricsPost(coachMetricsSaveRequest?: CoachMetricsSaveRequest, options?: any): AxiosPromise<CoachMetrics> {
            return localVarFp.apiV0CoachMetricsPost(coachMetricsSaveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete event from coaching session
         * @param {number} sessionId 
         * @param {number} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdEventItemIdDelete(sessionId: number, itemId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0CoachSessionIdEventItemIdDelete(sessionId, itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update event in coaching session
         * @param {number} sessionId 
         * @param {number} itemId 
         * @param {UpdateCoachEvent} [updateCoachEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdEventItemIdPatch(sessionId: number, itemId: number, updateCoachEvent?: UpdateCoachEvent, options?: any): AxiosPromise<CoachEvent> {
            return localVarFp.apiV0CoachSessionIdEventItemIdPatch(sessionId, itemId, updateCoachEvent, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get coaching session details
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdGet(sessionId: number, options?: any): AxiosPromise<CoachSession> {
            return localVarFp.apiV0CoachSessionIdGet(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get coaching session image
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdImageGet(sessionId: number, options?: any): AxiosPromise<any> {
            return localVarFp.apiV0CoachSessionIdImageGet(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete coach media file
         * @param {number} sessionId 
         * @param {number} coachMediaFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete(sessionId: number, coachMediaFileId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete(sessionId, coachMediaFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update coach media file
         * @param {number} sessionId 
         * @param {number} coachMediaFileId 
         * @param {CoachMediaFileRequest} [coachMediaFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch(sessionId: number, coachMediaFileId: number, coachMediaFileRequest?: CoachMediaFileRequest, options?: any): AxiosPromise<CoachMediaFile> {
            return localVarFp.apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch(sessionId, coachMediaFileId, coachMediaFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new coach media file
         * @param {number} sessionId 
         * @param {CoachMediaFileRequest} [coachMediaFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMediaFilePost(sessionId: number, coachMediaFileRequest?: CoachMediaFileRequest, options?: any): AxiosPromise<CoachMediaFile> {
            return localVarFp.apiV0CoachSessionIdMediaFilePost(sessionId, coachMediaFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete coach metrics
         * @param {number} sessionId 
         * @param {number} metricsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsMetricsIdDelete(sessionId: number, metricsId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0CoachSessionIdMetricsMetricsIdDelete(sessionId, metricsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update coach metrics
         * @param {number} sessionId 
         * @param {number} metricsId 
         * @param {CoachMetrics} [coachMetrics] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsMetricsIdPatch(sessionId: number, metricsId: number, coachMetrics?: CoachMetrics, options?: any): AxiosPromise<CoachMetrics> {
            return localVarFp.apiV0CoachSessionIdMetricsMetricsIdPatch(sessionId, metricsId, coachMetrics, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new coaching metrics
         * @param {number} sessionId 
         * @param {CoachMetricsRequest} [coachMetricsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdMetricsPost(sessionId: number, coachMetricsRequest?: CoachMetricsRequest, options?: any): AxiosPromise<CoachMetrics> {
            return localVarFp.apiV0CoachSessionIdMetricsPost(sessionId, coachMetricsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete manager notes
         * @param {number} sessionId 
         * @param {number} noteId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesNoteIdDelete(sessionId: number, noteId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0CoachSessionIdNotesNoteIdDelete(sessionId, noteId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update manager notes
         * @param {number} sessionId 
         * @param {number} noteId 
         * @param {CoachManagerNotes} [coachManagerNotes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesNoteIdPatch(sessionId: number, noteId: number, coachManagerNotes?: CoachManagerNotes, options?: any): AxiosPromise<CoachManagerNotes> {
            return localVarFp.apiV0CoachSessionIdNotesNoteIdPatch(sessionId, noteId, coachManagerNotes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new manager notes
         * @param {number} sessionId 
         * @param {ManagerNotesRequest} [managerNotesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdNotesPost(sessionId: number, managerNotesRequest?: ManagerNotesRequest, options?: any): AxiosPromise<CoachManagerNotes> {
            return localVarFp.apiV0CoachSessionIdNotesPost(sessionId, managerNotesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of coaching sessions
         * @param {number} sessionId 
         * @param {UpdateCoachSession} [updateCoachSession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdPost(sessionId: number, updateCoachSession?: UpdateCoachSession, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0CoachSessionIdPost(sessionId, updateCoachSession, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new driver response
         * @param {number} sessionId 
         * @param {DriverResponseRequest} [driverResponseRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponsePost(sessionId: number, driverResponseRequest?: DriverResponseRequest, options?: any): AxiosPromise<CoachDriverResponse> {
            return localVarFp.apiV0CoachSessionIdResponsePost(sessionId, driverResponseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete driver response
         * @param {number} sessionId 
         * @param {number} responseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponseResponseIdDelete(sessionId: number, responseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0CoachSessionIdResponseResponseIdDelete(sessionId, responseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update driver response
         * @param {number} sessionId 
         * @param {number} responseId 
         * @param {CoachDriverResponse} [coachDriverResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdResponseResponseIdPatch(sessionId: number, responseId: number, coachDriverResponse?: CoachDriverResponse, options?: any): AxiosPromise<CoachDriverResponse> {
            return localVarFp.apiV0CoachSessionIdResponseResponseIdPatch(sessionId, responseId, coachDriverResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove wellness status from driver coaching session
         * @param {number} sessionId 
         * @param {number} wellnessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdWellnessStatusWellnessIdDelete(sessionId: number, wellnessId: number, options?: any): AxiosPromise<CoachWellnessStatus> {
            return localVarFp.apiV0CoachSessionIdWellnessStatusWellnessIdDelete(sessionId, wellnessId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update wellness status from driver coaching session
         * @param {number} sessionId 
         * @param {number} wellnessId 
         * @param {UpdateCoachWellnessStatus} [updateCoachWellnessStatus] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachSessionIdWellnessStatusWellnessIdPatch(sessionId: number, wellnessId: number, updateCoachWellnessStatus?: UpdateCoachWellnessStatus, options?: any): AxiosPromise<CoachWellnessStatus> {
            return localVarFp.apiV0CoachSessionIdWellnessStatusWellnessIdPatch(sessionId, wellnessId, updateCoachWellnessStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get coaching overview
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CoachingOverviewGet(options?: any): AxiosPromise<CoachingOverview> {
            return localVarFp.apiV0CoachingOverviewGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get clip from device
         * @summary Get clip from device
         * @param {number} commandId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdGet(commandId: number, options?: any): AxiosPromise<CommandData> {
            return localVarFp.apiV0CommandCommandIdGet(commandId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create remote command
         * @summary Create remote command
         * @param {number} commandId 
         * @param {RemoteCommand} [remoteCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandCommandIdPost(commandId: number, remoteCommand?: RemoteCommand, options?: any): AxiosPromise<CommandData> {
            return localVarFp.apiV0CommandCommandIdPost(commandId, remoteCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of get clip commands
         * @summary Get list of get clip commands
         * @param {number} [timeFrom] 
         * @param {number} [timeTo] 
         * @param {number} [accident] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandGet(timeFrom?: number, timeTo?: number, accident?: number, options?: any): AxiosPromise<Array<CommandData>> {
            return localVarFp.apiV0CommandGet(timeFrom, timeTo, accident, options).then((request) => request(axios, basePath));
        },
        /**
         * Get clip from device
         * @summary Get clip from device
         * @param {Command} [command] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CommandPost(command?: Command, options?: any): AxiosPromise<CommandData> {
            return localVarFp.apiV0CommandPost(command, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove customer sub fleet
         * @param {CustomerSubFleetData} [customerSubFleetData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerDelete(customerSubFleetData?: CustomerSubFleetData, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0CustomerDelete(customerSubFleetData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get customer details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerGet(options?: any): AxiosPromise<ExtendedCustomerData> {
            return localVarFp.apiV0CustomerGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new customer sub fleet
         * @param {CustomerSubFleetData} [customerSubFleetData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0CustomerPost(customerSubFleetData?: CustomerSubFleetData, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0CustomerPost(customerSubFleetData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get device snapshot
         * @param {string} deviceId 
         * @param {number} [timestamp] 
         * @param {number} [since] 
         * @param {number} [exact] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceDeviceIdSnapshotGet(deviceId: string, timestamp?: number, since?: number, exact?: number, options?: any): AxiosPromise<any> {
            return localVarFp.apiV0DeviceDeviceIdSnapshotGet(deviceId, timestamp, since, exact, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get device location
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {number} [latitude] 
         * @param {number} [longitude] 
         * @param {number} [radius] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceLocateGet(timeFrom?: string, timeTo?: string, latitude?: number, longitude?: number, radius?: number, options?: any): AxiosPromise<Array<LocationSample>> {
            return localVarFp.apiV0DeviceLocateGet(timeFrom, timeTo, latitude, longitude, radius, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update device details
         * @param {Array<DeviceRequest>} [deviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DeviceUpdatePatch(deviceRequest?: Array<DeviceRequest>, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0DeviceUpdatePatch(deviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get driver badge
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverBadgeDriverTokenGet(driverToken: number, options?: any): AxiosPromise<string> {
            return localVarFp.apiV0DriverBadgeDriverTokenGet(driverToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get driver badges
         * @param {DriverBadgeRequest} [driverBadgeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverBadgePost(driverBadgeRequest?: DriverBadgeRequest, options?: any): AxiosPromise<string> {
            return localVarFp.apiV0DriverBadgePost(driverBadgeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get driver details
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverDriverTokenGet(driverToken: number, options?: any): AxiosPromise<FleetDriver> {
            return localVarFp.apiV0DriverDriverTokenGet(driverToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update driver details
         * @param {number} driverToken 
         * @param {FleetDriverRequest} [fleetDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverDriverTokenPatch(driverToken: number, fleetDriverRequest?: FleetDriverRequest, options?: any): AxiosPromise<FleetDriver> {
            return localVarFp.apiV0DriverDriverTokenPatch(driverToken, fleetDriverRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverGet(options?: any): AxiosPromise<Array<FleetDriver>> {
            return localVarFp.apiV0DriverGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update multiple drivers
         * @param {FleetDriverList} [fleetDriverList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverPatch(fleetDriverList?: FleetDriverList, options?: any): AxiosPromise<Array<FleetDriver>> {
            return localVarFp.apiV0DriverPatch(fleetDriverList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new driver
         * @param {FleetDriverRequest} [fleetDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverPost(fleetDriverRequest?: FleetDriverRequest, options?: any): AxiosPromise<FleetDriver> {
            return localVarFp.apiV0DriverPost(fleetDriverRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * recalculate driver score
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresDriverTokenCalculatePatch(driverToken: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0DriverScoresDriverTokenCalculatePatch(driverToken, options).then((request) => request(axios, basePath));
        },
        /**
         * get driver score with relevant events
         * @param {number} driverToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresDriverTokenGet(driverToken: number, options?: any): AxiosPromise<DriverScoreDetails> {
            return localVarFp.apiV0DriverScoresDriverTokenGet(driverToken, options).then((request) => request(axios, basePath));
        },
        /**
         * get driver scores
         * @param {number} [allDrivers] 
         * @param {number} [page] 
         * @param {number} [cache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0DriverScoresGet(allDrivers?: number, page?: number, cache?: number, options?: any): AxiosPromise<Array<DriverScore>> {
            return localVarFp.apiV0DriverScoresGet(allDrivers, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * Create new event from existing one
         * @param {number} eventId 
         * @param {CloneEventDetails} [cloneEventDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdClonePost(eventId: number, cloneEventDetails?: CloneEventDetails, options?: any): AxiosPromise<Event> {
            return localVarFp.apiV0EventEventIdClonePost(eventId, cloneEventDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * Get event coaching data
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdCoachGet(eventId: number, options?: any): AxiosPromise<CoachEvent> {
            return localVarFp.apiV0EventEventIdCoachGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add or dismiss event from driver coaching session
         * @param {number} eventId 
         * @param {CoachEventDetails} [coachEventDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdCoachPost(eventId: number, coachEventDetails?: CoachEventDetails, options?: any): AxiosPromise<SaveToSessionResult> {
            return localVarFp.apiV0EventEventIdCoachPost(eventId, coachEventDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download event video request
         * @param {number} eventId 
         * @param {DownloadVideoEventRequest} [downloadVideoEventRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdDownloadPost(eventId: number, downloadVideoEventRequest?: DownloadVideoEventRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0EventEventIdDownloadPost(eventId, downloadVideoEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get event details
         * @summary Get event details
         * @param {number} eventId 
         * @param {string} [bucket] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdGet(eventId: number, bucket?: string, options?: any): AxiosPromise<EventDetails> {
            return localVarFp.apiV0EventEventIdGet(eventId, bucket, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get event image
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdImageGet(eventId: number, options?: any): AxiosPromise<any> {
            return localVarFp.apiV0EventEventIdImageGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update event details
         * @param {number} eventId 
         * @param {InlineObject} [inlineObject] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdPatch(eventId: number, inlineObject?: InlineObject, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0EventEventIdPatch(eventId, inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get related events
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdRelatedGet(eventId: number, options?: any): AxiosPromise<RelatedEvents> {
            return localVarFp.apiV0EventEventIdRelatedGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send event
         * @param {number} eventId 
         * @param {SendEventRequest} [sendEventRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdSendPost(eventId: number, sendEventRequest?: SendEventRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0EventEventIdSendPost(eventId, sendEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Change event tags
         * @summary Change event tags
         * @param {number} eventId 
         * @param {EventTag} [eventTag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0EventEventIdTagPost(eventId: number, eventTag?: EventTag, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0EventEventIdTagPost(eventId, eventTag, options).then((request) => request(axios, basePath));
        },
        /**
         * Add comment to feed event
         * @summary Add comment
         * @param {number} eventId 
         * @param {FeedCommentRequest} [feedCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdCommentPost(eventId: number, feedCommentRequest?: FeedCommentRequest, options?: any): AxiosPromise<FeedEvent> {
            return localVarFp.apiV0FeedEventIdCommentPost(eventId, feedCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Add or remove dislike from event
         * @summary Dislike event
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdDislikePost(eventId: number, options?: any): AxiosPromise<FeedEvent> {
            return localVarFp.apiV0FeedEventIdDislikePost(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get feed event
         * @summary Get feed event
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdGet(eventId: number, options?: any): AxiosPromise<ExtendedFeedEvent> {
            return localVarFp.apiV0FeedEventIdGet(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add or remove like from event
         * @summary Like event
         * @param {number} eventId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdLikePost(eventId: number, options?: any): AxiosPromise<FeedEvent> {
            return localVarFp.apiV0FeedEventIdLikePost(eventId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update percent watched
         * @summary Update percent watched
         * @param {number} eventId 
         * @param {EventWatchedRequest} [eventWatchedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedEventIdWatchedPost(eventId: number, eventWatchedRequest?: EventWatchedRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0FeedEventIdWatchedPost(eventId, eventWatchedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get events
         * @summary Get user feed
         * @param {number} [generatedAt] 
         * @param {number} [size] 
         * @param {number} [fromEvent] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedGet(generatedAt?: number, size?: number, fromEvent?: number, options?: any): AxiosPromise<FeedResponse> {
            return localVarFp.apiV0FeedGet(generatedAt, size, fromEvent, options).then((request) => request(axios, basePath));
        },
        /**
         * Get sms with link to feed page
         * @summary Get sms with link to feed page
         * @param {FeedLinkRequest} [feedLinkRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FeedLinkPost(feedLinkRequest?: FeedLinkRequest, options?: any): AxiosPromise<FeedResponse> {
            return localVarFp.apiV0FeedLinkPost(feedLinkRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get fleet safety scores
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetSafetyScoresGet(options?: any): AxiosPromise<Array<FleetSafetyScores>> {
            return localVarFp.apiV0FleetSafetyScoresGet(options).then((request) => request(axios, basePath));
        },
        /**
         * get fleet score and fleet metric data
         * @param {number} [cache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetScoreGet(cache?: number, options?: any): AxiosPromise<Array<FleetScoreDetails>> {
            return localVarFp.apiV0FleetScoreGet(cache, options).then((request) => request(axios, basePath));
        },
        /**
         * get fleet scores and score distribution over time
         * @param {number} [cache] 
         * @param {number} [endDate] 
         * @param {number} [daysCount] 
         * @param {number} [daysInterval] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0FleetScoreTrendGet(cache?: number, endDate?: number, daysCount?: number, daysInterval?: number, options?: any): AxiosPromise<Array<FleetScoreShort>> {
            return localVarFp.apiV0FleetScoreTrendGet(cache, endDate, daysCount, daysInterval, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a geofence
         * @param {number} geofenceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGeofenceIdDelete(geofenceId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0GeofenceGeofenceIdDelete(geofenceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a geofence
         * @param {number} geofenceId 
         * @param {Geofence} [geofence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGeofenceIdPatch(geofenceId: number, geofence?: Geofence, options?: any): AxiosPromise<Geofence> {
            return localVarFp.apiV0GeofenceGeofenceIdPatch(geofenceId, geofence, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get geofence details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofenceGet(options?: any): AxiosPromise<Array<Geofence>> {
            return localVarFp.apiV0GeofenceGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new geofence
         * @param {Geofence} [geofence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0GeofencePost(geofence?: Geofence, options?: any): AxiosPromise<Geofence> {
            return localVarFp.apiV0GeofencePost(geofence, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get help videos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0HelpGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiV0HelpGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get aggregated data of malfunctions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionAggregatedGet(options?: any): AxiosPromise<AggregatedMalfunctionsHistory> {
            return localVarFp.apiV0MalfunctionAggregatedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get malfunction list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionGet(options?: any): AxiosPromise<Array<Malfunction>> {
            return localVarFp.apiV0MalfunctionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create guest technician
         * @param {GuestTechnicianRequest} [guestTechnicianRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionGuestPost(guestTechnicianRequest?: GuestTechnicianRequest, options?: any): AxiosPromise<CustomerUserDetails> {
            return localVarFp.apiV0MalfunctionGuestPost(guestTechnicianRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get malfunction comments
         * @param {number} malfunctionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdCommentGet(malfunctionId: number, options?: any): AxiosPromise<Array<MalfunctionComment>> {
            return localVarFp.apiV0MalfunctionMalfunctionIdCommentGet(malfunctionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add new comment to malfunction
         * @param {number} malfunctionId 
         * @param {MalfunctionCommentRequest} [malfunctionCommentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdCommentPost(malfunctionId: number, malfunctionCommentRequest?: MalfunctionCommentRequest, options?: any): AxiosPromise<MalfunctionComment> {
            return localVarFp.apiV0MalfunctionMalfunctionIdCommentPost(malfunctionId, malfunctionCommentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get malfunction image
         * @param {number} malfunctionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionMalfunctionIdImageGet(malfunctionId: number, options?: any): AxiosPromise<any> {
            return localVarFp.apiV0MalfunctionMalfunctionIdImageGet(malfunctionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update malfunction assignee
         * @param {MalfunctionAssigneeRequest} [malfunctionAssigneeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionPatch(malfunctionAssigneeRequest?: MalfunctionAssigneeRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0MalfunctionPatch(malfunctionAssigneeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync malfunctions with policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MalfunctionUpdateGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiV0MalfunctionUpdateGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get media file library
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesGet(options?: any): AxiosPromise<Array<MediaFile>> {
            return localVarFp.apiV0MediaFilesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete media file
         * @param {number} mediaFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdDelete(mediaFileId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0MediaFilesMediaFileIdDelete(mediaFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get signed url for media file
         * @summary Get signed url for media file
         * @param {number} mediaFileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdGet(mediaFileId: number, options?: any): AxiosPromise<string> {
            return localVarFp.apiV0MediaFilesMediaFileIdGet(mediaFileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update media file
         * @param {number} mediaFileId 
         * @param {MediaFile} [mediaFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesMediaFileIdPatch(mediaFileId: number, mediaFile?: MediaFile, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0MediaFilesMediaFileIdPatch(mediaFileId, mediaFile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get file upload url
         * @param {UploadMediaFileRequest} [uploadMediaFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesPost(uploadMediaFileRequest?: UploadMediaFileRequest, options?: any): AxiosPromise<FileUploadData> {
            return localVarFp.apiV0MediaFilesPost(uploadMediaFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add media file to database
         * @param {MediaFileRequest} [mediaFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0MediaFilesPut(mediaFileRequest?: MediaFileRequest, options?: any): AxiosPromise<MediaFile> {
            return localVarFp.apiV0MediaFilesPut(mediaFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new NPS
         * @param {Nps} [nps] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0NpsPost(nps?: Nps, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0NpsPost(nps, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove package to device list
         * @param {PackageTrackerData} [packageTrackerData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackageDelete(packageTrackerData?: PackageTrackerData, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0PackageDelete(packageTrackerData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove file from package
         * @param {number} packageId 
         * @param {FileData} [fileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdDelete(packageId: number, fileData?: FileData, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0PackagePackageIdDelete(packageId, fileData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get file upload data
         * @param {number} packageId 
         * @param {FileData} [fileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdPost(packageId: number, fileData?: FileData, options?: any): AxiosPromise<FileUploadData> {
            return localVarFp.apiV0PackagePackageIdPost(packageId, fileData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add file to existing package
         * @param {number} packageId 
         * @param {FileData} [fileData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePackageIdPut(packageId: number, fileData?: FileData, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0PackagePackageIdPut(packageId, fileData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new package
         * @param {PackageName} [packageName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePost(packageName?: PackageName, options?: any): AxiosPromise<PackageData> {
            return localVarFp.apiV0PackagePost(packageName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Attach package to device list
         * @param {PackageTrackerData} [packageTrackerData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PackagePut(packageTrackerData?: PackageTrackerData, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0PackagePut(packageTrackerData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get premium optimization details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationGet(options?: any): AxiosPromise<Array<PremiumOptimization>> {
            return localVarFp.apiV0PremiumOptimizationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new premium optimization details
         * @param {PremiumOptimizationRequest} [premiumOptimizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationPost(premiumOptimizationRequest?: PremiumOptimizationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0PremiumOptimizationPost(premiumOptimizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send reminder
         * @param {PremiumOptimizationReminderRequest} [premiumOptimizationReminderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0PremiumOptimizationReminderPost(premiumOptimizationReminderRequest?: PremiumOptimizationReminderRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0PremiumOptimizationReminderPost(premiumOptimizationReminderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get release notes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReleaseNotesGet(options?: any): AxiosPromise<Array<ReleaseNotes>> {
            return localVarFp.apiV0ReleaseNotesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of reports and alerts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportGet(options?: any): AxiosPromise<AlertReportList> {
            return localVarFp.apiV0ReportGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create new report or alert
         * @param {AlertOrReport} [alertOrReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportPost(alertOrReport?: AlertOrReport, options?: any): AxiosPromise<Alert | Report> {
            return localVarFp.apiV0ReportPost(alertOrReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create new report or alert
         * @param {number} reportId 
         * @param {AlertOrReport} [alertOrReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportReportIdDelete(reportId: number, alertOrReport?: AlertOrReport, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0ReportReportIdDelete(reportId, alertOrReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update report or alert
         * @param {number} reportId 
         * @param {AlertOrReport} [alertOrReport] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportReportIdPatch(reportId: number, alertOrReport?: AlertOrReport, options?: any): AxiosPromise<Alert | Report> {
            return localVarFp.apiV0ReportReportIdPatch(reportId, alertOrReport, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of report instances
         * @param {string} [reportType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunGet(reportType?: string, options?: any): AxiosPromise<Array<ReportInstance>> {
            return localVarFp.apiV0ReportRunGet(reportType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get report instance
         * @param {number} instanceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdGet(instanceId: number, options?: any): AxiosPromise<ReportInstance> {
            return localVarFp.apiV0ReportRunInstanceIdGet(instanceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update report instance
         * @param {number} instanceId 
         * @param {ReportInstanceUpdate} [reportInstanceUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdPatch(instanceId: number, reportInstanceUpdate?: ReportInstanceUpdate, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0ReportRunInstanceIdPatch(instanceId, reportInstanceUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send report
         * @param {number} instanceId 
         * @param {SendReportRequest} [sendReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunInstanceIdSendPost(instanceId: number, sendReportRequest?: SendReportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0ReportRunInstanceIdSendPost(instanceId, sendReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate report
         * @param {ReportInstanceRequest} [reportInstanceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ReportRunPost(reportInstanceRequest?: ReportInstanceRequest, options?: any): AxiosPromise<ReportInstance> {
            return localVarFp.apiV0ReportRunPost(reportInstanceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update customer settings
         * @param {CustomerSettingsRequest} [customerSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsCustomerPatch(customerSettingsRequest?: CustomerSettingsRequest, options?: any): AxiosPromise<ExtendedCustomerData> {
            return localVarFp.apiV0SettingsCustomerPatch(customerSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get customer accident sticker
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsCustomerStickerPost(options?: any): AxiosPromise<any> {
            return localVarFp.apiV0SettingsCustomerStickerPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change user\'s email
         * @param {ChangeEmailRequest} [changeEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserEmailPatch(changeEmailRequest?: ChangeEmailRequest, options?: any): AxiosPromise<UserProfile> {
            return localVarFp.apiV0SettingsUserEmailPatch(changeEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove users
         * @param {Array<UserDetails>} [userDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementDelete(userDetails?: Array<UserDetails>, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0SettingsUserManagementDelete(userDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users\' permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementGet(options?: any): AxiosPromise<Array<UserDetailsResponse>> {
            return localVarFp.apiV0SettingsUserManagementGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update users\' permissions
         * @param {Array<UserDetails>} [userDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementPatch(userDetails?: Array<UserDetails>, options?: any): AxiosPromise<Array<UserDetailsResponse>> {
            return localVarFp.apiV0SettingsUserManagementPatch(userDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new user
         * @param {Array<UserCreationData>} [userCreationData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserManagementPost(userCreationData?: Array<UserCreationData>, options?: any): AxiosPromise<Array<UserDetailsResponse>> {
            return localVarFp.apiV0SettingsUserManagementPost(userCreationData, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change user\'s password
         * @param {ChangePasswordRequest} [changePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserPasswordPatch(changePasswordRequest?: ChangePasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0SettingsUserPasswordPatch(changePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request permission change
         * @param {ChangePermissionsRequest} [changePermissionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserPermissionPost(changePermissionsRequest?: ChangePermissionsRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0SettingsUserPermissionPost(changePermissionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request password reset
         * @param {ResetPasswordRequest} [resetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SettingsUserResetPasswordPost(resetPasswordRequest?: ResetPasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0SettingsUserResetPasswordPost(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of existing tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0TagGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.apiV0TagGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user notifications
         * @param {number} [from] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationGet(from?: number, options?: any): AxiosPromise<UserNotificationList> {
            return localVarFp.apiV0UserNotificationGet(from, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user notification
         * @param {number} notificationId 
         * @param {UserNotificationRequest} [userNotificationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationNotificationIdPatch(notificationId: number, userNotificationRequest?: UserNotificationRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV0UserNotificationNotificationIdPatch(notificationId, userNotificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update last seen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0UserNotificationPatch(options?: any): AxiosPromise<void> {
            return localVarFp.apiV0UserNotificationPatch(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save video preview as an event
         * @param {number} previewRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestEventPreviewRequestIdPost(previewRequestId: number, options?: any): AxiosPromise<VideoPreviewRequest> {
            return localVarFp.apiV0VideoPreviewRequestEventPreviewRequestIdPost(previewRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get video preview request details
         * @param {number} tripId 
         * @param {number} [driverTripId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestGet(tripId: number, driverTripId?: number, options?: any): AxiosPromise<VideoPreviewRequest> {
            return localVarFp.apiV0VideoPreviewRequestGet(tripId, driverTripId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new video preview request
         * @param {VideoPreviewRequestBody} [videoPreviewRequestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0VideoPreviewRequestPost(videoPreviewRequestBody?: VideoPreviewRequestBody, options?: any): AxiosPromise<VideoPreviewRequest> {
            return localVarFp.apiV0VideoPreviewRequestPost(videoPreviewRequestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * get wellness score list
         * @param {number} [cache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessScoresGet(cache?: number, options?: any): AxiosPromise<Array<WellnessScore>> {
            return localVarFp.apiV0WellnessScoresGet(cache, options).then((request) => request(axios, basePath));
        },
        /**
         * get wellness score details
         * @param {string} licensePlate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessScoresLicensePlateGet(licensePlate: string, options?: any): AxiosPromise<WellnessScoreDetails> {
            return localVarFp.apiV0WellnessScoresLicensePlateGet(licensePlate, options).then((request) => request(axios, basePath));
        },
        /**
         * Add or dismiss wellness status from driver coaching session
         * @param {number} wellnessId 
         * @param {CoachWellnessDetails} [coachWellnessDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0WellnessStatusWellnessIdCoachPost(wellnessId: number, coachWellnessDetails?: CoachWellnessDetails, options?: any): AxiosPromise<SaveToSessionResult> {
            return localVarFp.apiV0WellnessStatusWellnessIdCoachPost(wellnessId, coachWellnessDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get driver coaching session
         * @param {string} token 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverGet(token: string, code?: string, options?: any): AxiosPromise<CoachSession | CoachSessionToken> {
            return localVarFp.apiV1CoachDriverGet(token, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update session metadata
         * @param {string} token 
         * @param {string} [code] 
         * @param {CoachSessionMetadata} [coachSessionMetadata] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverPatch(token: string, code?: string, coachSessionMetadata?: CoachSessionMetadata, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1CoachDriverPatch(token, code, coachSessionMetadata, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Complete driver coaching session
         * @param {string} token 
         * @param {string} [code] 
         * @param {UpdateCoachSession} [updateCoachSession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachDriverPost(token: string, code?: string, updateCoachSession?: UpdateCoachSession, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1CoachDriverPost(token, code, updateCoachSession, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of coaching sessions
         * @param {number} [driverToken] 
         * @param {number} [completedFrom] 
         * @param {number} [completedTo] 
         * @param {number} [additionalInfo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachGet(driverToken?: number, completedFrom?: number, completedTo?: number, additionalInfo?: number, options?: any): AxiosPromise<Array<ShortCoachSession>> {
            return localVarFp.apiV1CoachGet(driverToken, completedFrom, completedTo, additionalInfo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send coaching session link by sms
         * @param {CoachSessionMessageRequest} coachSessionMessageRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSendPost(coachSessionMessageRequest: CoachSessionMessageRequest, options?: any): AxiosPromise<CoachSessionMessageResponse> {
            return localVarFp.apiV1CoachSendPost(coachSessionMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete coaching session
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdDelete(sessionId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1CoachSessionIdDelete(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get coaching session details
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdGet(sessionId: number, options?: any): AxiosPromise<CoachSession> {
            return localVarFp.apiV1CoachSessionIdGet(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change coaching session assignee or agenda
         * @param {number} sessionId 
         * @param {CoachSession} [coachSession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdPatch(sessionId: number, coachSession?: CoachSession, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1CoachSessionIdPatch(sessionId, coachSession, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of coaching sessions
         * @param {number} sessionId 
         * @param {UpdateCoachSession} [updateCoachSession] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdPost(sessionId: number, updateCoachSession?: UpdateCoachSession, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1CoachSessionIdPost(sessionId, updateCoachSession, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send the driver a reminder to complete session
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdRemindPost(sessionId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1CoachSessionIdRemindPost(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save auto-generated coaching session
         * @param {number} sessionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1CoachSessionIdSavePost(sessionId: number, options?: any): AxiosPromise<CoachingMetadataResponse> {
            return localVarFp.apiV1CoachSessionIdSavePost(sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get events
         * @summary Get events
         * @param {string} [licensePlate] 
         * @param {string} [licensePlateList] 
         * @param {string} [licensePlateContains] 
         * @param {string} [subFleet] 
         * @param {string} [subFleetList] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {string} [tripId] 
         * @param {number} [lastTrip] 
         * @param {string} [tripObjIn] 
         * @param {string} [severity] 
         * @param {string} [eventType] 
         * @param {string} [eventTypeList] 
         * @param {number} [lastEvent] 
         * @param {string} [tag] 
         * @param {string} [level] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1EventGet(licensePlate?: string, licensePlateList?: string, licensePlateContains?: string, subFleet?: string, subFleetList?: string, date?: string, dateFrom?: string, dateTo?: string, timeFrom?: string, timeTo?: string, tripId?: string, lastTrip?: number, tripObjIn?: string, severity?: string, eventType?: string, eventTypeList?: string, lastEvent?: number, tag?: string, level?: string, limit?: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.apiV1EventGet(licensePlate, licensePlateList, licensePlateContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, lastTrip, tripObjIn, severity, eventType, eventTypeList, lastEvent, tag, level, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of policies
         * @param {string} [dateFrom] 
         * @param {string} [date] 
         * @param {string} [csv] 
         * @param {string} [_long] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PolicyGet(dateFrom?: string, date?: string, csv?: string, _long?: string, options?: any): AxiosPromise<Array<Policy>> {
            return localVarFp.apiV1PolicyGet(dateFrom, date, csv, _long, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send list of policies
         * @param {any} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1PolicyPost(body?: any, options?: any): AxiosPromise<void> {
            return localVarFp.apiV1PolicyPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get array of trips for a vehicle
         * @param {string} licensePlate 
         * @param {number} from 
         * @param {number} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripGet(licensePlate: string, from: number, to: number, options?: any): AxiosPromise<Array<TripDetails>> {
            return localVarFp.apiV1TripGet(licensePlate, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get trip location data
         * @param {string} licensePlate 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {boolean} [csv] 
         * @param {string} [tripId] 
         * @param {number} [snapshots] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripLicensePlateGet(licensePlate: string, timeFrom?: string, timeTo?: string, csv?: boolean, tripId?: string, snapshots?: number, options?: any): AxiosPromise<RouteData> {
            return localVarFp.apiV1TripLicensePlateGet(licensePlate, timeFrom, timeTo, csv, tripId, snapshots, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get trip wellness data
         * @param {string} licensePlate 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1TripLicensePlateWellnessGet(licensePlate: string, timeFrom?: string, timeTo?: string, options?: any): AxiosPromise<RouteWellnessData> {
            return localVarFp.apiV1TripLicensePlateWellnessGet(licensePlate, timeFrom, timeTo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users\' settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserGet(options?: any): AxiosPromise<UserProfile> {
            return localVarFp.apiV1UserGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user\'s settings
         * @param {UserProfile} [userProfile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UserPatch(userProfile?: UserProfile, options?: any): AxiosPromise<UserProfile> {
            return localVarFp.apiV1UserPatch(userProfile, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get device details
         * @param {string} [licensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [deviceId] 
         * @param {string} [deviceIdContains] 
         * @param {string} [subFleet] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [version] 
         * @param {string} [status] 
         * @param {string} [versionName] 
         * @param {number} [cache] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DeviceGet(licensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, deviceId?: string, deviceIdContains?: string, subFleet?: string, date?: string, dateFrom?: string, dateTo?: string, version?: string, status?: string, versionName?: string, cache?: number, options?: any): AxiosPromise<Array<DeviceV2>> {
            return localVarFp.apiV2DeviceGet(licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, status, versionName, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get device location
         * @param {string} [licensePlate] 
         * @param {string} [driverName] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [deviceId] 
         * @param {string} [deviceIdContains] 
         * @param {string} [subFleet] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [version] 
         * @param {string} [versionName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2DeviceLocationGet(licensePlate?: string, driverName?: string, licensePlateContains?: string, driverNameContains?: string, deviceId?: string, deviceIdContains?: string, subFleet?: string, date?: string, dateFrom?: string, dateTo?: string, version?: string, versionName?: string, options?: any): AxiosPromise<Array<DeviceLocation>> {
            return localVarFp.apiV2DeviceLocationGet(licensePlate, driverName, licensePlateContains, driverNameContains, deviceId, deviceIdContains, subFleet, date, dateFrom, dateTo, version, versionName, options).then((request) => request(axios, basePath));
        },
        /**
         * Get events
         * @summary Get events
         * @param {string} [licensePlate] 
         * @param {string} [licensePlateList] 
         * @param {string} [driverName] 
         * @param {string} [driverNameList] 
         * @param {string} [licensePlateContains] 
         * @param {string} [driverNameContains] 
         * @param {string} [subFleet] 
         * @param {string} [subFleetList] 
         * @param {string} [date] 
         * @param {string} [dateFrom] 
         * @param {string} [dateTo] 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {string} [tripId] 
         * @param {string} [tripObjIn] 
         * @param {string} [eventType] 
         * @param {string} [eventTypeList] 
         * @param {number} [severityFrom] 
         * @param {number} [severityTo] 
         * @param {string} [tag] 
         * @param {string} [level] 
         * @param {number} [limit] 
         * @param {number} [searchAfter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2EventGet(licensePlate?: string, licensePlateList?: string, driverName?: string, driverNameList?: string, licensePlateContains?: string, driverNameContains?: string, subFleet?: string, subFleetList?: string, date?: string, dateFrom?: string, dateTo?: string, timeFrom?: string, timeTo?: string, tripId?: string, tripObjIn?: string, eventType?: string, eventTypeList?: string, severityFrom?: number, severityTo?: number, tag?: string, level?: string, limit?: number, searchAfter?: number, options?: any): AxiosPromise<InlineResponse2001> {
            return localVarFp.apiV2EventGet(licensePlate, licensePlateList, driverName, driverNameList, licensePlateContains, driverNameContains, subFleet, subFleetList, date, dateFrom, dateTo, timeFrom, timeTo, tripId, tripObjIn, eventType, eventTypeList, severityFrom, severityTo, tag, level, limit, searchAfter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get trip location data
         * @param {string} licensePlate 
         * @param {string} [timeFrom] 
         * @param {string} [timeTo] 
         * @param {boolean} [csv] 
         * @param {string} [tripId] 
         * @param {number} [driverTripId] 
         * @param {number} [snapshots] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TripLicensePlateGet(licensePlate: string, timeFrom?: string, timeTo?: string, csv?: boolean, tripId?: string, driverTripId?: number, snapshots?: number, options?: any): AxiosPromise<ExtendedRouteData> {
            return localVarFp.apiV2TripLicensePlateGet(licensePlate, timeFrom, timeTo, csv, tripId, driverTripId, snapshots, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update trip details
         * @param {string} licensePlate 
         * @param {TripUpdateRequest} [tripUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2TripLicensePlatePost(licensePlate: string, tripUpdateRequest?: TripUpdateRequest, options?: any): AxiosPromise<TripDetails> {
            return localVarFp.apiV2TripLicensePlatePost(licensePlate, tripUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get wellness image
         * @param {string} wellnessType 
         * @param {string} [wellnessId] 
         * @param {number} [timestamp] 
         * @param {string} [licensePlate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2WellnessImageWellnessTypeGet(wellnessType: string, wellnessId?: string, timestamp?: number, licensePlate?: string, options?: any): AxiosPromise<any> {
            return localVarFp.apiV2WellnessImageWellnessTypeGet(wellnessType, wellnessId, timestamp, licensePlate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Run wellness check
         * @param {RunWellnessRequest} [runWellnessRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV2WellnessRunTaskPost(runWellnessRequest?: RunWellnessRequest, options?: any): AxiosPromise<void> {
            return localVarFp.apiV2WellnessRunTaskPost(runWellnessRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get device details
         * @param {number} [cache] 
         * @param {number} [timestamp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV3DeviceGet(cache?: number, timestamp?: number, options?: any): AxiosPromise<DeviceList> {
            return localVarFp.apiV3DeviceGet(cache, timestamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get customer drivers and home terminals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsCustomerGet(options?: any): AxiosPromise<HosCustomerData> {
            return localVarFp.hosV0SettingsCustomerGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove hos drivers
         * @param {Array<HosDriverRequest>} [hosDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementDelete(hosDriverRequest?: Array<HosDriverRequest>, options?: any): AxiosPromise<void> {
            return localVarFp.hosV0SettingsDriverManagementDelete(hosDriverRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get hos drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementGet(options?: any): AxiosPromise<Array<HosDriver>> {
            return localVarFp.hosV0SettingsDriverManagementGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update hos drivers
         * @param {Array<HosDriverRequest>} [hosDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementPatch(hosDriverRequest?: Array<HosDriverRequest>, options?: any): AxiosPromise<Array<HosDriver>> {
            return localVarFp.hosV0SettingsDriverManagementPatch(hosDriverRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new hos driver
         * @param {Array<HosDriverRequest>} [hosDriverRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsDriverManagementPost(hosDriverRequest?: Array<HosDriverRequest>, options?: any): AxiosPromise<Array<HosDriver>> {
            return localVarFp.hosV0SettingsDriverManagementPost(hosDriverRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove home terminals
         * @param {Array<HomeTerminal>} [homeTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementDelete(homeTerminal?: Array<HomeTerminal>, options?: any): AxiosPromise<void> {
            return localVarFp.hosV0SettingsTerminalManagementDelete(homeTerminal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get home terminals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementGet(options?: any): AxiosPromise<Array<HomeTerminal>> {
            return localVarFp.hosV0SettingsTerminalManagementGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update home terminals
         * @param {Array<HomeTerminal>} [homeTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementPatch(homeTerminal?: Array<HomeTerminal>, options?: any): AxiosPromise<Array<HomeTerminal>> {
            return localVarFp.hosV0SettingsTerminalManagementPatch(homeTerminal, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create new home terminal
         * @param {Array<HomeTerminal>} [homeTerminal] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0SettingsTerminalManagementPost(homeTerminal?: Array<HomeTerminal>, options?: any): AxiosPromise<Array<HomeTerminal>> {
            return localVarFp.hosV0SettingsTerminalManagementPost(homeTerminal, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiAdminDeviceGet operation in ApiApi.
 * @export
 * @interface ApiApiApiAdminDeviceGetRequest
 */
export interface ApiApiApiAdminDeviceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly licensePlate?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly driverName?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly licensePlateContains?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly driverNameContains?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly deviceId?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly deviceIdContains?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly subFleet?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly date?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly dateTo?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly version?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly versionName?: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly cache?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminDeviceGet
     */
    readonly country?: string
}

/**
 * Request parameters for apiAdminDeviceOperationPost operation in ApiApi.
 * @export
 * @interface ApiApiApiAdminDeviceOperationPostRequest
 */
export interface ApiApiApiAdminDeviceOperationPostRequest {
    /**
     * 
     * @type {DeviceOperationData}
     * @memberof ApiApiApiAdminDeviceOperationPost
     */
    readonly deviceOperationData?: DeviceOperationData
}

/**
 * Request parameters for apiAdminOverlayPost operation in ApiApi.
 * @export
 * @interface ApiApiApiAdminOverlayPostRequest
 */
export interface ApiApiApiAdminOverlayPostRequest {
    /**
     * 
     * @type {EventOverlayRequest}
     * @memberof ApiApiApiAdminOverlayPost
     */
    readonly eventOverlayRequest?: EventOverlayRequest
}

/**
 * Request parameters for apiAdminWellnessGet operation in ApiApi.
 * @export
 * @interface ApiApiApiAdminWellnessGetRequest
 */
export interface ApiApiApiAdminWellnessGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiAdminWellnessGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiAdminWellnessGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiAdminWellnessGet
     */
    readonly country?: string
}

/**
 * Request parameters for apiAdminWellnessPost operation in ApiApi.
 * @export
 * @interface ApiApiApiAdminWellnessPostRequest
 */
export interface ApiApiApiAdminWellnessPostRequest {
    /**
     * 
     * @type {WellnessUpdate}
     * @memberof ApiApiApiAdminWellnessPost
     */
    readonly wellnessUpdate?: WellnessUpdate
}

/**
 * Request parameters for apiAuthOtpPost operation in ApiApi.
 * @export
 * @interface ApiApiApiAuthOtpPostRequest
 */
export interface ApiApiApiAuthOtpPostRequest {
    /**
     * 
     * @type {OTPUserCredentials}
     * @memberof ApiApiApiAuthOtpPost
     */
    readonly oTPUserCredentials?: OTPUserCredentials
}

/**
 * Request parameters for apiAuthPost operation in ApiApi.
 * @export
 * @interface ApiApiApiAuthPostRequest
 */
export interface ApiApiApiAuthPostRequest {
    /**
     * 
     * @type {UserCredentials}
     * @memberof ApiApiApiAuthPost
     */
    readonly userCredentials?: UserCredentials
}

/**
 * Request parameters for apiAuthRefreshPost operation in ApiApi.
 * @export
 * @interface ApiApiApiAuthRefreshPostRequest
 */
export interface ApiApiApiAuthRefreshPostRequest {
    /**
     * 
     * @type {RefreshTokenRequest}
     * @memberof ApiApiApiAuthRefreshPost
     */
    readonly refreshTokenRequest?: RefreshTokenRequest
}

/**
 * Request parameters for apiV0CoachEventEventIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachEventEventIdGetRequest
 */
export interface ApiApiApiV0CoachEventEventIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachEventEventIdGet
     */
    readonly eventId: number
}

/**
 * Request parameters for apiV0CoachEventEventIdImageGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachEventEventIdImageGetRequest
 */
export interface ApiApiApiV0CoachEventEventIdImageGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachEventEventIdImageGet
     */
    readonly eventId: number
}

/**
 * Request parameters for apiV0CoachEventPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachEventPostRequest
 */
export interface ApiApiApiV0CoachEventPostRequest {
    /**
     * 
     * @type {CoachEventStatus}
     * @memberof ApiApiApiV0CoachEventPost
     */
    readonly coachEventStatus?: CoachEventStatus
}

/**
 * Request parameters for apiV0CoachMetricsGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachMetricsGetRequest
 */
export interface ApiApiApiV0CoachMetricsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachMetricsGet
     */
    readonly driverToken: number
}

/**
 * Request parameters for apiV0CoachMetricsPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachMetricsPostRequest
 */
export interface ApiApiApiV0CoachMetricsPostRequest {
    /**
     * 
     * @type {CoachMetricsSaveRequest}
     * @memberof ApiApiApiV0CoachMetricsPost
     */
    readonly coachMetricsSaveRequest?: CoachMetricsSaveRequest
}

/**
 * Request parameters for apiV0CoachSessionIdEventItemIdDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdEventItemIdDeleteRequest
 */
export interface ApiApiApiV0CoachSessionIdEventItemIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdEventItemIdDelete
     */
    readonly sessionId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdEventItemIdDelete
     */
    readonly itemId: number
}

/**
 * Request parameters for apiV0CoachSessionIdEventItemIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdEventItemIdPatchRequest
 */
export interface ApiApiApiV0CoachSessionIdEventItemIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdEventItemIdPatch
     */
    readonly sessionId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdEventItemIdPatch
     */
    readonly itemId: number

    /**
     * 
     * @type {UpdateCoachEvent}
     * @memberof ApiApiApiV0CoachSessionIdEventItemIdPatch
     */
    readonly updateCoachEvent?: UpdateCoachEvent
}

/**
 * Request parameters for apiV0CoachSessionIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdGetRequest
 */
export interface ApiApiApiV0CoachSessionIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdGet
     */
    readonly sessionId: number
}

/**
 * Request parameters for apiV0CoachSessionIdImageGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdImageGetRequest
 */
export interface ApiApiApiV0CoachSessionIdImageGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdImageGet
     */
    readonly sessionId: number
}

/**
 * Request parameters for apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdDeleteRequest
 */
export interface ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdDelete
     */
    readonly sessionId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdDelete
     */
    readonly coachMediaFileId: number
}

/**
 * Request parameters for apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdPatchRequest
 */
export interface ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdPatch
     */
    readonly sessionId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdPatch
     */
    readonly coachMediaFileId: number

    /**
     * 
     * @type {CoachMediaFileRequest}
     * @memberof ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdPatch
     */
    readonly coachMediaFileRequest?: CoachMediaFileRequest
}

/**
 * Request parameters for apiV0CoachSessionIdMediaFilePost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdMediaFilePostRequest
 */
export interface ApiApiApiV0CoachSessionIdMediaFilePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdMediaFilePost
     */
    readonly sessionId: number

    /**
     * 
     * @type {CoachMediaFileRequest}
     * @memberof ApiApiApiV0CoachSessionIdMediaFilePost
     */
    readonly coachMediaFileRequest?: CoachMediaFileRequest
}

/**
 * Request parameters for apiV0CoachSessionIdMetricsMetricsIdDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdMetricsMetricsIdDeleteRequest
 */
export interface ApiApiApiV0CoachSessionIdMetricsMetricsIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdMetricsMetricsIdDelete
     */
    readonly sessionId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdMetricsMetricsIdDelete
     */
    readonly metricsId: number
}

/**
 * Request parameters for apiV0CoachSessionIdMetricsMetricsIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdMetricsMetricsIdPatchRequest
 */
export interface ApiApiApiV0CoachSessionIdMetricsMetricsIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdMetricsMetricsIdPatch
     */
    readonly sessionId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdMetricsMetricsIdPatch
     */
    readonly metricsId: number

    /**
     * 
     * @type {CoachMetrics}
     * @memberof ApiApiApiV0CoachSessionIdMetricsMetricsIdPatch
     */
    readonly coachMetrics?: CoachMetrics
}

/**
 * Request parameters for apiV0CoachSessionIdMetricsPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdMetricsPostRequest
 */
export interface ApiApiApiV0CoachSessionIdMetricsPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdMetricsPost
     */
    readonly sessionId: number

    /**
     * 
     * @type {CoachMetricsRequest}
     * @memberof ApiApiApiV0CoachSessionIdMetricsPost
     */
    readonly coachMetricsRequest?: CoachMetricsRequest
}

/**
 * Request parameters for apiV0CoachSessionIdNotesNoteIdDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdNotesNoteIdDeleteRequest
 */
export interface ApiApiApiV0CoachSessionIdNotesNoteIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdNotesNoteIdDelete
     */
    readonly sessionId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdNotesNoteIdDelete
     */
    readonly noteId: number
}

/**
 * Request parameters for apiV0CoachSessionIdNotesNoteIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdNotesNoteIdPatchRequest
 */
export interface ApiApiApiV0CoachSessionIdNotesNoteIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdNotesNoteIdPatch
     */
    readonly sessionId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdNotesNoteIdPatch
     */
    readonly noteId: number

    /**
     * 
     * @type {CoachManagerNotes}
     * @memberof ApiApiApiV0CoachSessionIdNotesNoteIdPatch
     */
    readonly coachManagerNotes?: CoachManagerNotes
}

/**
 * Request parameters for apiV0CoachSessionIdNotesPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdNotesPostRequest
 */
export interface ApiApiApiV0CoachSessionIdNotesPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdNotesPost
     */
    readonly sessionId: number

    /**
     * 
     * @type {ManagerNotesRequest}
     * @memberof ApiApiApiV0CoachSessionIdNotesPost
     */
    readonly managerNotesRequest?: ManagerNotesRequest
}

/**
 * Request parameters for apiV0CoachSessionIdPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdPostRequest
 */
export interface ApiApiApiV0CoachSessionIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdPost
     */
    readonly sessionId: number

    /**
     * 
     * @type {UpdateCoachSession}
     * @memberof ApiApiApiV0CoachSessionIdPost
     */
    readonly updateCoachSession?: UpdateCoachSession
}

/**
 * Request parameters for apiV0CoachSessionIdResponsePost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdResponsePostRequest
 */
export interface ApiApiApiV0CoachSessionIdResponsePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdResponsePost
     */
    readonly sessionId: number

    /**
     * 
     * @type {DriverResponseRequest}
     * @memberof ApiApiApiV0CoachSessionIdResponsePost
     */
    readonly driverResponseRequest?: DriverResponseRequest
}

/**
 * Request parameters for apiV0CoachSessionIdResponseResponseIdDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdResponseResponseIdDeleteRequest
 */
export interface ApiApiApiV0CoachSessionIdResponseResponseIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdResponseResponseIdDelete
     */
    readonly sessionId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdResponseResponseIdDelete
     */
    readonly responseId: number
}

/**
 * Request parameters for apiV0CoachSessionIdResponseResponseIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdResponseResponseIdPatchRequest
 */
export interface ApiApiApiV0CoachSessionIdResponseResponseIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdResponseResponseIdPatch
     */
    readonly sessionId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdResponseResponseIdPatch
     */
    readonly responseId: number

    /**
     * 
     * @type {CoachDriverResponse}
     * @memberof ApiApiApiV0CoachSessionIdResponseResponseIdPatch
     */
    readonly coachDriverResponse?: CoachDriverResponse
}

/**
 * Request parameters for apiV0CoachSessionIdWellnessStatusWellnessIdDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdDeleteRequest
 */
export interface ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdDelete
     */
    readonly sessionId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdDelete
     */
    readonly wellnessId: number
}

/**
 * Request parameters for apiV0CoachSessionIdWellnessStatusWellnessIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdPatchRequest
 */
export interface ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdPatch
     */
    readonly sessionId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdPatch
     */
    readonly wellnessId: number

    /**
     * 
     * @type {UpdateCoachWellnessStatus}
     * @memberof ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdPatch
     */
    readonly updateCoachWellnessStatus?: UpdateCoachWellnessStatus
}

/**
 * Request parameters for apiV0CommandCommandIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CommandCommandIdGetRequest
 */
export interface ApiApiApiV0CommandCommandIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CommandCommandIdGet
     */
    readonly commandId: number
}

/**
 * Request parameters for apiV0CommandCommandIdPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CommandCommandIdPostRequest
 */
export interface ApiApiApiV0CommandCommandIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CommandCommandIdPost
     */
    readonly commandId: number

    /**
     * 
     * @type {RemoteCommand}
     * @memberof ApiApiApiV0CommandCommandIdPost
     */
    readonly remoteCommand?: RemoteCommand
}

/**
 * Request parameters for apiV0CommandGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CommandGetRequest
 */
export interface ApiApiApiV0CommandGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CommandGet
     */
    readonly timeFrom?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CommandGet
     */
    readonly timeTo?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0CommandGet
     */
    readonly accident?: number
}

/**
 * Request parameters for apiV0CommandPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CommandPostRequest
 */
export interface ApiApiApiV0CommandPostRequest {
    /**
     * 
     * @type {Command}
     * @memberof ApiApiApiV0CommandPost
     */
    readonly command?: Command
}

/**
 * Request parameters for apiV0CustomerDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CustomerDeleteRequest
 */
export interface ApiApiApiV0CustomerDeleteRequest {
    /**
     * 
     * @type {CustomerSubFleetData}
     * @memberof ApiApiApiV0CustomerDelete
     */
    readonly customerSubFleetData?: CustomerSubFleetData
}

/**
 * Request parameters for apiV0CustomerPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0CustomerPostRequest
 */
export interface ApiApiApiV0CustomerPostRequest {
    /**
     * 
     * @type {CustomerSubFleetData}
     * @memberof ApiApiApiV0CustomerPost
     */
    readonly customerSubFleetData?: CustomerSubFleetData
}

/**
 * Request parameters for apiV0DeviceDeviceIdSnapshotGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0DeviceDeviceIdSnapshotGetRequest
 */
export interface ApiApiApiV0DeviceDeviceIdSnapshotGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV0DeviceDeviceIdSnapshotGet
     */
    readonly deviceId: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DeviceDeviceIdSnapshotGet
     */
    readonly timestamp?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DeviceDeviceIdSnapshotGet
     */
    readonly since?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DeviceDeviceIdSnapshotGet
     */
    readonly exact?: number
}

/**
 * Request parameters for apiV0DeviceLocateGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0DeviceLocateGetRequest
 */
export interface ApiApiApiV0DeviceLocateGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV0DeviceLocateGet
     */
    readonly timeFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV0DeviceLocateGet
     */
    readonly timeTo?: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DeviceLocateGet
     */
    readonly latitude?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DeviceLocateGet
     */
    readonly longitude?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DeviceLocateGet
     */
    readonly radius?: number
}

/**
 * Request parameters for apiV0DeviceUpdatePatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0DeviceUpdatePatchRequest
 */
export interface ApiApiApiV0DeviceUpdatePatchRequest {
    /**
     * 
     * @type {Array<DeviceRequest>}
     * @memberof ApiApiApiV0DeviceUpdatePatch
     */
    readonly deviceRequest?: Array<DeviceRequest>
}

/**
 * Request parameters for apiV0DriverBadgeDriverTokenGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0DriverBadgeDriverTokenGetRequest
 */
export interface ApiApiApiV0DriverBadgeDriverTokenGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DriverBadgeDriverTokenGet
     */
    readonly driverToken: number
}

/**
 * Request parameters for apiV0DriverBadgePost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0DriverBadgePostRequest
 */
export interface ApiApiApiV0DriverBadgePostRequest {
    /**
     * 
     * @type {DriverBadgeRequest}
     * @memberof ApiApiApiV0DriverBadgePost
     */
    readonly driverBadgeRequest?: DriverBadgeRequest
}

/**
 * Request parameters for apiV0DriverDriverTokenGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0DriverDriverTokenGetRequest
 */
export interface ApiApiApiV0DriverDriverTokenGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DriverDriverTokenGet
     */
    readonly driverToken: number
}

/**
 * Request parameters for apiV0DriverDriverTokenPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0DriverDriverTokenPatchRequest
 */
export interface ApiApiApiV0DriverDriverTokenPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DriverDriverTokenPatch
     */
    readonly driverToken: number

    /**
     * 
     * @type {FleetDriverRequest}
     * @memberof ApiApiApiV0DriverDriverTokenPatch
     */
    readonly fleetDriverRequest?: FleetDriverRequest
}

/**
 * Request parameters for apiV0DriverPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0DriverPatchRequest
 */
export interface ApiApiApiV0DriverPatchRequest {
    /**
     * 
     * @type {FleetDriverList}
     * @memberof ApiApiApiV0DriverPatch
     */
    readonly fleetDriverList?: FleetDriverList
}

/**
 * Request parameters for apiV0DriverPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0DriverPostRequest
 */
export interface ApiApiApiV0DriverPostRequest {
    /**
     * 
     * @type {FleetDriverRequest}
     * @memberof ApiApiApiV0DriverPost
     */
    readonly fleetDriverRequest?: FleetDriverRequest
}

/**
 * Request parameters for apiV0DriverScoresDriverTokenCalculatePatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0DriverScoresDriverTokenCalculatePatchRequest
 */
export interface ApiApiApiV0DriverScoresDriverTokenCalculatePatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DriverScoresDriverTokenCalculatePatch
     */
    readonly driverToken: number
}

/**
 * Request parameters for apiV0DriverScoresDriverTokenGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0DriverScoresDriverTokenGetRequest
 */
export interface ApiApiApiV0DriverScoresDriverTokenGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DriverScoresDriverTokenGet
     */
    readonly driverToken: number
}

/**
 * Request parameters for apiV0DriverScoresGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0DriverScoresGetRequest
 */
export interface ApiApiApiV0DriverScoresGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DriverScoresGet
     */
    readonly allDrivers?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DriverScoresGet
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0DriverScoresGet
     */
    readonly cache?: number
}

/**
 * Request parameters for apiV0EventEventIdClonePost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0EventEventIdClonePostRequest
 */
export interface ApiApiApiV0EventEventIdClonePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0EventEventIdClonePost
     */
    readonly eventId: number

    /**
     * 
     * @type {CloneEventDetails}
     * @memberof ApiApiApiV0EventEventIdClonePost
     */
    readonly cloneEventDetails?: CloneEventDetails
}

/**
 * Request parameters for apiV0EventEventIdCoachGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0EventEventIdCoachGetRequest
 */
export interface ApiApiApiV0EventEventIdCoachGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0EventEventIdCoachGet
     */
    readonly eventId: number
}

/**
 * Request parameters for apiV0EventEventIdCoachPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0EventEventIdCoachPostRequest
 */
export interface ApiApiApiV0EventEventIdCoachPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0EventEventIdCoachPost
     */
    readonly eventId: number

    /**
     * 
     * @type {CoachEventDetails}
     * @memberof ApiApiApiV0EventEventIdCoachPost
     */
    readonly coachEventDetails?: CoachEventDetails
}

/**
 * Request parameters for apiV0EventEventIdDownloadPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0EventEventIdDownloadPostRequest
 */
export interface ApiApiApiV0EventEventIdDownloadPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0EventEventIdDownloadPost
     */
    readonly eventId: number

    /**
     * 
     * @type {DownloadVideoEventRequest}
     * @memberof ApiApiApiV0EventEventIdDownloadPost
     */
    readonly downloadVideoEventRequest?: DownloadVideoEventRequest
}

/**
 * Request parameters for apiV0EventEventIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0EventEventIdGetRequest
 */
export interface ApiApiApiV0EventEventIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0EventEventIdGet
     */
    readonly eventId: number

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV0EventEventIdGet
     */
    readonly bucket?: string
}

/**
 * Request parameters for apiV0EventEventIdImageGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0EventEventIdImageGetRequest
 */
export interface ApiApiApiV0EventEventIdImageGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0EventEventIdImageGet
     */
    readonly eventId: number
}

/**
 * Request parameters for apiV0EventEventIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0EventEventIdPatchRequest
 */
export interface ApiApiApiV0EventEventIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0EventEventIdPatch
     */
    readonly eventId: number

    /**
     * 
     * @type {InlineObject}
     * @memberof ApiApiApiV0EventEventIdPatch
     */
    readonly inlineObject?: InlineObject
}

/**
 * Request parameters for apiV0EventEventIdRelatedGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0EventEventIdRelatedGetRequest
 */
export interface ApiApiApiV0EventEventIdRelatedGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0EventEventIdRelatedGet
     */
    readonly eventId: number
}

/**
 * Request parameters for apiV0EventEventIdSendPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0EventEventIdSendPostRequest
 */
export interface ApiApiApiV0EventEventIdSendPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0EventEventIdSendPost
     */
    readonly eventId: number

    /**
     * 
     * @type {SendEventRequest}
     * @memberof ApiApiApiV0EventEventIdSendPost
     */
    readonly sendEventRequest?: SendEventRequest
}

/**
 * Request parameters for apiV0EventEventIdTagPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0EventEventIdTagPostRequest
 */
export interface ApiApiApiV0EventEventIdTagPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0EventEventIdTagPost
     */
    readonly eventId: number

    /**
     * 
     * @type {EventTag}
     * @memberof ApiApiApiV0EventEventIdTagPost
     */
    readonly eventTag?: EventTag
}

/**
 * Request parameters for apiV0FeedEventIdCommentPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0FeedEventIdCommentPostRequest
 */
export interface ApiApiApiV0FeedEventIdCommentPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FeedEventIdCommentPost
     */
    readonly eventId: number

    /**
     * 
     * @type {FeedCommentRequest}
     * @memberof ApiApiApiV0FeedEventIdCommentPost
     */
    readonly feedCommentRequest?: FeedCommentRequest
}

/**
 * Request parameters for apiV0FeedEventIdDislikePost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0FeedEventIdDislikePostRequest
 */
export interface ApiApiApiV0FeedEventIdDislikePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FeedEventIdDislikePost
     */
    readonly eventId: number
}

/**
 * Request parameters for apiV0FeedEventIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0FeedEventIdGetRequest
 */
export interface ApiApiApiV0FeedEventIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FeedEventIdGet
     */
    readonly eventId: number
}

/**
 * Request parameters for apiV0FeedEventIdLikePost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0FeedEventIdLikePostRequest
 */
export interface ApiApiApiV0FeedEventIdLikePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FeedEventIdLikePost
     */
    readonly eventId: number
}

/**
 * Request parameters for apiV0FeedEventIdWatchedPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0FeedEventIdWatchedPostRequest
 */
export interface ApiApiApiV0FeedEventIdWatchedPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FeedEventIdWatchedPost
     */
    readonly eventId: number

    /**
     * 
     * @type {EventWatchedRequest}
     * @memberof ApiApiApiV0FeedEventIdWatchedPost
     */
    readonly eventWatchedRequest?: EventWatchedRequest
}

/**
 * Request parameters for apiV0FeedGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0FeedGetRequest
 */
export interface ApiApiApiV0FeedGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FeedGet
     */
    readonly generatedAt?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FeedGet
     */
    readonly size?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FeedGet
     */
    readonly fromEvent?: number
}

/**
 * Request parameters for apiV0FeedLinkPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0FeedLinkPostRequest
 */
export interface ApiApiApiV0FeedLinkPostRequest {
    /**
     * 
     * @type {FeedLinkRequest}
     * @memberof ApiApiApiV0FeedLinkPost
     */
    readonly feedLinkRequest?: FeedLinkRequest
}

/**
 * Request parameters for apiV0FleetScoreGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0FleetScoreGetRequest
 */
export interface ApiApiApiV0FleetScoreGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FleetScoreGet
     */
    readonly cache?: number
}

/**
 * Request parameters for apiV0FleetScoreTrendGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0FleetScoreTrendGetRequest
 */
export interface ApiApiApiV0FleetScoreTrendGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FleetScoreTrendGet
     */
    readonly cache?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FleetScoreTrendGet
     */
    readonly endDate?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FleetScoreTrendGet
     */
    readonly daysCount?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0FleetScoreTrendGet
     */
    readonly daysInterval?: number
}

/**
 * Request parameters for apiV0GeofenceGeofenceIdDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0GeofenceGeofenceIdDeleteRequest
 */
export interface ApiApiApiV0GeofenceGeofenceIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0GeofenceGeofenceIdDelete
     */
    readonly geofenceId: number
}

/**
 * Request parameters for apiV0GeofenceGeofenceIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0GeofenceGeofenceIdPatchRequest
 */
export interface ApiApiApiV0GeofenceGeofenceIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0GeofenceGeofenceIdPatch
     */
    readonly geofenceId: number

    /**
     * 
     * @type {Geofence}
     * @memberof ApiApiApiV0GeofenceGeofenceIdPatch
     */
    readonly geofence?: Geofence
}

/**
 * Request parameters for apiV0GeofencePost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0GeofencePostRequest
 */
export interface ApiApiApiV0GeofencePostRequest {
    /**
     * 
     * @type {Geofence}
     * @memberof ApiApiApiV0GeofencePost
     */
    readonly geofence?: Geofence
}

/**
 * Request parameters for apiV0MalfunctionGuestPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0MalfunctionGuestPostRequest
 */
export interface ApiApiApiV0MalfunctionGuestPostRequest {
    /**
     * 
     * @type {GuestTechnicianRequest}
     * @memberof ApiApiApiV0MalfunctionGuestPost
     */
    readonly guestTechnicianRequest?: GuestTechnicianRequest
}

/**
 * Request parameters for apiV0MalfunctionMalfunctionIdCommentGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0MalfunctionMalfunctionIdCommentGetRequest
 */
export interface ApiApiApiV0MalfunctionMalfunctionIdCommentGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0MalfunctionMalfunctionIdCommentGet
     */
    readonly malfunctionId: number
}

/**
 * Request parameters for apiV0MalfunctionMalfunctionIdCommentPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0MalfunctionMalfunctionIdCommentPostRequest
 */
export interface ApiApiApiV0MalfunctionMalfunctionIdCommentPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0MalfunctionMalfunctionIdCommentPost
     */
    readonly malfunctionId: number

    /**
     * 
     * @type {MalfunctionCommentRequest}
     * @memberof ApiApiApiV0MalfunctionMalfunctionIdCommentPost
     */
    readonly malfunctionCommentRequest?: MalfunctionCommentRequest
}

/**
 * Request parameters for apiV0MalfunctionMalfunctionIdImageGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0MalfunctionMalfunctionIdImageGetRequest
 */
export interface ApiApiApiV0MalfunctionMalfunctionIdImageGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0MalfunctionMalfunctionIdImageGet
     */
    readonly malfunctionId: number
}

/**
 * Request parameters for apiV0MalfunctionPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0MalfunctionPatchRequest
 */
export interface ApiApiApiV0MalfunctionPatchRequest {
    /**
     * 
     * @type {MalfunctionAssigneeRequest}
     * @memberof ApiApiApiV0MalfunctionPatch
     */
    readonly malfunctionAssigneeRequest?: MalfunctionAssigneeRequest
}

/**
 * Request parameters for apiV0MediaFilesMediaFileIdDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0MediaFilesMediaFileIdDeleteRequest
 */
export interface ApiApiApiV0MediaFilesMediaFileIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0MediaFilesMediaFileIdDelete
     */
    readonly mediaFileId: number
}

/**
 * Request parameters for apiV0MediaFilesMediaFileIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0MediaFilesMediaFileIdGetRequest
 */
export interface ApiApiApiV0MediaFilesMediaFileIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0MediaFilesMediaFileIdGet
     */
    readonly mediaFileId: number
}

/**
 * Request parameters for apiV0MediaFilesMediaFileIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0MediaFilesMediaFileIdPatchRequest
 */
export interface ApiApiApiV0MediaFilesMediaFileIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0MediaFilesMediaFileIdPatch
     */
    readonly mediaFileId: number

    /**
     * 
     * @type {MediaFile}
     * @memberof ApiApiApiV0MediaFilesMediaFileIdPatch
     */
    readonly mediaFile?: MediaFile
}

/**
 * Request parameters for apiV0MediaFilesPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0MediaFilesPostRequest
 */
export interface ApiApiApiV0MediaFilesPostRequest {
    /**
     * 
     * @type {UploadMediaFileRequest}
     * @memberof ApiApiApiV0MediaFilesPost
     */
    readonly uploadMediaFileRequest?: UploadMediaFileRequest
}

/**
 * Request parameters for apiV0MediaFilesPut operation in ApiApi.
 * @export
 * @interface ApiApiApiV0MediaFilesPutRequest
 */
export interface ApiApiApiV0MediaFilesPutRequest {
    /**
     * 
     * @type {MediaFileRequest}
     * @memberof ApiApiApiV0MediaFilesPut
     */
    readonly mediaFileRequest?: MediaFileRequest
}

/**
 * Request parameters for apiV0NpsPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0NpsPostRequest
 */
export interface ApiApiApiV0NpsPostRequest {
    /**
     * 
     * @type {Nps}
     * @memberof ApiApiApiV0NpsPost
     */
    readonly nps?: Nps
}

/**
 * Request parameters for apiV0PackageDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0PackageDeleteRequest
 */
export interface ApiApiApiV0PackageDeleteRequest {
    /**
     * 
     * @type {PackageTrackerData}
     * @memberof ApiApiApiV0PackageDelete
     */
    readonly packageTrackerData?: PackageTrackerData
}

/**
 * Request parameters for apiV0PackagePackageIdDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0PackagePackageIdDeleteRequest
 */
export interface ApiApiApiV0PackagePackageIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0PackagePackageIdDelete
     */
    readonly packageId: number

    /**
     * 
     * @type {FileData}
     * @memberof ApiApiApiV0PackagePackageIdDelete
     */
    readonly fileData?: FileData
}

/**
 * Request parameters for apiV0PackagePackageIdPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0PackagePackageIdPostRequest
 */
export interface ApiApiApiV0PackagePackageIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0PackagePackageIdPost
     */
    readonly packageId: number

    /**
     * 
     * @type {FileData}
     * @memberof ApiApiApiV0PackagePackageIdPost
     */
    readonly fileData?: FileData
}

/**
 * Request parameters for apiV0PackagePackageIdPut operation in ApiApi.
 * @export
 * @interface ApiApiApiV0PackagePackageIdPutRequest
 */
export interface ApiApiApiV0PackagePackageIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0PackagePackageIdPut
     */
    readonly packageId: number

    /**
     * 
     * @type {FileData}
     * @memberof ApiApiApiV0PackagePackageIdPut
     */
    readonly fileData?: FileData
}

/**
 * Request parameters for apiV0PackagePost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0PackagePostRequest
 */
export interface ApiApiApiV0PackagePostRequest {
    /**
     * 
     * @type {PackageName}
     * @memberof ApiApiApiV0PackagePost
     */
    readonly packageName?: PackageName
}

/**
 * Request parameters for apiV0PackagePut operation in ApiApi.
 * @export
 * @interface ApiApiApiV0PackagePutRequest
 */
export interface ApiApiApiV0PackagePutRequest {
    /**
     * 
     * @type {PackageTrackerData}
     * @memberof ApiApiApiV0PackagePut
     */
    readonly packageTrackerData?: PackageTrackerData
}

/**
 * Request parameters for apiV0PremiumOptimizationPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0PremiumOptimizationPostRequest
 */
export interface ApiApiApiV0PremiumOptimizationPostRequest {
    /**
     * 
     * @type {PremiumOptimizationRequest}
     * @memberof ApiApiApiV0PremiumOptimizationPost
     */
    readonly premiumOptimizationRequest?: PremiumOptimizationRequest
}

/**
 * Request parameters for apiV0PremiumOptimizationReminderPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0PremiumOptimizationReminderPostRequest
 */
export interface ApiApiApiV0PremiumOptimizationReminderPostRequest {
    /**
     * 
     * @type {PremiumOptimizationReminderRequest}
     * @memberof ApiApiApiV0PremiumOptimizationReminderPost
     */
    readonly premiumOptimizationReminderRequest?: PremiumOptimizationReminderRequest
}

/**
 * Request parameters for apiV0ReportPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0ReportPostRequest
 */
export interface ApiApiApiV0ReportPostRequest {
    /**
     * 
     * @type {AlertOrReport}
     * @memberof ApiApiApiV0ReportPost
     */
    readonly alertOrReport?: AlertOrReport
}

/**
 * Request parameters for apiV0ReportReportIdDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0ReportReportIdDeleteRequest
 */
export interface ApiApiApiV0ReportReportIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0ReportReportIdDelete
     */
    readonly reportId: number

    /**
     * 
     * @type {AlertOrReport}
     * @memberof ApiApiApiV0ReportReportIdDelete
     */
    readonly alertOrReport?: AlertOrReport
}

/**
 * Request parameters for apiV0ReportReportIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0ReportReportIdPatchRequest
 */
export interface ApiApiApiV0ReportReportIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0ReportReportIdPatch
     */
    readonly reportId: number

    /**
     * 
     * @type {AlertOrReport}
     * @memberof ApiApiApiV0ReportReportIdPatch
     */
    readonly alertOrReport?: AlertOrReport
}

/**
 * Request parameters for apiV0ReportRunGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0ReportRunGetRequest
 */
export interface ApiApiApiV0ReportRunGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV0ReportRunGet
     */
    readonly reportType?: string
}

/**
 * Request parameters for apiV0ReportRunInstanceIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0ReportRunInstanceIdGetRequest
 */
export interface ApiApiApiV0ReportRunInstanceIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0ReportRunInstanceIdGet
     */
    readonly instanceId: number
}

/**
 * Request parameters for apiV0ReportRunInstanceIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0ReportRunInstanceIdPatchRequest
 */
export interface ApiApiApiV0ReportRunInstanceIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0ReportRunInstanceIdPatch
     */
    readonly instanceId: number

    /**
     * 
     * @type {ReportInstanceUpdate}
     * @memberof ApiApiApiV0ReportRunInstanceIdPatch
     */
    readonly reportInstanceUpdate?: ReportInstanceUpdate
}

/**
 * Request parameters for apiV0ReportRunInstanceIdSendPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0ReportRunInstanceIdSendPostRequest
 */
export interface ApiApiApiV0ReportRunInstanceIdSendPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0ReportRunInstanceIdSendPost
     */
    readonly instanceId: number

    /**
     * 
     * @type {SendReportRequest}
     * @memberof ApiApiApiV0ReportRunInstanceIdSendPost
     */
    readonly sendReportRequest?: SendReportRequest
}

/**
 * Request parameters for apiV0ReportRunPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0ReportRunPostRequest
 */
export interface ApiApiApiV0ReportRunPostRequest {
    /**
     * 
     * @type {ReportInstanceRequest}
     * @memberof ApiApiApiV0ReportRunPost
     */
    readonly reportInstanceRequest?: ReportInstanceRequest
}

/**
 * Request parameters for apiV0SettingsCustomerPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0SettingsCustomerPatchRequest
 */
export interface ApiApiApiV0SettingsCustomerPatchRequest {
    /**
     * 
     * @type {CustomerSettingsRequest}
     * @memberof ApiApiApiV0SettingsCustomerPatch
     */
    readonly customerSettingsRequest?: CustomerSettingsRequest
}

/**
 * Request parameters for apiV0SettingsUserEmailPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0SettingsUserEmailPatchRequest
 */
export interface ApiApiApiV0SettingsUserEmailPatchRequest {
    /**
     * 
     * @type {ChangeEmailRequest}
     * @memberof ApiApiApiV0SettingsUserEmailPatch
     */
    readonly changeEmailRequest?: ChangeEmailRequest
}

/**
 * Request parameters for apiV0SettingsUserManagementDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV0SettingsUserManagementDeleteRequest
 */
export interface ApiApiApiV0SettingsUserManagementDeleteRequest {
    /**
     * 
     * @type {Array<UserDetails>}
     * @memberof ApiApiApiV0SettingsUserManagementDelete
     */
    readonly userDetails?: Array<UserDetails>
}

/**
 * Request parameters for apiV0SettingsUserManagementPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0SettingsUserManagementPatchRequest
 */
export interface ApiApiApiV0SettingsUserManagementPatchRequest {
    /**
     * 
     * @type {Array<UserDetails>}
     * @memberof ApiApiApiV0SettingsUserManagementPatch
     */
    readonly userDetails?: Array<UserDetails>
}

/**
 * Request parameters for apiV0SettingsUserManagementPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0SettingsUserManagementPostRequest
 */
export interface ApiApiApiV0SettingsUserManagementPostRequest {
    /**
     * 
     * @type {Array<UserCreationData>}
     * @memberof ApiApiApiV0SettingsUserManagementPost
     */
    readonly userCreationData?: Array<UserCreationData>
}

/**
 * Request parameters for apiV0SettingsUserPasswordPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0SettingsUserPasswordPatchRequest
 */
export interface ApiApiApiV0SettingsUserPasswordPatchRequest {
    /**
     * 
     * @type {ChangePasswordRequest}
     * @memberof ApiApiApiV0SettingsUserPasswordPatch
     */
    readonly changePasswordRequest?: ChangePasswordRequest
}

/**
 * Request parameters for apiV0SettingsUserPermissionPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0SettingsUserPermissionPostRequest
 */
export interface ApiApiApiV0SettingsUserPermissionPostRequest {
    /**
     * 
     * @type {ChangePermissionsRequest}
     * @memberof ApiApiApiV0SettingsUserPermissionPost
     */
    readonly changePermissionsRequest?: ChangePermissionsRequest
}

/**
 * Request parameters for apiV0SettingsUserResetPasswordPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0SettingsUserResetPasswordPostRequest
 */
export interface ApiApiApiV0SettingsUserResetPasswordPostRequest {
    /**
     * 
     * @type {ResetPasswordRequest}
     * @memberof ApiApiApiV0SettingsUserResetPasswordPost
     */
    readonly resetPasswordRequest?: ResetPasswordRequest
}

/**
 * Request parameters for apiV0UserNotificationGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0UserNotificationGetRequest
 */
export interface ApiApiApiV0UserNotificationGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0UserNotificationGet
     */
    readonly from?: number
}

/**
 * Request parameters for apiV0UserNotificationNotificationIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV0UserNotificationNotificationIdPatchRequest
 */
export interface ApiApiApiV0UserNotificationNotificationIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0UserNotificationNotificationIdPatch
     */
    readonly notificationId: number

    /**
     * 
     * @type {UserNotificationRequest}
     * @memberof ApiApiApiV0UserNotificationNotificationIdPatch
     */
    readonly userNotificationRequest?: UserNotificationRequest
}

/**
 * Request parameters for apiV0VideoPreviewRequestEventPreviewRequestIdPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0VideoPreviewRequestEventPreviewRequestIdPostRequest
 */
export interface ApiApiApiV0VideoPreviewRequestEventPreviewRequestIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0VideoPreviewRequestEventPreviewRequestIdPost
     */
    readonly previewRequestId: number
}

/**
 * Request parameters for apiV0VideoPreviewRequestGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0VideoPreviewRequestGetRequest
 */
export interface ApiApiApiV0VideoPreviewRequestGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0VideoPreviewRequestGet
     */
    readonly tripId: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0VideoPreviewRequestGet
     */
    readonly driverTripId?: number
}

/**
 * Request parameters for apiV0VideoPreviewRequestPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0VideoPreviewRequestPostRequest
 */
export interface ApiApiApiV0VideoPreviewRequestPostRequest {
    /**
     * 
     * @type {VideoPreviewRequestBody}
     * @memberof ApiApiApiV0VideoPreviewRequestPost
     */
    readonly videoPreviewRequestBody?: VideoPreviewRequestBody
}

/**
 * Request parameters for apiV0WellnessScoresGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0WellnessScoresGetRequest
 */
export interface ApiApiApiV0WellnessScoresGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0WellnessScoresGet
     */
    readonly cache?: number
}

/**
 * Request parameters for apiV0WellnessScoresLicensePlateGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV0WellnessScoresLicensePlateGetRequest
 */
export interface ApiApiApiV0WellnessScoresLicensePlateGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV0WellnessScoresLicensePlateGet
     */
    readonly licensePlate: string
}

/**
 * Request parameters for apiV0WellnessStatusWellnessIdCoachPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV0WellnessStatusWellnessIdCoachPostRequest
 */
export interface ApiApiApiV0WellnessStatusWellnessIdCoachPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV0WellnessStatusWellnessIdCoachPost
     */
    readonly wellnessId: number

    /**
     * 
     * @type {CoachWellnessDetails}
     * @memberof ApiApiApiV0WellnessStatusWellnessIdCoachPost
     */
    readonly coachWellnessDetails?: CoachWellnessDetails
}

/**
 * Request parameters for apiV1CoachDriverGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV1CoachDriverGetRequest
 */
export interface ApiApiApiV1CoachDriverGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1CoachDriverGet
     */
    readonly token: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1CoachDriverGet
     */
    readonly code?: string
}

/**
 * Request parameters for apiV1CoachDriverPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV1CoachDriverPatchRequest
 */
export interface ApiApiApiV1CoachDriverPatchRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1CoachDriverPatch
     */
    readonly token: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1CoachDriverPatch
     */
    readonly code?: string

    /**
     * 
     * @type {CoachSessionMetadata}
     * @memberof ApiApiApiV1CoachDriverPatch
     */
    readonly coachSessionMetadata?: CoachSessionMetadata
}

/**
 * Request parameters for apiV1CoachDriverPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV1CoachDriverPostRequest
 */
export interface ApiApiApiV1CoachDriverPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1CoachDriverPost
     */
    readonly token: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1CoachDriverPost
     */
    readonly code?: string

    /**
     * 
     * @type {UpdateCoachSession}
     * @memberof ApiApiApiV1CoachDriverPost
     */
    readonly updateCoachSession?: UpdateCoachSession
}

/**
 * Request parameters for apiV1CoachGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV1CoachGetRequest
 */
export interface ApiApiApiV1CoachGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1CoachGet
     */
    readonly driverToken?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1CoachGet
     */
    readonly completedFrom?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1CoachGet
     */
    readonly completedTo?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1CoachGet
     */
    readonly additionalInfo?: number
}

/**
 * Request parameters for apiV1CoachSendPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV1CoachSendPostRequest
 */
export interface ApiApiApiV1CoachSendPostRequest {
    /**
     * 
     * @type {CoachSessionMessageRequest}
     * @memberof ApiApiApiV1CoachSendPost
     */
    readonly coachSessionMessageRequest: CoachSessionMessageRequest
}

/**
 * Request parameters for apiV1CoachSessionIdDelete operation in ApiApi.
 * @export
 * @interface ApiApiApiV1CoachSessionIdDeleteRequest
 */
export interface ApiApiApiV1CoachSessionIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1CoachSessionIdDelete
     */
    readonly sessionId: number
}

/**
 * Request parameters for apiV1CoachSessionIdGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV1CoachSessionIdGetRequest
 */
export interface ApiApiApiV1CoachSessionIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1CoachSessionIdGet
     */
    readonly sessionId: number
}

/**
 * Request parameters for apiV1CoachSessionIdPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV1CoachSessionIdPatchRequest
 */
export interface ApiApiApiV1CoachSessionIdPatchRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1CoachSessionIdPatch
     */
    readonly sessionId: number

    /**
     * 
     * @type {CoachSession}
     * @memberof ApiApiApiV1CoachSessionIdPatch
     */
    readonly coachSession?: CoachSession
}

/**
 * Request parameters for apiV1CoachSessionIdPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV1CoachSessionIdPostRequest
 */
export interface ApiApiApiV1CoachSessionIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1CoachSessionIdPost
     */
    readonly sessionId: number

    /**
     * 
     * @type {UpdateCoachSession}
     * @memberof ApiApiApiV1CoachSessionIdPost
     */
    readonly updateCoachSession?: UpdateCoachSession
}

/**
 * Request parameters for apiV1CoachSessionIdRemindPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV1CoachSessionIdRemindPostRequest
 */
export interface ApiApiApiV1CoachSessionIdRemindPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1CoachSessionIdRemindPost
     */
    readonly sessionId: number
}

/**
 * Request parameters for apiV1CoachSessionIdSavePost operation in ApiApi.
 * @export
 * @interface ApiApiApiV1CoachSessionIdSavePostRequest
 */
export interface ApiApiApiV1CoachSessionIdSavePostRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1CoachSessionIdSavePost
     */
    readonly sessionId: number
}

/**
 * Request parameters for apiV1EventGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV1EventGetRequest
 */
export interface ApiApiApiV1EventGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly licensePlate?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly licensePlateList?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly licensePlateContains?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly subFleet?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly subFleetList?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly date?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly dateTo?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly timeFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly timeTo?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly tripId?: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1EventGet
     */
    readonly lastTrip?: number

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly tripObjIn?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly severity?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly eventType?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly eventTypeList?: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1EventGet
     */
    readonly lastEvent?: number

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly tag?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1EventGet
     */
    readonly level?: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1EventGet
     */
    readonly limit?: number
}

/**
 * Request parameters for apiV1PolicyGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV1PolicyGetRequest
 */
export interface ApiApiApiV1PolicyGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1PolicyGet
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1PolicyGet
     */
    readonly date?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1PolicyGet
     */
    readonly csv?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1PolicyGet
     */
    readonly _long?: string
}

/**
 * Request parameters for apiV1PolicyPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV1PolicyPostRequest
 */
export interface ApiApiApiV1PolicyPostRequest {
    /**
     * 
     * @type {any}
     * @memberof ApiApiApiV1PolicyPost
     */
    readonly body?: any
}

/**
 * Request parameters for apiV1TripGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV1TripGetRequest
 */
export interface ApiApiApiV1TripGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1TripGet
     */
    readonly licensePlate: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1TripGet
     */
    readonly from: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1TripGet
     */
    readonly to: number
}

/**
 * Request parameters for apiV1TripLicensePlateGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV1TripLicensePlateGetRequest
 */
export interface ApiApiApiV1TripLicensePlateGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1TripLicensePlateGet
     */
    readonly licensePlate: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1TripLicensePlateGet
     */
    readonly timeFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1TripLicensePlateGet
     */
    readonly timeTo?: string

    /**
     * 
     * @type {boolean}
     * @memberof ApiApiApiV1TripLicensePlateGet
     */
    readonly csv?: boolean

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1TripLicensePlateGet
     */
    readonly tripId?: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV1TripLicensePlateGet
     */
    readonly snapshots?: number
}

/**
 * Request parameters for apiV1TripLicensePlateWellnessGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV1TripLicensePlateWellnessGetRequest
 */
export interface ApiApiApiV1TripLicensePlateWellnessGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1TripLicensePlateWellnessGet
     */
    readonly licensePlate: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1TripLicensePlateWellnessGet
     */
    readonly timeFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV1TripLicensePlateWellnessGet
     */
    readonly timeTo?: string
}

/**
 * Request parameters for apiV1UserPatch operation in ApiApi.
 * @export
 * @interface ApiApiApiV1UserPatchRequest
 */
export interface ApiApiApiV1UserPatchRequest {
    /**
     * 
     * @type {UserProfile}
     * @memberof ApiApiApiV1UserPatch
     */
    readonly userProfile?: UserProfile
}

/**
 * Request parameters for apiV2DeviceGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV2DeviceGetRequest
 */
export interface ApiApiApiV2DeviceGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly licensePlate?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly driverName?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly licensePlateContains?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly driverNameContains?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly deviceId?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly deviceIdContains?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly subFleet?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly date?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly dateTo?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly version?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly status?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly versionName?: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV2DeviceGet
     */
    readonly cache?: number
}

/**
 * Request parameters for apiV2DeviceLocationGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV2DeviceLocationGetRequest
 */
export interface ApiApiApiV2DeviceLocationGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceLocationGet
     */
    readonly licensePlate?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceLocationGet
     */
    readonly driverName?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceLocationGet
     */
    readonly licensePlateContains?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceLocationGet
     */
    readonly driverNameContains?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceLocationGet
     */
    readonly deviceId?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceLocationGet
     */
    readonly deviceIdContains?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceLocationGet
     */
    readonly subFleet?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceLocationGet
     */
    readonly date?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceLocationGet
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceLocationGet
     */
    readonly dateTo?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceLocationGet
     */
    readonly version?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2DeviceLocationGet
     */
    readonly versionName?: string
}

/**
 * Request parameters for apiV2EventGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV2EventGetRequest
 */
export interface ApiApiApiV2EventGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly licensePlate?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly licensePlateList?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly driverName?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly driverNameList?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly licensePlateContains?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly driverNameContains?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly subFleet?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly subFleetList?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly date?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly dateFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly dateTo?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly timeFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly timeTo?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly tripId?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly tripObjIn?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly eventType?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly eventTypeList?: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV2EventGet
     */
    readonly severityFrom?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV2EventGet
     */
    readonly severityTo?: number

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly tag?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2EventGet
     */
    readonly level?: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV2EventGet
     */
    readonly limit?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV2EventGet
     */
    readonly searchAfter?: number
}

/**
 * Request parameters for apiV2TripLicensePlateGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV2TripLicensePlateGetRequest
 */
export interface ApiApiApiV2TripLicensePlateGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2TripLicensePlateGet
     */
    readonly licensePlate: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2TripLicensePlateGet
     */
    readonly timeFrom?: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2TripLicensePlateGet
     */
    readonly timeTo?: string

    /**
     * 
     * @type {boolean}
     * @memberof ApiApiApiV2TripLicensePlateGet
     */
    readonly csv?: boolean

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2TripLicensePlateGet
     */
    readonly tripId?: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV2TripLicensePlateGet
     */
    readonly driverTripId?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV2TripLicensePlateGet
     */
    readonly snapshots?: number
}

/**
 * Request parameters for apiV2TripLicensePlatePost operation in ApiApi.
 * @export
 * @interface ApiApiApiV2TripLicensePlatePostRequest
 */
export interface ApiApiApiV2TripLicensePlatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2TripLicensePlatePost
     */
    readonly licensePlate: string

    /**
     * 
     * @type {TripUpdateRequest}
     * @memberof ApiApiApiV2TripLicensePlatePost
     */
    readonly tripUpdateRequest?: TripUpdateRequest
}

/**
 * Request parameters for apiV2WellnessImageWellnessTypeGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV2WellnessImageWellnessTypeGetRequest
 */
export interface ApiApiApiV2WellnessImageWellnessTypeGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2WellnessImageWellnessTypeGet
     */
    readonly wellnessType: string

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2WellnessImageWellnessTypeGet
     */
    readonly wellnessId?: string

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV2WellnessImageWellnessTypeGet
     */
    readonly timestamp?: number

    /**
     * 
     * @type {string}
     * @memberof ApiApiApiV2WellnessImageWellnessTypeGet
     */
    readonly licensePlate?: string
}

/**
 * Request parameters for apiV2WellnessRunTaskPost operation in ApiApi.
 * @export
 * @interface ApiApiApiV2WellnessRunTaskPostRequest
 */
export interface ApiApiApiV2WellnessRunTaskPostRequest {
    /**
     * 
     * @type {RunWellnessRequest}
     * @memberof ApiApiApiV2WellnessRunTaskPost
     */
    readonly runWellnessRequest?: RunWellnessRequest
}

/**
 * Request parameters for apiV3DeviceGet operation in ApiApi.
 * @export
 * @interface ApiApiApiV3DeviceGetRequest
 */
export interface ApiApiApiV3DeviceGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV3DeviceGet
     */
    readonly cache?: number

    /**
     * 
     * @type {number}
     * @memberof ApiApiApiV3DeviceGet
     */
    readonly timestamp?: number
}

/**
 * Request parameters for hosV0SettingsDriverManagementDelete operation in ApiApi.
 * @export
 * @interface ApiApiHosV0SettingsDriverManagementDeleteRequest
 */
export interface ApiApiHosV0SettingsDriverManagementDeleteRequest {
    /**
     * 
     * @type {Array<HosDriverRequest>}
     * @memberof ApiApiHosV0SettingsDriverManagementDelete
     */
    readonly hosDriverRequest?: Array<HosDriverRequest>
}

/**
 * Request parameters for hosV0SettingsDriverManagementPatch operation in ApiApi.
 * @export
 * @interface ApiApiHosV0SettingsDriverManagementPatchRequest
 */
export interface ApiApiHosV0SettingsDriverManagementPatchRequest {
    /**
     * 
     * @type {Array<HosDriverRequest>}
     * @memberof ApiApiHosV0SettingsDriverManagementPatch
     */
    readonly hosDriverRequest?: Array<HosDriverRequest>
}

/**
 * Request parameters for hosV0SettingsDriverManagementPost operation in ApiApi.
 * @export
 * @interface ApiApiHosV0SettingsDriverManagementPostRequest
 */
export interface ApiApiHosV0SettingsDriverManagementPostRequest {
    /**
     * 
     * @type {Array<HosDriverRequest>}
     * @memberof ApiApiHosV0SettingsDriverManagementPost
     */
    readonly hosDriverRequest?: Array<HosDriverRequest>
}

/**
 * Request parameters for hosV0SettingsTerminalManagementDelete operation in ApiApi.
 * @export
 * @interface ApiApiHosV0SettingsTerminalManagementDeleteRequest
 */
export interface ApiApiHosV0SettingsTerminalManagementDeleteRequest {
    /**
     * 
     * @type {Array<HomeTerminal>}
     * @memberof ApiApiHosV0SettingsTerminalManagementDelete
     */
    readonly homeTerminal?: Array<HomeTerminal>
}

/**
 * Request parameters for hosV0SettingsTerminalManagementPatch operation in ApiApi.
 * @export
 * @interface ApiApiHosV0SettingsTerminalManagementPatchRequest
 */
export interface ApiApiHosV0SettingsTerminalManagementPatchRequest {
    /**
     * 
     * @type {Array<HomeTerminal>}
     * @memberof ApiApiHosV0SettingsTerminalManagementPatch
     */
    readonly homeTerminal?: Array<HomeTerminal>
}

/**
 * Request parameters for hosV0SettingsTerminalManagementPost operation in ApiApi.
 * @export
 * @interface ApiApiHosV0SettingsTerminalManagementPostRequest
 */
export interface ApiApiHosV0SettingsTerminalManagementPostRequest {
    /**
     * 
     * @type {Array<HomeTerminal>}
     * @memberof ApiApiHosV0SettingsTerminalManagementPost
     */
    readonly homeTerminal?: Array<HomeTerminal>
}

/**
 * ApiApi - object-oriented interface
 * @export
 * @class ApiApi
 * @extends {BaseAPI}
 */
export class ApiApi extends BaseAPI {
    /**
     * 
     * @summary Get device details
     * @param {ApiApiApiAdminDeviceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiAdminDeviceGet(requestParameters: ApiApiApiAdminDeviceGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiAdminDeviceGet(requestParameters.licensePlate, requestParameters.driverName, requestParameters.licensePlateContains, requestParameters.driverNameContains, requestParameters.deviceId, requestParameters.deviceIdContains, requestParameters.subFleet, requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.version, requestParameters.status, requestParameters.versionName, requestParameters.cache, requestParameters.page, requestParameters.pageSize, requestParameters.country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get device operation details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiAdminDeviceOperationGet(options?: any) {
        return ApiApiFp(this.configuration).apiAdminDeviceOperationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new device operation details
     * @param {ApiApiApiAdminDeviceOperationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiAdminDeviceOperationPost(requestParameters: ApiApiApiAdminDeviceOperationPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiAdminDeviceOperationPost(requestParameters.deviceOperationData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create overlay on event video
     * @param {ApiApiApiAdminOverlayPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiAdminOverlayPost(requestParameters: ApiApiApiAdminOverlayPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiAdminOverlayPost(requestParameters.eventOverlayRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get list of all wellness details
     * @param {ApiApiApiAdminWellnessGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiAdminWellnessGet(requestParameters: ApiApiApiAdminWellnessGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiAdminWellnessGet(requestParameters.page, requestParameters.pageSize, requestParameters.country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new wellness details
     * @param {ApiApiApiAdminWellnessPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiAdminWellnessPost(requestParameters: ApiApiApiAdminWellnessPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiAdminWellnessPost(requestParameters.wellnessUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user token
     * @param {ApiApiApiAuthOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiAuthOtpPost(requestParameters: ApiApiApiAuthOtpPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiAuthOtpPost(requestParameters.oTPUserCredentials, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user token
     * @param {ApiApiApiAuthPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiAuthPost(requestParameters: ApiApiApiAuthPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiAuthPost(requestParameters.userCredentials, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user token
     * @param {ApiApiApiAuthRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiAuthRefreshPost(requestParameters: ApiApiApiAuthRefreshPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiAuthRefreshPost(requestParameters.refreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get accident overview data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0AccidentOverviewGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0AccidentOverviewGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get event details
     * @summary Get event details
     * @param {ApiApiApiV0CoachEventEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachEventEventIdGet(requestParameters: ApiApiApiV0CoachEventEventIdGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachEventEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get coaching event image
     * @param {ApiApiApiV0CoachEventEventIdImageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachEventEventIdImageGet(requestParameters: ApiApiApiV0CoachEventEventIdImageGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachEventEventIdImageGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get event coaching status
     * @param {ApiApiApiV0CoachEventPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachEventPost(requestParameters: ApiApiApiV0CoachEventPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachEventPost(requestParameters.coachEventStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get metrics data
     * @param {ApiApiApiV0CoachMetricsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachMetricsGet(requestParameters: ApiApiApiV0CoachMetricsGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachMetricsGet(requestParameters.driverToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new coaching metrics by driver token
     * @param {ApiApiApiV0CoachMetricsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachMetricsPost(requestParameters: ApiApiApiV0CoachMetricsPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachMetricsPost(requestParameters.coachMetricsSaveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete event from coaching session
     * @param {ApiApiApiV0CoachSessionIdEventItemIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdEventItemIdDelete(requestParameters: ApiApiApiV0CoachSessionIdEventItemIdDeleteRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdEventItemIdDelete(requestParameters.sessionId, requestParameters.itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update event in coaching session
     * @param {ApiApiApiV0CoachSessionIdEventItemIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdEventItemIdPatch(requestParameters: ApiApiApiV0CoachSessionIdEventItemIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdEventItemIdPatch(requestParameters.sessionId, requestParameters.itemId, requestParameters.updateCoachEvent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get coaching session details
     * @param {ApiApiApiV0CoachSessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdGet(requestParameters: ApiApiApiV0CoachSessionIdGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdGet(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get coaching session image
     * @param {ApiApiApiV0CoachSessionIdImageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdImageGet(requestParameters: ApiApiApiV0CoachSessionIdImageGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdImageGet(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete coach media file
     * @param {ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete(requestParameters: ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdDeleteRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdMediaFileCoachMediaFileIdDelete(requestParameters.sessionId, requestParameters.coachMediaFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update coach media file
     * @param {ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch(requestParameters: ApiApiApiV0CoachSessionIdMediaFileCoachMediaFileIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdMediaFileCoachMediaFileIdPatch(requestParameters.sessionId, requestParameters.coachMediaFileId, requestParameters.coachMediaFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new coach media file
     * @param {ApiApiApiV0CoachSessionIdMediaFilePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdMediaFilePost(requestParameters: ApiApiApiV0CoachSessionIdMediaFilePostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdMediaFilePost(requestParameters.sessionId, requestParameters.coachMediaFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete coach metrics
     * @param {ApiApiApiV0CoachSessionIdMetricsMetricsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdMetricsMetricsIdDelete(requestParameters: ApiApiApiV0CoachSessionIdMetricsMetricsIdDeleteRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdMetricsMetricsIdDelete(requestParameters.sessionId, requestParameters.metricsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update coach metrics
     * @param {ApiApiApiV0CoachSessionIdMetricsMetricsIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdMetricsMetricsIdPatch(requestParameters: ApiApiApiV0CoachSessionIdMetricsMetricsIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdMetricsMetricsIdPatch(requestParameters.sessionId, requestParameters.metricsId, requestParameters.coachMetrics, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new coaching metrics
     * @param {ApiApiApiV0CoachSessionIdMetricsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdMetricsPost(requestParameters: ApiApiApiV0CoachSessionIdMetricsPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdMetricsPost(requestParameters.sessionId, requestParameters.coachMetricsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete manager notes
     * @param {ApiApiApiV0CoachSessionIdNotesNoteIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdNotesNoteIdDelete(requestParameters: ApiApiApiV0CoachSessionIdNotesNoteIdDeleteRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdNotesNoteIdDelete(requestParameters.sessionId, requestParameters.noteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update manager notes
     * @param {ApiApiApiV0CoachSessionIdNotesNoteIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdNotesNoteIdPatch(requestParameters: ApiApiApiV0CoachSessionIdNotesNoteIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdNotesNoteIdPatch(requestParameters.sessionId, requestParameters.noteId, requestParameters.coachManagerNotes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new manager notes
     * @param {ApiApiApiV0CoachSessionIdNotesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdNotesPost(requestParameters: ApiApiApiV0CoachSessionIdNotesPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdNotesPost(requestParameters.sessionId, requestParameters.managerNotesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of coaching sessions
     * @param {ApiApiApiV0CoachSessionIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdPost(requestParameters: ApiApiApiV0CoachSessionIdPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdPost(requestParameters.sessionId, requestParameters.updateCoachSession, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new driver response
     * @param {ApiApiApiV0CoachSessionIdResponsePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdResponsePost(requestParameters: ApiApiApiV0CoachSessionIdResponsePostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdResponsePost(requestParameters.sessionId, requestParameters.driverResponseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete driver response
     * @param {ApiApiApiV0CoachSessionIdResponseResponseIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdResponseResponseIdDelete(requestParameters: ApiApiApiV0CoachSessionIdResponseResponseIdDeleteRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdResponseResponseIdDelete(requestParameters.sessionId, requestParameters.responseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update driver response
     * @param {ApiApiApiV0CoachSessionIdResponseResponseIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdResponseResponseIdPatch(requestParameters: ApiApiApiV0CoachSessionIdResponseResponseIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdResponseResponseIdPatch(requestParameters.sessionId, requestParameters.responseId, requestParameters.coachDriverResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove wellness status from driver coaching session
     * @param {ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdWellnessStatusWellnessIdDelete(requestParameters: ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdDeleteRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdWellnessStatusWellnessIdDelete(requestParameters.sessionId, requestParameters.wellnessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update wellness status from driver coaching session
     * @param {ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachSessionIdWellnessStatusWellnessIdPatch(requestParameters: ApiApiApiV0CoachSessionIdWellnessStatusWellnessIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachSessionIdWellnessStatusWellnessIdPatch(requestParameters.sessionId, requestParameters.wellnessId, requestParameters.updateCoachWellnessStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get coaching overview
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CoachingOverviewGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0CoachingOverviewGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get clip from device
     * @summary Get clip from device
     * @param {ApiApiApiV0CommandCommandIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CommandCommandIdGet(requestParameters: ApiApiApiV0CommandCommandIdGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CommandCommandIdGet(requestParameters.commandId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create remote command
     * @summary Create remote command
     * @param {ApiApiApiV0CommandCommandIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CommandCommandIdPost(requestParameters: ApiApiApiV0CommandCommandIdPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0CommandCommandIdPost(requestParameters.commandId, requestParameters.remoteCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of get clip commands
     * @summary Get list of get clip commands
     * @param {ApiApiApiV0CommandGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CommandGet(requestParameters: ApiApiApiV0CommandGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0CommandGet(requestParameters.timeFrom, requestParameters.timeTo, requestParameters.accident, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get clip from device
     * @summary Get clip from device
     * @param {ApiApiApiV0CommandPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CommandPost(requestParameters: ApiApiApiV0CommandPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0CommandPost(requestParameters.command, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove customer sub fleet
     * @param {ApiApiApiV0CustomerDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CustomerDelete(requestParameters: ApiApiApiV0CustomerDeleteRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0CustomerDelete(requestParameters.customerSubFleetData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get customer details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CustomerGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0CustomerGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new customer sub fleet
     * @param {ApiApiApiV0CustomerPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0CustomerPost(requestParameters: ApiApiApiV0CustomerPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0CustomerPost(requestParameters.customerSubFleetData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get device snapshot
     * @param {ApiApiApiV0DeviceDeviceIdSnapshotGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DeviceDeviceIdSnapshotGet(requestParameters: ApiApiApiV0DeviceDeviceIdSnapshotGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0DeviceDeviceIdSnapshotGet(requestParameters.deviceId, requestParameters.timestamp, requestParameters.since, requestParameters.exact, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get device location
     * @param {ApiApiApiV0DeviceLocateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DeviceLocateGet(requestParameters: ApiApiApiV0DeviceLocateGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0DeviceLocateGet(requestParameters.timeFrom, requestParameters.timeTo, requestParameters.latitude, requestParameters.longitude, requestParameters.radius, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update device details
     * @param {ApiApiApiV0DeviceUpdatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DeviceUpdatePatch(requestParameters: ApiApiApiV0DeviceUpdatePatchRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0DeviceUpdatePatch(requestParameters.deviceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get driver badge
     * @param {ApiApiApiV0DriverBadgeDriverTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DriverBadgeDriverTokenGet(requestParameters: ApiApiApiV0DriverBadgeDriverTokenGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0DriverBadgeDriverTokenGet(requestParameters.driverToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get driver badges
     * @param {ApiApiApiV0DriverBadgePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DriverBadgePost(requestParameters: ApiApiApiV0DriverBadgePostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0DriverBadgePost(requestParameters.driverBadgeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get driver details
     * @param {ApiApiApiV0DriverDriverTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DriverDriverTokenGet(requestParameters: ApiApiApiV0DriverDriverTokenGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0DriverDriverTokenGet(requestParameters.driverToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update driver details
     * @param {ApiApiApiV0DriverDriverTokenPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DriverDriverTokenPatch(requestParameters: ApiApiApiV0DriverDriverTokenPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0DriverDriverTokenPatch(requestParameters.driverToken, requestParameters.fleetDriverRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of drivers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DriverGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0DriverGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update multiple drivers
     * @param {ApiApiApiV0DriverPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DriverPatch(requestParameters: ApiApiApiV0DriverPatchRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0DriverPatch(requestParameters.fleetDriverList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new driver
     * @param {ApiApiApiV0DriverPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DriverPost(requestParameters: ApiApiApiV0DriverPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0DriverPost(requestParameters.fleetDriverRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * recalculate driver score
     * @param {ApiApiApiV0DriverScoresDriverTokenCalculatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DriverScoresDriverTokenCalculatePatch(requestParameters: ApiApiApiV0DriverScoresDriverTokenCalculatePatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0DriverScoresDriverTokenCalculatePatch(requestParameters.driverToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get driver score with relevant events
     * @param {ApiApiApiV0DriverScoresDriverTokenGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DriverScoresDriverTokenGet(requestParameters: ApiApiApiV0DriverScoresDriverTokenGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0DriverScoresDriverTokenGet(requestParameters.driverToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get driver scores
     * @param {ApiApiApiV0DriverScoresGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0DriverScoresGet(requestParameters: ApiApiApiV0DriverScoresGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0DriverScoresGet(requestParameters.allDrivers, requestParameters.page, requestParameters.cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create new event from existing one
     * @param {ApiApiApiV0EventEventIdClonePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0EventEventIdClonePost(requestParameters: ApiApiApiV0EventEventIdClonePostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0EventEventIdClonePost(requestParameters.eventId, requestParameters.cloneEventDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get event coaching data
     * @param {ApiApiApiV0EventEventIdCoachGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0EventEventIdCoachGet(requestParameters: ApiApiApiV0EventEventIdCoachGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0EventEventIdCoachGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add or dismiss event from driver coaching session
     * @param {ApiApiApiV0EventEventIdCoachPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0EventEventIdCoachPost(requestParameters: ApiApiApiV0EventEventIdCoachPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0EventEventIdCoachPost(requestParameters.eventId, requestParameters.coachEventDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download event video request
     * @param {ApiApiApiV0EventEventIdDownloadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0EventEventIdDownloadPost(requestParameters: ApiApiApiV0EventEventIdDownloadPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0EventEventIdDownloadPost(requestParameters.eventId, requestParameters.downloadVideoEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get event details
     * @summary Get event details
     * @param {ApiApiApiV0EventEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0EventEventIdGet(requestParameters: ApiApiApiV0EventEventIdGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0EventEventIdGet(requestParameters.eventId, requestParameters.bucket, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get event image
     * @param {ApiApiApiV0EventEventIdImageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0EventEventIdImageGet(requestParameters: ApiApiApiV0EventEventIdImageGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0EventEventIdImageGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update event details
     * @param {ApiApiApiV0EventEventIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0EventEventIdPatch(requestParameters: ApiApiApiV0EventEventIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0EventEventIdPatch(requestParameters.eventId, requestParameters.inlineObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get related events
     * @param {ApiApiApiV0EventEventIdRelatedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0EventEventIdRelatedGet(requestParameters: ApiApiApiV0EventEventIdRelatedGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0EventEventIdRelatedGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send event
     * @param {ApiApiApiV0EventEventIdSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0EventEventIdSendPost(requestParameters: ApiApiApiV0EventEventIdSendPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0EventEventIdSendPost(requestParameters.eventId, requestParameters.sendEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Change event tags
     * @summary Change event tags
     * @param {ApiApiApiV0EventEventIdTagPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0EventEventIdTagPost(requestParameters: ApiApiApiV0EventEventIdTagPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0EventEventIdTagPost(requestParameters.eventId, requestParameters.eventTag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add comment to feed event
     * @summary Add comment
     * @param {ApiApiApiV0FeedEventIdCommentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0FeedEventIdCommentPost(requestParameters: ApiApiApiV0FeedEventIdCommentPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0FeedEventIdCommentPost(requestParameters.eventId, requestParameters.feedCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add or remove dislike from event
     * @summary Dislike event
     * @param {ApiApiApiV0FeedEventIdDislikePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0FeedEventIdDislikePost(requestParameters: ApiApiApiV0FeedEventIdDislikePostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0FeedEventIdDislikePost(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get feed event
     * @summary Get feed event
     * @param {ApiApiApiV0FeedEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0FeedEventIdGet(requestParameters: ApiApiApiV0FeedEventIdGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0FeedEventIdGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add or remove like from event
     * @summary Like event
     * @param {ApiApiApiV0FeedEventIdLikePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0FeedEventIdLikePost(requestParameters: ApiApiApiV0FeedEventIdLikePostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0FeedEventIdLikePost(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update percent watched
     * @summary Update percent watched
     * @param {ApiApiApiV0FeedEventIdWatchedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0FeedEventIdWatchedPost(requestParameters: ApiApiApiV0FeedEventIdWatchedPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0FeedEventIdWatchedPost(requestParameters.eventId, requestParameters.eventWatchedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get events
     * @summary Get user feed
     * @param {ApiApiApiV0FeedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0FeedGet(requestParameters: ApiApiApiV0FeedGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0FeedGet(requestParameters.generatedAt, requestParameters.size, requestParameters.fromEvent, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get sms with link to feed page
     * @summary Get sms with link to feed page
     * @param {ApiApiApiV0FeedLinkPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0FeedLinkPost(requestParameters: ApiApiApiV0FeedLinkPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0FeedLinkPost(requestParameters.feedLinkRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get fleet safety scores
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0FleetSafetyScoresGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0FleetSafetyScoresGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get fleet score and fleet metric data
     * @param {ApiApiApiV0FleetScoreGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0FleetScoreGet(requestParameters: ApiApiApiV0FleetScoreGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0FleetScoreGet(requestParameters.cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get fleet scores and score distribution over time
     * @param {ApiApiApiV0FleetScoreTrendGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0FleetScoreTrendGet(requestParameters: ApiApiApiV0FleetScoreTrendGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0FleetScoreTrendGet(requestParameters.cache, requestParameters.endDate, requestParameters.daysCount, requestParameters.daysInterval, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a geofence
     * @param {ApiApiApiV0GeofenceGeofenceIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0GeofenceGeofenceIdDelete(requestParameters: ApiApiApiV0GeofenceGeofenceIdDeleteRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0GeofenceGeofenceIdDelete(requestParameters.geofenceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a geofence
     * @param {ApiApiApiV0GeofenceGeofenceIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0GeofenceGeofenceIdPatch(requestParameters: ApiApiApiV0GeofenceGeofenceIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0GeofenceGeofenceIdPatch(requestParameters.geofenceId, requestParameters.geofence, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get geofence details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0GeofenceGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0GeofenceGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new geofence
     * @param {ApiApiApiV0GeofencePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0GeofencePost(requestParameters: ApiApiApiV0GeofencePostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0GeofencePost(requestParameters.geofence, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get help videos
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0HelpGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0HelpGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get aggregated data of malfunctions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MalfunctionAggregatedGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0MalfunctionAggregatedGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get malfunction list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MalfunctionGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0MalfunctionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create guest technician
     * @param {ApiApiApiV0MalfunctionGuestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MalfunctionGuestPost(requestParameters: ApiApiApiV0MalfunctionGuestPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0MalfunctionGuestPost(requestParameters.guestTechnicianRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get malfunction comments
     * @param {ApiApiApiV0MalfunctionMalfunctionIdCommentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MalfunctionMalfunctionIdCommentGet(requestParameters: ApiApiApiV0MalfunctionMalfunctionIdCommentGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0MalfunctionMalfunctionIdCommentGet(requestParameters.malfunctionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add new comment to malfunction
     * @param {ApiApiApiV0MalfunctionMalfunctionIdCommentPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MalfunctionMalfunctionIdCommentPost(requestParameters: ApiApiApiV0MalfunctionMalfunctionIdCommentPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0MalfunctionMalfunctionIdCommentPost(requestParameters.malfunctionId, requestParameters.malfunctionCommentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get malfunction image
     * @param {ApiApiApiV0MalfunctionMalfunctionIdImageGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MalfunctionMalfunctionIdImageGet(requestParameters: ApiApiApiV0MalfunctionMalfunctionIdImageGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0MalfunctionMalfunctionIdImageGet(requestParameters.malfunctionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update malfunction assignee
     * @param {ApiApiApiV0MalfunctionPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MalfunctionPatch(requestParameters: ApiApiApiV0MalfunctionPatchRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0MalfunctionPatch(requestParameters.malfunctionAssigneeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync malfunctions with policies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MalfunctionUpdateGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0MalfunctionUpdateGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get media file library
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MediaFilesGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0MediaFilesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete media file
     * @param {ApiApiApiV0MediaFilesMediaFileIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MediaFilesMediaFileIdDelete(requestParameters: ApiApiApiV0MediaFilesMediaFileIdDeleteRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0MediaFilesMediaFileIdDelete(requestParameters.mediaFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get signed url for media file
     * @summary Get signed url for media file
     * @param {ApiApiApiV0MediaFilesMediaFileIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MediaFilesMediaFileIdGet(requestParameters: ApiApiApiV0MediaFilesMediaFileIdGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0MediaFilesMediaFileIdGet(requestParameters.mediaFileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update media file
     * @param {ApiApiApiV0MediaFilesMediaFileIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MediaFilesMediaFileIdPatch(requestParameters: ApiApiApiV0MediaFilesMediaFileIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0MediaFilesMediaFileIdPatch(requestParameters.mediaFileId, requestParameters.mediaFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get file upload url
     * @param {ApiApiApiV0MediaFilesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MediaFilesPost(requestParameters: ApiApiApiV0MediaFilesPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0MediaFilesPost(requestParameters.uploadMediaFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add media file to database
     * @param {ApiApiApiV0MediaFilesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0MediaFilesPut(requestParameters: ApiApiApiV0MediaFilesPutRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0MediaFilesPut(requestParameters.mediaFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new NPS
     * @param {ApiApiApiV0NpsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0NpsPost(requestParameters: ApiApiApiV0NpsPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0NpsPost(requestParameters.nps, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove package to device list
     * @param {ApiApiApiV0PackageDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0PackageDelete(requestParameters: ApiApiApiV0PackageDeleteRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0PackageDelete(requestParameters.packageTrackerData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove file from package
     * @param {ApiApiApiV0PackagePackageIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0PackagePackageIdDelete(requestParameters: ApiApiApiV0PackagePackageIdDeleteRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0PackagePackageIdDelete(requestParameters.packageId, requestParameters.fileData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get file upload data
     * @param {ApiApiApiV0PackagePackageIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0PackagePackageIdPost(requestParameters: ApiApiApiV0PackagePackageIdPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0PackagePackageIdPost(requestParameters.packageId, requestParameters.fileData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add file to existing package
     * @param {ApiApiApiV0PackagePackageIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0PackagePackageIdPut(requestParameters: ApiApiApiV0PackagePackageIdPutRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0PackagePackageIdPut(requestParameters.packageId, requestParameters.fileData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new package
     * @param {ApiApiApiV0PackagePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0PackagePost(requestParameters: ApiApiApiV0PackagePostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0PackagePost(requestParameters.packageName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Attach package to device list
     * @param {ApiApiApiV0PackagePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0PackagePut(requestParameters: ApiApiApiV0PackagePutRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0PackagePut(requestParameters.packageTrackerData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get premium optimization details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0PremiumOptimizationGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0PremiumOptimizationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new premium optimization details
     * @param {ApiApiApiV0PremiumOptimizationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0PremiumOptimizationPost(requestParameters: ApiApiApiV0PremiumOptimizationPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0PremiumOptimizationPost(requestParameters.premiumOptimizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send reminder
     * @param {ApiApiApiV0PremiumOptimizationReminderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0PremiumOptimizationReminderPost(requestParameters: ApiApiApiV0PremiumOptimizationReminderPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0PremiumOptimizationReminderPost(requestParameters.premiumOptimizationReminderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get release notes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0ReleaseNotesGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0ReleaseNotesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of reports and alerts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0ReportGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0ReportGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create new report or alert
     * @param {ApiApiApiV0ReportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0ReportPost(requestParameters: ApiApiApiV0ReportPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0ReportPost(requestParameters.alertOrReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create new report or alert
     * @param {ApiApiApiV0ReportReportIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0ReportReportIdDelete(requestParameters: ApiApiApiV0ReportReportIdDeleteRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0ReportReportIdDelete(requestParameters.reportId, requestParameters.alertOrReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update report or alert
     * @param {ApiApiApiV0ReportReportIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0ReportReportIdPatch(requestParameters: ApiApiApiV0ReportReportIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0ReportReportIdPatch(requestParameters.reportId, requestParameters.alertOrReport, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of report instances
     * @param {ApiApiApiV0ReportRunGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0ReportRunGet(requestParameters: ApiApiApiV0ReportRunGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0ReportRunGet(requestParameters.reportType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get report instance
     * @param {ApiApiApiV0ReportRunInstanceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0ReportRunInstanceIdGet(requestParameters: ApiApiApiV0ReportRunInstanceIdGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0ReportRunInstanceIdGet(requestParameters.instanceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update report instance
     * @param {ApiApiApiV0ReportRunInstanceIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0ReportRunInstanceIdPatch(requestParameters: ApiApiApiV0ReportRunInstanceIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0ReportRunInstanceIdPatch(requestParameters.instanceId, requestParameters.reportInstanceUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send report
     * @param {ApiApiApiV0ReportRunInstanceIdSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0ReportRunInstanceIdSendPost(requestParameters: ApiApiApiV0ReportRunInstanceIdSendPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0ReportRunInstanceIdSendPost(requestParameters.instanceId, requestParameters.sendReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate report
     * @param {ApiApiApiV0ReportRunPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0ReportRunPost(requestParameters: ApiApiApiV0ReportRunPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0ReportRunPost(requestParameters.reportInstanceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update customer settings
     * @param {ApiApiApiV0SettingsCustomerPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0SettingsCustomerPatch(requestParameters: ApiApiApiV0SettingsCustomerPatchRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0SettingsCustomerPatch(requestParameters.customerSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get customer accident sticker
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0SettingsCustomerStickerPost(options?: any) {
        return ApiApiFp(this.configuration).apiV0SettingsCustomerStickerPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change user\'s email
     * @param {ApiApiApiV0SettingsUserEmailPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0SettingsUserEmailPatch(requestParameters: ApiApiApiV0SettingsUserEmailPatchRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0SettingsUserEmailPatch(requestParameters.changeEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove users
     * @param {ApiApiApiV0SettingsUserManagementDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0SettingsUserManagementDelete(requestParameters: ApiApiApiV0SettingsUserManagementDeleteRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0SettingsUserManagementDelete(requestParameters.userDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users\' permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0SettingsUserManagementGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0SettingsUserManagementGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update users\' permissions
     * @param {ApiApiApiV0SettingsUserManagementPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0SettingsUserManagementPatch(requestParameters: ApiApiApiV0SettingsUserManagementPatchRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0SettingsUserManagementPatch(requestParameters.userDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new user
     * @param {ApiApiApiV0SettingsUserManagementPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0SettingsUserManagementPost(requestParameters: ApiApiApiV0SettingsUserManagementPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0SettingsUserManagementPost(requestParameters.userCreationData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change user\'s password
     * @param {ApiApiApiV0SettingsUserPasswordPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0SettingsUserPasswordPatch(requestParameters: ApiApiApiV0SettingsUserPasswordPatchRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0SettingsUserPasswordPatch(requestParameters.changePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request permission change
     * @param {ApiApiApiV0SettingsUserPermissionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0SettingsUserPermissionPost(requestParameters: ApiApiApiV0SettingsUserPermissionPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0SettingsUserPermissionPost(requestParameters.changePermissionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request password reset
     * @param {ApiApiApiV0SettingsUserResetPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0SettingsUserResetPasswordPost(requestParameters: ApiApiApiV0SettingsUserResetPasswordPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0SettingsUserResetPasswordPost(requestParameters.resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of existing tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0TagGet(options?: any) {
        return ApiApiFp(this.configuration).apiV0TagGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user notifications
     * @param {ApiApiApiV0UserNotificationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0UserNotificationGet(requestParameters: ApiApiApiV0UserNotificationGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0UserNotificationGet(requestParameters.from, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user notification
     * @param {ApiApiApiV0UserNotificationNotificationIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0UserNotificationNotificationIdPatch(requestParameters: ApiApiApiV0UserNotificationNotificationIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0UserNotificationNotificationIdPatch(requestParameters.notificationId, requestParameters.userNotificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update last seen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0UserNotificationPatch(options?: any) {
        return ApiApiFp(this.configuration).apiV0UserNotificationPatch(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save video preview as an event
     * @param {ApiApiApiV0VideoPreviewRequestEventPreviewRequestIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0VideoPreviewRequestEventPreviewRequestIdPost(requestParameters: ApiApiApiV0VideoPreviewRequestEventPreviewRequestIdPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0VideoPreviewRequestEventPreviewRequestIdPost(requestParameters.previewRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get video preview request details
     * @param {ApiApiApiV0VideoPreviewRequestGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0VideoPreviewRequestGet(requestParameters: ApiApiApiV0VideoPreviewRequestGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0VideoPreviewRequestGet(requestParameters.tripId, requestParameters.driverTripId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new video preview request
     * @param {ApiApiApiV0VideoPreviewRequestPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0VideoPreviewRequestPost(requestParameters: ApiApiApiV0VideoPreviewRequestPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0VideoPreviewRequestPost(requestParameters.videoPreviewRequestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get wellness score list
     * @param {ApiApiApiV0WellnessScoresGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0WellnessScoresGet(requestParameters: ApiApiApiV0WellnessScoresGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV0WellnessScoresGet(requestParameters.cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get wellness score details
     * @param {ApiApiApiV0WellnessScoresLicensePlateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0WellnessScoresLicensePlateGet(requestParameters: ApiApiApiV0WellnessScoresLicensePlateGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0WellnessScoresLicensePlateGet(requestParameters.licensePlate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add or dismiss wellness status from driver coaching session
     * @param {ApiApiApiV0WellnessStatusWellnessIdCoachPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV0WellnessStatusWellnessIdCoachPost(requestParameters: ApiApiApiV0WellnessStatusWellnessIdCoachPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV0WellnessStatusWellnessIdCoachPost(requestParameters.wellnessId, requestParameters.coachWellnessDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get driver coaching session
     * @param {ApiApiApiV1CoachDriverGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1CoachDriverGet(requestParameters: ApiApiApiV1CoachDriverGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1CoachDriverGet(requestParameters.token, requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update session metadata
     * @param {ApiApiApiV1CoachDriverPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1CoachDriverPatch(requestParameters: ApiApiApiV1CoachDriverPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1CoachDriverPatch(requestParameters.token, requestParameters.code, requestParameters.coachSessionMetadata, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Complete driver coaching session
     * @param {ApiApiApiV1CoachDriverPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1CoachDriverPost(requestParameters: ApiApiApiV1CoachDriverPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1CoachDriverPost(requestParameters.token, requestParameters.code, requestParameters.updateCoachSession, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of coaching sessions
     * @param {ApiApiApiV1CoachGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1CoachGet(requestParameters: ApiApiApiV1CoachGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV1CoachGet(requestParameters.driverToken, requestParameters.completedFrom, requestParameters.completedTo, requestParameters.additionalInfo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send coaching session link by sms
     * @param {ApiApiApiV1CoachSendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1CoachSendPost(requestParameters: ApiApiApiV1CoachSendPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1CoachSendPost(requestParameters.coachSessionMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete coaching session
     * @param {ApiApiApiV1CoachSessionIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1CoachSessionIdDelete(requestParameters: ApiApiApiV1CoachSessionIdDeleteRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1CoachSessionIdDelete(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get coaching session details
     * @param {ApiApiApiV1CoachSessionIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1CoachSessionIdGet(requestParameters: ApiApiApiV1CoachSessionIdGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1CoachSessionIdGet(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change coaching session assignee or agenda
     * @param {ApiApiApiV1CoachSessionIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1CoachSessionIdPatch(requestParameters: ApiApiApiV1CoachSessionIdPatchRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1CoachSessionIdPatch(requestParameters.sessionId, requestParameters.coachSession, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of coaching sessions
     * @param {ApiApiApiV1CoachSessionIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1CoachSessionIdPost(requestParameters: ApiApiApiV1CoachSessionIdPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1CoachSessionIdPost(requestParameters.sessionId, requestParameters.updateCoachSession, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send the driver a reminder to complete session
     * @param {ApiApiApiV1CoachSessionIdRemindPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1CoachSessionIdRemindPost(requestParameters: ApiApiApiV1CoachSessionIdRemindPostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1CoachSessionIdRemindPost(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save auto-generated coaching session
     * @param {ApiApiApiV1CoachSessionIdSavePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1CoachSessionIdSavePost(requestParameters: ApiApiApiV1CoachSessionIdSavePostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1CoachSessionIdSavePost(requestParameters.sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get events
     * @summary Get events
     * @param {ApiApiApiV1EventGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1EventGet(requestParameters: ApiApiApiV1EventGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV1EventGet(requestParameters.licensePlate, requestParameters.licensePlateList, requestParameters.licensePlateContains, requestParameters.subFleet, requestParameters.subFleetList, requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.timeFrom, requestParameters.timeTo, requestParameters.tripId, requestParameters.lastTrip, requestParameters.tripObjIn, requestParameters.severity, requestParameters.eventType, requestParameters.eventTypeList, requestParameters.lastEvent, requestParameters.tag, requestParameters.level, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of policies
     * @param {ApiApiApiV1PolicyGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1PolicyGet(requestParameters: ApiApiApiV1PolicyGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV1PolicyGet(requestParameters.dateFrom, requestParameters.date, requestParameters.csv, requestParameters._long, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send list of policies
     * @param {ApiApiApiV1PolicyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1PolicyPost(requestParameters: ApiApiApiV1PolicyPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV1PolicyPost(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get array of trips for a vehicle
     * @param {ApiApiApiV1TripGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1TripGet(requestParameters: ApiApiApiV1TripGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1TripGet(requestParameters.licensePlate, requestParameters.from, requestParameters.to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get trip location data
     * @param {ApiApiApiV1TripLicensePlateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1TripLicensePlateGet(requestParameters: ApiApiApiV1TripLicensePlateGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1TripLicensePlateGet(requestParameters.licensePlate, requestParameters.timeFrom, requestParameters.timeTo, requestParameters.csv, requestParameters.tripId, requestParameters.snapshots, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get trip wellness data
     * @param {ApiApiApiV1TripLicensePlateWellnessGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1TripLicensePlateWellnessGet(requestParameters: ApiApiApiV1TripLicensePlateWellnessGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV1TripLicensePlateWellnessGet(requestParameters.licensePlate, requestParameters.timeFrom, requestParameters.timeTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users\' settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1UserGet(options?: any) {
        return ApiApiFp(this.configuration).apiV1UserGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user\'s settings
     * @param {ApiApiApiV1UserPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV1UserPatch(requestParameters: ApiApiApiV1UserPatchRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV1UserPatch(requestParameters.userProfile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get device details
     * @param {ApiApiApiV2DeviceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV2DeviceGet(requestParameters: ApiApiApiV2DeviceGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV2DeviceGet(requestParameters.licensePlate, requestParameters.driverName, requestParameters.licensePlateContains, requestParameters.driverNameContains, requestParameters.deviceId, requestParameters.deviceIdContains, requestParameters.subFleet, requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.version, requestParameters.status, requestParameters.versionName, requestParameters.cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get device location
     * @param {ApiApiApiV2DeviceLocationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV2DeviceLocationGet(requestParameters: ApiApiApiV2DeviceLocationGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV2DeviceLocationGet(requestParameters.licensePlate, requestParameters.driverName, requestParameters.licensePlateContains, requestParameters.driverNameContains, requestParameters.deviceId, requestParameters.deviceIdContains, requestParameters.subFleet, requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.version, requestParameters.versionName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get events
     * @summary Get events
     * @param {ApiApiApiV2EventGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV2EventGet(requestParameters: ApiApiApiV2EventGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV2EventGet(requestParameters.licensePlate, requestParameters.licensePlateList, requestParameters.driverName, requestParameters.driverNameList, requestParameters.licensePlateContains, requestParameters.driverNameContains, requestParameters.subFleet, requestParameters.subFleetList, requestParameters.date, requestParameters.dateFrom, requestParameters.dateTo, requestParameters.timeFrom, requestParameters.timeTo, requestParameters.tripId, requestParameters.tripObjIn, requestParameters.eventType, requestParameters.eventTypeList, requestParameters.severityFrom, requestParameters.severityTo, requestParameters.tag, requestParameters.level, requestParameters.limit, requestParameters.searchAfter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get trip location data
     * @param {ApiApiApiV2TripLicensePlateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV2TripLicensePlateGet(requestParameters: ApiApiApiV2TripLicensePlateGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV2TripLicensePlateGet(requestParameters.licensePlate, requestParameters.timeFrom, requestParameters.timeTo, requestParameters.csv, requestParameters.tripId, requestParameters.driverTripId, requestParameters.snapshots, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update trip details
     * @param {ApiApiApiV2TripLicensePlatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV2TripLicensePlatePost(requestParameters: ApiApiApiV2TripLicensePlatePostRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV2TripLicensePlatePost(requestParameters.licensePlate, requestParameters.tripUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get wellness image
     * @param {ApiApiApiV2WellnessImageWellnessTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV2WellnessImageWellnessTypeGet(requestParameters: ApiApiApiV2WellnessImageWellnessTypeGetRequest, options?: any) {
        return ApiApiFp(this.configuration).apiV2WellnessImageWellnessTypeGet(requestParameters.wellnessType, requestParameters.wellnessId, requestParameters.timestamp, requestParameters.licensePlate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Run wellness check
     * @param {ApiApiApiV2WellnessRunTaskPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV2WellnessRunTaskPost(requestParameters: ApiApiApiV2WellnessRunTaskPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV2WellnessRunTaskPost(requestParameters.runWellnessRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get device details
     * @param {ApiApiApiV3DeviceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiV3DeviceGet(requestParameters: ApiApiApiV3DeviceGetRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).apiV3DeviceGet(requestParameters.cache, requestParameters.timestamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get customer drivers and home terminals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public hosV0SettingsCustomerGet(options?: any) {
        return ApiApiFp(this.configuration).hosV0SettingsCustomerGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove hos drivers
     * @param {ApiApiHosV0SettingsDriverManagementDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public hosV0SettingsDriverManagementDelete(requestParameters: ApiApiHosV0SettingsDriverManagementDeleteRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).hosV0SettingsDriverManagementDelete(requestParameters.hosDriverRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get hos drivers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public hosV0SettingsDriverManagementGet(options?: any) {
        return ApiApiFp(this.configuration).hosV0SettingsDriverManagementGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update hos drivers
     * @param {ApiApiHosV0SettingsDriverManagementPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public hosV0SettingsDriverManagementPatch(requestParameters: ApiApiHosV0SettingsDriverManagementPatchRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).hosV0SettingsDriverManagementPatch(requestParameters.hosDriverRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new hos driver
     * @param {ApiApiHosV0SettingsDriverManagementPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public hosV0SettingsDriverManagementPost(requestParameters: ApiApiHosV0SettingsDriverManagementPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).hosV0SettingsDriverManagementPost(requestParameters.hosDriverRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove home terminals
     * @param {ApiApiHosV0SettingsTerminalManagementDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public hosV0SettingsTerminalManagementDelete(requestParameters: ApiApiHosV0SettingsTerminalManagementDeleteRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).hosV0SettingsTerminalManagementDelete(requestParameters.homeTerminal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get home terminals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public hosV0SettingsTerminalManagementGet(options?: any) {
        return ApiApiFp(this.configuration).hosV0SettingsTerminalManagementGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update home terminals
     * @param {ApiApiHosV0SettingsTerminalManagementPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public hosV0SettingsTerminalManagementPatch(requestParameters: ApiApiHosV0SettingsTerminalManagementPatchRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).hosV0SettingsTerminalManagementPatch(requestParameters.homeTerminal, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create new home terminal
     * @param {ApiApiHosV0SettingsTerminalManagementPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public hosV0SettingsTerminalManagementPost(requestParameters: ApiApiHosV0SettingsTerminalManagementPostRequest = {}, options?: any) {
        return ApiApiFp(this.configuration).hosV0SettingsTerminalManagementPost(requestParameters.homeTerminal, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ControlApi - axios parameter creator
 * @export
 */
export const ControlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Clean device VSC configuration
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusDeviceIdCleanVscPost: async (deviceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('controlV0ConfigStatusDeviceIdCleanVscPost', 'deviceId', deviceId)
            const localVarPath = `/control/v0/config_status/{deviceId}/clean_vsc`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend failed device configuration
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusDeviceIdResendPost: async (deviceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('controlV0ConfigStatusDeviceIdResendPost', 'deviceId', deviceId)
            const localVarPath = `/control/v0/config_status/{deviceId}/resend`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all config status
         * @param {string} [customer] 
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusGet: async (customer?: string, deviceId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/control/v0/config_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (customer !== undefined) {
                localVarQueryParameter['customer'] = customer;
            }

            if (deviceId !== undefined) {
                localVarQueryParameter['device_id'] = deviceId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get customer config
         * @param {string} customerName 
         * @param {string} subFleetName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigCustomerNameSubFleetNameGet: async (customerName: string, subFleetName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'customerName' is not null or undefined
            assertParamExists('controlV0CustomerConfigCustomerNameSubFleetNameGet', 'customerName', customerName)
            // verify required parameter 'subFleetName' is not null or undefined
            assertParamExists('controlV0CustomerConfigCustomerNameSubFleetNameGet', 'subFleetName', subFleetName)
            const localVarPath = `/control/v0/customer_config/{customerName}/{subFleetName}`
                .replace(`{${"customerName"}}`, encodeURIComponent(String(customerName)))
                .replace(`{${"subFleetName"}}`, encodeURIComponent(String(subFleetName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all customer config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/control/v0/customer_config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change customer config
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigPost: async (body?: object, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/control/v0/customer_config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all experiment config
         * @param {number} experimentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigExperimentIdGet: async (experimentId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'experimentId' is not null or undefined
            assertParamExists('controlV0ExperimentConfigExperimentIdGet', 'experimentId', experimentId)
            const localVarPath = `/control/v0/experiment_config/{ExperimentId}`
                .replace(`{${"ExperimentId"}}`, encodeURIComponent(String(experimentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change experiment config
         * @param {number} experimentId 
         * @param {ExperimentDeviceRequest} [experimentDeviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigExperimentIdPost: async (experimentId: number, experimentDeviceRequest?: ExperimentDeviceRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'experimentId' is not null or undefined
            assertParamExists('controlV0ExperimentConfigExperimentIdPost', 'experimentId', experimentId)
            const localVarPath = `/control/v0/experiment_config/{ExperimentId}`
                .replace(`{${"ExperimentId"}}`, encodeURIComponent(String(experimentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(experimentDeviceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all experiment config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/control/v0/experiment_config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all overlays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0OverlayGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/control/v0/overlay`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary change an overlay
         * @param {number} overlayId 
         * @param {OverlayRequest} [overlayRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0OverlayOverlayIdPost: async (overlayId: number, overlayRequest?: OverlayRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'overlayId' is not null or undefined
            assertParamExists('controlV0OverlayOverlayIdPost', 'overlayId', overlayId)
            const localVarPath = `/control/v0/overlay/{overlayId}`
                .replace(`{${"overlayId"}}`, encodeURIComponent(String(overlayId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(overlayRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ControlApi - functional programming interface
 * @export
 */
export const ControlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ControlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Clean device VSC configuration
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlV0ConfigStatusDeviceIdCleanVscPost(deviceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlV0ConfigStatusDeviceIdCleanVscPost(deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resend failed device configuration
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlV0ConfigStatusDeviceIdResendPost(deviceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlV0ConfigStatusDeviceIdResendPost(deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all config status
         * @param {string} [customer] 
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlV0ConfigStatusGet(customer?: string, deviceId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceConfigStatus>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlV0ConfigStatusGet(customer, deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get customer config
         * @param {string} customerName 
         * @param {string} subFleetName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlV0CustomerConfigCustomerNameSubFleetNameGet(customerName: string, subFleetName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlV0CustomerConfigCustomerNameSubFleetNameGet(customerName, subFleetName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all customer config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlV0CustomerConfigGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomerConfig>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlV0CustomerConfigGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change customer config
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlV0CustomerConfigPost(body?: object, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlV0CustomerConfigPost(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all experiment config
         * @param {number} experimentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlV0ExperimentConfigExperimentIdGet(experimentId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlV0ExperimentConfigExperimentIdGet(experimentId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change experiment config
         * @param {number} experimentId 
         * @param {ExperimentDeviceRequest} [experimentDeviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlV0ExperimentConfigExperimentIdPost(experimentId: number, experimentDeviceRequest?: ExperimentDeviceRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlV0ExperimentConfigExperimentIdPost(experimentId, experimentDeviceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all experiment config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlV0ExperimentConfigGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExperimentConfig>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlV0ExperimentConfigGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all overlays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlV0OverlayGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OverlaysResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlV0OverlayGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary change an overlay
         * @param {number} overlayId 
         * @param {OverlayRequest} [overlayRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async controlV0OverlayOverlayIdPost(overlayId: number, overlayRequest?: OverlayRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Overlay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.controlV0OverlayOverlayIdPost(overlayId, overlayRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ControlApi - factory interface
 * @export
 */
export const ControlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ControlApiFp(configuration)
    return {
        /**
         * 
         * @summary Clean device VSC configuration
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusDeviceIdCleanVscPost(deviceId: string, options?: any): AxiosPromise<void> {
            return localVarFp.controlV0ConfigStatusDeviceIdCleanVscPost(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend failed device configuration
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusDeviceIdResendPost(deviceId: string, options?: any): AxiosPromise<void> {
            return localVarFp.controlV0ConfigStatusDeviceIdResendPost(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all config status
         * @param {string} [customer] 
         * @param {string} [deviceId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ConfigStatusGet(customer?: string, deviceId?: string, options?: any): AxiosPromise<Array<DeviceConfigStatus>> {
            return localVarFp.controlV0ConfigStatusGet(customer, deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get customer config
         * @param {string} customerName 
         * @param {string} subFleetName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigCustomerNameSubFleetNameGet(customerName: string, subFleetName: string, options?: any): AxiosPromise<object> {
            return localVarFp.controlV0CustomerConfigCustomerNameSubFleetNameGet(customerName, subFleetName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all customer config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigGet(options?: any): AxiosPromise<Array<CustomerConfig>> {
            return localVarFp.controlV0CustomerConfigGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change customer config
         * @param {object} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0CustomerConfigPost(body?: object, options?: any): AxiosPromise<CustomerConfig> {
            return localVarFp.controlV0CustomerConfigPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all experiment config
         * @param {number} experimentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigExperimentIdGet(experimentId: number, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.controlV0ExperimentConfigExperimentIdGet(experimentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change experiment config
         * @param {number} experimentId 
         * @param {ExperimentDeviceRequest} [experimentDeviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigExperimentIdPost(experimentId: number, experimentDeviceRequest?: ExperimentDeviceRequest, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.controlV0ExperimentConfigExperimentIdPost(experimentId, experimentDeviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all experiment config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0ExperimentConfigGet(options?: any): AxiosPromise<Array<ExperimentConfig>> {
            return localVarFp.controlV0ExperimentConfigGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all overlays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0OverlayGet(options?: any): AxiosPromise<OverlaysResponse> {
            return localVarFp.controlV0OverlayGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary change an overlay
         * @param {number} overlayId 
         * @param {OverlayRequest} [overlayRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        controlV0OverlayOverlayIdPost(overlayId: number, overlayRequest?: OverlayRequest, options?: any): AxiosPromise<Overlay> {
            return localVarFp.controlV0OverlayOverlayIdPost(overlayId, overlayRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for controlV0ConfigStatusDeviceIdCleanVscPost operation in ControlApi.
 * @export
 * @interface ControlApiControlV0ConfigStatusDeviceIdCleanVscPostRequest
 */
export interface ControlApiControlV0ConfigStatusDeviceIdCleanVscPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlApiControlV0ConfigStatusDeviceIdCleanVscPost
     */
    readonly deviceId: string
}

/**
 * Request parameters for controlV0ConfigStatusDeviceIdResendPost operation in ControlApi.
 * @export
 * @interface ControlApiControlV0ConfigStatusDeviceIdResendPostRequest
 */
export interface ControlApiControlV0ConfigStatusDeviceIdResendPostRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlApiControlV0ConfigStatusDeviceIdResendPost
     */
    readonly deviceId: string
}

/**
 * Request parameters for controlV0ConfigStatusGet operation in ControlApi.
 * @export
 * @interface ControlApiControlV0ConfigStatusGetRequest
 */
export interface ControlApiControlV0ConfigStatusGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlApiControlV0ConfigStatusGet
     */
    readonly customer?: string

    /**
     * 
     * @type {string}
     * @memberof ControlApiControlV0ConfigStatusGet
     */
    readonly deviceId?: string
}

/**
 * Request parameters for controlV0CustomerConfigCustomerNameSubFleetNameGet operation in ControlApi.
 * @export
 * @interface ControlApiControlV0CustomerConfigCustomerNameSubFleetNameGetRequest
 */
export interface ControlApiControlV0CustomerConfigCustomerNameSubFleetNameGetRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlApiControlV0CustomerConfigCustomerNameSubFleetNameGet
     */
    readonly customerName: string

    /**
     * 
     * @type {string}
     * @memberof ControlApiControlV0CustomerConfigCustomerNameSubFleetNameGet
     */
    readonly subFleetName: string
}

/**
 * Request parameters for controlV0CustomerConfigPost operation in ControlApi.
 * @export
 * @interface ControlApiControlV0CustomerConfigPostRequest
 */
export interface ControlApiControlV0CustomerConfigPostRequest {
    /**
     * 
     * @type {object}
     * @memberof ControlApiControlV0CustomerConfigPost
     */
    readonly body?: object
}

/**
 * Request parameters for controlV0ExperimentConfigExperimentIdGet operation in ControlApi.
 * @export
 * @interface ControlApiControlV0ExperimentConfigExperimentIdGetRequest
 */
export interface ControlApiControlV0ExperimentConfigExperimentIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ControlApiControlV0ExperimentConfigExperimentIdGet
     */
    readonly experimentId: number
}

/**
 * Request parameters for controlV0ExperimentConfigExperimentIdPost operation in ControlApi.
 * @export
 * @interface ControlApiControlV0ExperimentConfigExperimentIdPostRequest
 */
export interface ControlApiControlV0ExperimentConfigExperimentIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ControlApiControlV0ExperimentConfigExperimentIdPost
     */
    readonly experimentId: number

    /**
     * 
     * @type {ExperimentDeviceRequest}
     * @memberof ControlApiControlV0ExperimentConfigExperimentIdPost
     */
    readonly experimentDeviceRequest?: ExperimentDeviceRequest
}

/**
 * Request parameters for controlV0OverlayOverlayIdPost operation in ControlApi.
 * @export
 * @interface ControlApiControlV0OverlayOverlayIdPostRequest
 */
export interface ControlApiControlV0OverlayOverlayIdPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ControlApiControlV0OverlayOverlayIdPost
     */
    readonly overlayId: number

    /**
     * 
     * @type {OverlayRequest}
     * @memberof ControlApiControlV0OverlayOverlayIdPost
     */
    readonly overlayRequest?: OverlayRequest
}

/**
 * ControlApi - object-oriented interface
 * @export
 * @class ControlApi
 * @extends {BaseAPI}
 */
export class ControlApi extends BaseAPI {
    /**
     * 
     * @summary Clean device VSC configuration
     * @param {ControlApiControlV0ConfigStatusDeviceIdCleanVscPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public controlV0ConfigStatusDeviceIdCleanVscPost(requestParameters: ControlApiControlV0ConfigStatusDeviceIdCleanVscPostRequest, options?: any) {
        return ControlApiFp(this.configuration).controlV0ConfigStatusDeviceIdCleanVscPost(requestParameters.deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend failed device configuration
     * @param {ControlApiControlV0ConfigStatusDeviceIdResendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public controlV0ConfigStatusDeviceIdResendPost(requestParameters: ControlApiControlV0ConfigStatusDeviceIdResendPostRequest, options?: any) {
        return ControlApiFp(this.configuration).controlV0ConfigStatusDeviceIdResendPost(requestParameters.deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all config status
     * @param {ControlApiControlV0ConfigStatusGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public controlV0ConfigStatusGet(requestParameters: ControlApiControlV0ConfigStatusGetRequest = {}, options?: any) {
        return ControlApiFp(this.configuration).controlV0ConfigStatusGet(requestParameters.customer, requestParameters.deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get customer config
     * @param {ControlApiControlV0CustomerConfigCustomerNameSubFleetNameGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public controlV0CustomerConfigCustomerNameSubFleetNameGet(requestParameters: ControlApiControlV0CustomerConfigCustomerNameSubFleetNameGetRequest, options?: any) {
        return ControlApiFp(this.configuration).controlV0CustomerConfigCustomerNameSubFleetNameGet(requestParameters.customerName, requestParameters.subFleetName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all customer config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public controlV0CustomerConfigGet(options?: any) {
        return ControlApiFp(this.configuration).controlV0CustomerConfigGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change customer config
     * @param {ControlApiControlV0CustomerConfigPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public controlV0CustomerConfigPost(requestParameters: ControlApiControlV0CustomerConfigPostRequest = {}, options?: any) {
        return ControlApiFp(this.configuration).controlV0CustomerConfigPost(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all experiment config
     * @param {ControlApiControlV0ExperimentConfigExperimentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public controlV0ExperimentConfigExperimentIdGet(requestParameters: ControlApiControlV0ExperimentConfigExperimentIdGetRequest, options?: any) {
        return ControlApiFp(this.configuration).controlV0ExperimentConfigExperimentIdGet(requestParameters.experimentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change experiment config
     * @param {ControlApiControlV0ExperimentConfigExperimentIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public controlV0ExperimentConfigExperimentIdPost(requestParameters: ControlApiControlV0ExperimentConfigExperimentIdPostRequest, options?: any) {
        return ControlApiFp(this.configuration).controlV0ExperimentConfigExperimentIdPost(requestParameters.experimentId, requestParameters.experimentDeviceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all experiment config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public controlV0ExperimentConfigGet(options?: any) {
        return ControlApiFp(this.configuration).controlV0ExperimentConfigGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all overlays
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public controlV0OverlayGet(options?: any) {
        return ControlApiFp(this.configuration).controlV0OverlayGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary change an overlay
     * @param {ControlApiControlV0OverlayOverlayIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ControlApi
     */
    public controlV0OverlayOverlayIdPost(requestParameters: ControlApiControlV0OverlayOverlayIdPostRequest, options?: any) {
        return ControlApiFp(this.configuration).controlV0OverlayOverlayIdPost(requestParameters.overlayId, requestParameters.overlayRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * HosApi - axios parameter creator
 * @export
 */
export const HosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost: async (oTPUserCredentials?: OTPUserCredentials, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/otp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(oTPUserCredentials, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user token
         * @param {UserCredentials} [userCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost: async (userCredentials?: UserCredentials, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCredentials, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost: async (refreshTokenRequest?: RefreshTokenRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update device details
         * @param {string} deviceId 
         * @param {EldDeviceDetails} [eldDeviceDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosDeviceIdV0DetailsPost: async (deviceId: string, eldDeviceDetails?: EldDeviceDetails, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('hosDeviceIdV0DetailsPost', 'deviceId', deviceId)
            const localVarPath = `/hos/{deviceId}/v0/details`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eldDeviceDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of devices
         * @param {string} deviceId 
         * @param {'login' | 'logout'} action 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DeviceDeviceIdActionPost: async (deviceId: string, action: 'login' | 'logout', options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('hosV0DeviceDeviceIdActionPost', 'deviceId', deviceId)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('hosV0DeviceDeviceIdActionPost', 'action', action)
            const localVarPath = `/hos/v0/device/{deviceId}/{action}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)))
                .replace(`{${"action"}}`, encodeURIComponent(String(action)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DeviceGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Records list
         * @param {number} driverId 
         * @param {string} dateFrom 
         * @param {string} dateTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverDriverIdRecordDateFromDateToGet: async (driverId: number, dateFrom: string, dateTo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'driverId' is not null or undefined
            assertParamExists('hosV0DriverDriverIdRecordDateFromDateToGet', 'driverId', driverId)
            // verify required parameter 'dateFrom' is not null or undefined
            assertParamExists('hosV0DriverDriverIdRecordDateFromDateToGet', 'dateFrom', dateFrom)
            // verify required parameter 'dateTo' is not null or undefined
            assertParamExists('hosV0DriverDriverIdRecordDateFromDateToGet', 'dateTo', dateTo)
            const localVarPath = `/hos/v0/driver/{driverId}/record/{dateFrom}/{dateTo}`
                .replace(`{${"driverId"}}`, encodeURIComponent(String(driverId)))
                .replace(`{${"dateFrom"}}`, encodeURIComponent(String(dateFrom)))
                .replace(`{${"dateTo"}}`, encodeURIComponent(String(dateTo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/driver`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Approve driver amend request
         * @param {EventEntryApproval} [eventEntryApproval] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordAmendApprovalPost: async (eventEntryApproval?: EventEntryApproval, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/driver/record/amend/approval`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventEntryApproval, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update driver records
         * @param {Array<EventEntry>} [eventEntry] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordAmendPost: async (eventEntry?: Array<EventEntry>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/driver/record/amend`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Records list
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordDateGet: async (date: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('hosV0DriverRecordDateGet', 'date', date)
            const localVarPath = `/hos/v0/driver/record/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Certify records of day
         * @param {string} date 
         * @param {Certification} [certification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordDatePost: async (date: string, certification?: Certification, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'date' is not null or undefined
            assertParamExists('hosV0DriverRecordDatePost', 'date', date)
            const localVarPath = `/hos/v0/driver/record/{date}`
                .replace(`{${"date"}}`, encodeURIComponent(String(date)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(certification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update driver status
         * @param {EventEntry} [eventEntry] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordPost: async (eventEntry?: EventEntry, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/driver/record`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventEntry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of amend records
         * @param {string} dateFrom 
         * @param {string} dateTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordAmendDateFromDateToGet: async (dateFrom: string, dateTo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateFrom' is not null or undefined
            assertParamExists('hosV0RecordAmendDateFromDateToGet', 'dateFrom', dateFrom)
            // verify required parameter 'dateTo' is not null or undefined
            assertParamExists('hosV0RecordAmendDateFromDateToGet', 'dateTo', dateTo)
            const localVarPath = `/hos/v0/record/amend/{dateFrom}/{dateTo}`
                .replace(`{${"dateFrom"}}`, encodeURIComponent(String(dateFrom)))
                .replace(`{${"dateTo"}}`, encodeURIComponent(String(dateTo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of unassigned records groups
         * @param {string} dateFrom 
         * @param {string} dateTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordUnassignedDateFromDateToGet: async (dateFrom: string, dateTo: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'dateFrom' is not null or undefined
            assertParamExists('hosV0RecordUnassignedDateFromDateToGet', 'dateFrom', dateFrom)
            // verify required parameter 'dateTo' is not null or undefined
            assertParamExists('hosV0RecordUnassignedDateFromDateToGet', 'dateTo', dateTo)
            const localVarPath = `/hos/v0/record/unassigned/{dateFrom}/{dateTo}`
                .replace(`{${"dateFrom"}}`, encodeURIComponent(String(dateFrom)))
                .replace(`{${"dateTo"}}`, encodeURIComponent(String(dateTo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * assign unassigned records
         * @param {Array<HosUnassignedAssignmentRequest>} [hosUnassignedAssignmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordUnassignedPost: async (hosUnassignedAssignmentRequest?: Array<HosUnassignedAssignmentRequest>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/record/unassigned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hosUnassignedAssignmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Transfer hos data
         * @param {HosTransferRequest} [hosTransferRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0TransferPost: async (hosTransferRequest?: HosTransferRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/hos/v0/transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hosTransferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HosApi - functional programming interface
 * @export
 */
export const HosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HosApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthOtpPost(oTPUserCredentials?: OTPUserCredentials, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWTToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthOtpPost(oTPUserCredentials, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user token
         * @param {UserCredentials} [userCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthPost(userCredentials?: UserCredentials, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWTToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthPost(userCredentials, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuthRefreshPost(refreshTokenRequest?: RefreshTokenRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JWTToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuthRefreshPost(refreshTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update device details
         * @param {string} deviceId 
         * @param {EldDeviceDetails} [eldDeviceDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosDeviceIdV0DetailsPost(deviceId: string, eldDeviceDetails?: EldDeviceDetails, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EldDeviceDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosDeviceIdV0DetailsPost(deviceId, eldDeviceDetails, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of devices
         * @param {string} deviceId 
         * @param {'login' | 'logout'} action 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0DeviceDeviceIdActionPost(deviceId: string, action: 'login' | 'logout', options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HosDriver>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0DeviceDeviceIdActionPost(deviceId, action, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0DeviceGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceV2>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0DeviceGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Records list
         * @param {number} driverId 
         * @param {string} dateFrom 
         * @param {string} dateTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0DriverDriverIdRecordDateFromDateToGet(driverId: number, dateFrom: string, dateTo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0DriverDriverIdRecordDateFromDateToGet(driverId, dateFrom, dateTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0DriverGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HosDriver>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0DriverGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Approve driver amend request
         * @param {EventEntryApproval} [eventEntryApproval] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0DriverRecordAmendApprovalPost(eventEntryApproval?: EventEntryApproval, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0DriverRecordAmendApprovalPost(eventEntryApproval, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update driver records
         * @param {Array<EventEntry>} [eventEntry] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0DriverRecordAmendPost(eventEntry?: Array<EventEntry>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0DriverRecordAmendPost(eventEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Records list
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0DriverRecordDateGet(date: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0DriverRecordDateGet(date, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Certify records of day
         * @param {string} date 
         * @param {Certification} [certification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0DriverRecordDatePost(date: string, certification?: Certification, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventEntry>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0DriverRecordDatePost(date, certification, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update driver status
         * @param {EventEntry} [eventEntry] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0DriverRecordPost(eventEntry?: EventEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0DriverRecordPost(eventEntry, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of amend records
         * @param {string} dateFrom 
         * @param {string} dateTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0RecordAmendDateFromDateToGet(dateFrom: string, dateTo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Array<EventEntry>>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0RecordAmendDateFromDateToGet(dateFrom, dateTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * List of unassigned records groups
         * @param {string} dateFrom 
         * @param {string} dateTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0RecordUnassignedDateFromDateToGet(dateFrom: string, dateTo: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HosUnassignedRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0RecordUnassignedDateFromDateToGet(dateFrom, dateTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * assign unassigned records
         * @param {Array<HosUnassignedAssignmentRequest>} [hosUnassignedAssignmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0RecordUnassignedPost(hosUnassignedAssignmentRequest?: Array<HosUnassignedAssignmentRequest>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0RecordUnassignedPost(hosUnassignedAssignmentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Transfer hos data
         * @param {HosTransferRequest} [hosTransferRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hosV0TransferPost(hosTransferRequest?: HosTransferRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hosV0TransferPost(hosTransferRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HosApi - factory interface
 * @export
 */
export const HosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HosApiFp(configuration)
    return {
        /**
         * 
         * @summary Get user token
         * @param {OTPUserCredentials} [oTPUserCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthOtpPost(oTPUserCredentials?: OTPUserCredentials, options?: any): AxiosPromise<JWTToken> {
            return localVarFp.apiAuthOtpPost(oTPUserCredentials, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user token
         * @param {UserCredentials} [userCredentials] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthPost(userCredentials?: UserCredentials, options?: any): AxiosPromise<JWTToken> {
            return localVarFp.apiAuthPost(userCredentials, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user token
         * @param {RefreshTokenRequest} [refreshTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuthRefreshPost(refreshTokenRequest?: RefreshTokenRequest, options?: any): AxiosPromise<JWTToken> {
            return localVarFp.apiAuthRefreshPost(refreshTokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update device details
         * @param {string} deviceId 
         * @param {EldDeviceDetails} [eldDeviceDetails] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosDeviceIdV0DetailsPost(deviceId: string, eldDeviceDetails?: EldDeviceDetails, options?: any): AxiosPromise<EldDeviceDetails> {
            return localVarFp.hosDeviceIdV0DetailsPost(deviceId, eldDeviceDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * List of devices
         * @param {string} deviceId 
         * @param {'login' | 'logout'} action 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DeviceDeviceIdActionPost(deviceId: string, action: 'login' | 'logout', options?: any): AxiosPromise<Array<HosDriver>> {
            return localVarFp.hosV0DeviceDeviceIdActionPost(deviceId, action, options).then((request) => request(axios, basePath));
        },
        /**
         * List of devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DeviceGet(options?: any): AxiosPromise<Array<DeviceV2>> {
            return localVarFp.hosV0DeviceGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Records list
         * @param {number} driverId 
         * @param {string} dateFrom 
         * @param {string} dateTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverDriverIdRecordDateFromDateToGet(driverId: number, dateFrom: string, dateTo: string, options?: any): AxiosPromise<Array<EventEntry>> {
            return localVarFp.hosV0DriverDriverIdRecordDateFromDateToGet(driverId, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of drivers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverGet(options?: any): AxiosPromise<Array<HosDriver>> {
            return localVarFp.hosV0DriverGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Approve driver amend request
         * @param {EventEntryApproval} [eventEntryApproval] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordAmendApprovalPost(eventEntryApproval?: EventEntryApproval, options?: any): AxiosPromise<void> {
            return localVarFp.hosV0DriverRecordAmendApprovalPost(eventEntryApproval, options).then((request) => request(axios, basePath));
        },
        /**
         * Update driver records
         * @param {Array<EventEntry>} [eventEntry] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordAmendPost(eventEntry?: Array<EventEntry>, options?: any): AxiosPromise<Array<EventEntry>> {
            return localVarFp.hosV0DriverRecordAmendPost(eventEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * Records list
         * @param {string} date 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordDateGet(date: string, options?: any): AxiosPromise<Array<EventEntry>> {
            return localVarFp.hosV0DriverRecordDateGet(date, options).then((request) => request(axios, basePath));
        },
        /**
         * Certify records of day
         * @param {string} date 
         * @param {Certification} [certification] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordDatePost(date: string, certification?: Certification, options?: any): AxiosPromise<Array<EventEntry>> {
            return localVarFp.hosV0DriverRecordDatePost(date, certification, options).then((request) => request(axios, basePath));
        },
        /**
         * Update driver status
         * @param {EventEntry} [eventEntry] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0DriverRecordPost(eventEntry?: EventEntry, options?: any): AxiosPromise<void> {
            return localVarFp.hosV0DriverRecordPost(eventEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * List of amend records
         * @param {string} dateFrom 
         * @param {string} dateTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordAmendDateFromDateToGet(dateFrom: string, dateTo: string, options?: any): AxiosPromise<Array<Array<EventEntry>>> {
            return localVarFp.hosV0RecordAmendDateFromDateToGet(dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * List of unassigned records groups
         * @param {string} dateFrom 
         * @param {string} dateTo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordUnassignedDateFromDateToGet(dateFrom: string, dateTo: string, options?: any): AxiosPromise<HosUnassignedRecord> {
            return localVarFp.hosV0RecordUnassignedDateFromDateToGet(dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
        /**
         * assign unassigned records
         * @param {Array<HosUnassignedAssignmentRequest>} [hosUnassignedAssignmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0RecordUnassignedPost(hosUnassignedAssignmentRequest?: Array<HosUnassignedAssignmentRequest>, options?: any): AxiosPromise<void> {
            return localVarFp.hosV0RecordUnassignedPost(hosUnassignedAssignmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Transfer hos data
         * @param {HosTransferRequest} [hosTransferRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hosV0TransferPost(hosTransferRequest?: HosTransferRequest, options?: any): AxiosPromise<void> {
            return localVarFp.hosV0TransferPost(hosTransferRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiAuthOtpPost operation in HosApi.
 * @export
 * @interface HosApiApiAuthOtpPostRequest
 */
export interface HosApiApiAuthOtpPostRequest {
    /**
     * 
     * @type {OTPUserCredentials}
     * @memberof HosApiApiAuthOtpPost
     */
    readonly oTPUserCredentials?: OTPUserCredentials
}

/**
 * Request parameters for apiAuthPost operation in HosApi.
 * @export
 * @interface HosApiApiAuthPostRequest
 */
export interface HosApiApiAuthPostRequest {
    /**
     * 
     * @type {UserCredentials}
     * @memberof HosApiApiAuthPost
     */
    readonly userCredentials?: UserCredentials
}

/**
 * Request parameters for apiAuthRefreshPost operation in HosApi.
 * @export
 * @interface HosApiApiAuthRefreshPostRequest
 */
export interface HosApiApiAuthRefreshPostRequest {
    /**
     * 
     * @type {RefreshTokenRequest}
     * @memberof HosApiApiAuthRefreshPost
     */
    readonly refreshTokenRequest?: RefreshTokenRequest
}

/**
 * Request parameters for hosDeviceIdV0DetailsPost operation in HosApi.
 * @export
 * @interface HosApiHosDeviceIdV0DetailsPostRequest
 */
export interface HosApiHosDeviceIdV0DetailsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof HosApiHosDeviceIdV0DetailsPost
     */
    readonly deviceId: string

    /**
     * 
     * @type {EldDeviceDetails}
     * @memberof HosApiHosDeviceIdV0DetailsPost
     */
    readonly eldDeviceDetails?: EldDeviceDetails
}

/**
 * Request parameters for hosV0DeviceDeviceIdActionPost operation in HosApi.
 * @export
 * @interface HosApiHosV0DeviceDeviceIdActionPostRequest
 */
export interface HosApiHosV0DeviceDeviceIdActionPostRequest {
    /**
     * 
     * @type {string}
     * @memberof HosApiHosV0DeviceDeviceIdActionPost
     */
    readonly deviceId: string

    /**
     * 
     * @type {'login' | 'logout'}
     * @memberof HosApiHosV0DeviceDeviceIdActionPost
     */
    readonly action: 'login' | 'logout'
}

/**
 * Request parameters for hosV0DriverDriverIdRecordDateFromDateToGet operation in HosApi.
 * @export
 * @interface HosApiHosV0DriverDriverIdRecordDateFromDateToGetRequest
 */
export interface HosApiHosV0DriverDriverIdRecordDateFromDateToGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HosApiHosV0DriverDriverIdRecordDateFromDateToGet
     */
    readonly driverId: number

    /**
     * 
     * @type {string}
     * @memberof HosApiHosV0DriverDriverIdRecordDateFromDateToGet
     */
    readonly dateFrom: string

    /**
     * 
     * @type {string}
     * @memberof HosApiHosV0DriverDriverIdRecordDateFromDateToGet
     */
    readonly dateTo: string
}

/**
 * Request parameters for hosV0DriverRecordAmendApprovalPost operation in HosApi.
 * @export
 * @interface HosApiHosV0DriverRecordAmendApprovalPostRequest
 */
export interface HosApiHosV0DriverRecordAmendApprovalPostRequest {
    /**
     * 
     * @type {EventEntryApproval}
     * @memberof HosApiHosV0DriverRecordAmendApprovalPost
     */
    readonly eventEntryApproval?: EventEntryApproval
}

/**
 * Request parameters for hosV0DriverRecordAmendPost operation in HosApi.
 * @export
 * @interface HosApiHosV0DriverRecordAmendPostRequest
 */
export interface HosApiHosV0DriverRecordAmendPostRequest {
    /**
     * 
     * @type {Array<EventEntry>}
     * @memberof HosApiHosV0DriverRecordAmendPost
     */
    readonly eventEntry?: Array<EventEntry>
}

/**
 * Request parameters for hosV0DriverRecordDateGet operation in HosApi.
 * @export
 * @interface HosApiHosV0DriverRecordDateGetRequest
 */
export interface HosApiHosV0DriverRecordDateGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HosApiHosV0DriverRecordDateGet
     */
    readonly date: string
}

/**
 * Request parameters for hosV0DriverRecordDatePost operation in HosApi.
 * @export
 * @interface HosApiHosV0DriverRecordDatePostRequest
 */
export interface HosApiHosV0DriverRecordDatePostRequest {
    /**
     * 
     * @type {string}
     * @memberof HosApiHosV0DriverRecordDatePost
     */
    readonly date: string

    /**
     * 
     * @type {Certification}
     * @memberof HosApiHosV0DriverRecordDatePost
     */
    readonly certification?: Certification
}

/**
 * Request parameters for hosV0DriverRecordPost operation in HosApi.
 * @export
 * @interface HosApiHosV0DriverRecordPostRequest
 */
export interface HosApiHosV0DriverRecordPostRequest {
    /**
     * 
     * @type {EventEntry}
     * @memberof HosApiHosV0DriverRecordPost
     */
    readonly eventEntry?: EventEntry
}

/**
 * Request parameters for hosV0RecordAmendDateFromDateToGet operation in HosApi.
 * @export
 * @interface HosApiHosV0RecordAmendDateFromDateToGetRequest
 */
export interface HosApiHosV0RecordAmendDateFromDateToGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HosApiHosV0RecordAmendDateFromDateToGet
     */
    readonly dateFrom: string

    /**
     * 
     * @type {string}
     * @memberof HosApiHosV0RecordAmendDateFromDateToGet
     */
    readonly dateTo: string
}

/**
 * Request parameters for hosV0RecordUnassignedDateFromDateToGet operation in HosApi.
 * @export
 * @interface HosApiHosV0RecordUnassignedDateFromDateToGetRequest
 */
export interface HosApiHosV0RecordUnassignedDateFromDateToGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HosApiHosV0RecordUnassignedDateFromDateToGet
     */
    readonly dateFrom: string

    /**
     * 
     * @type {string}
     * @memberof HosApiHosV0RecordUnassignedDateFromDateToGet
     */
    readonly dateTo: string
}

/**
 * Request parameters for hosV0RecordUnassignedPost operation in HosApi.
 * @export
 * @interface HosApiHosV0RecordUnassignedPostRequest
 */
export interface HosApiHosV0RecordUnassignedPostRequest {
    /**
     * 
     * @type {Array<HosUnassignedAssignmentRequest>}
     * @memberof HosApiHosV0RecordUnassignedPost
     */
    readonly hosUnassignedAssignmentRequest?: Array<HosUnassignedAssignmentRequest>
}

/**
 * Request parameters for hosV0TransferPost operation in HosApi.
 * @export
 * @interface HosApiHosV0TransferPostRequest
 */
export interface HosApiHosV0TransferPostRequest {
    /**
     * 
     * @type {HosTransferRequest}
     * @memberof HosApiHosV0TransferPost
     */
    readonly hosTransferRequest?: HosTransferRequest
}

/**
 * HosApi - object-oriented interface
 * @export
 * @class HosApi
 * @extends {BaseAPI}
 */
export class HosApi extends BaseAPI {
    /**
     * 
     * @summary Get user token
     * @param {HosApiApiAuthOtpPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public apiAuthOtpPost(requestParameters: HosApiApiAuthOtpPostRequest = {}, options?: any) {
        return HosApiFp(this.configuration).apiAuthOtpPost(requestParameters.oTPUserCredentials, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user token
     * @param {HosApiApiAuthPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public apiAuthPost(requestParameters: HosApiApiAuthPostRequest = {}, options?: any) {
        return HosApiFp(this.configuration).apiAuthPost(requestParameters.userCredentials, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user token
     * @param {HosApiApiAuthRefreshPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public apiAuthRefreshPost(requestParameters: HosApiApiAuthRefreshPostRequest = {}, options?: any) {
        return HosApiFp(this.configuration).apiAuthRefreshPost(requestParameters.refreshTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update device details
     * @param {HosApiHosDeviceIdV0DetailsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosDeviceIdV0DetailsPost(requestParameters: HosApiHosDeviceIdV0DetailsPostRequest, options?: any) {
        return HosApiFp(this.configuration).hosDeviceIdV0DetailsPost(requestParameters.deviceId, requestParameters.eldDeviceDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of devices
     * @param {HosApiHosV0DeviceDeviceIdActionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0DeviceDeviceIdActionPost(requestParameters: HosApiHosV0DeviceDeviceIdActionPostRequest, options?: any) {
        return HosApiFp(this.configuration).hosV0DeviceDeviceIdActionPost(requestParameters.deviceId, requestParameters.action, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0DeviceGet(options?: any) {
        return HosApiFp(this.configuration).hosV0DeviceGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Records list
     * @param {HosApiHosV0DriverDriverIdRecordDateFromDateToGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0DriverDriverIdRecordDateFromDateToGet(requestParameters: HosApiHosV0DriverDriverIdRecordDateFromDateToGetRequest, options?: any) {
        return HosApiFp(this.configuration).hosV0DriverDriverIdRecordDateFromDateToGet(requestParameters.driverId, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of drivers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0DriverGet(options?: any) {
        return HosApiFp(this.configuration).hosV0DriverGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Approve driver amend request
     * @param {HosApiHosV0DriverRecordAmendApprovalPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0DriverRecordAmendApprovalPost(requestParameters: HosApiHosV0DriverRecordAmendApprovalPostRequest = {}, options?: any) {
        return HosApiFp(this.configuration).hosV0DriverRecordAmendApprovalPost(requestParameters.eventEntryApproval, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update driver records
     * @param {HosApiHosV0DriverRecordAmendPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0DriverRecordAmendPost(requestParameters: HosApiHosV0DriverRecordAmendPostRequest = {}, options?: any) {
        return HosApiFp(this.configuration).hosV0DriverRecordAmendPost(requestParameters.eventEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Records list
     * @param {HosApiHosV0DriverRecordDateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0DriverRecordDateGet(requestParameters: HosApiHosV0DriverRecordDateGetRequest, options?: any) {
        return HosApiFp(this.configuration).hosV0DriverRecordDateGet(requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Certify records of day
     * @param {HosApiHosV0DriverRecordDatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0DriverRecordDatePost(requestParameters: HosApiHosV0DriverRecordDatePostRequest, options?: any) {
        return HosApiFp(this.configuration).hosV0DriverRecordDatePost(requestParameters.date, requestParameters.certification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update driver status
     * @param {HosApiHosV0DriverRecordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0DriverRecordPost(requestParameters: HosApiHosV0DriverRecordPostRequest = {}, options?: any) {
        return HosApiFp(this.configuration).hosV0DriverRecordPost(requestParameters.eventEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of amend records
     * @param {HosApiHosV0RecordAmendDateFromDateToGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0RecordAmendDateFromDateToGet(requestParameters: HosApiHosV0RecordAmendDateFromDateToGetRequest, options?: any) {
        return HosApiFp(this.configuration).hosV0RecordAmendDateFromDateToGet(requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of unassigned records groups
     * @param {HosApiHosV0RecordUnassignedDateFromDateToGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0RecordUnassignedDateFromDateToGet(requestParameters: HosApiHosV0RecordUnassignedDateFromDateToGetRequest, options?: any) {
        return HosApiFp(this.configuration).hosV0RecordUnassignedDateFromDateToGet(requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * assign unassigned records
     * @param {HosApiHosV0RecordUnassignedPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0RecordUnassignedPost(requestParameters: HosApiHosV0RecordUnassignedPostRequest = {}, options?: any) {
        return HosApiFp(this.configuration).hosV0RecordUnassignedPost(requestParameters.hosUnassignedAssignmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Transfer hos data
     * @param {HosApiHosV0TransferPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HosApi
     */
    public hosV0TransferPost(requestParameters: HosApiHosV0TransferPostRequest = {}, options?: any) {
        return HosApiFp(this.configuration).hosV0TransferPost(requestParameters.hosTransferRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * InstallApi - axios parameter creator
 * @export
 */
export const InstallApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create installation command
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installConnectDeviceIdPost: async (deviceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('installConnectDeviceIdPost', 'deviceId', deviceId)
            const localVarPath = `/install/connect/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of new devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/install`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get device installation params
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installParamsDeviceIdGet: async (deviceId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceId' is not null or undefined
            assertParamExists('installParamsDeviceIdGet', 'deviceId', deviceId)
            const localVarPath = `/install/params/{deviceId}`
                .replace(`{${"deviceId"}}`, encodeURIComponent(String(deviceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Install new device
         * @param {InstallDeviceRequest} [installDeviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installPost: async (installDeviceRequest?: InstallDeviceRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/install`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(installDeviceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove installed device
         * @param {RemoveDeviceRequest} [removeDeviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installRemovePost: async (removeDeviceRequest?: RemoveDeviceRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/install/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeDeviceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate installation report
         * @param {InstallationReportRequest} [installationReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installReportPost: async (installationReportRequest?: InstallationReportRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/install/report`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(installationReportRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check old device and get installation params
         * @param {CheckDeviceRequest} [checkDeviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installSwitchPost: async (checkDeviceRequest?: CheckDeviceRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/install/switch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkDeviceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request upload url for installation file
         * @param {string} fileType 
         * @param {InstallationFileRequest} [installationFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installUploadFileTypePost: async (fileType: string, installationFileRequest?: InstallationFileRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileType' is not null or undefined
            assertParamExists('installUploadFileTypePost', 'fileType', fileType)
            const localVarPath = `/install/upload/{fileType}`
                .replace(`{${"fileType"}}`, encodeURIComponent(String(fileType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(installationFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of new devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installV2Get: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/install/v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request upload url for installation file
         * @param {InstallationFileRequestV2} [installationFileRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installV2UploadPost: async (installationFileRequestV2?: InstallationFileRequestV2, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/install/v2/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(installationFileRequestV2, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify installed cameras
         * @param {VerifyCamerasRequest} [verifyCamerasRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installVerifyPost: async (verifyCamerasRequest?: VerifyCamerasRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/install/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyCamerasRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InstallApi - functional programming interface
 * @export
 */
export const InstallApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InstallApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create installation command
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installConnectDeviceIdPost(deviceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstallationCommandResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.installConnectDeviceIdPost(deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of new devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.installGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get device installation params
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installParamsDeviceIdGet(deviceId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstallationParams>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.installParamsDeviceIdGet(deviceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Install new device
         * @param {InstallDeviceRequest} [installDeviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installPost(installDeviceRequest?: InstallDeviceRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.installPost(installDeviceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove installed device
         * @param {RemoveDeviceRequest} [removeDeviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installRemovePost(removeDeviceRequest?: RemoveDeviceRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.installRemovePost(removeDeviceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate installation report
         * @param {InstallationReportRequest} [installationReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installReportPost(installationReportRequest?: InstallationReportRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.installReportPost(installationReportRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Check old device and get installation params
         * @param {CheckDeviceRequest} [checkDeviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installSwitchPost(checkDeviceRequest?: CheckDeviceRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstallationFileResponse1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.installSwitchPost(checkDeviceRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request upload url for installation file
         * @param {string} fileType 
         * @param {InstallationFileRequest} [installationFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installUploadFileTypePost(fileType: string, installationFileRequest?: InstallationFileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstallationFileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.installUploadFileTypePost(fileType, installationFileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of new devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installV2Get(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NewDevice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.installV2Get(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request upload url for installation file
         * @param {InstallationFileRequestV2} [installationFileRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installV2UploadPost(installationFileRequestV2?: InstallationFileRequestV2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstallationFileResponseV2>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.installV2UploadPost(installationFileRequestV2, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verify installed cameras
         * @param {VerifyCamerasRequest} [verifyCamerasRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async installVerifyPost(verifyCamerasRequest?: VerifyCamerasRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.installVerifyPost(verifyCamerasRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InstallApi - factory interface
 * @export
 */
export const InstallApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InstallApiFp(configuration)
    return {
        /**
         * 
         * @summary Create installation command
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installConnectDeviceIdPost(deviceId: string, options?: any): AxiosPromise<InstallationCommandResult> {
            return localVarFp.installConnectDeviceIdPost(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of new devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.installGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get device installation params
         * @param {string} deviceId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installParamsDeviceIdGet(deviceId: string, options?: any): AxiosPromise<InstallationParams> {
            return localVarFp.installParamsDeviceIdGet(deviceId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Install new device
         * @param {InstallDeviceRequest} [installDeviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installPost(installDeviceRequest?: InstallDeviceRequest, options?: any): AxiosPromise<void> {
            return localVarFp.installPost(installDeviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove installed device
         * @param {RemoveDeviceRequest} [removeDeviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installRemovePost(removeDeviceRequest?: RemoveDeviceRequest, options?: any): AxiosPromise<void> {
            return localVarFp.installRemovePost(removeDeviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate installation report
         * @param {InstallationReportRequest} [installationReportRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installReportPost(installationReportRequest?: InstallationReportRequest, options?: any): AxiosPromise<void> {
            return localVarFp.installReportPost(installationReportRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check old device and get installation params
         * @param {CheckDeviceRequest} [checkDeviceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installSwitchPost(checkDeviceRequest?: CheckDeviceRequest, options?: any): AxiosPromise<InstallationFileResponse1> {
            return localVarFp.installSwitchPost(checkDeviceRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request upload url for installation file
         * @param {string} fileType 
         * @param {InstallationFileRequest} [installationFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installUploadFileTypePost(fileType: string, installationFileRequest?: InstallationFileRequest, options?: any): AxiosPromise<InstallationFileResponse> {
            return localVarFp.installUploadFileTypePost(fileType, installationFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of new devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installV2Get(options?: any): AxiosPromise<Array<NewDevice>> {
            return localVarFp.installV2Get(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request upload url for installation file
         * @param {InstallationFileRequestV2} [installationFileRequestV2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installV2UploadPost(installationFileRequestV2?: InstallationFileRequestV2, options?: any): AxiosPromise<InstallationFileResponseV2> {
            return localVarFp.installV2UploadPost(installationFileRequestV2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify installed cameras
         * @param {VerifyCamerasRequest} [verifyCamerasRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        installVerifyPost(verifyCamerasRequest?: VerifyCamerasRequest, options?: any): AxiosPromise<void> {
            return localVarFp.installVerifyPost(verifyCamerasRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for installConnectDeviceIdPost operation in InstallApi.
 * @export
 * @interface InstallApiInstallConnectDeviceIdPostRequest
 */
export interface InstallApiInstallConnectDeviceIdPostRequest {
    /**
     * 
     * @type {string}
     * @memberof InstallApiInstallConnectDeviceIdPost
     */
    readonly deviceId: string
}

/**
 * Request parameters for installParamsDeviceIdGet operation in InstallApi.
 * @export
 * @interface InstallApiInstallParamsDeviceIdGetRequest
 */
export interface InstallApiInstallParamsDeviceIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof InstallApiInstallParamsDeviceIdGet
     */
    readonly deviceId: string
}

/**
 * Request parameters for installPost operation in InstallApi.
 * @export
 * @interface InstallApiInstallPostRequest
 */
export interface InstallApiInstallPostRequest {
    /**
     * 
     * @type {InstallDeviceRequest}
     * @memberof InstallApiInstallPost
     */
    readonly installDeviceRequest?: InstallDeviceRequest
}

/**
 * Request parameters for installRemovePost operation in InstallApi.
 * @export
 * @interface InstallApiInstallRemovePostRequest
 */
export interface InstallApiInstallRemovePostRequest {
    /**
     * 
     * @type {RemoveDeviceRequest}
     * @memberof InstallApiInstallRemovePost
     */
    readonly removeDeviceRequest?: RemoveDeviceRequest
}

/**
 * Request parameters for installReportPost operation in InstallApi.
 * @export
 * @interface InstallApiInstallReportPostRequest
 */
export interface InstallApiInstallReportPostRequest {
    /**
     * 
     * @type {InstallationReportRequest}
     * @memberof InstallApiInstallReportPost
     */
    readonly installationReportRequest?: InstallationReportRequest
}

/**
 * Request parameters for installSwitchPost operation in InstallApi.
 * @export
 * @interface InstallApiInstallSwitchPostRequest
 */
export interface InstallApiInstallSwitchPostRequest {
    /**
     * 
     * @type {CheckDeviceRequest}
     * @memberof InstallApiInstallSwitchPost
     */
    readonly checkDeviceRequest?: CheckDeviceRequest
}

/**
 * Request parameters for installUploadFileTypePost operation in InstallApi.
 * @export
 * @interface InstallApiInstallUploadFileTypePostRequest
 */
export interface InstallApiInstallUploadFileTypePostRequest {
    /**
     * 
     * @type {string}
     * @memberof InstallApiInstallUploadFileTypePost
     */
    readonly fileType: string

    /**
     * 
     * @type {InstallationFileRequest}
     * @memberof InstallApiInstallUploadFileTypePost
     */
    readonly installationFileRequest?: InstallationFileRequest
}

/**
 * Request parameters for installV2UploadPost operation in InstallApi.
 * @export
 * @interface InstallApiInstallV2UploadPostRequest
 */
export interface InstallApiInstallV2UploadPostRequest {
    /**
     * 
     * @type {InstallationFileRequestV2}
     * @memberof InstallApiInstallV2UploadPost
     */
    readonly installationFileRequestV2?: InstallationFileRequestV2
}

/**
 * Request parameters for installVerifyPost operation in InstallApi.
 * @export
 * @interface InstallApiInstallVerifyPostRequest
 */
export interface InstallApiInstallVerifyPostRequest {
    /**
     * 
     * @type {VerifyCamerasRequest}
     * @memberof InstallApiInstallVerifyPost
     */
    readonly verifyCamerasRequest?: VerifyCamerasRequest
}

/**
 * InstallApi - object-oriented interface
 * @export
 * @class InstallApi
 * @extends {BaseAPI}
 */
export class InstallApi extends BaseAPI {
    /**
     * 
     * @summary Create installation command
     * @param {InstallApiInstallConnectDeviceIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    public installConnectDeviceIdPost(requestParameters: InstallApiInstallConnectDeviceIdPostRequest, options?: any) {
        return InstallApiFp(this.configuration).installConnectDeviceIdPost(requestParameters.deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of new devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    public installGet(options?: any) {
        return InstallApiFp(this.configuration).installGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get device installation params
     * @param {InstallApiInstallParamsDeviceIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    public installParamsDeviceIdGet(requestParameters: InstallApiInstallParamsDeviceIdGetRequest, options?: any) {
        return InstallApiFp(this.configuration).installParamsDeviceIdGet(requestParameters.deviceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Install new device
     * @param {InstallApiInstallPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    public installPost(requestParameters: InstallApiInstallPostRequest = {}, options?: any) {
        return InstallApiFp(this.configuration).installPost(requestParameters.installDeviceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove installed device
     * @param {InstallApiInstallRemovePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    public installRemovePost(requestParameters: InstallApiInstallRemovePostRequest = {}, options?: any) {
        return InstallApiFp(this.configuration).installRemovePost(requestParameters.removeDeviceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate installation report
     * @param {InstallApiInstallReportPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    public installReportPost(requestParameters: InstallApiInstallReportPostRequest = {}, options?: any) {
        return InstallApiFp(this.configuration).installReportPost(requestParameters.installationReportRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check old device and get installation params
     * @param {InstallApiInstallSwitchPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    public installSwitchPost(requestParameters: InstallApiInstallSwitchPostRequest = {}, options?: any) {
        return InstallApiFp(this.configuration).installSwitchPost(requestParameters.checkDeviceRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request upload url for installation file
     * @param {InstallApiInstallUploadFileTypePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    public installUploadFileTypePost(requestParameters: InstallApiInstallUploadFileTypePostRequest, options?: any) {
        return InstallApiFp(this.configuration).installUploadFileTypePost(requestParameters.fileType, requestParameters.installationFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of new devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    public installV2Get(options?: any) {
        return InstallApiFp(this.configuration).installV2Get(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request upload url for installation file
     * @param {InstallApiInstallV2UploadPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    public installV2UploadPost(requestParameters: InstallApiInstallV2UploadPostRequest = {}, options?: any) {
        return InstallApiFp(this.configuration).installV2UploadPost(requestParameters.installationFileRequestV2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify installed cameras
     * @param {InstallApiInstallVerifyPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InstallApi
     */
    public installVerifyPost(requestParameters: InstallApiInstallVerifyPostRequest = {}, options?: any) {
        return InstallApiFp(this.configuration).installVerifyPost(requestParameters.verifyCamerasRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


